import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  GenericScalar: any;
  JSONString: any;
  PositiveFloat: any;
  UUID: any;
};

export type AcceptFirmInviteMutationSchema = {
  __typename?: 'AcceptFirmInviteMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type AcceptTaxProClientInviteMutationSchema = {
  __typename?: 'AcceptTaxProClientInviteMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type AccountLevelTaxSummary = {
  __typename?: 'AccountLevelTaxSummary';
  taxSummary?: Maybe<TaxSummary>;
  walletName?: Maybe<Scalars['String']>;
  walletPublicId?: Maybe<Scalars['String']>;
  walletType?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum AccountType {
  Acx = 'ACX',
  Anchorage = 'ANCHORAGE',
  Bibox = 'BIBOX',
  Binance = 'BINANCE',
  Binancechain = 'BINANCECHAIN',
  Binancedex = 'BINANCEDEX',
  BinanceEarn = 'BINANCE_EARN',
  BinanceFutures = 'BINANCE_FUTURES',
  BinanceIsolatedMargin = 'BINANCE_ISOLATED_MARGIN',
  BinanceMargin = 'BINANCE_MARGIN',
  BinanceStaking = 'BINANCE_STAKING',
  BinanceUs = 'BINANCE_US',
  Bitfinex = 'BITFINEX',
  Bitgo = 'BITGO',
  Bitmex = 'BITMEX',
  Bitpanda = 'BITPANDA',
  Bitrue = 'BITRUE',
  Bitsane = 'BITSANE',
  Bitstamp = 'BITSTAMP',
  Bittrex = 'BITTREX',
  BittrexV2 = 'BITTREX_V2',
  Blockfolio = 'BLOCKFOLIO',
  Btcmarkets = 'BTCMARKETS',
  Bybit = 'BYBIT',
  Celsius = 'CELSIUS',
  CexIo = 'CEX_IO',
  Cobinhood = 'COBINHOOD',
  Coinbase = 'COINBASE',
  CoinbaseExchange = 'COINBASE_EXCHANGE',
  CoinbasePrime = 'COINBASE_PRIME',
  CoinbaseProV2 = 'COINBASE_PRO_V2',
  Coindcx = 'COINDCX',
  CoindcxBeta = 'COINDCX_BETA',
  Coinexchange = 'COINEXCHANGE',
  Coinjar = 'COINJAR',
  CoinjarExchange = 'COINJAR_EXCHANGE',
  CoinlistPro = 'COINLIST_PRO',
  Coinspot = 'COINSPOT',
  Coinswitch = 'COINSWITCH',
  CoinswitchBeta = 'COINSWITCH_BETA',
  Coss = 'COSS',
  Crex24 = 'CREX24',
  Cryptocom = 'CRYPTOCOM',
  Cryptopia = 'CRYPTOPIA',
  Deribit = 'DERIBIT',
  Fireblocks = 'FIREBLOCKS',
  Ftx = 'FTX',
  FtxUs = 'FTX_US',
  GateIo = 'GATE_IO',
  GateIoV2 = 'GATE_IO_V2',
  Gdax = 'GDAX',
  Gemini = 'GEMINI',
  Hitbtc = 'HITBTC',
  Huobi = 'HUOBI',
  Idex = 'IDEX',
  IndependentReserve = 'INDEPENDENT_RESERVE',
  Kraken = 'KRAKEN',
  Kucoin = 'KUCOIN',
  Liqui = 'LIQUI',
  Liquid = 'LIQUID',
  Livecoin = 'LIVECOIN',
  Nicehash = 'NICEHASH',
  Okex = 'OKEX',
  Poloniex = 'POLONIEX',
  Quadrigacx = 'QUADRIGACX',
  Robinhood = 'ROBINHOOD',
  Swyftx = 'SWYFTX',
  Tidex = 'TIDEX',
  Uphold = 'UPHOLD',
  Wazirx = 'WAZIRX',
  Yobit = 'YOBIT',
  Zebpay = 'ZEBPAY',
  ZebpayBeta = 'ZEBPAY_BETA'
}

export type AcquisitionLogType = {
  __typename?: 'AcquisitionLogType';
  action: Scalars['String'];
  data: Scalars['JSONString'];
  dateTime: Scalars['DateTime'];
};

export type AddAssetMutation = {
  __typename?: 'AddAssetMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type AddCbeDeposit = {
  __typename?: 'AddCbeDeposit';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddCbeDepositInput = {
  quantity: Scalars['Decimal'];
  timestamp: Scalars['DateTime'];
  uaid: Scalars['String'];
};

export type AddCbeDisposal = {
  __typename?: 'AddCbeDisposal';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddCbeDisposalInput = {
  feeQuantity?: InputMaybe<Scalars['Decimal']>;
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  rules?: InputMaybe<Array<InputMaybe<SpecIdRule>>>;
  uaid: Scalars['String'];
};

export type AddDepositOverrideMutationSchema = {
  __typename?: 'AddDepositOverrideMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddExchangeWithApiKeyAndSecretInput = {
  accountTypeSlug: Scalars['String'];
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
};

export type AddExchangeWithApiKeyAndSecretMutationSchema = {
  __typename?: 'AddExchangeWithAPIKeyAndSecretMutationSchema';
  createdExchange?: Maybe<Exchange>;
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddExchangeWithApiKeyInput = {
  accountTypeSlug: Scalars['String'];
  apiKey: Scalars['String'];
};

export type AddExchangeWithApiKeyMutationSchema = {
  __typename?: 'AddExchangeWithAPIKeyMutationSchema';
  createdExchange?: Maybe<Exchange>;
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddExchangeWithCustomerIdInput = {
  accountTypeSlug: Scalars['String'];
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  customerId: Scalars['String'];
};

export type AddExchangeWithCustomerIdMutationSchema = {
  __typename?: 'AddExchangeWithCustomerIdMutationSchema';
  createdExchange?: Maybe<Exchange>;
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddExchangeWithOauthCodeInput = {
  accountTypeSlug: Scalars['String'];
  /** Code received from initial authorize request */
  code: Scalars['String'];
  isCoinbaseBusinessAccount?: InputMaybe<Scalars['Boolean']>;
  /** The redirect uri must be the same as the one used to generate the code. */
  redirectUri: Scalars['String'];
};

export type AddExchangeWithOauthCodeMutationSchema = {
  __typename?: 'AddExchangeWithOauthCodeMutationSchema';
  createdExchange?: Maybe<Exchange>;
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddExchangeWithPassphraseInput = {
  accountTypeSlug: Scalars['String'];
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  passphrase: Scalars['String'];
};

export type AddExchangeWithPassphraseMutationSchema = {
  __typename?: 'AddExchangeWithPassphraseMutationSchema';
  createdExchange?: Maybe<Exchange>;
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddFirmAdminMutationSchema = {
  __typename?: 'AddFirmAdminMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type AddMultiAddressInput = {
  accountTypeSlug: Scalars['String'];
  /** Supports single address and multiple public keys in the following format: {SYMBOL}:{ADDRESS},{SYMBOL}:{ADDRESS} */
  publicKeys: Scalars['String'];
};

export type AddMultiAddressMutationSchema = {
  __typename?: 'AddMultiAddressMutationSchema';
  error?: Maybe<AddWalletErrors>;
  jobId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddPublicAddressMutationSchema = {
  __typename?: 'AddPublicAddressMutationSchema';
  createdExchange?: Maybe<Exchange>;
  createdWallet?: Maybe<Wallet>;
  error?: Maybe<AddWalletErrors>;
  multiAddError?: Maybe<Scalars['String']>;
  multiAddWarning?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['String']>;
  warning?: Maybe<AddWalletWarnings>;
};

export type AddPublicAddressWalletInput = {
  addAllEvmChainWallets?: InputMaybe<Scalars['Boolean']>;
  coinSymbol: Scalars['String'];
  cryptoNetwork: Scalars['String'];
  cryptoNetworksToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Scalars['String']>;
  walletAddress: Scalars['String'];
  walletName?: InputMaybe<Scalars['String']>;
};

export type AddPublicXpubInput = {
  accountTypeSlug: Scalars['String'];
  coinSymbol: Scalars['String'];
  cryptoNetwork: Scalars['String'];
  xpubKey: Scalars['String'];
};

export type AddPublicXpubMutationSchema = {
  __typename?: 'AddPublicXpubMutationSchema';
  createdWallet?: Maybe<Wallet>;
  error?: Maybe<AddWalletErrors>;
  success?: Maybe<Scalars['String']>;
  warning?: Maybe<AddWalletWarnings>;
};

export type AddSpecificIdRuleMutationSchema = {
  __typename?: 'AddSpecificIdRuleMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddTwoXpubInput = {
  accountTypeSlug: Scalars['String'];
  changeAddressXpub: Scalars['String'];
  coinSymbol: Scalars['String'];
  cryptoNetwork: Scalars['String'];
  receiveAddressXpub: Scalars['String'];
};

export type AddTwoXpubMutationSchema = {
  __typename?: 'AddTwoXpubMutationSchema';
  createdWallet?: Maybe<Wallet>;
  error?: Maybe<AddWalletErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum AddWalletErrors {
  HasZeroTransactions = 'has_zero_transactions',
  InvalidCryptoCurrency = 'invalid_crypto_currency',
  InvalidPublicKeys = 'invalid_public_keys',
  ReceiveChangeXpubSame = 'receive_change_xpub_same',
  TooManyTransactions = 'too_many_transactions',
  TooManyWallets = 'too_many_wallets',
  UnknownError = 'unknown_error',
  UnknownWalletType = 'unknown_wallet_type',
  ValueError = 'value_error',
  WalletAlreadyLinked = 'wallet_already_linked',
  WalletValidationError = 'wallet_validation_error'
}

/** An enumeration. */
export enum AddWalletWarnings {
  ReviewWalletForDuplicateTransactions = 'review_wallet_for_duplicate_transactions'
}

export type AdminAddTaxProForClient = {
  __typename?: 'AdminAddTaxProForClient';
  success?: Maybe<Scalars['Boolean']>;
};

export type AdminRemoveTaxProForClient = {
  __typename?: 'AdminRemoveTaxProForClient';
  success?: Maybe<Scalars['Boolean']>;
};

export type AppInfo = {
  __typename?: 'AppInfo';
  isAdmin?: Maybe<Scalars['Boolean']>;
  isAuthenticated?: Maybe<Scalars['Boolean']>;
  isViewAsUser?: Maybe<Scalars['Boolean']>;
  maintenanceMessage?: Maybe<Scalars['String']>;
  maintenanceMode?: Maybe<Scalars['Boolean']>;
  minimumClientVersion?: Maybe<MinimumClientVersion>;
  webAppHomePage?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  contractAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  priceUsd?: Maybe<Scalars['Float']>;
  slug?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  type?: Maybe<CurrencyType>;
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  edges?: Maybe<Array<Maybe<Asset>>>;
  totalCount: Scalars['Int'];
};

/** Enum for each distinct type of asset */
export enum AssetType {
  BlockchainToken = 'BLOCKCHAIN_TOKEN',
  CryptoCurrency = 'CRYPTO_CURRENCY',
  ExchangeToken = 'EXCHANGE_TOKEN',
  Fiat = 'FIAT',
  Nft = 'NFT',
  Unknown = 'UNKNOWN',
  UserDefinedToken = 'USER_DEFINED_TOKEN',
  VirtualToken = 'VIRTUAL_TOKEN'
}

export type AvailableLot = {
  __typename?: 'AvailableLot';
  acquisitionTransactionId?: Maybe<Scalars['String']>;
  adjustedCostBasis?: Maybe<Scalars['Float']>;
  adjustedCostBasisPerUnit?: Maybe<Scalars['Float']>;
  asset?: Maybe<Asset>;
  coveredState?: Maybe<Scalars['String']>;
  dateAcquired?: Maybe<Scalars['DateTime']>;
  gainLossAmount?: Maybe<Scalars['Float']>;
  gainLossPercent?: Maybe<Scalars['Float']>;
  holdingPeriod?: Maybe<Scalars['String']>;
  marketValue?: Maybe<Scalars['Float']>;
  marketValuePerUnit?: Maybe<Scalars['Float']>;
  orderToSell?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  walletName?: Maybe<Scalars['String']>;
};

export type AvailableLotNodeData = {
  __typename?: 'AvailableLotNodeData';
  adjustedCostBasis: Scalars['Decimal'];
  assetName: Scalars['String'];
  coveredState: Scalars['String'];
  dateAcquired: Scalars['DateTime'];
  id: Scalars['String'];
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  startDate: Scalars['DateTime'];
  storageType: Scalars['String'];
  taxEvent: Scalars['String'];
  txQueryLinkId: Scalars['String'];
  walletName: Scalars['String'];
};

export type AvailableLotsData = {
  __typename?: 'AvailableLotsData';
  availableLots?: Maybe<Array<Maybe<AvailableLot>>>;
  hasAccess?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AvailableSubscriptionPlans = {
  __typename?: 'AvailableSubscriptionPlans';
  currencySymbol?: Maybe<Scalars['String']>;
  hasTrial?: Maybe<Scalars['Boolean']>;
  isFixedTrialEndDate?: Maybe<Scalars['Boolean']>;
  isInUnifiedSubscription?: Maybe<Scalars['Boolean']>;
  plans?: Maybe<Array<Maybe<PortfolioPlanDetails>>>;
  trialDays?: Maybe<Scalars['Int']>;
  trialEndDate?: Maybe<Scalars['Date']>;
};

export type AvailableUnifiedSubscriptionPlans = {
  __typename?: 'AvailableUnifiedSubscriptionPlans';
  currencySymbol: Scalars['String'];
  featureTablePlans: Array<UnifiedFeatureTableDetails>;
  plans: Array<UnifiedPlanDetails>;
  transactionCountingYear?: Maybe<Scalars['Int']>;
};

export type Balance = {
  __typename?: 'Balance';
  balance?: Maybe<Scalars['Float']>;
  calculatedBalance?: Maybe<Scalars['Float']>;
  calculatedValue?: Maybe<Scalars['Float']>;
  cmcSlug?: Maybe<Scalars['String']>;
  /** @deprecated Please use sanitized_crypto_symbol. */
  cryptoSymbol?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  entryCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sanitizedCryptoSymbol?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type BulkUpdateTransactionAsset = {
  __typename?: 'BulkUpdateTransactionAsset';
  /** Returned if a job was enqueued. If job_id is empty, then we processed the update synchronously. */
  jobId?: Maybe<Scalars['String']>;
  /** List of results for each update token parameter */
  results: Array<Maybe<Result>>;
};

export type CbeUserSettings = {
  __typename?: 'CBEUserSettings';
  isExchangeReportingBasis: Scalars['Boolean'];
  userTaxReportingStatus: Scalars['Boolean'];
  userWithholdingStatus: Scalars['Boolean'];
};

export type CsvImportJobStatus = {
  __typename?: 'CSVImportJobStatus';
  createdCustomWallet?: Maybe<CustomWallet>;
  createdResourceName?: Maybe<Scalars['String']>;
  createdResourcePublicId?: Maybe<Scalars['String']>;
  error?: Maybe<CsvImportJobStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
  isStatusFinal?: Maybe<Scalars['Boolean']>;
  numberIgnored?: Maybe<Scalars['Int']>;
  numberImported?: Maybe<Scalars['Int']>;
  numberTotal?: Maybe<Scalars['Int']>;
  numberUserDefinedTokens?: Maybe<Scalars['Int']>;
  status?: Maybe<JobStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum CsvImportJobStatusError {
  FailedToImportCsv = 'failed_to_import_csv',
  UnknownJobId = 'unknown_job_id'
}

/** An enumeration. */
export enum CalloutSeverity {
  Error = 'ERROR',
  Informational = 'INFORMATIONAL',
  Notice = 'NOTICE',
  Severe = 'SEVERE',
  Warning = 'WARNING'
}

/** An enumeration. */
export enum CalloutType {
  InsufficientQuantity = 'INSUFFICIENT_QUANTITY',
  MissingBalance = 'MISSING_BALANCE',
  MissingPriceHistory = 'MISSING_PRICE_HISTORY',
  UnbalancedTransaction = 'UNBALANCED_TRANSACTION',
  ValueOutOfBounds = 'VALUE_OUT_OF_BOUNDS'
}

/**
 * The status of a coinbase one credit.
 *
 * active: The credit is active and can be used.
 * redeemed: The credit has been redeemed and cannot be used.
 * expired: The credit has expired and cannot be used (promotion is disabled).
 *
 */
export enum CoinbaseOneCreditStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export type CoinbaseOneCreditStatusOutput = {
  __typename?: 'CoinbaseOneCreditStatusOutput';
  creditValue?: Maybe<Scalars['String']>;
  status?: Maybe<CoinbaseOneCreditStatus>;
  tier?: Maybe<CoinbaseOneTier>;
};

/** The tier of a Coinbase One subscription. */
export enum CoinbaseOneTier {
  Basic = 'basic',
  Premium = 'premium'
}

/** An enumeration. */
export enum ContactType {
  Customer = 'customer',
  Employee = 'employee',
  Supplier = 'supplier'
}

export type ContractAddressNetworkPairInput = {
  contractAddress: Scalars['String'];
  network: Scalars['String'];
};

export type CostBasisEngineConnectUser = {
  __typename?: 'CostBasisEngineConnectUser';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum CostBasisMethod {
  Acb = 'ACB',
  Fifo = 'FIFO',
  Hifo = 'HIFO',
  Lifo = 'LIFO',
  Sp = 'SP',
  Wac = 'WAC'
}

export type CostBasisMethodSchema = {
  __typename?: 'CostBasisMethodSchema';
  breakoutByDateAcquired?: Maybe<Scalars['Boolean']>;
  enumValue?: Maybe<CostBasisMethod>;
  longName?: Maybe<Scalars['String']>;
  niceName?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CostBasisState {
  Cancelled = 'CANCELLED',
  Enqueued = 'ENQUEUED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
  Unknown = 'UNKNOWN'
}

export type CostBasisStatusSchema = {
  __typename?: 'CostBasisStatusSchema';
  priority?: Maybe<QueuePriority>;
  state?: Maybe<CostBasisState>;
};

/** An enumeration. */
export enum CostBasisTracking {
  Universal = 'UNIVERSAL',
  Wallet = 'WALLET'
}

export type CounterPartyAddressSchema = {
  __typename?: 'CounterPartyAddressSchema';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  organizationCounterPartyAddress?: Maybe<OrganizationCounterPartyAddress>;
};

export type Country = {
  __typename?: 'Country';
  canAccessTaxLossHarvesting?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CreateCustomWalletInput = {
  accountTypeSlug?: InputMaybe<Scalars['String']>;
  csvUrl: Scalars['String'];
  walletName: Scalars['String'];
};

export type CreateCustomWalletMutationSchema = {
  __typename?: 'CreateCustomWalletMutationSchema';
  error?: Maybe<CustomWalletMutationErrors>;
  jobId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateTransactionLink = {
  __typename?: 'CreateTransactionLink';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateTransactionMutationSchema = {
  __typename?: 'CreateTransactionMutationSchema';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateUserFeedbackMessage = {
  __typename?: 'CreateUserFeedbackMessage';
  success?: Maybe<Scalars['Boolean']>;
};

export type CryptoNetworkResult = {
  __typename?: 'CryptoNetworkResult';
  cryptoNetworkName?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  symbol?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CurrenciesConnection = {
  __typename?: 'CurrenciesConnection';
  edges?: Maybe<Array<Maybe<Currency>>>;
  totalCount: Scalars['Int'];
};

export type Currency = {
  __typename?: 'Currency';
  availableSupply?: Maybe<Scalars['Float']>;
  chat?: Maybe<Scalars['String']>;
  cmcId?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  cryptoNetwork?: Maybe<Scalars['String']>;
  formatSymbol?: Maybe<Scalars['String']>;
  forum?: Maybe<Scalars['String']>;
  iconUrlFromInfo?: Maybe<Scalars['String']>;
  intervalPriceHigh?: Maybe<Scalars['Float']>;
  intervalPriceLow?: Maybe<Scalars['Float']>;
  isInWatchlist?: Maybe<Scalars['Boolean']>;
  marketCap?: Maybe<Scalars['Float']>;
  marketCapUsd?: Maybe<Scalars['Float']>;
  marketDominance?: Maybe<Scalars['Float']>;
  maxSupply?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  nameOrSymbol?: Maybe<Scalars['String']>;
  percentChange7d?: Maybe<Scalars['Float']>;
  percentChange24h?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceHigh?: Maybe<Scalars['Float']>;
  priceHighDate?: Maybe<Scalars['String']>;
  priceHistory?: Maybe<Array<Maybe<CurrencyPriceHistory>>>;
  priceHistoryUsd?: Maybe<Array<Maybe<CurrencyPriceHistory>>>;
  priceLow?: Maybe<Scalars['Float']>;
  priceLowDate?: Maybe<Scalars['String']>;
  priceUsd?: Maybe<Scalars['Float']>;
  reddit?: Maybe<Scalars['String']>;
  similarCurrencies?: Maybe<Array<Maybe<SearchCurrency>>>;
  slug?: Maybe<Scalars['String']>;
  /** @deprecated No longer supported. Please don't use this field. */
  sparklines?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  type?: Maybe<CurrencyType>;
  uaid?: Maybe<Scalars['String']>;
  volume24h?: Maybe<Scalars['Float']>;
  volume24hUsd?: Maybe<Scalars['Float']>;
  website?: Maybe<Scalars['String']>;
  whitepaper?: Maybe<Scalars['String']>;
};


export type CurrencyIntervalPriceHighArgs = {
  timeSpan?: InputMaybe<PerformanceDuration>;
};


export type CurrencyIntervalPriceLowArgs = {
  timeSpan?: InputMaybe<PerformanceDuration>;
};


export type CurrencyPriceHistoryArgs = {
  maxDays?: InputMaybe<Scalars['Int']>;
  timeSpan?: InputMaybe<PerformanceDuration>;
};


export type CurrencyPriceHistoryUsdArgs = {
  timeSpan?: InputMaybe<PerformanceDuration>;
};

/** An enumeration. */
export enum CurrencyIdTypeEnum {
  CryptoCurrency = 'CRYPTO_CURRENCY',
  Fiat = 'FIAT',
  UserAsset = 'USER_ASSET'
}

export type CurrencyInput = {
  availableSupply?: InputMaybe<Scalars['Float']>;
  chat?: InputMaybe<Scalars['String']>;
  cmcId?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  cryptoNetwork?: InputMaybe<Scalars['String']>;
  formatSymbol?: InputMaybe<Scalars['String']>;
  forum?: InputMaybe<Scalars['String']>;
  iconUrlFromInfo?: InputMaybe<Scalars['String']>;
  intervalPriceHigh?: InputMaybe<Scalars['Float']>;
  intervalPriceLow?: InputMaybe<Scalars['Float']>;
  isInWatchlist?: InputMaybe<Scalars['Boolean']>;
  marketCap?: InputMaybe<Scalars['Float']>;
  marketCapUsd?: InputMaybe<Scalars['Float']>;
  marketDominance?: InputMaybe<Scalars['Float']>;
  maxSupply?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  nameOrSymbol?: InputMaybe<Scalars['String']>;
  percentChange7d?: InputMaybe<Scalars['Float']>;
  percentChange24h?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  priceHigh?: InputMaybe<Scalars['Float']>;
  priceHighDate?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<Array<InputMaybe<CurrencyPriceHistoryInput>>>;
  priceLow?: InputMaybe<Scalars['Float']>;
  priceLowDate?: InputMaybe<Scalars['String']>;
  priceUsd?: InputMaybe<Scalars['Float']>;
  reddit?: InputMaybe<Scalars['String']>;
  similarCurrencies?: InputMaybe<Array<InputMaybe<SearchCurrencyInput>>>;
  slug?: InputMaybe<Scalars['String']>;
  summary?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CurrencyType>;
  uaid?: InputMaybe<Scalars['String']>;
  volume24h?: InputMaybe<Scalars['Float']>;
  volume24hUsd?: InputMaybe<Scalars['Float']>;
  website?: InputMaybe<Scalars['String']>;
  whitepaper?: InputMaybe<Scalars['String']>;
};

export type CurrencyPriceHistory = {
  __typename?: 'CurrencyPriceHistory';
  date?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['Float']>;
};

export type CurrencyPriceHistoryInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  price?: InputMaybe<Scalars['Float']>;
};

/** An enumeration. */
export enum CurrencyType {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT'
}

export type CustomWallet = {
  __typename?: 'CustomWallet';
  assetsCount?: Maybe<Scalars['Int']>;
  balances?: Maybe<Array<Maybe<Balance>>>;
  computedTransactionCount?: Maybe<Scalars['Int']>;
  hasTransactionsInFrozenPeriod?: Maybe<Scalars['Boolean']>;
  headerLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  instructions?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentAccountName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  supportedFileFormats?: Maybe<Array<Maybe<FileFormats>>>;
  syncInfo?: Maybe<SyncInfo>;
  syncMethod?: Maybe<Scalars['String']>;
  transactionLabel?: Maybe<Scalars['String']>;
  userAssetBalances?: Maybe<Array<Maybe<Balance>>>;
  value?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum CustomWalletMutationErrors {
  GenericError = 'generic_error',
  InvalidCsvUrl = 'invalid_csv_url',
  InvalidPublicId = 'invalid_public_id',
  InvalidWalletName = 'invalid_wallet_name',
  NoWalletFound = 'no_wallet_found'
}

export type DeleteAllSpecificIdRuleMutationSchema = {
  __typename?: 'DeleteAllSpecificIdRuleMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteCustomWalletMutationSchema = {
  __typename?: 'DeleteCustomWalletMutationSchema';
  error?: Maybe<GenericWalletErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteExchangeMutationSchema = {
  __typename?: 'DeleteExchangeMutationSchema';
  error?: Maybe<ExchangeDeleteErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFirmInviteMutationSchema = {
  __typename?: 'DeleteFirmInviteMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteFirmMemberMutationSchema = {
  __typename?: 'DeleteFirmMemberMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLendingUserSettingsMutationSchema = {
  __typename?: 'DeleteLendingUserSettingsMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLiquidSettingUserSettingsMutationSchema = {
  __typename?: 'DeleteLiquidSettingUserSettingsMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLiquidityUserSettingsMutationSchema = {
  __typename?: 'DeleteLiquidityUserSettingsMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteManualTransactionsMutationSchema = {
  __typename?: 'DeleteManualTransactionsMutationSchema';
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  successes?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type DeleteSpecificIdRuleMutationSchema = {
  __typename?: 'DeleteSpecificIdRuleMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStakingRewardsUserSettingsMutationSchema = {
  __typename?: 'DeleteStakingRewardsUserSettingsMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteTaxProClientInviteMutationSchema = {
  __typename?: 'DeleteTaxProClientInviteMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteTaxProClientMutationSchema = {
  __typename?: 'DeleteTaxProClientMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteUserMutationSchema = {
  __typename?: 'DeleteUserMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteWalletMutationSchema = {
  __typename?: 'DeleteWalletMutationSchema';
  error?: Maybe<GenericWalletErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteWrappingUserSettingsMutationSchema = {
  __typename?: 'DeleteWrappingUserSettingsMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DepositInformation = {
  __typename?: 'DepositInformation';
  hasDepositInformation?: Maybe<Scalars['Boolean']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type DepositOverrideHistory = {
  __typename?: 'DepositOverrideHistory';
  history?: Maybe<Scalars['JSONString']>;
};

export type DepositOverrides = {
  __typename?: 'DepositOverrides';
  acquisitionLogs: Array<Maybe<AcquisitionLogType>>;
  costBasis: Scalars['Decimal'];
  dateAcquired: Scalars['DateTime'];
  flowId: Scalars['String'];
  quantity: Scalars['Decimal'];
  sourceType: Scalars['String'];
};

/** The type of discount applied to the price */
export enum DiscountType {
  CartAbandonmentTaxDay = 'CART_ABANDONMENT_TAX_DAY',
  CoinbaseOneCredit = 'COINBASE_ONE_CREDIT',
  EarlyBird = 'EARLY_BIRD',
  Partner = 'PARTNER',
  PortfolioSubscribers = 'PORTFOLIO_SUBSCRIBERS',
  Prime_20PurchasersLookalike = 'PRIME_20_PURCHASERS_LOOKALIKE',
  TaxPro = 'TAX_PRO',
  UserReferral = 'USER_REFERRAL',
  WelcomeBack = 'WELCOME_BACK'
}

export type DisplayUser = {
  __typename?: 'DisplayUser';
  baseCurrency?: Maybe<Currency>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']>;
  hasDefi?: Maybe<Scalars['Boolean']>;
  hasUnified?: Maybe<Scalars['Boolean']>;
  isWhitelisted?: Maybe<Scalars['Boolean']>;
  publicId?: Maybe<Scalars['String']>;
  registeredAsTaxPro?: Maybe<Scalars['Boolean']>;
  taxYearToUse?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DisplayedBalances {
  Calculated = 'CALCULATED',
  Reported = 'REPORTED'
}

export type DisposedLotData = {
  __typename?: 'DisposedLotData';
  adjustedAmountRealized: Scalars['Decimal'];
  adjustedCostBasis: Scalars['Decimal'];
  assetName: Scalars['String'];
  coveredState: Scalars['String'];
  dateAcquired: Scalars['DateTime'];
  dateSold: Scalars['DateTime'];
  flowId: Scalars['String'];
  gainLoss: Scalars['Decimal'];
  holdingPeriod: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
};

export type DisposedLotNodeData = {
  __typename?: 'DisposedLotNodeData';
  adjustedAmountRealized: Scalars['Decimal'];
  adjustedCostBasis: Scalars['Decimal'];
  assetName: Scalars['String'];
  coveredState: Scalars['String'];
  dateAcquired: Scalars['DateTime'];
  dateSold: Scalars['DateTime'];
  gainLoss: Scalars['Decimal'];
  id: Scalars['String'];
  price: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  taxEvent: Scalars['String'];
  txQueryLinkId: Scalars['String'];
};

export type EdgeData = {
  __typename?: 'EdgeData';
  edgeEvent: Scalars['String'];
  sourceNodeId: Scalars['String'];
  targetNodeId: Scalars['String'];
};

export type EditAssetMutation = {
  __typename?: 'EditAssetMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum EnqueueCostBasisJobErrors {
  AcquireLockFailed = 'acquire_lock_failed',
  BlockedFromEnqueuing = 'blocked_from_enqueuing',
  MaxRetriesReached = 'max_retries_reached',
  UnknownError = 'unknown_error'
}

export type EnqueueCostBasisJobMutationSchema = {
  __typename?: 'EnqueueCostBasisJobMutationSchema';
  error?: Maybe<EnqueueCostBasisJobErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type EnqueueExchangeForSyncMutation = {
  __typename?: 'EnqueueExchangeForSyncMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type EnqueueLocalWalletForSyncMutation = {
  __typename?: 'EnqueueLocalWalletForSyncMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type EntryCostBasisSchema = {
  __typename?: 'EntryCostBasisSchema';
  callouts?: Maybe<Array<Maybe<GrapheneCallout>>>;
  currentCostBasis?: Maybe<Scalars['PositiveFloat']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  originalCostBasis?: Maybe<Scalars['PositiveFloat']>;
  quantity?: Maybe<Scalars['PositiveFloat']>;
  symbol?: Maybe<Scalars['String']>;
};

export type EntryProceedsSchema = {
  __typename?: 'EntryProceedsSchema';
  callouts?: Maybe<Array<Maybe<GrapheneCallout>>>;
  currentProceeds?: Maybe<Scalars['PositiveFloat']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  originalProceeds?: Maybe<Scalars['PositiveFloat']>;
  quantity?: Maybe<Scalars['PositiveFloat']>;
  symbol?: Maybe<Scalars['String']>;
};

export type EntryV2 = {
  __typename?: 'EntryV2';
  amount?: Maybe<Scalars['Float']>;
  balanceAfter?: Maybe<Scalars['Float']>;
  baseCurrencyPrice?: Maybe<Scalars['PositiveFloat']>;
  callouts?: Maybe<Array<Maybe<GrapheneCallout>>>;
  canMarkAssetAsSpam?: Maybe<Scalars['Boolean']>;
  comments?: Maybe<Array<Maybe<Scalars['String']>>>;
  costBasis?: Maybe<Scalars['Float']>;
  currencyId?: Maybe<Scalars['ID']>;
  currencyIdType?: Maybe<CurrencyIdTypeEnum>;
  fee?: Maybe<Fee>;
  feeCurrencyId?: Maybe<Scalars['ID']>;
  feeCurrencyIdType?: Maybe<CurrencyIdTypeEnum>;
  fiatValue?: Maybe<Scalars['Float']>;
  hasCustomCostBasis?: Maybe<Scalars['Boolean']>;
  hasCustomProceeds?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  isIgnored?: Maybe<Scalars['Boolean']>;
  isMarginTrade?: Maybe<Scalars['Boolean']>;
  isNft?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  perCoinValue?: Maybe<Scalars['Float']>;
  proceeds?: Maybe<Scalars['Float']>;
  profitOrLoss?: Maybe<Scalars['Float']>;
  publicId?: Maybe<Scalars['String']>;
  relatedEntrySymbol?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  transactionHash?: Maybe<Scalars['String']>;
  transactionUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uaid?: Maybe<Scalars['String']>;
};

export type EntryV2Input = {
  amount?: InputMaybe<Scalars['Float']>;
  balanceAfter?: InputMaybe<Scalars['Float']>;
  canMarkAssetAsSpam?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  costBasis?: InputMaybe<Scalars['Float']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  currencyIdType?: InputMaybe<CurrencyIdTypeEnum>;
  fee?: InputMaybe<FeeInput>;
  feeCurrencyId?: InputMaybe<Scalars['ID']>;
  feeCurrencyIdType?: InputMaybe<CurrencyIdTypeEnum>;
  fiatValue?: InputMaybe<Scalars['Float']>;
  hasCustomCostBasis?: InputMaybe<Scalars['Boolean']>;
  hasCustomProceeds?: InputMaybe<Scalars['Boolean']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  isIgnored?: InputMaybe<Scalars['Boolean']>;
  isMarginTrade?: InputMaybe<Scalars['Boolean']>;
  isNft?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  perCoinValue?: InputMaybe<Scalars['Float']>;
  proceeds?: InputMaybe<Scalars['Float']>;
  profitOrLoss?: InputMaybe<Scalars['Float']>;
  publicId?: InputMaybe<Scalars['String']>;
  relatedEntrySymbol?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  transactionHash?: InputMaybe<Scalars['String']>;
  transactionUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uaid?: InputMaybe<Scalars['String']>;
};

export type EntryView = {
  __typename?: 'EntryView';
  costBasis?: Maybe<EntryCostBasisSchema>;
  proceeds?: Maybe<EntryProceedsSchema>;
  publicId?: Maybe<Scalars['ID']>;
};

export type Exchange = {
  __typename?: 'Exchange';
  allowsHardResync?: Maybe<Scalars['Boolean']>;
  allowsTradeImports?: Maybe<Scalars['Boolean']>;
  allowsTransactionHistoryImports?: Maybe<Scalars['Boolean']>;
  allowsTransactionImports?: Maybe<Scalars['Boolean']>;
  allowsTransferImports?: Maybe<Scalars['Boolean']>;
  assetsCount?: Maybe<Scalars['Int']>;
  calculatedValue?: Maybe<Scalars['Float']>;
  defaultName?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  formId?: Maybe<IntegrationFormType>;
  hasIgnoredTransactionsInFrozenPeriod?: Maybe<Scalars['Boolean']>;
  hasTransactionsInFrozenPeriod?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isCoinbaseBusinessAccount?: Maybe<Scalars['Boolean']>;
  isPortfolioValueDifferenceSignificant?: Maybe<Scalars['Boolean']>;
  mobileOauthAuthorize?: Maybe<OAuthAuthorize>;
  name?: Maybe<Scalars['String']>;
  shouldBeRemoved?: Maybe<Scalars['Boolean']>;
  showDeprecationWarning?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  supportedFileFormats?: Maybe<Array<Maybe<FileFormats>>>;
  syncInfo?: Maybe<SyncInfo>;
  syncMethod?: Maybe<Scalars['String']>;
  syncProgress?: Maybe<SyncProgress>;
  type?: Maybe<AccountType>;
  value?: Maybe<Scalars['Float']>;
  wallets?: Maybe<Array<Maybe<Wallet>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum ExchangeDeleteErrors {
  ExchangeCantBeDeleted = 'exchange_cant_be_deleted',
  ExchangeHasTransactionsInFrozenPeriod = 'exchange_has_transactions_in_frozen_period',
  ExchangeNotFound = 'exchange_not_found'
}

export type ExchangeFundsInfo = {
  __typename?: 'ExchangeFundsInfo';
  percent?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum ExchangeMigrateErrors {
  ExchangeCannotBeMigrated = 'exchange_cannot_be_migrated',
  ExchangeNotFound = 'exchange_not_found'
}

/** An enumeration. */
export enum ExchangeMutationErrors {
  AccountAlreadyLinked = 'account_already_linked',
  AccountNotFound = 'account_not_found',
  AccountTypeSlugNotFound = 'account_type_slug_not_found',
  CoinbaseAccountAlreadyAdded = 'coinbase_account_already_added',
  ErrorWithPartnerConnection = 'error_with_partner_connection',
  GenericError = 'generic_error',
  InvalidAccount = 'invalid_account',
  InvalidAccountTypeSlug = 'invalid_account_type_slug',
  InvalidApiKey = 'invalid_api_key',
  InvalidApiSecret = 'invalid_api_secret',
  InvalidCode = 'invalid_code',
  InvalidCustomerId = 'invalid_customer_id',
  InvalidFileUrl = 'invalid_file_url',
  InvalidImportType = 'invalid_import_type',
  InvalidPassphrase = 'invalid_passphrase',
  InvalidPublicId = 'invalid_public_id',
  InvalidRedirectUri = 'invalid_redirect_uri',
  NotSupportedAccountForOauth = 'not_supported_account_for_oauth'
}

/** An enumeration. */
export enum ExchangeRenameErrors {
  ExchangeNotFound = 'exchange_not_found',
  MissingName = 'missing_name'
}

export type ExchangeTaxData = {
  __typename?: 'ExchangeTaxData';
  customerSpecificField1dDateAcquired: Scalars['String'];
  customerSpecificField1gCostBasis: Scalars['String'];
  customerSpecificField6aGainOrLoss: Scalars['String'];
  field1aCodeOfDa: Scalars['String'];
  field1bNameOfDa: Scalars['String'];
  field1cNumberOfUnits: Scalars['String'];
  field1dDateAcquired: Scalars['String'];
  field1eDateSold: Scalars['String'];
  field1fProceeds: Scalars['String'];
  field1gCostBasis: Scalars['String'];
  field2BasisReported: Scalars['String'];
  field3aReportedToTheIrs: Scalars['String'];
  field4FederalIncomeTaxWithheld: Scalars['String'];
  field6aGainOrLoss: Scalars['String'];
  field6bShortTerm: Scalars['Boolean'];
  field6cLongTerm: Scalars['Boolean'];
  field6dOrdinary: Scalars['Boolean'];
  field7CashOnly: Scalars['Boolean'];
  field8ReliedOnCustomerInfo: Scalars['Boolean'];
  field9Noncovered: Scalars['Boolean'];
  field11aGpAggregate: Scalars['String'];
  field11bNumberOfTxs: Scalars['String'];
  field11cSnftsFirstSale: Scalars['String'];
  field12aNumberOfUnitsTransferredIn: Scalars['String'];
  field12bTransferInDate: Scalars['String'];
  field14StateName: Scalars['String'];
  field15StateId: Scalars['String'];
  field16StateTaxWithheld: Scalars['String'];
  field8949Code: Scalars['String'];
  txId: Scalars['String'];
  userId: Scalars['String'];
};

/** An enumeration. */
export enum ExtendedTransactionType {
  AddLiquidity = 'ADD_LIQUIDITY',
  Airdrop = 'AIRDROP',
  Borrow = 'BORROW',
  Bridge = 'BRIDGE',
  Buy = 'BUY',
  CloseOrder = 'CLOSE_ORDER',
  Deposit = 'DEPOSIT',
  Donation = 'DONATION',
  Fork = 'FORK',
  Gift = 'GIFT',
  Income = 'INCOME',
  InflationReward = 'INFLATION_REWARD',
  InterestExpense = 'INTEREST_EXPENSE',
  InterestPayment = 'INTEREST_PAYMENT',
  LendingDeposit = 'LENDING_DEPOSIT',
  LendingWithdrawal = 'LENDING_WITHDRAWAL',
  LoanRepayment = 'LOAN_REPAYMENT',
  Lost = 'LOST',
  Margin = 'MARGIN',
  MarginFee = 'MARGIN_FEE',
  MarginGain = 'MARGIN_GAIN',
  MarginLoss = 'MARGIN_LOSS',
  MarginRebate = 'MARGIN_REBATE',
  MarginSettle = 'MARGIN_SETTLE',
  Mined = 'MINED',
  Mint = 'MINT',
  MultiTokenTrade = 'MULTI_TOKEN_TRADE',
  OpenOrder = 'OPEN_ORDER',
  OtherIncome = 'OTHER_INCOME',
  Rebate = 'REBATE',
  Receive = 'RECEIVE',
  RemoveLiquidity = 'REMOVE_LIQUIDITY',
  Royalty = 'ROYALTY',
  Sell = 'SELL',
  Send = 'SEND',
  Service = 'SERVICE',
  Spam = 'SPAM',
  Stake = 'STAKE',
  StakingReward = 'STAKING_REWARD',
  Trade = 'TRADE',
  Transfer = 'TRANSFER',
  Unstake = 'UNSTAKE',
  Withdrawal = 'WITHDRAWAL',
  Wrap = 'WRAP'
}

export type ExtraParam = {
  __typename?: 'ExtraParam';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Fee = {
  __typename?: 'Fee';
  amount?: Maybe<Scalars['Float']>;
  baseCurrencyPrice?: Maybe<Scalars['PositiveFloat']>;
  callouts?: Maybe<Array<Maybe<GrapheneCallout>>>;
  costBasis?: Maybe<Scalars['Float']>;
  fiatValue?: Maybe<Scalars['Float']>;
  iconUrl?: Maybe<Scalars['String']>;
  profitOrLoss?: Maybe<Scalars['Float']>;
  symbol?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uaid?: Maybe<Scalars['String']>;
};

export type FeeInput = {
  amount?: InputMaybe<Scalars['Float']>;
  costBasis?: InputMaybe<Scalars['Float']>;
  fiatValue?: InputMaybe<Scalars['Float']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  profitOrLoss?: InputMaybe<Scalars['Float']>;
  symbol?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uaid?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum FileFormats {
  Csv = 'CSV',
  Xls = 'XLS',
  Xlsx = 'XLSX',
  Zip = 'ZIP'
}

export type FixApiCredentialsTask = TaskInterface & {
  __typename?: 'FixApiCredentialsTask';
  createdAt: Scalars['DateTime'];
  exchange: Exchange;
  id: Scalars['UUID'];
  status: TaskStatus;
  updatedAt: Scalars['DateTime'];
};

/** Schema for a single flow */
export type Flow = {
  __typename?: 'Flow';
  amount?: Maybe<Scalars['Decimal']>;
  asset?: Maybe<UniversalAsset>;
  callouts?: Maybe<Array<Maybe<GrapheneCallout>>>;
  counterPartyAddress?: Maybe<CounterPartyAddressSchema>;
  direction?: Maybe<FlowDirection>;
  fiatValue?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  isIgnored?: Maybe<Scalars['Boolean']>;
  isImported?: Maybe<Scalars['Boolean']>;
  isManual?: Maybe<Scalars['Boolean']>;
  lotSummary?: Maybe<LotsSummary>;
  notes?: Maybe<FlowNotes>;
  organizationCounterPartyAddress?: Maybe<OrganizationCounterPartyAddress>;
  uaid?: Maybe<Scalars['String']>;
  walletInfo?: Maybe<TransactionWalletInfo>;
  walletUri?: Maybe<Scalars['String']>;
};

/** Schema for the flow direction */
export enum FlowDirection {
  Inflow = 'INFLOW',
  Outflow = 'OUTFLOW'
}

/** Schema for the flow notes and comments */
export type FlowNotes = {
  __typename?: 'FlowNotes';
  comment?: Maybe<Scalars['String']>;
  destinationAddress?: Maybe<Scalars['String']>;
  sourceAddress?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type FormFieldInfo = {
  __typename?: 'FormFieldInfo';
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FreezeUserMutationSchema = {
  __typename?: 'FreezeUserMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum FrontendOperationPurpose {
  AddLiquidity = 'ADD_LIQUIDITY',
  Airdrop = 'AIRDROP',
  Borrow = 'BORROW',
  Buy = 'BUY',
  CloseOrder = 'CLOSE_ORDER',
  CollectRewards = 'COLLECT_REWARDS',
  Deposit = 'DEPOSIT',
  Donation = 'DONATION',
  Fee = 'FEE',
  FeeBlockchainFee = 'FEE__BLOCKCHAIN_FEE',
  FeeExchangeFee = 'FEE__EXCHANGE_FEE',
  FeeMarginFee = 'FEE__MARGIN_FEE',
  HardFork = 'HARD_FORK',
  InterestExpense = 'INTEREST_EXPENSE',
  InterestIncome = 'INTEREST_INCOME',
  Liquidated = 'LIQUIDATED',
  LoanRepayment = 'LOAN_REPAYMENT',
  LoanRepaymentMargin = 'LOAN_REPAYMENT__MARGIN',
  Lost = 'LOST',
  Margin = 'MARGIN',
  MarginGain = 'MARGIN_GAIN',
  MarginLoss = 'MARGIN_LOSS',
  MarginRebate = 'MARGIN_REBATE',
  MarginReward = 'MARGIN_REWARD',
  MarginSettle = 'MARGIN_SETTLE',
  MiningReward = 'MINING_REWARD',
  OpenOrder = 'OPEN_ORDER',
  OtherIncome = 'OTHER_INCOME',
  Payment = 'PAYMENT',
  Rebate = 'REBATE',
  Receive = 'RECEIVE',
  ReceiveBridge = 'RECEIVE_BRIDGE',
  ReceiveGift = 'RECEIVE_GIFT',
  ReceiveLendingDeposit = 'RECEIVE_LENDING_DEPOSIT',
  ReceiveLendingWithdrawal = 'RECEIVE_LENDING_WITHDRAWAL',
  ReceiveMint = 'RECEIVE_MINT',
  RemoveLiquidity = 'REMOVE_LIQUIDITY',
  Royalty = 'ROYALTY',
  Sell = 'SELL',
  Send = 'SEND',
  SendBridge = 'SEND_BRIDGE',
  SendGift = 'SEND_GIFT',
  SendLendingDeposit = 'SEND_LENDING_DEPOSIT',
  SendLendingWithdrawal = 'SEND_LENDING_WITHDRAWAL',
  Service = 'SERVICE',
  Stake = 'STAKE',
  StakingReward = 'STAKING_REWARD',
  Stolen = 'STOLEN',
  Trade = 'TRADE',
  TradeLendingDeposit = 'TRADE_LENDING_DEPOSIT',
  TradeLendingWithdrawal = 'TRADE_LENDING_WITHDRAWAL',
  TradeMint = 'TRADE_MINT',
  TradeStake = 'TRADE_STAKE',
  TradeUnstake = 'TRADE_UNSTAKE',
  Unstake = 'UNSTAKE',
  Unwrap = 'UNWRAP',
  Withdrawal = 'WITHDRAWAL',
  Wrap = 'WRAP'
}

export type GenerateCelloTokenSchema = {
  __typename?: 'GenerateCelloTokenSchema';
  celloToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GenerateCoinbaseOneCredit = {
  __typename?: 'GenerateCoinbaseOneCredit';
  coinbaseOneCreditStatus: CoinbaseOneCreditStatusOutput;
};

export type GenerateCoinbaseOneCreditInput = {
  code?: InputMaybe<Scalars['String']>;
};

/** Generates CSVs for tax lots. */
export type GenerateTaxLotsCsv = {
  __typename?: 'GenerateTaxLotsCsv';
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<GenerateTaxLotsCsvResult>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum GenerateTaxLotsCsvResult {
  CostBasisFailed = 'cost_basis_failed',
  CostBasisInProcess = 'cost_basis_in_process',
  InsufficientPlan = 'insufficient_plan',
  InsufficientTaxPlan = 'insufficient_tax_plan',
  Success = 'success',
  Unauthorized = 'unauthorized'
}

export type GenerateTaxReport = {
  __typename?: 'GenerateTaxReport';
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<GenerateTaxReportResult>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum GenerateTaxReportResult {
  CostBasisFailed = 'cost_basis_failed',
  CostBasisInProcess = 'cost_basis_in_process',
  InsufficientTaxPlan = 'insufficient_tax_plan',
  InvalidReportType = 'invalid_report_type',
  Success = 'success',
  Unauthorized = 'unauthorized'
}

/** An enumeration. */
export enum GenericWalletErrors {
  WalletHasSyncedJournalEntries = 'wallet_has_synced_journal_entries',
  WalletHasTransactionsInFrozenPeriod = 'wallet_has_transactions_in_frozen_period',
  WalletNotFound = 'wallet_not_found'
}

export type GraphData = {
  __typename?: 'GraphData';
  availableLotNodes?: Maybe<Array<Maybe<AvailableLotNodeData>>>;
  disposedLotNodes?: Maybe<Array<Maybe<DisposedLotNodeData>>>;
  edges?: Maybe<Array<Maybe<EdgeData>>>;
};

export type GrapheneCallout = {
  __typename?: 'GrapheneCallout';
  quantityRequested?: Maybe<Scalars['Decimal']>;
  reviewActionUrl?: Maybe<Scalars['String']>;
  severity?: Maybe<CalloutSeverity>;
  type?: Maybe<CalloutType>;
};

export type IgnoreTokenTransactionsAndReportAsSpamMutation = {
  __typename?: 'IgnoreTokenTransactionsAndReportAsSpamMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type ImportCustomWalletTransactionsInput = {
  csvUrl: Scalars['String'];
  publicId: Scalars['String'];
};

export type ImportCustomWalletTransactionsMutationSchema = {
  __typename?: 'ImportCustomWalletTransactionsMutationSchema';
  error?: Maybe<CustomWalletMutationErrors>;
  jobId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ImportExchangeTransactionsInput = {
  fileUrl: Scalars['String'];
  importType?: InputMaybe<Scalars['Int']>;
  publicId: Scalars['String'];
};

export type ImportExchangeTransactionsSchema = {
  __typename?: 'ImportExchangeTransactionsSchema';
  error?: Maybe<ExchangeMutationErrors>;
  jobId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Info = {
  __typename?: 'Info';
  circleIconUrl?: Maybe<Scalars['String']>;
  cryptoNetwork?: Maybe<Scalars['String']>;
  csvIntegrationCoverageInfo?: Maybe<Scalars['String']>;
  hideInstructions?: Maybe<Scalars['Boolean']>;
  isEvmChain?: Maybe<Scalars['Boolean']>;
  isInstitutional?: Maybe<Scalars['Boolean']>;
  supportedCryptoNetworks?: Maybe<Array<Maybe<Scalars['String']>>>;
  supportedFileFormats?: Maybe<Array<Maybe<FileFormats>>>;
  symbol?: Maybe<Scalars['String']>;
  syncIntegrationCoverageInfo?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum InsufficientPlanReason {
  ExceededLifetimeTransactionLimit = 'EXCEEDED_LIFETIME_TRANSACTION_LIMIT',
  ExceededTransactionLimit = 'EXCEEDED_TRANSACTION_LIMIT',
  NeedsEarlyRenewal = 'NEEDS_EARLY_RENEWAL',
  NotAvailable = 'NOT_AVAILABLE',
  NoReportsInFreePlan = 'NO_REPORTS_IN_FREE_PLAN',
  PastDue = 'PAST_DUE',
  TaxYearNotAvailable = 'TAX_YEAR_NOT_AVAILABLE'
}

export type Integration = {
  __typename?: 'Integration';
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  formId?: Maybe<IntegrationFormType>;
  imageUrl?: Maybe<Scalars['String']>;
  info?: Maybe<Info>;
  instructions?: Maybe<Scalars['String']>;
  isDisabled?: Maybe<Scalars['Boolean']>;
  mobileOauthAuthorize?: Maybe<OAuthAuthorize>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  supportsHdWallet?: Maybe<Scalars['Boolean']>;
  syncMethod?: Maybe<Scalars['String']>;
  webOauthAuthorize?: Maybe<OAuthAuthorize>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum IntegrationFormType {
  Address = 'address',
  ApiKey = 'api_key',
  Coinbase = 'coinbase',
  Coinjar = 'coinjar',
  Csv = 'csv',
  CustomerId = 'customer_id',
  MultiAddress = 'multi_address',
  Passphrase = 'passphrase',
  Public = 'public',
  PublicXpub = 'public_xpub',
  TokenDevice = 'token_device',
  TwoXpub = 'two_xpub',
  UnknownType = 'unknown_type',
  Uphold = 'uphold',
  Xpub = 'xpub'
}

export type InviteProToFirmMutationSchema = {
  __typename?: 'InviteProToFirmMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type InviteTaxProClientMutationSchema = {
  __typename?: 'InviteTaxProClientMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

/** The Status of Job within its lifecycle at any given time. */
export enum JobStatus {
  Canceled = 'CANCELED',
  Deferred = 'DEFERRED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Queued = 'QUEUED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED',
  Stopped = 'STOPPED'
}

/** The current user leaves the Tax Firm. Throws an error if the firm doesn't exist or the user doesn't belong to the firm. */
export type LeaveFirmMutationSchema = {
  __typename?: 'LeaveFirmMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum LotAllocationMethod {
  Hcfi = 'HCFI',
  Hcli = 'HCLI'
}

export type LotImporterMutationSchema = {
  __typename?: 'LotImporterMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type LotImporterStatusSchema = {
  __typename?: 'LotImporterStatusSchema';
  jobStatus?: Maybe<JobStatus>;
};

export type LotsSummary = {
  __typename?: 'LotsSummary';
  costBasis?: Maybe<Scalars['Decimal']>;
  proceeds?: Maybe<Scalars['Decimal']>;
  profitOrLoss?: Maybe<Scalars['Decimal']>;
};

export type MakeTransferMutationSchema = {
  __typename?: 'MakeTransferMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MarketInfo = {
  __typename?: 'MarketInfo';
  bitcoinPercentageOfMarketCap?: Maybe<Scalars['Float']>;
  ethereumPercentageOfMarketCap?: Maybe<Scalars['Float']>;
  pricesLastUpdated?: Maybe<Scalars['DateTime']>;
  totalMarketCapUsd?: Maybe<Scalars['Float']>;
  totalVolume24hUsd?: Maybe<Scalars['Float']>;
};

export type MfaHookAuth0Schema = {
  __typename?: 'MfaHookAuth0Schema';
  success?: Maybe<Scalars['Boolean']>;
};

export type MigrateExchangeMutationSchema = {
  __typename?: 'MigrateExchangeMutationSchema';
  error?: Maybe<ExchangeMigrateErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Minimum client version, used by client to check whether it's outdated. */
export type MinimumClientVersion = {
  __typename?: 'MinimumClientVersion';
  android: Scalars['String'];
  ios: Scalars['String'];
};

export type MultiAddressImportJobStatus = {
  __typename?: 'MultiAddressImportJobStatus';
  createdWallets?: Maybe<Array<Maybe<Wallet>>>;
  error?: Maybe<MultiAddressImportJobStatusError>;
  errorMessage?: Maybe<Scalars['String']>;
  isStatusFinal?: Maybe<Scalars['Boolean']>;
  status?: Maybe<JobStatus>;
  success?: Maybe<Scalars['Boolean']>;
  successMessage?: Maybe<Scalars['String']>;
  warningMessage?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum MultiAddressImportJobStatusError {
  FailedToImportAllAddresses = 'failed_to_import_all_addresses',
  FailedToImportMultiAddressWallet = 'failed_to_import_multi_address_wallet',
  FailedToImportSomeAddresses = 'failed_to_import_some_addresses',
  UnknownJobId = 'unknown_job_id'
}

export type Mutations = {
  __typename?: 'Mutations';
  acceptFirmInvite?: Maybe<AcceptFirmInviteMutationSchema>;
  acceptTaxProClientInvite?: Maybe<AcceptTaxProClientInviteMutationSchema>;
  addAsset?: Maybe<AddAssetMutation>;
  addCbeDeposit?: Maybe<AddCbeDeposit>;
  addCbeDisposal?: Maybe<AddCbeDisposal>;
  addDepositOverride?: Maybe<AddDepositOverrideMutationSchema>;
  addExchangeWithApiKey?: Maybe<AddExchangeWithApiKeyMutationSchema>;
  addExchangeWithApiKeyAndSecret?: Maybe<AddExchangeWithApiKeyAndSecretMutationSchema>;
  addExchangeWithCustomerId?: Maybe<AddExchangeWithCustomerIdMutationSchema>;
  addExchangeWithOauth?: Maybe<AddExchangeWithOauthCodeMutationSchema>;
  addExchangeWithPassphrase?: Maybe<AddExchangeWithPassphraseMutationSchema>;
  addFirmAdmin?: Maybe<AddFirmAdminMutationSchema>;
  addMultiAddress?: Maybe<AddMultiAddressMutationSchema>;
  addPublicAddress?: Maybe<AddPublicAddressMutationSchema>;
  addPublicXpub?: Maybe<AddPublicXpubMutationSchema>;
  addSpecificIdRule?: Maybe<AddSpecificIdRuleMutationSchema>;
  addTwoXpub?: Maybe<AddTwoXpubMutationSchema>;
  adminAddTaxProForClient?: Maybe<AdminAddTaxProForClient>;
  adminRemoveTaxProForClient?: Maybe<AdminRemoveTaxProForClient>;
  bulkUpdateTransactionAsset?: Maybe<BulkUpdateTransactionAsset>;
  confirmOnboardingSettings?: Maybe<OnboardingConfirmSettingsMutation>;
  createCustomWallet?: Maybe<CreateCustomWalletMutationSchema>;
  createTransaction?: Maybe<CreateTransactionMutationSchema>;
  createTransactionLink?: Maybe<CreateTransactionLink>;
  createUserFeedbackMessage?: Maybe<CreateUserFeedbackMessage>;
  deleteAllSpecificIdRule?: Maybe<DeleteAllSpecificIdRuleMutationSchema>;
  deleteCustomWallet?: Maybe<DeleteCustomWalletMutationSchema>;
  deleteExchange?: Maybe<DeleteExchangeMutationSchema>;
  deleteFirmInvite?: Maybe<DeleteFirmInviteMutationSchema>;
  deleteFirmMember?: Maybe<DeleteFirmMemberMutationSchema>;
  deleteLendingUserSettings?: Maybe<DeleteLendingUserSettingsMutationSchema>;
  deleteLiquidStakingUserSettings?: Maybe<DeleteLiquidSettingUserSettingsMutationSchema>;
  deleteLiquidityUserSettings?: Maybe<DeleteLiquidityUserSettingsMutationSchema>;
  deleteManualTransactions?: Maybe<DeleteManualTransactionsMutationSchema>;
  deleteSpecificIdRule?: Maybe<DeleteSpecificIdRuleMutationSchema>;
  deleteStakingRewardsUserSettings?: Maybe<DeleteStakingRewardsUserSettingsMutationSchema>;
  deleteTaxProClient?: Maybe<DeleteTaxProClientMutationSchema>;
  deleteTaxProClientInvite?: Maybe<DeleteTaxProClientInviteMutationSchema>;
  deleteUser?: Maybe<DeleteUserMutationSchema>;
  deleteWallet?: Maybe<DeleteWalletMutationSchema>;
  deleteWrappingUserSettings?: Maybe<DeleteWrappingUserSettingsMutationSchema>;
  editAsset?: Maybe<EditAssetMutation>;
  /** Edit firm details if public id is provided, otherwise create a new firm */
  editFirm?: Maybe<TaxProsEditFirmMutationSchema>;
  enqueueCostBasis?: Maybe<EnqueueCostBasisJobMutationSchema>;
  enqueueExchangeForSync?: Maybe<EnqueueExchangeForSyncMutation>;
  enqueueLocalWalletForSync?: Maybe<EnqueueLocalWalletForSyncMutation>;
  freezeUser?: Maybe<FreezeUserMutationSchema>;
  generateCelloToken?: Maybe<GenerateCelloTokenSchema>;
  generateCoinbaseOneCredit?: Maybe<GenerateCoinbaseOneCredit>;
  /** Generates CSVs for tax lots. */
  generateTaxLotsCsv?: Maybe<GenerateTaxLotsCsv>;
  generateTaxReport?: Maybe<GenerateTaxReport>;
  ignoreTokenTransactionsAndReportAsSpam?: Maybe<IgnoreTokenTransactionsAndReportAsSpamMutation>;
  importCustomWalletTransactions?: Maybe<ImportCustomWalletTransactionsMutationSchema>;
  importExchangeTransactions?: Maybe<ImportExchangeTransactionsSchema>;
  importNft?: Maybe<NftImporterMutationSchema>;
  inviteProToFirm?: Maybe<InviteProToFirmMutationSchema>;
  inviteTaxProClient?: Maybe<InviteTaxProClientMutationSchema>;
  /** The current user leaves the Tax Firm. Throws an error if the firm doesn't exist or the user doesn't belong to the firm. */
  leaveFirm?: Maybe<LeaveFirmMutationSchema>;
  makeTransfer?: Maybe<MakeTransferMutationSchema>;
  mfaHookAuth0?: Maybe<MfaHookAuth0Schema>;
  migrateExchange?: Maybe<MigrateExchangeMutationSchema>;
  presignFileUpload?: Maybe<PresignFileUploadMutation>;
  registerAsTaxPro?: Maybe<RegisterAsTaxProMutationSchema>;
  removeTransactionLink?: Maybe<RemoveTransactionLink>;
  renameCustomWallet?: Maybe<RenameCustomWalletMutationSchema>;
  renameExchange?: Maybe<RenameExchangeMutationSchema>;
  renameWallet?: Maybe<RenameWalletMutationSchema>;
  reportSpam?: Maybe<ReportSpamMutationSchema>;
  /** Mutation to request tax recalculation for a user */
  requestTaxRecalculation?: Maybe<RequestTaxRecalculation>;
  resetCbeUser?: Maybe<ResetCbeUser>;
  resetUserPassword?: Maybe<ResetUserPasswordMutationSchema>;
  resyncAllWalletsAndAccounts?: Maybe<ResyncAllWalletsAndAccountsSchema>;
  savePushToken?: Maybe<SavePushToken>;
  setMiningStatus?: Maybe<SetMiningStatusMutationSchema>;
  setSelectedPerformanceMode?: Maybe<SetSelectedPerformanceMode>;
  startUniversalToPerWalletMigration?: Maybe<StartUniversalToPerWalletMigrationMutationSchema>;
  submitLotsFile?: Maybe<LotImporterMutationSchema>;
  submitUserEmailChangeRequest?: Maybe<SubmitUserEmailChangeMutationResult>;
  syncCtDeposits?: Maybe<SyncCtDeposit>;
  toggleUserHardcodeUsdcCostBasisToOne?: Maybe<ToggleUserHardcodeUsdcCostBasisToOneSchema>;
  toggleUserSpamPreference?: Maybe<ToggleUserSpamPreferenceSchema>;
  toggleUserStakingRewardsPreference?: Maybe<ToggleUserStakingRewardsPreferenceSchema>;
  toggleUserWalletsSpamPreference?: Maybe<ToggleUserWalletsSpamPreferenceSchema>;
  unfreezeUser?: Maybe<UnfreezeUserMutationSchema>;
  updateBaseCurrency?: Maybe<UpdateBaseCurrencyMutationSchema>;
  updateCostBasisMethod?: Maybe<UpdateCostBasisMethodMutationSchema>;
  updateCostBasisMethodTimeline?: Maybe<UpdateCostBasisMethodTimelineMutationSchema>;
  updateCostBasisPaused?: Maybe<UpdateCostBasisPausedMutationSchema>;
  updateCostBasisTracking?: Maybe<UpdateCostBasisTrackingMutationSchema>;
  updateCountryCode?: Maybe<UpdateCountryCodeMutationSchema>;
  updateExchangeSettings?: Maybe<UpdateExchangeSettingsMutationSchema>;
  updateExchangeWithApiKey?: Maybe<UpdateExchangeWithApiKeyMutationSchema>;
  updateExchangeWithApiKeyAndSecret?: Maybe<UpdateExchangeWithApiKeyAndSecretMutationSchema>;
  updateExchangeWithCustomerId?: Maybe<UpdateExchangeWithCustomerIdMutationSchema>;
  updateExchangeWithOauth?: Maybe<UpdateExchangeWithOauthCodeMutationSchema>;
  updateExchangeWithPassphrase?: Maybe<UpdateExchangeWithPassphraseMutationSchema>;
  /** Edit integration instructions */
  updateInstructions?: Maybe<UpdateInstructionsMutationSchema>;
  updateLastUsedTaxYear?: Maybe<UpdateLastUsedTaxYear>;
  updateLendingTaxability?: Maybe<UpdateLendingTaxabilityMutationSchema>;
  updateLiquidStakingTaxability?: Maybe<UpdateLiquidStakingTaxabilityMutationSchema>;
  updateLiquidityTaxability?: Maybe<UpdateLiquidityTaxabilityMutationSchema>;
  updateLotAllocationMethod?: Maybe<UpdateTaxLotAllocationMethodMutationSchema>;
  updateOperationPurpose?: Maybe<UpdateOperationsPurposeMutationSchema>;
  updateSkipInLinkDetection?: Maybe<UpdateSkipInLinkDetectionMutation>;
  updateStakingRewardsTaxability?: Maybe<UpdateStakingRewardsTaxabilityMutationSchema>;
  updateSyncCutoffDate?: Maybe<UpdateUserSyncCutOffDateMutationSchema>;
  updateTask?: Maybe<UpdateTaskMutation>;
  updateTaxYear?: Maybe<UpdateTaxYearMutationSchema>;
  updateTransaction?: Maybe<UpdateTransactionMutationSchema>;
  updateTransactionActiveStatus?: Maybe<UpdateTransactionActiveStatusMutation>;
  updateTransactionCostBasis?: Maybe<UpdateCostBasisTransactionMutation>;
  updateTransactionDatetime?: Maybe<UpdateDatetimeTransactionMutation>;
  updateTransactionLabel?: Maybe<UpdateTransactionLabelMutation>;
  updateTransactionProceeds?: Maybe<UpdateProceedsTransactionMutation>;
  updateTransactionTaxability?: Maybe<UpdateTransactionTaxabilityMutation>;
  updateTransactionsActiveStatus?: Maybe<UpdateTransactionsActiveStatusMutation>;
  updateTransactionsLabel?: Maybe<UpdateTransactionsLabelMutation>;
  updateTransactionsTaxability?: Maybe<UpdateTransactionsTaxabilityMutationSchema>;
  /** @deprecated We no longer support showing calculated balances. */
  updateUserDisplayedBalances?: Maybe<UpdateUserDisplayedBalancesMutationSchema>;
  updateUserStateSettings?: Maybe<UpdateUserStateSettingsMutationSchema>;
  updateUserTaxReportSettings?: Maybe<UpdateUserTaxReportSettingsMutationSchema>;
  updateUserTaxSettings?: Maybe<UpdateUserTaxSettingsMutation>;
  updateUserTaxWithholdingSettings?: Maybe<UpdateUserTaxWithholdingSettingsMutationSchema>;
  updateUserUiTheme?: Maybe<UpdateUserUiThemeMutationSchema>;
  updateUserinfoSetting?: Maybe<UpdateUserinfoSettingMutation>;
  updateWrappingTaxability?: Maybe<UpdateWrappingTaxabilityMutationSchema>;
  uploadCbeCsv?: Maybe<UploadCbeCsv>;
  upsertLocalUserFromAuth0?: Maybe<UpsertUserFromAuth0Schema>;
  verifyUserEmailChangeRequest?: Maybe<VerifyUserEmailChangeMutationResult>;
  watchlistToggle?: Maybe<WatchlistToggle>;
};


export type MutationsAcceptFirmInviteArgs = {
  taxFirmPublicId: Scalars['String'];
};


export type MutationsAcceptTaxProClientInviteArgs = {
  currentUserRole: TaxProClientInviteInitiator;
  senderPublicId: Scalars['String'];
};


export type MutationsAddAssetArgs = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceUsd?: InputMaybe<Scalars['Float']>;
  symbol?: InputMaybe<Scalars['String']>;
};


export type MutationsAddCbeDepositArgs = {
  input: AddCbeDepositInput;
};


export type MutationsAddCbeDisposalArgs = {
  input: AddCbeDisposalInput;
};


export type MutationsAddDepositOverrideArgs = {
  costBasis: Scalars['Decimal'];
  dateAcquired: Scalars['DateTime'];
  flowId: Scalars['String'];
};


export type MutationsAddExchangeWithApiKeyArgs = {
  addExchangeInput: AddExchangeWithApiKeyInput;
};


export type MutationsAddExchangeWithApiKeyAndSecretArgs = {
  addExchangeInput: AddExchangeWithApiKeyAndSecretInput;
};


export type MutationsAddExchangeWithCustomerIdArgs = {
  addExchangeInput: AddExchangeWithCustomerIdInput;
};


export type MutationsAddExchangeWithOauthArgs = {
  addExchangeInput: AddExchangeWithOauthCodeInput;
};


export type MutationsAddExchangeWithPassphraseArgs = {
  addExchangeInput: AddExchangeWithPassphraseInput;
};


export type MutationsAddFirmAdminArgs = {
  email: Scalars['String'];
  taxFirmPublicId: Scalars['String'];
};


export type MutationsAddMultiAddressArgs = {
  multiAddressInput: AddMultiAddressInput;
};


export type MutationsAddPublicAddressArgs = {
  publicAddressInput: AddPublicAddressWalletInput;
};


export type MutationsAddPublicXpubArgs = {
  publicXpubInput: AddPublicXpubInput;
};


export type MutationsAddSpecificIdRuleArgs = {
  flowSelectedId: Scalars['String'];
  quantity: Scalars['Decimal'];
  selectedLotId: Scalars['String'];
  transactionSelectedId: Scalars['String'];
  uaid: Scalars['String'];
};


export type MutationsAddTwoXpubArgs = {
  twoXpubInput: AddTwoXpubInput;
};


export type MutationsAdminAddTaxProForClientArgs = {
  clientEmail: Scalars['String'];
  taxFirmPublicId: Scalars['String'];
  taxProEmail: Scalars['String'];
};


export type MutationsAdminRemoveTaxProForClientArgs = {
  clientEmail: Scalars['String'];
  taxFirmPublicId: Scalars['String'];
  taxProEmail: Scalars['String'];
};


export type MutationsBulkUpdateTransactionAssetArgs = {
  updateTokenParameters: Array<InputMaybe<UpdateTokenInput>>;
};


export type MutationsConfirmOnboardingSettingsArgs = {
  baseCurrencySymbol?: InputMaybe<Scalars['String']>;
  costBasisMethodId?: InputMaybe<Scalars['Int']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
};


export type MutationsCreateCustomWalletArgs = {
  customWalletInput: CreateCustomWalletInput;
};


export type MutationsCreateTransactionArgs = {
  transaction: TransactionNodeInput;
};


export type MutationsCreateTransactionLinkArgs = {
  receiveTransactionId?: InputMaybe<Scalars['String']>;
  sendTransactionId?: InputMaybe<Scalars['String']>;
  transactionLinkType?: InputMaybe<TransactionLinkTypeEnum>;
};


export type MutationsCreateUserFeedbackMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
};


export type MutationsDeleteCustomWalletArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsDeleteExchangeArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsDeleteFirmInviteArgs = {
  email: Scalars['String'];
  taxFirmPublicId: Scalars['String'];
};


export type MutationsDeleteFirmMemberArgs = {
  taxFirmPublicId: Scalars['String'];
  userPublicId: Scalars['String'];
};


export type MutationsDeleteManualTransactionsArgs = {
  entryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationsDeleteSpecificIdRuleArgs = {
  transactionSelectedId: Scalars['String'];
};


export type MutationsDeleteTaxProClientArgs = {
  currentUserRole: TaxProClientInviteInitiator;
  partnerPublicId: Scalars['String'];
};


export type MutationsDeleteTaxProClientInviteArgs = {
  initiatedBy: TaxProClientInviteInitiator;
  recipientEmail: Scalars['String'];
  senderPublicId: Scalars['String'];
};


export type MutationsDeleteWalletArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsEditAssetArgs = {
  assetId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceUsd?: InputMaybe<Scalars['Float']>;
  symbol?: InputMaybe<Scalars['String']>;
};


export type MutationsEditFirmArgs = {
  description?: InputMaybe<Scalars['String']>;
  emailSuffix?: InputMaybe<Scalars['String']>;
  isContracted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<PartnerType>;
  publicId?: InputMaybe<Scalars['String']>;
  taxPlanDiscountPercent?: InputMaybe<Scalars['Int']>;
};


export type MutationsEnqueueCostBasisArgs = {
  priority?: InputMaybe<QueuePriority>;
};


export type MutationsEnqueueExchangeForSyncArgs = {
  publicId?: InputMaybe<Scalars['String']>;
  syncType?: InputMaybe<Scalars['String']>;
};


export type MutationsEnqueueLocalWalletForSyncArgs = {
  publicId?: InputMaybe<Scalars['String']>;
  syncType?: InputMaybe<Scalars['String']>;
};


export type MutationsFreezeUserArgs = {
  year: Scalars['Int'];
};


export type MutationsGenerateCoinbaseOneCreditArgs = {
  input: GenerateCoinbaseOneCreditInput;
};


export type MutationsGenerateTaxLotsCsvArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type MutationsGenerateTaxReportArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  query?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<TaxReportType>;
  startDate?: InputMaybe<Scalars['Date']>;
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type MutationsIgnoreTokenTransactionsAndReportAsSpamArgs = {
  contractAddressNetworkPairs: Array<InputMaybe<ContractAddressNetworkPairInput>>;
  ignore?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsImportCustomWalletTransactionsArgs = {
  customWalletInput: ImportCustomWalletTransactionsInput;
};


export type MutationsImportExchangeTransactionsArgs = {
  importTransactionsInput: ImportExchangeTransactionsInput;
};


export type MutationsImportNftArgs = {
  address: Scalars['String'];
  costBasis: Scalars['Float'];
  dateAcquired: Scalars['String'];
  tokenId: Scalars['String'];
  walletId: Scalars['String'];
};


export type MutationsInviteProToFirmArgs = {
  email: Scalars['String'];
  taxFirmPublicId: Scalars['String'];
};


export type MutationsInviteTaxProClientArgs = {
  currentUserRole: TaxProClientInviteInitiator;
  email: Scalars['String'];
};


export type MutationsLeaveFirmArgs = {
  taxFirmPublicId: Scalars['String'];
};


export type MutationsMakeTransferArgs = {
  transactionId?: InputMaybe<Scalars['String']>;
};


export type MutationsMfaHookAuth0Args = {
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
};


export type MutationsMigrateExchangeArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsPresignFileUploadArgs = {
  filename?: InputMaybe<Scalars['String']>;
};


export type MutationsRemoveTransactionLinkArgs = {
  transactionId?: InputMaybe<Scalars['String']>;
};


export type MutationsRenameCustomWalletArgs = {
  newName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsRenameExchangeArgs = {
  newName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsRenameWalletArgs = {
  newName?: InputMaybe<Scalars['String']>;
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsReportSpamArgs = {
  markAsSpam?: InputMaybe<Scalars['Boolean']>;
  uaids: Array<InputMaybe<Scalars['String']>>;
};


export type MutationsResetCbeUserArgs = {
  input: ResetCbeUserInput;
};


export type MutationsSavePushTokenArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationsSetMiningStatusArgs = {
  applyToAll?: InputMaybe<Scalars['Boolean']>;
  isMining?: InputMaybe<Scalars['Boolean']>;
  publicId?: InputMaybe<Scalars['String']>;
};


export type MutationsSetSelectedPerformanceModeArgs = {
  mode?: InputMaybe<Scalars['Int']>;
};


export type MutationsSubmitLotsFileArgs = {
  fileUrl: Scalars['String'];
};


export type MutationsSubmitUserEmailChangeRequestArgs = {
  toEmail?: InputMaybe<Scalars['String']>;
};


export type MutationsSyncCtDepositsArgs = {
  input: SyncCtDepositInput;
};


export type MutationsUnfreezeUserArgs = {
  year: Scalars['Int'];
};


export type MutationsUpdateBaseCurrencyArgs = {
  cryptoId?: InputMaybe<Scalars['String']>;
  fiatId?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateCostBasisMethodArgs = {
  costBasisType?: InputMaybe<CostBasisMethod>;
};


export type MutationsUpdateCostBasisMethodTimelineArgs = {
  costBasisType?: InputMaybe<CostBasisMethod>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationsUpdateCostBasisPausedArgs = {
  costBasisPaused?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateCostBasisTrackingArgs = {
  costBasisTrackingMethod?: InputMaybe<CostBasisTracking>;
};


export type MutationsUpdateCountryCodeArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateExchangeSettingsArgs = {
  isExchangeReportingBasis?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateExchangeWithApiKeyArgs = {
  updateExchangeInput: UpdateExchangeWithApiKeyInput;
};


export type MutationsUpdateExchangeWithApiKeyAndSecretArgs = {
  updateExchangeInput: UpdateExchangeWithApiKeyAndSecretInput;
};


export type MutationsUpdateExchangeWithCustomerIdArgs = {
  updateExchangeInput: UpdateExchangeWithCustomerIdInput;
};


export type MutationsUpdateExchangeWithOauthArgs = {
  updateExchangeInput: UpdateExchangeWithOauthCodeInput;
};


export type MutationsUpdateExchangeWithPassphraseArgs = {
  updateExchangeInput: UpdateExchangeWithPassphraseInput;
};


export type MutationsUpdateInstructionsArgs = {
  instructions: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationsUpdateLastUsedTaxYearArgs = {
  taxYear: Scalars['Int'];
};


export type MutationsUpdateLendingTaxabilityArgs = {
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
  settingStartDate: Scalars['DateTime'];
};


export type MutationsUpdateLiquidStakingTaxabilityArgs = {
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
  settingStartDate: Scalars['DateTime'];
};


export type MutationsUpdateLiquidityTaxabilityArgs = {
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
  settingStartDate: Scalars['DateTime'];
};


export type MutationsUpdateLotAllocationMethodArgs = {
  lotAllocationMethod?: InputMaybe<LotAllocationMethod>;
};


export type MutationsUpdateOperationPurposeArgs = {
  frontendOperationPurpose?: InputMaybe<FrontendOperationPurpose>;
  operationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationsUpdateSkipInLinkDetectionArgs = {
  skipInLinkDetection?: InputMaybe<Scalars['Boolean']>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationsUpdateStakingRewardsTaxabilityArgs = {
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
  settingStartDate: Scalars['DateTime'];
};


export type MutationsUpdateSyncCutoffDateArgs = {
  syncCutoffDate?: InputMaybe<Scalars['Date']>;
};


export type MutationsUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationsUpdateTaxYearArgs = {
  taxStartDay?: InputMaybe<Scalars['Int']>;
  taxStartMonth?: InputMaybe<Scalars['Int']>;
};


export type MutationsUpdateTransactionArgs = {
  created?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  deleted?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  modified?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  transaction: TransactionNodeInput;
};


export type MutationsUpdateTransactionActiveStatusArgs = {
  enable?: InputMaybe<Scalars['Boolean']>;
  entryId?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateTransactionCostBasisArgs = {
  costBasis?: InputMaybe<Scalars['PositiveFloat']>;
  entryId: Scalars['String'];
};


export type MutationsUpdateTransactionDatetimeArgs = {
  newDatetime: Scalars['DateTime'];
  transactionId: Scalars['String'];
};


export type MutationsUpdateTransactionLabelArgs = {
  entryId?: InputMaybe<Scalars['String']>;
  isMarkAs?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateTransactionProceedsArgs = {
  entryId: Scalars['String'];
  proceeds?: InputMaybe<Scalars['PositiveFloat']>;
};


export type MutationsUpdateTransactionTaxabilityArgs = {
  publicId?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateTransactionsActiveStatusArgs = {
  enable?: InputMaybe<Scalars['Boolean']>;
  entryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationsUpdateTransactionsLabelArgs = {
  entryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isMarkAs?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateTransactionsTaxabilityArgs = {
  publicIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  taxable?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateUserDisplayedBalancesArgs = {
  displayedBalances?: InputMaybe<DisplayedBalances>;
};


export type MutationsUpdateUserStateSettingsArgs = {
  userStateSettings?: InputMaybe<Scalars['String']>;
};


export type MutationsUpdateUserTaxReportSettingsArgs = {
  userTaxReportingStatus?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateUserTaxSettingsArgs = {
  taxSettings: Array<InputMaybe<TaxSettingsInput>>;
};


export type MutationsUpdateUserTaxWithholdingSettingsArgs = {
  userTaxWithholdingStatus?: InputMaybe<Scalars['Boolean']>;
};


export type MutationsUpdateUserUiThemeArgs = {
  uiTheme?: InputMaybe<UiTheme>;
};


export type MutationsUpdateUserinfoSettingArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  settingType?: InputMaybe<UserSettings>;
};


export type MutationsUpdateWrappingTaxabilityArgs = {
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
  settingStartDate: Scalars['DateTime'];
};


export type MutationsUploadCbeCsvArgs = {
  input: UploadCbeCsvInput;
};


export type MutationsUpsertLocalUserFromAuth0Args = {
  idToken: Scalars['String'];
};


export type MutationsVerifyUserEmailChangeRequestArgs = {
  otpValue?: InputMaybe<Scalars['String']>;
  toEmail?: InputMaybe<Scalars['String']>;
};


export type MutationsWatchlistToggleArgs = {
  symbol?: InputMaybe<Scalars['String']>;
};

export type NftImporterMutationSchema = {
  __typename?: 'NFTImporterMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type Nft = {
  __typename?: 'Nft';
  acquiredAt?: Maybe<Scalars['String']>;
  animationUrl?: Maybe<Scalars['String']>;
  collectionName?: Maybe<Scalars['String']>;
  contractAddress?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  ethPrice?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalDate?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  traits?: Maybe<Array<Maybe<Trait>>>;
  usdPrice?: Maybe<Scalars['String']>;
};

export type OAuthAuthorize = {
  __typename?: 'OAuthAuthorize';
  clientId?: Maybe<Scalars['String']>;
  extraParams?: Maybe<Array<Maybe<ExtraParam>>>;
  redirectUri?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
};

export type OnboardingConfirmSettingsMutation = {
  __typename?: 'OnboardingConfirmSettingsMutation';
  errors?: Maybe<Array<Maybe<FormFieldInfo>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Schema for a single operation */
export type Operation = {
  __typename?: 'Operation';
  flows?: Maybe<Array<Maybe<Flow>>>;
  flowsHiddenInOperation?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isFeeOperation?: Maybe<Scalars['Boolean']>;
  markAsOperationPurposes?: Maybe<Array<Maybe<FrontendOperationPurpose>>>;
  operationPurpose?: Maybe<FrontendOperationPurpose>;
  operationType?: Maybe<OperationType>;
};

/** An enumeration. */
export enum OperationType {
  Receive = 'RECEIVE',
  Send = 'SEND',
  Trade = 'TRADE'
}

export type OrganizationContact = {
  __typename?: 'OrganizationContact';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  info?: Maybe<Scalars['GenericScalar']>;
  name: Scalars['String'];
  type?: Maybe<ContactType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationCounterPartyAddress = {
  __typename?: 'OrganizationCounterPartyAddress';
  count: Scalars['Int'];
  counterPartyAddressId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  organizationContact?: Maybe<OrganizationContact>;
  organizationContactId?: Maybe<Scalars['UUID']>;
  organizationId: Scalars['Int'];
};

export type OtherTransactions = {
  __typename?: 'OtherTransactions';
  assetsCount?: Maybe<Scalars['Int']>;
  balances?: Maybe<Array<Maybe<Balance>>>;
  headerLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  parentAccountName?: Maybe<Scalars['String']>;
  userAssetBalances?: Maybe<Array<Maybe<Balance>>>;
  value?: Maybe<Scalars['Float']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNext: Scalars['Boolean'];
  hasPrev: Scalars['Boolean'];
  page: Scalars['Int'];
  pages: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type PaginatedCustomWallets = {
  __typename?: 'PaginatedCustomWallets';
  currentPage?: Maybe<Scalars['Int']>;
  customWallets?: Maybe<Array<Maybe<CustomWallet>>>;
  endPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedExchanges = {
  __typename?: 'PaginatedExchanges';
  currentPage?: Maybe<Scalars['Int']>;
  endPage?: Maybe<Scalars['Int']>;
  exchanges?: Maybe<Array<Maybe<Exchange>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaginatedWallets = {
  __typename?: 'PaginatedWallets';
  currentPage?: Maybe<Scalars['Int']>;
  endPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  wallets?: Maybe<Array<Maybe<Wallet>>>;
};

export type Partner = {
  __typename?: 'Partner';
  name: Scalars['String'];
  type: PartnerType;
};

export type PartnerPromo = {
  __typename?: 'PartnerPromo';
  discount: Scalars['Float'];
  partner: Partner;
};

/** An enumeration. */
export enum PartnerType {
  BeProCrypto = 'BE_PRO_CRYPTO',
  Bitbuy = 'BITBUY',
  Blockchaincom = 'BLOCKCHAINCOM',
  Brave = 'BRAVE',
  Cch = 'CCH',
  Coinbase = 'COINBASE',
  CoinbaseOne = 'COINBASE_ONE',
  Coinjar = 'COINJAR',
  Coinsquare = 'COINSQUARE',
  Etoro = 'ETORO',
  Etoroclub = 'ETOROCLUB',
  GordonLaw = 'GORDON_LAW',
  Hrblock = 'HRBLOCK',
  Intuit = 'INTUIT',
  Matcha = 'MATCHA',
  Moontax = 'MOONTAX',
  Opensea = 'OPENSEA',
  Phantom = 'PHANTOM',
  PicnicTax = 'PICNIC_TAX',
  Solana = 'SOLANA',
  Sureprep = 'SUREPREP',
  Taxcaddy = 'TAXCADDY',
  TaxingCryptocurrency = 'TAXING_CRYPTOCURRENCY',
  TheNetworkFirm = 'THE_NETWORK_FIRM',
  TrustWallet = 'TRUST_WALLET',
  TurboTax = 'TURBO_TAX',
  Uniswap = 'UNISWAP',
  Uphold = 'UPHOLD',
  WoltersKluwer = 'WOLTERS_KLUWER'
}

export type PerformanceDataPoint = {
  __typename?: 'PerformanceDataPoint';
  costBasis?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  marketValue?: Maybe<Scalars['Float']>;
  netTotalDeposits?: Maybe<Scalars['Float']>;
  netTotalWithdrawals?: Maybe<Scalars['Float']>;
  returnOnInvestment?: Maybe<Scalars['Float']>;
  returnOnInvestmentPercent?: Maybe<Scalars['Float']>;
  totalReturnOnInvestment?: Maybe<Scalars['Float']>;
  totalReturnOnInvestmentPercent?: Maybe<Scalars['Float']>;
};

export type PerformanceDataPointConnection = {
  __typename?: 'PerformanceDataPointConnection';
  edges?: Maybe<Array<Maybe<PerformanceDataPoint>>>;
  hasAccess: Scalars['Boolean'];
  hasAccessToPerformanceFeatures?: Maybe<Scalars['Boolean']>;
  hasAccessToPortfolioFeatures?: Maybe<Scalars['Boolean']>;
  noAccessMessage?: Maybe<Scalars['String']>;
};

/** Data point for Performance graphs */
export type PerformanceDataPointV2 = {
  __typename?: 'PerformanceDataPointV2';
  balanceDelta?: Maybe<Scalars['Float']>;
  costBasisDelta?: Maybe<Scalars['Float']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  marketValue?: Maybe<Scalars['Float']>;
  runningBalance?: Maybe<Scalars['Float']>;
  runningCostBasis?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum PerformanceDuration {
  AllTime = 'ALL_TIME',
  FiveYear = 'FIVE_YEAR',
  OneDay = 'ONE_DAY',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  OneYear = 'ONE_YEAR',
  ThreeMonth = 'THREE_MONTH'
}

export type PerformanceGraphBalance = {
  __typename?: 'PerformanceGraphBalance';
  balanceDelta?: Maybe<Scalars['Float']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  runningBalance?: Maybe<Scalars['Float']>;
};

export type PerformanceGraphCostBasis = {
  __typename?: 'PerformanceGraphCostBasis';
  costBasisDelta?: Maybe<Scalars['Float']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  runningCostBasis?: Maybe<Scalars['Float']>;
};

export type PerformanceGraphList = {
  __typename?: 'PerformanceGraphList';
  dataPoints?: Maybe<Array<Maybe<PerformanceDataPointV2>>>;
  graphBalance?: Maybe<Array<Maybe<PerformanceGraphBalance>>>;
  graphCostBasis?: Maybe<Array<Maybe<PerformanceGraphCostBasis>>>;
  graphMarketValue?: Maybe<Array<Maybe<PerformanceGraphMarketValue>>>;
  symbol?: Maybe<Scalars['String']>;
};

export type PerformanceGraphMarketValue = {
  __typename?: 'PerformanceGraphMarketValue';
  dateTime?: Maybe<Scalars['DateTime']>;
  marketValue?: Maybe<Scalars['Float']>;
};

export type PerformanceGraphRealizedReturn = {
  __typename?: 'PerformanceGraphRealizedReturn';
  dateTime?: Maybe<Scalars['DateTime']>;
  realizedReturn?: Maybe<Scalars['Float']>;
};

/** Features for the subscription plan */
export enum PlanFeature {
  AdvancedPortfolioTracking = 'ADVANCED_PORTFOLIO_TRACKING',
  AdvancedReporting = 'ADVANCED_REPORTING',
  CollaborateWithTaxPros = 'COLLABORATE_WITH_TAX_PROS',
  CostBasisMethodByYear = 'COST_BASIS_METHOD_BY_YEAR',
  DefiTracking = 'DEFI_TRACKING',
  EarlyAccessFeatures = 'EARLY_ACCESS_FEATURES',
  MobileApps = 'MOBILE_APPS',
  PortfolioAllocation = 'PORTFOLIO_ALLOCATION',
  PortfolioTracking = 'PORTFOLIO_TRACKING',
  PortfolioUpdates = 'PORTFOLIO_UPDATES',
  PortfolioValue = 'PORTFOLIO_VALUE',
  SpamDetection = 'SPAM_DETECTION',
  SupportPriority = 'SUPPORT_PRIORITY',
  SupportSelfServe = 'SUPPORT_SELF_SERVE',
  SupportStandard = 'SUPPORT_STANDARD',
  TaxLossHarvesting = 'TAX_LOSS_HARVESTING',
  TaxLots = 'TAX_LOTS',
  TaxMinimization = 'TAX_MINIMIZATION',
  TaxReportsAllYears = 'TAX_REPORTS_ALL_YEARS',
  TaxSummary = 'TAX_SUMMARY',
  TurbotaxHrblockIntegration = 'TURBOTAX_HRBLOCK_INTEGRATION'
}

/** What is the staking limit for the subscription plan */
export enum PlanStaking {
  Limited = 'LIMITED',
  None = 'NONE',
  Unlimited = 'UNLIMITED'
}

/** What is the support tier for the subscription plan */
export enum PlanSupport {
  Priority = 'PRIORITY',
  SelfServe = 'SELF_SERVE',
  Standard = 'STANDARD'
}

/** Which tax forms are available for the subscription plan */
export enum PlanTaxForms {
  AllPastYears = 'ALL_PAST_YEARS',
  None = 'NONE'
}

export type PlanTransactionCounts = {
  __typename?: 'PlanTransactionCounts';
  excludedStakingTransactionCount: Scalars['Int'];
  lifetimeTransactionCount: Scalars['Int'];
  netTransactionCount: Scalars['Int'];
  totalTransactionCount: Scalars['Int'];
};

export type Portfolio = {
  __typename?: 'Portfolio';
  allTimeReturn?: Maybe<Scalars['Float']>;
  allTimeReturnPercent?: Maybe<Scalars['Float']>;
  calculatedMarketValue?: Maybe<Scalars['Float']>;
  costBasis?: Maybe<Scalars['Float']>;
  currencies?: Maybe<Array<Maybe<PortfolioCurrency>>>;
  fiats?: Maybe<Array<Maybe<PortfolioCurrency>>>;
  hasAccessToPerformanceByCrypto: Scalars['Boolean'];
  hasSubscription: Scalars['Boolean'];
  isSignificantMarketValueDiff?: Maybe<Scalars['Boolean']>;
  marketValue?: Maybe<Scalars['Float']>;
  netFiat?: Maybe<Scalars['Float']>;
  netTotalDeposits?: Maybe<Scalars['Float']>;
  netTotalWithdrawals?: Maybe<Scalars['Float']>;
  oneDayReturn?: Maybe<Scalars['Float']>;
  oneDayReturnPercent?: Maybe<Scalars['Float']>;
  reportedMarketValue?: Maybe<Scalars['Float']>;
  timeSpanMarketReturn?: Maybe<Scalars['Float']>;
  timeSpanMarketReturnPercent?: Maybe<Scalars['Float']>;
  totalReturnOnInvestment?: Maybe<Scalars['Float']>;
  totalReturnOnInvestmentPercent?: Maybe<Scalars['Float']>;
  userAssets?: Maybe<Array<Maybe<PortfolioCurrency>>>;
};

export type PortfolioCurrency = {
  __typename?: 'PortfolioCurrency';
  allTimeReturn?: Maybe<Scalars['Float']>;
  allTimeReturnPercent?: Maybe<Scalars['Float']>;
  averageCostBasis?: Maybe<Scalars['Float']>;
  calculatedMarketValue?: Maybe<Scalars['Float']>;
  calculatedQuantity?: Maybe<Scalars['Float']>;
  costBasis?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  error?: Maybe<Scalars['String']>;
  marketValue?: Maybe<Scalars['Float']>;
  netTotalDeposits?: Maybe<Scalars['Float']>;
  netTotalWithdrawals?: Maybe<Scalars['Float']>;
  portfolioPercent?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  reportedMarketValue?: Maybe<Scalars['Float']>;
  reportedQuantity?: Maybe<Scalars['Float']>;
  totalReturnOnInvestment?: Maybe<Scalars['Float']>;
  totalReturnOnInvestmentPercent?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum PortfolioPlan {
  Custom = 'CUSTOM',
  Enthusiast = 'ENTHUSIAST',
  Free = 'FREE',
  Hobbyist = 'HOBBYIST',
  Pro = 'PRO'
}

export type PortfolioPlanDetails = {
  __typename?: 'PortfolioPlanDetails';
  description?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstChargeDate?: Maybe<Scalars['Date']>;
  isRecommended?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  trialDays?: Maybe<Scalars['Int']>;
  trialDescription?: Maybe<Scalars['String']>;
};

export type PortfolioSubscription = {
  __typename?: 'PortfolioSubscription';
  billing?: Maybe<PortfolioSubscriptionBilling>;
  portfolioPlan?: Maybe<PortfolioPlan>;
  portfolioPlanName?: Maybe<Scalars['String']>;
  recommendationLabel?: Maybe<Scalars['String']>;
  transactionLimit?: Maybe<Scalars['Int']>;
  walletLimit?: Maybe<Scalars['Int']>;
};

/** Billing info of the portfolio subscription */
export type PortfolioSubscriptionBilling = {
  __typename?: 'PortfolioSubscriptionBilling';
  cancelAtPeriodEnd: Scalars['Boolean'];
  currentPeriodEnd: Scalars['Date'];
  interval: PortfolioSubscriptionBillingInterval;
  status: PortfolioSubscriptionBillingStatus;
};

/** Wrapper over interval on plan object from Stripe API https://stripe.com/docs/api/plans/object */
export enum PortfolioSubscriptionBillingInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Wrapper over status on subscription object from Stripe API https://stripe.com/docs/api/subscriptions/object */
export enum PortfolioSubscriptionBillingStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type PresignFileUploadMutation = {
  __typename?: 'PresignFileUploadMutation';
  error?: Maybe<Scalars['String']>;
  result?: Maybe<UploadPresignResult>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PriceInfo = {
  __typename?: 'PriceInfo';
  currencySymbol: Scalars['String'];
  discount: Scalars['Decimal'];
  /** @deprecated Use discount_type instead */
  discountReason?: Maybe<Scalars['String']>;
  discountType?: Maybe<DiscountType>;
  finalPrice: Scalars['Decimal'];
  originalPrice: Scalars['Decimal'];
};

export enum PricesSortBy {
  Change_24H = 'CHANGE_24H',
  MarketCap = 'MARKET_CAP',
  Price = 'PRICE',
  Symbol = 'SYMBOL',
  Volume_24H = 'VOLUME_24H'
}

export type PublicBalanceResponse = {
  __typename?: 'PublicBalanceResponse';
  balance?: Maybe<Scalars['String']>;
  shouldPoll?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  usdValue?: Maybe<Scalars['String']>;
  walletAlreadyLinked?: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  accountLevelTaxSummary?: Maybe<Array<Maybe<AccountLevelTaxSummary>>>;
  appInfo?: Maybe<AppInfo>;
  assetsMetadata?: Maybe<Array<Maybe<UniversalAsset>>>;
  availableLotNodes?: Maybe<Array<Maybe<AvailableLotNodeData>>>;
  availableLotsData?: Maybe<AvailableLotsData>;
  availableSettings?: Maybe<Array<Maybe<TaxIdMethod>>>;
  availableSubscriptionPlans?: Maybe<AvailableSubscriptionPlans>;
  availableUnifiedSubscriptionPlans: AvailableUnifiedSubscriptionPlans;
  cbeAvailableStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  cbePipelineStages?: Maybe<Array<Maybe<TransactionStageStatus>>>;
  cbeUserCurrencies?: Maybe<Array<Maybe<UserCurrency>>>;
  cbeUserCurrentState?: Maybe<Scalars['String']>;
  cbeUserSettings?: Maybe<CbeUserSettings>;
  cbeUserTaxSettings?: Maybe<Array<Maybe<TaxSettings>>>;
  coinbaseOneCreditStatus: CoinbaseOneCreditStatusOutput;
  commonCurrencies?: Maybe<Array<Maybe<Currency>>>;
  connectedCtUsers?: Maybe<Array<Maybe<CostBasisEngineConnectUser>>>;
  countriesList?: Maybe<Array<Maybe<Country>>>;
  csvImportJobStatus?: Maybe<CsvImportJobStatus>;
  csvValidationErrors?: Maybe<Array<Maybe<Scalars['String']>>>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  currency?: Maybe<Currency>;
  currentTaxFirm?: Maybe<TaxFirm>;
  customWallet?: Maybe<CustomWallet>;
  customWallets?: Maybe<Array<Maybe<CustomWallet>>>;
  customWalletsPage?: Maybe<PaginatedCustomWallets>;
  depositInformationStatus?: Maybe<Array<Maybe<DepositInformation>>>;
  depositOverrideHistory?: Maybe<DepositOverrideHistory>;
  depositOverrides?: Maybe<Array<Maybe<DepositOverrides>>>;
  depositValidationState?: Maybe<ValidationData>;
  detectedCryptoNetworks?: Maybe<Array<Maybe<CryptoNetworkResult>>>;
  disposedLots?: Maybe<Array<Maybe<DisposedLotData>>>;
  entry?: Maybe<EntryView>;
  exchange?: Maybe<Exchange>;
  exchangeFunds?: Maybe<ExchangeFundsInfo>;
  exchangeIncrementalPersistanceSyncProgress?: Maybe<SyncProgress>;
  exchangeLevelReport?: Maybe<Array<Maybe<ExchangeTaxData>>>;
  exchanges?: Maybe<Array<Maybe<Exchange>>>;
  exchangesPage?: Maybe<PaginatedExchanges>;
  exchangesWithInvalidCredentials?: Maybe<Array<Maybe<Exchange>>>;
  filteredPrices?: Maybe<CurrenciesConnection>;
  firmInvites?: Maybe<Array<Maybe<TaxFirmInviteObj>>>;
  firmInvitesForPro?: Maybe<Array<Maybe<TaxFirmInviteObj>>>;
  firmMembers?: Maybe<Array<Maybe<TaxFirmMemberObj>>>;
  graphData?: Maybe<Array<Maybe<GraphData>>>;
  integrations?: Maybe<Array<Maybe<Integration>>>;
  localWallet?: Maybe<Wallet>;
  localWalletIncrementalPersistanceSyncProgress?: Maybe<SyncProgress>;
  localWallets?: Maybe<Array<Maybe<Wallet>>>;
  localWalletsPage?: Maybe<PaginatedWallets>;
  lotImporterStatus?: Maybe<LotImporterStatusSchema>;
  marketInfo?: Maybe<MarketInfo>;
  multiAddressImportJobStatus?: Maybe<MultiAddressImportJobStatus>;
  myAssets?: Maybe<AssetConnection>;
  myProfile?: Maybe<UserProfile>;
  nfts?: Maybe<Array<Maybe<Nft>>>;
  otherTransactions?: Maybe<OtherTransactions>;
  performanceGraphList?: Maybe<Array<Maybe<PerformanceGraphList>>>;
  performanceGraphRealizedReturn?: Maybe<Array<Maybe<PerformanceGraphRealizedReturn>>>;
  performanceHistory?: Maybe<PerformanceDataPointConnection>;
  portfolio?: Maybe<Portfolio>;
  portfolioSubscription?: Maybe<PortfolioSubscription>;
  price?: Maybe<Currency>;
  prices?: Maybe<Array<Maybe<Currency>>>;
  publicWalletBalance?: Maybe<PublicBalanceResponse>;
  searchCurrencies?: Maybe<SearchCurrencies>;
  searchFiat?: Maybe<SearchFiat>;
  session?: Maybe<SessionObj>;
  showContractedTaxFirmTaxPlans?: Maybe<Scalars['Boolean']>;
  spamAssets?: Maybe<Array<Maybe<SpamAsset>>>;
  specificIds?: Maybe<Array<Maybe<SpecificIdRuleObject>>>;
  tasksByType?: Maybe<TasksByType>;
  taxConfiguration?: Maybe<TaxConfiguration>;
  taxFirm?: Maybe<TaxFirm>;
  taxFirms?: Maybe<Array<Maybe<TaxFirm>>>;
  taxImpactPreview?: Maybe<TaxImpactPreview>;
  taxLossHarvest?: Maybe<TaxLossHarvest>;
  taxLotsCsvPollResult?: Maybe<TaxLotsCsvPollResult>;
  taxProClientInvites?: Maybe<Array<Maybe<TaxProsClientInviteObj>>>;
  taxProClients?: Maybe<Array<Maybe<TaxProsClientObj>>>;
  taxPros?: Maybe<Array<Maybe<TaxProsClientObj>>>;
  taxReportPollResult?: Maybe<TaxReportPollResult>;
  taxSummaries?: Maybe<Array<Maybe<TaxSummary>>>;
  taxSummary?: Maybe<TaxSummary>;
  taxYear?: Maybe<Scalars['Int']>;
  taxYears?: Maybe<Array<Maybe<UserTaxYear>>>;
  transaction?: Maybe<TransactionNode>;
  transactionPage?: Maybe<TransactionPage>;
  transactionPageCount?: Maybe<TransactionPageCount>;
  transactionsCsv?: Maybe<TransactionsCsvDownloadSchema>;
  transactionsCsvPoll?: Maybe<TransactionsCsvPollingSchema>;
  transactionsSearch?: Maybe<TransactionsSearch>;
  transactionsV2?: Maybe<TransactionsV2>;
  unifiedSubscription?: Maybe<UnifiedSubscription>;
  userContractedFirms?: Maybe<Array<Maybe<TaxFirm>>>;
  userInfo?: Maybe<UserInfo>;
  userLendingAndStakingAssets?: Maybe<Array<Maybe<UserStakingAndLendingAsset>>>;
  userProfile?: Maybe<UserProfile>;
  userProperties?: Maybe<UserPropertiesObj>;
  userStats?: Maybe<UserStats>;
  walletAllocationPerCrypto?: Maybe<Array<Maybe<WalletAllocation>>>;
  walletClassification?: Maybe<Array<Maybe<WalletClassification>>>;
  watchlistPrices?: Maybe<CurrenciesConnection>;
};


export type QueryAccountLevelTaxSummaryArgs = {
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetsMetadataArgs = {
  uaids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAvailableLotNodesArgs = {
  flowId?: InputMaybe<Scalars['String']>;
};


export type QueryAvailableLotsDataArgs = {
  assetIdentifier?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['Boolean']>;
  forSwapPreview?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  walletAddress?: InputMaybe<Scalars['String']>;
  walletChain?: InputMaybe<Scalars['String']>;
  walletPublicGid?: InputMaybe<Scalars['String']>;
};


export type QueryCoinbaseOneCreditStatusArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type QueryCsvImportJobStatusArgs = {
  jobId: Scalars['String'];
};


export type QueryCsvValidationErrorsArgs = {
  accountTypeSlug?: InputMaybe<Scalars['String']>;
  csvFileUrl?: InputMaybe<Scalars['String']>;
  isGeneric?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCurrenciesArgs = {
  queries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCurrencyArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryCustomWalletArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryCustomWalletsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryCustomWalletsPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryDepositOverridesArgs = {
  flowId?: InputMaybe<Scalars['String']>;
};


export type QueryDepositValidationStateArgs = {
  costBasis?: InputMaybe<Scalars['Decimal']>;
  dateAcquired?: InputMaybe<Scalars['DateTime']>;
  flowId?: InputMaybe<Scalars['String']>;
};


export type QueryDetectedCryptoNetworksArgs = {
  address?: InputMaybe<Scalars['String']>;
};


export type QueryDisposedLotsArgs = {
  flowId?: InputMaybe<Scalars['String']>;
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type QueryEntryArgs = {
  publicId?: InputMaybe<Scalars['ID']>;
};


export type QueryExchangeArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryExchangeIncrementalPersistanceSyncProgressArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryExchangeLevelReportArgs = {
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type QueryExchangesArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryExchangesPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryFilteredPricesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<PricesSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryFirmInvitesArgs = {
  taxFirmPublicId?: InputMaybe<Scalars['String']>;
};


export type QueryFirmMembersArgs = {
  taxFirmPublicId?: InputMaybe<Scalars['String']>;
};


export type QueryGraphDataArgs = {
  disposedLotId?: InputMaybe<Scalars['String']>;
  flowId?: InputMaybe<Scalars['String']>;
};


export type QueryLocalWalletArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryLocalWalletIncrementalPersistanceSyncProgressArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryLocalWalletsArgs = {
  includeEmptyWallets?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryLocalWalletsPageArgs = {
  includeEmptyWallets?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryMultiAddressImportJobStatusArgs = {
  jobId: Scalars['String'];
};


export type QueryMyAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryNftsArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  publicAddress?: InputMaybe<Scalars['String']>;
};


export type QueryOtherTransactionsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryPerformanceGraphListArgs = {
  normalizedNamesList: Array<InputMaybe<Scalars['String']>>;
  timeSpan?: InputMaybe<PerformanceDuration>;
  walletList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPerformanceGraphRealizedReturnArgs = {
  assetList: Array<InputMaybe<Scalars['String']>>;
  timeSpan?: InputMaybe<RealizedReturnPerformanceDuration>;
  walletList: Array<InputMaybe<Scalars['String']>>;
};


export type QueryPerformanceHistoryArgs = {
  performanceDuration?: InputMaybe<PerformanceDuration>;
};


export type QueryPortfolioArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  performanceDuration?: InputMaybe<PerformanceDuration>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryPriceArgs = {
  symbol?: InputMaybe<Scalars['String']>;
};


export type QueryPublicWalletBalanceArgs = {
  address?: InputMaybe<Scalars['String']>;
  coinSymbol?: InputMaybe<Scalars['String']>;
};


export type QuerySearchCurrenciesArgs = {
  hideInactiveCryptos?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySearchFiatArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryShowContractedTaxFirmTaxPlansArgs = {
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type QueryTasksByTypeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<TaskStatus>;
  taskType: TaskType;
};


export type QueryTaxFirmArgs = {
  publicId?: InputMaybe<Scalars['String']>;
};


export type QueryTaxImpactPreviewArgs = {
  fees?: InputMaybe<Array<InputMaybe<SwapFeeInput>>>;
  inflowAssetContractAddress?: InputMaybe<Scalars['String']>;
  inflowAssetSymbol: Scalars['String'];
  inflowChain: Scalars['String'];
  inflowQuantity: Scalars['Float'];
  inflowWalletAddress: Scalars['String'];
  outflowAssetContractAddress?: InputMaybe<Scalars['String']>;
  outflowAssetSymbol: Scalars['String'];
  outflowChain: Scalars['String'];
  outflowQuantity: Scalars['Float'];
  outflowWalletAddress: Scalars['String'];
  transactionDatetime?: InputMaybe<Scalars['String']>;
};


export type QueryTaxLossHarvestArgs = {
  forSwapPreview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTaxLotsCsvPollResultArgs = {
  jobId?: InputMaybe<Scalars['String']>;
};


export type QueryTaxProClientInvitesArgs = {
  inviteFilter?: InputMaybe<TaxProsClientInviteFilter>;
};


export type QueryTaxReportPollResultArgs = {
  jobId?: InputMaybe<Scalars['String']>;
};


export type QueryTaxSummaryArgs = {
  taxYear?: InputMaybe<Scalars['Int']>;
};


export type QueryTransactionArgs = {
  publicId: Scalars['String'];
};


export type QueryTransactionPageArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  transactionsOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTransactionPageCountArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsCsvArgs = {
  query?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsCsvPollArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsSearchArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryTransactionsV2Args = {
  counter?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  useEntries?: InputMaybe<Scalars['Boolean']>;
  useTransactions?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUserInfoArgs = {
  userPublicId?: InputMaybe<Scalars['String']>;
};


export type QueryUserProfileArgs = {
  userPublicId?: InputMaybe<Scalars['String']>;
};


export type QueryUserStatsArgs = {
  userPublicId?: InputMaybe<Scalars['String']>;
};


export type QueryWalletAllocationPerCryptoArgs = {
  query: Scalars['String'];
};


export type QueryWatchlistPricesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<PricesSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

/**
 * Enum representing priorities in a queue. Various job classes use these enums to decide which queue to enqueue jobs
 * into. If you need more granularity, add more values.
 *
 */
export enum QueuePriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

/** An enumeration. */
export enum RealizedReturnPerformanceDuration {
  AllTime = 'ALL_TIME',
  CurrentTaxYear = 'CURRENT_TAX_YEAR',
  PreviousTaxYear = 'PREVIOUS_TAX_YEAR'
}

export type RegisterAsTaxProMutationSchema = {
  __typename?: 'RegisterAsTaxProMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveTransactionLink = {
  __typename?: 'RemoveTransactionLink';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RenameCustomWalletMutationSchema = {
  __typename?: 'RenameCustomWalletMutationSchema';
  error?: Maybe<WalletRenameErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RenameExchangeMutationSchema = {
  __typename?: 'RenameExchangeMutationSchema';
  error?: Maybe<ExchangeRenameErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RenameWalletMutationSchema = {
  __typename?: 'RenameWalletMutationSchema';
  error?: Maybe<WalletRenameErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ReportSpamMutationSchema = {
  __typename?: 'ReportSpamMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

/** Mutation to request tax recalculation for a user */
export type RequestTaxRecalculation = {
  __typename?: 'RequestTaxRecalculation';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Defines different status for the client tax plan.
 * - "Unpaid" means the client has not paid for any tax plan.
 * - "Partially paid" means the client has paid for some tax plan that is lower than Premium.
 * - "Paid" means the client has already paid for a Premium tax plan in full.
 *
 */
export enum RequiredTaxPlanStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type ResetCbeUser = {
  __typename?: 'ResetCbeUser';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ResetCbeUserInput = {
  brokerId: Scalars['String'];
};

export type ResetUserPasswordMutationSchema = {
  __typename?: 'ResetUserPasswordMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Result = {
  __typename?: 'Result';
  /** Contains information about the caught error */
  error: Scalars['String'];
  /** Index of the update token parameter that was processed. Starts at 0. */
  index: Scalars['Int'];
  /** Indicates that the mutation was successful */
  success: Scalars['Boolean'];
};

export type ResyncAllWalletsAndAccountsSchema = {
  __typename?: 'ResyncAllWalletsAndAccountsSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SavePushToken = {
  __typename?: 'SavePushToken';
  success?: Maybe<Scalars['Boolean']>;
};

export type SearchCurrencies = {
  __typename?: 'SearchCurrencies';
  blockchainTokens?: Maybe<Array<Maybe<SearchCurrency>>>;
  cryptos?: Maybe<Array<Maybe<SearchCurrency>>>;
  fiats?: Maybe<Array<Maybe<SearchCurrency>>>;
  nfts?: Maybe<Array<Maybe<SearchCurrency>>>;
  userAssets?: Maybe<Array<Maybe<SearchCurrency>>>;
  virtualTokens?: Maybe<Array<Maybe<SearchCurrency>>>;
};

export type SearchCurrency = {
  __typename?: 'SearchCurrency';
  icon?: Maybe<Scalars['String']>;
  iconUrlFromInfo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceUsd?: Maybe<Scalars['Float']>;
  slug?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  uaid?: Maybe<Scalars['String']>;
};

export type SearchCurrencyInput = {
  icon?: InputMaybe<Scalars['String']>;
  iconUrlFromInfo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  priceUsd?: InputMaybe<Scalars['Float']>;
  slug?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  uaid?: InputMaybe<Scalars['String']>;
};

export type SearchFiat = {
  __typename?: 'SearchFiat';
  fiats?: Maybe<Array<Maybe<SearchCurrency>>>;
};

export type SessionObj = {
  __typename?: 'SessionObj';
  anonymousId?: Maybe<Scalars['String']>;
  taxProsReturnPublicId?: Maybe<Scalars['String']>;
};

export type SetMiningStatusMutationSchema = {
  __typename?: 'SetMiningStatusMutationSchema';
  error?: Maybe<GenericWalletErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetSelectedPerformanceMode = {
  __typename?: 'SetSelectedPerformanceMode';
  success?: Maybe<Scalars['Boolean']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpamAsset = {
  __typename?: 'SpamAsset';
  assetName?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  contractAddress?: Maybe<Scalars['String']>;
  cryptoNetwork?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  /** Frontend consumable value for whether the user should see this token as marked spam, not spam, or neither. */
  isSpam?: Maybe<Scalars['Boolean']>;
  sanitizedSymbol?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  /** Whether the token was auto-classified as SPAM or MALICIOUS by Blockaid. */
  wasAutomarkedAsSpam?: Maybe<Scalars['Boolean']>;
};

export type SpecIdRule = {
  quantity: Scalars['Decimal'];
  selectedLotId: Scalars['String'];
  uaid: Scalars['String'];
};

export type SpecificIdRuleObject = {
  __typename?: 'SpecificIDRuleObject';
  flowSelectedId: Scalars['String'];
  quantity: Scalars['Decimal'];
  selectedLotId: Scalars['String'];
  transactionSelectedId: Scalars['String'];
  uaid: Scalars['String'];
};

export type StartUniversalToPerWalletMigrationMutationSchema = {
  __typename?: 'StartUniversalToPerWalletMigrationMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum SubmitUserEmailChangeMutationError {
  EmailAlreadyExisted = 'EMAIL_ALREADY_EXISTED',
  NotAllowed = 'NOT_ALLOWED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type SubmitUserEmailChangeMutationResult = {
  __typename?: 'SubmitUserEmailChangeMutationResult';
  error?: Maybe<SubmitUserEmailChangeMutationError>;
  ok: Scalars['Boolean'];
};

/** An enumeration. */
export enum SubscriptionPlan {
  Base = 'BASE',
  BasePlus = 'BASE_PLUS',
  Free = 'FREE',
  FullService = 'FULL_SERVICE',
  Prime = 'PRIME',
  PrimePlus = 'PRIME_PLUS',
  Ultra = 'ULTRA',
  UltraPlus = 'ULTRA_PLUS'
}

export type SwapFeeInput = {
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  symbol: Scalars['String'];
};

export type SyncCtDeposit = {
  __typename?: 'SyncCtDeposit';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SyncCtDepositInput = {
  ctUserId: Scalars['Int'];
};

export type SyncInfo = {
  __typename?: 'SyncInfo';
  isDisabled?: Maybe<Scalars['Boolean']>;
  isFirstTimeSync?: Maybe<Scalars['Boolean']>;
  isSyncing?: Maybe<Scalars['Boolean']>;
  lastSynced?: Maybe<Scalars['DateTime']>;
  willBeDeleted?: Maybe<Scalars['Boolean']>;
};

export type SyncProgress = {
  __typename?: 'SyncProgress';
  currentStage?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type TaskInterface = {
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  status: TaskStatus;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum TaskStatus {
  Ignored = 'IGNORED',
  ToDo = 'TO_DO'
}

/** An enumeration. */
export enum TaskType {
  FixApiCredentials = 'FIX_API_CREDENTIALS'
}

export type TasksByType = {
  __typename?: 'TasksByType';
  pageInfo?: Maybe<PageInfo>;
  status: TaskStatus;
  taskType: TaskType;
  tasks: Array<Maybe<TaskInterface>>;
};

export type TaxConfiguration = {
  __typename?: 'TaxConfiguration';
  hasLendingUserSetting?: Maybe<Scalars['Boolean']>;
  hasLiquidStakingUserSetting?: Maybe<Scalars['Boolean']>;
  hasLiquidityUserSetting?: Maybe<Scalars['Boolean']>;
  hasStakingRewardsUserSetting?: Maybe<Scalars['Boolean']>;
  hasWrappingUserSetting?: Maybe<Scalars['Boolean']>;
  lendingSettingEndDate?: Maybe<Scalars['DateTime']>;
  lendingSettingStartDate?: Maybe<Scalars['DateTime']>;
  liquidStakeSettingEndDate?: Maybe<Scalars['DateTime']>;
  liquidStakeSettingStartDate?: Maybe<Scalars['DateTime']>;
  liquiditySettingEndDate?: Maybe<Scalars['DateTime']>;
  liquiditySettingStartDate?: Maybe<Scalars['DateTime']>;
  stakingRewardsSettingEndDate?: Maybe<Scalars['DateTime']>;
  stakingRewardsSettingStartDate?: Maybe<Scalars['DateTime']>;
  wrappingSettingEndDate?: Maybe<Scalars['DateTime']>;
  wrappingSettingStartDate?: Maybe<Scalars['DateTime']>;
};

export type TaxConstants = {
  __typename?: 'TaxConstants';
  faqUrl?: Maybe<Scalars['String']>;
  fileOnlineUrl?: Maybe<Scalars['String']>;
  taxFormUrl?: Maybe<Scalars['String']>;
  taxInstructionsUrl?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum TaxEvent {
  AddLiquidity = 'ADD_LIQUIDITY',
  Airdropped = 'AIRDROPPED',
  BlockchainFee = 'BLOCKCHAIN_FEE',
  Borrowing = 'BORROWING',
  Bought = 'BOUGHT',
  Bridge = 'BRIDGE',
  BridgeReceive = 'BRIDGE_RECEIVE',
  BridgeSend = 'BRIDGE_SEND',
  CloseOrder = 'CLOSE_ORDER',
  ContractExecution = 'CONTRACT_EXECUTION',
  Deposit = 'DEPOSIT',
  Donated = 'DONATED',
  ExchangeFee = 'EXCHANGE_FEE',
  GamblingExpense = 'GAMBLING_EXPENSE',
  GamblingIncome = 'GAMBLING_INCOME',
  Gifted = 'GIFTED',
  HardFork = 'HARD_FORK',
  IlliquidStaking = 'ILLIQUID_STAKING',
  IlliquidUnstaking = 'ILLIQUID_UNSTAKING',
  IllLiqLendDeposit = 'ILL_LIQ_LEND_DEPOSIT',
  IllLiqLendWithdrawal = 'ILL_LIQ_LEND_WITHDRAWAL',
  InterestExpense = 'INTEREST_EXPENSE',
  InterestIncome = 'INTEREST_INCOME',
  LiquidStaking = 'LIQUID_STAKING',
  LiquidUnstaking = 'LIQUID_UNSTAKING',
  LiqLendDeposit = 'LIQ_LEND_DEPOSIT',
  LiqLendWithdrawal = 'LIQ_LEND_WITHDRAWAL',
  Loan = 'LOAN',
  LoanPayment = 'LOAN_PAYMENT',
  Lost = 'LOST',
  MarginFee = 'MARGIN_FEE',
  MarginGainLoss = 'MARGIN_GAIN_LOSS',
  MarginPnl = 'MARGIN_PNL',
  MarginRebate = 'MARGIN_REBATE',
  MarginSettleReceive = 'MARGIN_SETTLE_RECEIVE',
  MarginSettleSend = 'MARGIN_SETTLE_SEND',
  MiningReward = 'MINING_REWARD',
  Minted = 'MINTED',
  OpenOrder = 'OPEN_ORDER',
  OtherIncome = 'OTHER_INCOME',
  Payment = 'PAYMENT',
  Rebate = 'REBATE',
  Received = 'RECEIVED',
  ReceiveGift = 'RECEIVE_GIFT',
  RemoveLiquidity = 'REMOVE_LIQUIDITY',
  Royalty = 'ROYALTY',
  Sent = 'SENT',
  Service = 'SERVICE',
  Sold = 'SOLD',
  StakingReward = 'STAKING_REWARD',
  Stolen = 'STOLEN',
  Traded = 'TRADED',
  Transferred = 'TRANSFERRED',
  Withdrawal = 'WITHDRAWAL',
  Wrapping = 'WRAPPING'
}

export type TaxFirm = {
  __typename?: 'TaxFirm';
  currentMember?: Maybe<TaxFirmMemberObj>;
  description?: Maybe<Scalars['String']>;
  emailSuffix?: Maybe<Scalars['String']>;
  isContracted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partnerType?: Maybe<PartnerType>;
  publicId?: Maybe<Scalars['String']>;
  taxPlanDiscountPercent?: Maybe<Scalars['Int']>;
};

export type TaxFirmInviteObj = {
  __typename?: 'TaxFirmInviteObj';
  email?: Maybe<Scalars['String']>;
  taxFirm?: Maybe<TaxFirm>;
};

export type TaxFirmMemberObj = {
  __typename?: 'TaxFirmMemberObj';
  email?: Maybe<Scalars['String']>;
  role?: Maybe<TaxFirmRole>;
  taxFirmPublicId?: Maybe<Scalars['String']>;
  taxProClientInvites?: Maybe<Array<Maybe<TaxProsClientInviteObj>>>;
  taxProClients?: Maybe<Array<Maybe<TaxProsClientObj>>>;
  userPublicId?: Maybe<Scalars['String']>;
};


export type TaxFirmMemberObjTaxProClientInvitesArgs = {
  inviteFilter?: InputMaybe<TaxProsClientInviteFilter>;
};

/** An enumeration. */
export enum TaxFirmRole {
  TaxFirmAdmin = 'TAX_FIRM_ADMIN',
  TaxPro = 'TAX_PRO'
}

export type TaxIdMethod = {
  __typename?: 'TaxIdMethod';
  setting: Scalars['String'];
};

export type TaxImpactPreview = {
  __typename?: 'TaxImpactPreview';
  costBasis: Scalars['String'];
  estimatedTaxSavings: Scalars['String'];
  gainLoss: Scalars['String'];
  gainLossPercentage: Scalars['Decimal'];
  totalLongTermEstimatedTaxes: Scalars['String'];
  totalLongTermGain: Scalars['String'];
  totalShortTermEstimatedTaxes: Scalars['String'];
  totalShortTermGain: Scalars['String'];
  tradeProceeds: Scalars['String'];
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount?: Maybe<Scalars['String']>;
  /** Is taxable during the tax year */
  isTaxable?: Maybe<Scalars['Boolean']>;
  /** Is taxable at the current time */
  isTaxableNow?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  taxEvent?: Maybe<TaxEvent>;
  transactionsCount?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
};

export type TaxLossHarvest = {
  __typename?: 'TaxLossHarvest';
  hasAccess?: Maybe<Scalars['Boolean']>;
  taxLossInfoList?: Maybe<Array<Maybe<TaxLossInfo>>>;
  taxLossTotals?: Maybe<TaxLossTotals>;
  /** Most recent tax year. eg UK user in jan 1st should be current year - 1. UK user in aug 1st should be current year */
  taxYear?: Maybe<Scalars['Int']>;
};

export type TaxLossInfo = {
  __typename?: 'TaxLossInfo';
  /** Positive magnitude of unrealized loss */
  absUnrealizedLoss?: Maybe<Scalars['Float']>;
  costBasis?: Maybe<Scalars['Float']>;
  cryptoCmcId?: Maybe<Scalars['Int']>;
  cryptoContractAddress?: Maybe<Scalars['String']>;
  cryptoName?: Maybe<Scalars['String']>;
  cryptoSlug?: Maybe<Scalars['String']>;
  cryptoSymbol?: Maybe<Scalars['String']>;
  customWallet?: Maybe<CustomWallet>;
  holdings?: Maybe<Scalars['Float']>;
  marketValue?: Maybe<Scalars['Float']>;
  potentialSavings?: Maybe<Scalars['Float']>;
  wallet?: Maybe<Wallet>;
};

export type TaxLossTotals = {
  __typename?: 'TaxLossTotals';
  /** Positive magnitude of unrealized loss */
  absUnrealizedLoss?: Maybe<Scalars['Float']>;
  potentialSavings?: Maybe<Scalars['Float']>;
};

export type TaxLotsCsvPollResult = {
  __typename?: 'TaxLotsCsvPollResult';
  ready?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum TaxPackage {
  Basic = 'BASIC',
  Free = 'FREE',
  Hobbyist = 'HOBBYIST',
  Lite = 'LITE',
  Medium = 'MEDIUM',
  Premium = 'PREMIUM',
  Pro = 'PRO',
  Pro_2 = 'PRO_2',
  Satoshi = 'SATOSHI',
  Starter = 'STARTER',
  Trader = 'TRADER',
  Ultimate = 'ULTIMATE',
  Unified = 'UNIFIED'
}

export type TaxPlan = {
  __typename?: 'TaxPlan';
  dynamicTransactionLimitLabel?: Maybe<Scalars['String']>;
  hasGeneratedTaxReport?: Maybe<Scalars['Boolean']>;
  insufficientReason?: Maybe<InsufficientPlanReason>;
  insufficientUnifiedPlanLongReason?: Maybe<Scalars['String']>;
  insufficientUnifiedPlanShortReason?: Maybe<Scalars['String']>;
  isSufficient?: Maybe<Scalars['Boolean']>;
  isUnified?: Maybe<Scalars['Boolean']>;
  planName?: Maybe<Scalars['String']>;
  shouldRenew?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['String']>;
  transactionLimit?: Maybe<Scalars['Int']>;
  type?: Maybe<TaxPackage>;
};

/** An enumeration. */
export enum TaxProClientInviteInitiator {
  Client = 'CLIENT',
  TaxPro = 'TAX_PRO'
}

export enum TaxProsClientInviteFilter {
  ReceivedByUser = 'RECEIVED_BY_USER',
  SentByUser = 'SENT_BY_USER'
}

export type TaxProsClientInviteObj = {
  __typename?: 'TaxProsClientInviteObj';
  clientEmail?: Maybe<Scalars['String']>;
  clientPublicId?: Maybe<Scalars['String']>;
  initiatedBy: TaxProClientInviteInitiator;
  senderEmail?: Maybe<Scalars['String']>;
  taxProEmail?: Maybe<Scalars['String']>;
  taxProPublicId?: Maybe<Scalars['String']>;
};

export type TaxProsClientObj = {
  __typename?: 'TaxProsClientObj';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  requiredTaxPlanStatus?: Maybe<RequiredTaxPlanStatus>;
  taxProEmail?: Maybe<Scalars['String']>;
  taxProsFirmMemberPublicId?: Maybe<Scalars['String']>;
  userPublicId?: Maybe<Scalars['String']>;
};

/** Edit firm details if public id is provided, otherwise create a new firm */
export type TaxProsEditFirmMutationSchema = {
  __typename?: 'TaxProsEditFirmMutationSchema';
  publicId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TaxReportPollResult = {
  __typename?: 'TaxReportPollResult';
  ready?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export enum TaxReportType {
  AnlageSoReport = 'ANLAGE_SO_REPORT',
  CapitalGainsCch = 'CAPITAL_GAINS_CCH',
  CapitalGainsCsv = 'CAPITAL_GAINS_CSV',
  CapitalGainsTaxAct = 'CAPITAL_GAINS_TAX_ACT',
  CapitalGainsTurboTaxDesktop = 'CAPITAL_GAINS_TURBO_TAX_DESKTOP',
  CapitalGainsTurboTaxOnline = 'CAPITAL_GAINS_TURBO_TAX_ONLINE',
  CaSchedule_3 = 'CA_SCHEDULE_3',
  EoyTaxLotsReport = 'EOY_TAX_LOTS_REPORT',
  Exchange_1099Reports = 'EXCHANGE_1099_REPORTS',
  Form_1040S1 = 'FORM_1040S1',
  Form_1040Sd = 'FORM_1040SD',
  Form_8949 = 'FORM_8949',
  Form_8949Condensed = 'FORM_8949_CONDENSED',
  IncomeCsvReport = 'INCOME_CSV_REPORT',
  LotsAsOfDate = 'LOTS_AS_OF_DATE',
  TaxLotsCsv = 'TAX_LOTS_CSV',
  TransactionsCsv = 'TRANSACTIONS_CSV',
  WisoCsv = 'WISO_CSV'
}

export type TaxReports = {
  __typename?: 'TaxReports';
  anlageSoReport?: Maybe<Scalars['Boolean']>;
  capitalGainsCsv?: Maybe<Scalars['Boolean']>;
  condensedIrsForm8949?: Maybe<Scalars['Boolean']>;
  craSchedule3?: Maybe<Scalars['Boolean']>;
  eoyTaxLotsReport?: Maybe<Scalars['Boolean']>;
  hAndRBlock?: Maybe<Scalars['Boolean']>;
  incomeCsvReport?: Maybe<Scalars['Boolean']>;
  irsForm8949?: Maybe<Scalars['Boolean']>;
  irsSchedule1Form1040?: Maybe<Scalars['Boolean']>;
  irsScheduleDForm1040?: Maybe<Scalars['Boolean']>;
  selfFileWithCointracker?: Maybe<Scalars['Boolean']>;
  taxactFile?: Maybe<Scalars['Boolean']>;
  taxcaddy8949?: Maybe<Scalars['Boolean']>;
  taxcaddySchedule1?: Maybe<Scalars['Boolean']>;
  transactionHistoryCsv?: Maybe<Scalars['Boolean']>;
  turboTaxOnlineSync?: Maybe<Scalars['Boolean']>;
  turbotaxCdDownload?: Maybe<Scalars['Boolean']>;
  turbotaxOnline?: Maybe<Scalars['Boolean']>;
  wisoCsv?: Maybe<Scalars['Boolean']>;
  woltersKluwerCchFile?: Maybe<Scalars['Boolean']>;
};

export type TaxSettings = {
  __typename?: 'TaxSettings';
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  taxIdMethod: Scalars['String'];
};

export type TaxSettingsInput = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  taxIdMethod: Scalars['String'];
};

export type TaxSummary = {
  __typename?: 'TaxSummary';
  calloutCountInsufficientQuantity?: Maybe<Scalars['Int']>;
  calloutCountMissingBalance?: Maybe<Scalars['Int']>;
  calloutCountMissingPriceHistory?: Maybe<Scalars['Int']>;
  capitalGain?: Maybe<Scalars['String']>;
  capitalGainWithoutSymbol?: Maybe<Scalars['String']>;
  donationLongTerm?: Maybe<Scalars['String']>;
  donationShortTerm?: Maybe<Scalars['String']>;
  errorsCount?: Maybe<Scalars['Int']>;
  /** Estimated taxes for the tax year based on 30% tax rate */
  estimatedTaxes?: Maybe<Scalars['String']>;
  freeTransactionsCount?: Maybe<Scalars['Int']>;
  hasPlan?: Maybe<Scalars['Boolean']>;
  hasSufficientPlan?: Maybe<Scalars['Boolean']>;
  incomeAirdrops?: Maybe<Scalars['String']>;
  incomeFork?: Maybe<Scalars['String']>;
  incomeGambling?: Maybe<Scalars['String']>;
  incomeInterest?: Maybe<Scalars['String']>;
  incomeMining?: Maybe<Scalars['String']>;
  incomeOther?: Maybe<Scalars['String']>;
  incomeRoyalty?: Maybe<Scalars['String']>;
  incomeSalary?: Maybe<Scalars['String']>;
  incomeStaking?: Maybe<Scalars['String']>;
  longTermCostBasis?: Maybe<Scalars['String']>;
  longTermCryptoToCryptoGain?: Maybe<Scalars['String']>;
  longTermGain?: Maybe<Scalars['String']>;
  longTermOtherGain?: Maybe<Scalars['String']>;
  longTermProceeds?: Maybe<Scalars['String']>;
  netFuturesGains?: Maybe<Scalars['String']>;
  numberOfDisposals?: Maybe<Scalars['String']>;
  otherCategoriesTotal?: Maybe<Scalars['String']>;
  receivesCount?: Maybe<Scalars['Int']>;
  sendsCount?: Maybe<Scalars['Int']>;
  serviceGains?: Maybe<Scalars['String']>;
  shortTermCostBasis?: Maybe<Scalars['String']>;
  shortTermCryptoToCryptoGain?: Maybe<Scalars['String']>;
  shortTermGain?: Maybe<Scalars['String']>;
  shortTermLosses?: Maybe<Scalars['String']>;
  shortTermOtherGain?: Maybe<Scalars['String']>;
  shortTermProceeds?: Maybe<Scalars['String']>;
  taxConstants?: Maybe<TaxConstants>;
  taxEndDate?: Maybe<Scalars['String']>;
  taxIncome?: Maybe<Scalars['String']>;
  taxItems?: Maybe<Array<Maybe<TaxItem>>>;
  taxPlan?: Maybe<TaxPlan>;
  taxReports?: Maybe<TaxReports>;
  taxStartDate?: Maybe<Scalars['String']>;
  taxSummaryByAccounts?: Maybe<Array<Maybe<TaxSummaryByType>>>;
  taxSummaryByCustomWallets?: Maybe<Array<Maybe<TaxSummaryByType>>>;
  taxSummaryByForeignAccounts?: Maybe<Array<Maybe<TaxSummaryByType>>>;
  taxSummaryByWallets?: Maybe<Array<Maybe<TaxSummaryByType>>>;
  taxYear?: Maybe<Scalars['Int']>;
  taxYearLabel?: Maybe<Scalars['String']>;
  taxYearTitle?: Maybe<Scalars['String']>;
  taxableIncomeTotal?: Maybe<Scalars['String']>;
  totalCapitalGains?: Maybe<Scalars['String']>;
  totalCostBasis?: Maybe<Scalars['String']>;
  totalDonations?: Maybe<Scalars['String']>;
  /** Total gains for the tax year, for Australia and United Kingdom */
  totalGains?: Maybe<Scalars['String']>;
  totalGamblingLosses?: Maybe<Scalars['String']>;
  totalGifts?: Maybe<Scalars['String']>;
  totalInterestExpense?: Maybe<Scalars['String']>;
  totalLosses?: Maybe<Scalars['String']>;
  totalMarginFees?: Maybe<Scalars['String']>;
  totalProceeds?: Maybe<Scalars['String']>;
  totalShortTermGains?: Maybe<Scalars['String']>;
  totalShortTermLosses?: Maybe<Scalars['String']>;
  totalStolenLosses?: Maybe<Scalars['String']>;
  transactionCount?: Maybe<Scalars['Int']>;
};

export type TaxSummaryByType = {
  __typename?: 'TaxSummaryByType';
  gains?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  transactionsCount?: Maybe<Scalars['String']>;
};

export type TaxabilityObject = {
  __typename?: 'TaxabilityObject';
  countrySupportsOptionalityForTaxEvents?: Maybe<Scalars['Boolean']>;
  hasTaxabilityOverride?: Maybe<Scalars['Boolean']>;
  isOptionalityEnabled?: Maybe<Scalars['Boolean']>;
  taxable?: Maybe<Scalars['Boolean']>;
};

export type ToggleUserHardcodeUsdcCostBasisToOneSchema = {
  __typename?: 'ToggleUserHardcodeUsdcCostBasisToOneSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type ToggleUserSpamPreferenceSchema = {
  __typename?: 'ToggleUserSpamPreferenceSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type ToggleUserStakingRewardsPreferenceSchema = {
  __typename?: 'ToggleUserStakingRewardsPreferenceSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type ToggleUserWalletsSpamPreferenceSchema = {
  __typename?: 'ToggleUserWalletsSpamPreferenceSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type Token = {
  __typename?: 'Token';
  balance?: Maybe<Scalars['Float']>;
  calculatedBalance?: Maybe<Scalars['Float']>;
  calculatedValue?: Maybe<Scalars['Float']>;
  computedTransactionCount?: Maybe<Scalars['Int']>;
  cryptoContractAddress?: Maybe<Scalars['String']>;
  /** @deprecated Please use sanitized_crypto_symbol. */
  cryptoSymbol?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  isBalanceDifferenceSignificant?: Maybe<Scalars['Boolean']>;
  parentAccountName?: Maybe<Scalars['String']>;
  sanitizedCryptoSymbol?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Trait = {
  __typename?: 'Trait';
  traitType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TransactionBalanceSchema = {
  __typename?: 'TransactionBalanceSchema';
  address?: Maybe<Scalars['String']>;
  asset?: Maybe<UniversalAsset>;
  /** @deprecated The 'asset_symbol' field is being deprecated from persisted transactions. Use 'asset.symbol' instead when on persisted transactions. */
  assetSymbol?: Maybe<Scalars['String']>;
  balanceAfter?: Maybe<Scalars['Float']>;
  walletLabel?: Maybe<Scalars['String']>;
};

export type TransactionBalanceSchemaInput = {
  address?: InputMaybe<Scalars['String']>;
  assetSymbol?: InputMaybe<Scalars['String']>;
  balanceAfter?: InputMaybe<Scalars['Float']>;
  walletLabel?: InputMaybe<Scalars['String']>;
};

export enum TransactionLinkTypeEnum {
  Bridge = 'bridge',
  LinkedTrade = 'linked_trade',
  Transfer = 'transfer'
}

export type TransactionNode = {
  __typename?: 'TransactionNode';
  canEditCostBasis?: Maybe<Scalars['Boolean']>;
  canEditProceeds?: Maybe<Scalars['Boolean']>;
  countrySupportsOptionalityForTaxEvents?: Maybe<Scalars['Boolean']>;
  credits?: Maybe<Array<Maybe<EntryV2>>>;
  dateTime?: Maybe<Scalars['DateTime']>;
  debits?: Maybe<Array<Maybe<EntryV2>>>;
  hasAllDeletableEntries?: Maybe<Scalars['Boolean']>;
  hasAtleastOneDeletableEntry?: Maybe<Scalars['Boolean']>;
  hasTaxabilityOverride?: Maybe<Scalars['Boolean']>;
  isIgnored?: Maybe<Scalars['Boolean']>;
  isImported?: Maybe<Scalars['Boolean']>;
  isManual?: Maybe<Scalars['Boolean']>;
  isOptionalityEnabled?: Maybe<Scalars['Boolean']>;
  markLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
  publicId?: Maybe<Scalars['ID']>;
  taxable?: Maybe<Scalars['Boolean']>;
  transactionBalances?: Maybe<Array<Maybe<TransactionBalanceSchema>>>;
  transactionFrom?: Maybe<TransactionWalletInfo>;
  transactionRowType?: Maybe<TransactionRowType>;
  transactionTo?: Maybe<TransactionWalletInfo>;
  transactionType?: Maybe<ExtendedTransactionType>;
  unmarkLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type TransactionNodeInput = {
  canEditCostBasis?: InputMaybe<Scalars['Boolean']>;
  canEditProceeds?: InputMaybe<Scalars['Boolean']>;
  countrySupportsOptionalityForTaxEvents?: InputMaybe<Scalars['Boolean']>;
  credits?: InputMaybe<Array<InputMaybe<EntryV2Input>>>;
  dateTime?: InputMaybe<Scalars['DateTime']>;
  debits?: InputMaybe<Array<InputMaybe<EntryV2Input>>>;
  hasAllDeletableEntries?: InputMaybe<Scalars['Boolean']>;
  hasAtleastOneDeletableEntry?: InputMaybe<Scalars['Boolean']>;
  hasTaxabilityOverride?: InputMaybe<Scalars['Boolean']>;
  isIgnored?: InputMaybe<Scalars['Boolean']>;
  isImported?: InputMaybe<Scalars['Boolean']>;
  isManual?: InputMaybe<Scalars['Boolean']>;
  isOptionalityEnabled?: InputMaybe<Scalars['Boolean']>;
  markLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publicId?: InputMaybe<Scalars['ID']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  transactionBalances?: InputMaybe<Array<InputMaybe<TransactionBalanceSchemaInput>>>;
  transactionFrom?: InputMaybe<TransactionWalletInfoInput>;
  transactionRowType?: InputMaybe<TransactionRowType>;
  transactionTo?: InputMaybe<TransactionWalletInfoInput>;
  transactionType?: InputMaybe<ExtendedTransactionType>;
  unmarkLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Schema for a page of visual transactions */
export type TransactionPage = {
  __typename?: 'TransactionPage';
  endPage?: Maybe<Scalars['Int']>;
  isCostBasisRunning?: Maybe<Scalars['Boolean']>;
  startPage?: Maybe<Scalars['Int']>;
  visualTransactions?: Maybe<Array<Maybe<TransactionRow>>>;
};

/** Schema for the transaction page counts */
export type TransactionPageCount = {
  __typename?: 'TransactionPageCount';
  endPage?: Maybe<Scalars['Int']>;
  totalNumberOfTransactions?: Maybe<Scalars['Int']>;
};

/** Schema for a single visual transaction */
export type TransactionRow = {
  __typename?: 'TransactionRow';
  canEditCostBasis?: Maybe<Scalars['Boolean']>;
  canEditProceeds?: Maybe<Scalars['Boolean']>;
  canUnlink?: Maybe<Scalars['Boolean']>;
  dateTime?: Maybe<Scalars['DateTime']>;
  hasAllDeletableFlows?: Maybe<Scalars['Boolean']>;
  hasAtLeastOneDeletableFlow?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isFrozen?: Maybe<Scalars['Boolean']>;
  operations?: Maybe<Array<Maybe<Operation>>>;
  skipInLinkDetection?: Maybe<Scalars['Boolean']>;
  taxability?: Maybe<TaxabilityObject>;
  taxableIncome?: Maybe<Scalars['Decimal']>;
  totalGainLoss?: Maybe<Scalars['Decimal']>;
  totalInflowsHidden?: Maybe<Scalars['Int']>;
  totalOutflowsHidden?: Maybe<Scalars['Int']>;
  totalValue?: Maybe<Scalars['Decimal']>;
  transactionBalances?: Maybe<Array<Maybe<TransactionBalanceSchema>>>;
  transactionHash?: Maybe<Scalars['String']>;
  transactionRowType?: Maybe<TransactionRowType>;
  transactionUrl?: Maybe<Scalars['String']>;
};

/** Enum for each distinct type of transaction row */
export enum TransactionRowType {
  AddLiquidity = 'ADD_LIQUIDITY',
  Airdrop = 'AIRDROP',
  Borrow = 'BORROW',
  Bridge = 'BRIDGE',
  Buy = 'BUY',
  CloseOrder = 'CLOSE_ORDER',
  CollectRewards = 'COLLECT_REWARDS',
  Deposit = 'DEPOSIT',
  Donation = 'DONATION',
  Fee = 'FEE',
  FeeBlockchainFee = 'FEE__BLOCKCHAIN_FEE',
  FeeExchangeFee = 'FEE__EXCHANGE_FEE',
  FeeMarginFee = 'FEE__MARGIN_FEE',
  HardFork = 'HARD_FORK',
  InterestExpense = 'INTEREST_EXPENSE',
  InterestIncome = 'INTEREST_INCOME',
  LinkedTrade = 'LINKED_TRADE',
  Liquidated = 'LIQUIDATED',
  LoanRepayment = 'LOAN_REPAYMENT',
  LoanRepaymentMargin = 'LOAN_REPAYMENT__MARGIN',
  Lost = 'LOST',
  Margin = 'MARGIN',
  MarginGain = 'MARGIN_GAIN',
  MarginLoss = 'MARGIN_LOSS',
  MarginRebate = 'MARGIN_REBATE',
  MarginReward = 'MARGIN_REWARD',
  MarginSettle = 'MARGIN_SETTLE',
  MiningReward = 'MINING_REWARD',
  MultiOperationTransaction = 'MULTI_OPERATION_TRANSACTION',
  OpenOrder = 'OPEN_ORDER',
  OtherIncome = 'OTHER_INCOME',
  Payment = 'PAYMENT',
  Rebate = 'REBATE',
  Receive = 'RECEIVE',
  ReceiveBridge = 'RECEIVE_BRIDGE',
  ReceiveGift = 'RECEIVE_GIFT',
  ReceiveLendingDeposit = 'RECEIVE_LENDING_DEPOSIT',
  ReceiveLendingWithdrawal = 'RECEIVE_LENDING_WITHDRAWAL',
  ReceiveMint = 'RECEIVE_MINT',
  RemoveLiquidity = 'REMOVE_LIQUIDITY',
  Royalty = 'ROYALTY',
  Sell = 'SELL',
  Send = 'SEND',
  SendBridge = 'SEND_BRIDGE',
  SendGift = 'SEND_GIFT',
  SendLendingDeposit = 'SEND_LENDING_DEPOSIT',
  SendLendingWithdrawal = 'SEND_LENDING_WITHDRAWAL',
  Service = 'SERVICE',
  Stake = 'STAKE',
  StakingReward = 'STAKING_REWARD',
  Stolen = 'STOLEN',
  Trade = 'TRADE',
  TradeLendingDeposit = 'TRADE_LENDING_DEPOSIT',
  TradeLendingWithdrawal = 'TRADE_LENDING_WITHDRAWAL',
  TradeMint = 'TRADE_MINT',
  TradeStake = 'TRADE_STAKE',
  TradeUnstake = 'TRADE_UNSTAKE',
  Transfer = 'TRANSFER',
  Unstake = 'UNSTAKE',
  Unwrap = 'UNWRAP',
  Withdrawal = 'WITHDRAWAL',
  Wrap = 'WRAP'
}

export type TransactionStageStatus = {
  __typename?: 'TransactionStageStatus';
  count?: Maybe<Scalars['Int']>;
  maxDatetime?: Maybe<Scalars['DateTime']>;
  minDatetime?: Maybe<Scalars['DateTime']>;
  stage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type TransactionWalletInfo = {
  __typename?: 'TransactionWalletInfo';
  address?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  label?: Maybe<Scalars['String']>;
  networkName?: Maybe<Scalars['String']>;
  walletId?: Maybe<Scalars['String']>;
  walletType?: Maybe<WalletTypeEnum>;
};

export type TransactionWalletInfoInput = {
  address?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<CurrencyInput>;
  label?: InputMaybe<Scalars['String']>;
  networkName?: InputMaybe<Scalars['String']>;
  walletId?: InputMaybe<Scalars['String']>;
  walletType?: InputMaybe<WalletTypeEnum>;
};

export type TransactionsCsvDownloadSchema = {
  __typename?: 'TransactionsCSVDownloadSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TransactionsCsvPollingSchema = {
  __typename?: 'TransactionsCSVPollingSchema';
  ready?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type TransactionsSearch = {
  __typename?: 'TransactionsSearch';
  result?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type TransactionsV2 = {
  __typename?: 'TransactionsV2';
  endPage?: Maybe<Scalars['Int']>;
  isCostBasisRunning?: Maybe<Scalars['Boolean']>;
  isPagePoweredByPersistedTransactions?: Maybe<Scalars['Boolean']>;
  isUserInPersistedTransactionsRolloutGroup?: Maybe<Scalars['Boolean']>;
  startPage?: Maybe<Scalars['Int']>;
  transactionNodes?: Maybe<Array<Maybe<TransactionNode>>>;
};

/** An enumeration. */
export enum UiTheme {
  Dark = 'DARK',
  Light = 'LIGHT',
  System = 'SYSTEM'
}

export type UnfreezeUserMutationSchema = {
  __typename?: 'UnfreezeUserMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type UnifiedFeatureTableDetails = {
  __typename?: 'UnifiedFeatureTableDetails';
  displayName: Scalars['String'];
  featureList: Array<PlanFeature>;
  /** @deprecated Use featureList instead */
  features: Array<Scalars['String']>;
  hasSufficientTransactionLimit: Scalars['Boolean'];
  internalName: Scalars['String'];
  isRecommended: Scalars['Boolean'];
  lifetimeTransactionLimit: Scalars['String'];
  name: Scalars['String'];
  plan: SubscriptionPlan;
  price: Scalars['Float'];
  priceInfo: PriceInfo;
  pricePlus?: Maybe<Scalars['Float']>;
  pricePlusInfo?: Maybe<PriceInfo>;
  staking: PlanStaking;
  /** @deprecated Use staking instead */
  stakingDescription: Scalars['String'];
  support: PlanSupport;
  /** @deprecated Use support instead */
  supportDescription: Scalars['String'];
  taxForms: PlanTaxForms;
  /** @deprecated Use taxForms instead */
  taxFormsDescription: Scalars['String'];
  transactionLimit: Scalars['String'];
};

export type UnifiedPlanDetails = {
  __typename?: 'UnifiedPlanDetails';
  /** @deprecated Field to be removed soon */
  description?: Maybe<Scalars['String']>;
  featureList?: Maybe<Array<PlanFeature>>;
  /** @deprecated Use featureList instead */
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasSufficientTransactionLimit?: Maybe<Scalars['Boolean']>;
  internalName?: Maybe<Scalars['String']>;
  isRecommended?: Maybe<Scalars['Boolean']>;
  lifetimeTransactionLimit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  plan?: Maybe<SubscriptionPlan>;
  price?: Maybe<PriceInfo>;
  /** @deprecated Field to be removed soon */
  tagLine?: Maybe<Scalars['String']>;
  transactionCounts?: Maybe<PlanTransactionCounts>;
  transactionLimit?: Maybe<Scalars['Int']>;
};

export type UnifiedSubscription = {
  __typename?: 'UnifiedSubscription';
  billing: UnifiedSubscriptionBilling;
  lifetimeTransactionLimit: Scalars['Int'];
  partnersPromo?: Maybe<PartnerPromo>;
  /** @deprecated Field to be removed soon */
  recommendationLabel: Scalars['String'];
  recommendedPlanForTax?: Maybe<UnifiedPlanDetails>;
  showCoinbasePromo: Scalars['Boolean'];
  subscriptionPlan: SubscriptionPlan;
  subscriptionPlanName: Scalars['String'];
  transactionCounts?: Maybe<PlanTransactionCounts>;
  transactionLimit: Scalars['Int'];
};

/** Billing info of the unified subscription */
export type UnifiedSubscriptionBilling = {
  __typename?: 'UnifiedSubscriptionBilling';
  cancelAtPeriodEnd: Scalars['Boolean'];
  currentPeriodEnd?: Maybe<Scalars['Date']>;
  renewalNeeded: Scalars['Boolean'];
};

export type UniversalAsset = {
  __typename?: 'UniversalAsset';
  assetId?: Maybe<Scalars['String']>;
  assetType?: Maybe<AssetType>;
  canMarkAsSpam?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  isSpam?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  uaid?: Maybe<Scalars['String']>;
};

export type UpdateBaseCurrencyMutationSchema = {
  __typename?: 'UpdateBaseCurrencyMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCostBasisMethodMutationSchema = {
  __typename?: 'UpdateCostBasisMethodMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCostBasisMethodTimelineMutationSchema = {
  __typename?: 'UpdateCostBasisMethodTimelineMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCostBasisPausedMutationSchema = {
  __typename?: 'UpdateCostBasisPausedMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCostBasisTrackingMutationSchema = {
  __typename?: 'UpdateCostBasisTrackingMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCostBasisTransactionMutation = {
  __typename?: 'UpdateCostBasisTransactionMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCountryCodeMutationSchema = {
  __typename?: 'UpdateCountryCodeMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateDatetimeTransactionMutation = {
  __typename?: 'UpdateDatetimeTransactionMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateExchangeSettingsMutationSchema = {
  __typename?: 'UpdateExchangeSettingsMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateExchangeWithApiKeyAndSecretInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  publicId: Scalars['String'];
};

export type UpdateExchangeWithApiKeyAndSecretMutationSchema = {
  __typename?: 'UpdateExchangeWithAPIKeyAndSecretMutationSchema';
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  updatedExchange?: Maybe<Exchange>;
};

export type UpdateExchangeWithApiKeyInput = {
  apiKey: Scalars['String'];
  publicId: Scalars['String'];
};

export type UpdateExchangeWithApiKeyMutationSchema = {
  __typename?: 'UpdateExchangeWithAPIKeyMutationSchema';
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  updatedExchange?: Maybe<Exchange>;
};

export type UpdateExchangeWithCustomerIdInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  customerId: Scalars['String'];
  publicId: Scalars['String'];
};

export type UpdateExchangeWithCustomerIdMutationSchema = {
  __typename?: 'UpdateExchangeWithCustomerIdMutationSchema';
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  updatedExchange?: Maybe<Exchange>;
};

export type UpdateExchangeWithOauthCodeInput = {
  /** Code received from initial authorize request */
  code: Scalars['String'];
  publicId: Scalars['String'];
  /** The redirect uri must be the same as the one used to generate the code. */
  redirectUri: Scalars['String'];
};

export type UpdateExchangeWithOauthCodeMutationSchema = {
  __typename?: 'UpdateExchangeWithOauthCodeMutationSchema';
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  updatedExchange?: Maybe<Exchange>;
};

export type UpdateExchangeWithPassphraseInput = {
  apiKey: Scalars['String'];
  apiSecret: Scalars['String'];
  passphrase: Scalars['String'];
  publicId: Scalars['String'];
};

export type UpdateExchangeWithPassphraseMutationSchema = {
  __typename?: 'UpdateExchangeWithPassphraseMutationSchema';
  error?: Maybe<ExchangeMutationErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  updatedExchange?: Maybe<Exchange>;
};

/** Edit integration instructions */
export type UpdateInstructionsMutationSchema = {
  __typename?: 'UpdateInstructionsMutationSchema';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLastUsedTaxYear = {
  __typename?: 'UpdateLastUsedTaxYear';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLendingTaxabilityMutationSchema = {
  __typename?: 'UpdateLendingTaxabilityMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLiquidStakingTaxabilityMutationSchema = {
  __typename?: 'UpdateLiquidStakingTaxabilityMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLiquidityTaxabilityMutationSchema = {
  __typename?: 'UpdateLiquidityTaxabilityMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateOperationsPurposeMutationSchema = {
  __typename?: 'UpdateOperationsPurposeMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateProceedsTransactionMutation = {
  __typename?: 'UpdateProceedsTransactionMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSkipInLinkDetectionMutation = {
  __typename?: 'UpdateSkipInLinkDetectionMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateStakingRewardsTaxabilityMutationSchema = {
  __typename?: 'UpdateStakingRewardsTaxabilityMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTaskInput = {
  status: TaskStatus;
  taskId: Scalars['UUID'];
};

export type UpdateTaskMutation = {
  __typename?: 'UpdateTaskMutation';
  error?: Maybe<UpdateTaskMutationError>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UpdateTaskMutationError {
  GenericError = 'generic_error'
}

export type UpdateTaxLotAllocationMethodMutationSchema = {
  __typename?: 'UpdateTaxLotAllocationMethodMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTaxYearMutationSchema = {
  __typename?: 'UpdateTaxYearMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTokenInput = {
  /** The number of tokens we estimate to change */
  count?: InputMaybe<Scalars['Int']>;
  /** The UAID of the existing token we are updating */
  existingUaid: Scalars['String'];
  /** The UAID of the new token we are updating to */
  newUaid: Scalars['String'];
  /** The wallet public_id to limit which transactions we update */
  walletPublicId: Scalars['String'];
};

export type UpdateTransactionActiveStatusMutation = {
  __typename?: 'UpdateTransactionActiveStatusMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UpdateTransactionErrors {
  CostBasisRunNotFound = 'cost_basis_run_not_found',
  EntryIdNotFound = 'entry_id_not_found',
  TaxEventNotFound = 'tax_event_not_found',
  TransactionNotFound = 'transaction_not_found'
}

export type UpdateTransactionLabelMutation = {
  __typename?: 'UpdateTransactionLabelMutation';
  markLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  newTransactionTags?: Maybe<Array<Maybe<Scalars['String']>>>;
  newTransactionType?: Maybe<ExtendedTransactionType>;
  success?: Maybe<Scalars['Boolean']>;
  unmarkLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateTransactionMutationSchema = {
  __typename?: 'UpdateTransactionMutationSchema';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTransactionTaxabilityMutation = {
  __typename?: 'UpdateTransactionTaxabilityMutation';
  error?: Maybe<UpdateTransactionErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTransactionsActiveStatusMutation = {
  __typename?: 'UpdateTransactionsActiveStatusMutation';
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  successes?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type UpdateTransactionsLabelMutation = {
  __typename?: 'UpdateTransactionsLabelMutation';
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  successes?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
};

export type UpdateTransactionsTaxabilityMutationSchema = {
  __typename?: 'UpdateTransactionsTaxabilityMutationSchema';
  error?: Maybe<UpdateTransactionErrors>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserDisplayedBalancesMutationSchema = {
  __typename?: 'UpdateUserDisplayedBalancesMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum UpdateUserSettingConfigurationErrors {
  ClosedPeriodError = 'closed_period_error',
  UnknownError = 'unknown_error'
}

export type UpdateUserStateSettingsMutationSchema = {
  __typename?: 'UpdateUserStateSettingsMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserSyncCutOffDateMutationSchema = {
  __typename?: 'UpdateUserSyncCutOffDateMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserTaxReportSettingsMutationSchema = {
  __typename?: 'UpdateUserTaxReportSettingsMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserTaxSettingsMutation = {
  __typename?: 'UpdateUserTaxSettingsMutation';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserTaxWithholdingSettingsMutationSchema = {
  __typename?: 'UpdateUserTaxWithholdingSettingsMutationSchema';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserUiThemeMutationSchema = {
  __typename?: 'UpdateUserUIThemeMutationSchema';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserinfoSettingMutation = {
  __typename?: 'UpdateUserinfoSettingMutation';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateWrappingTaxabilityMutationSchema = {
  __typename?: 'UpdateWrappingTaxabilityMutationSchema';
  error?: Maybe<UpdateUserSettingConfigurationErrors>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UploadCbeCsv = {
  __typename?: 'UploadCbeCsv';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UploadCbeCsvInput = {
  brokerId: Scalars['String'];
  file?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
};

export type UploadInfoField = {
  __typename?: 'UploadInfoField';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UploadPresignResult = {
  __typename?: 'UploadPresignResult';
  fileUrl?: Maybe<Scalars['String']>;
  postUrl?: Maybe<Scalars['String']>;
  uploadInfoFields?: Maybe<Array<Maybe<UploadInfoField>>>;
};

export type UpsertUserFromAuth0Schema = {
  __typename?: 'UpsertUserFromAuth0Schema';
  success?: Maybe<Scalars['Boolean']>;
};

export type UserCostBasisMethodSetting = {
  __typename?: 'UserCostBasisMethodSetting';
  costBasisMethod?: Maybe<CostBasisMethodSchema>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type UserCostBasisMethodTimelineSchema = {
  __typename?: 'UserCostBasisMethodTimelineSchema';
  hasAccess?: Maybe<Scalars['Boolean']>;
  userCostBasisSettings?: Maybe<Array<Maybe<UserCostBasisMethodSetting>>>;
};

export type UserCurrency = {
  __typename?: 'UserCurrency';
  cmcId?: Maybe<Scalars['Int']>;
  iconUrlFromInfo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  symbol: Scalars['String'];
  uaid: Scalars['String'];
};

/** Errors for checking if user email change is allowed */
export enum UserEmailChangeIsAllowedError {
  HasSocialProfiles = 'HAS_SOCIAL_PROFILES',
  MaxChangeLimitReached = 'MAX_CHANGE_LIMIT_REACHED',
  MaxChangeRequestLimitReached = 'MAX_CHANGE_REQUEST_LIMIT_REACHED'
}

export type UserEmailChangeIsAllowedResult = {
  __typename?: 'UserEmailChangeIsAllowedResult';
  error?: Maybe<UserEmailChangeIsAllowedError>;
  ok: Scalars['Boolean'];
};

export type UserEmailChangeRequestStatus = {
  __typename?: 'UserEmailChangeRequestStatus';
  fromEmail?: Maybe<Scalars['String']>;
  inProgress: Scalars['Boolean'];
  toEmail?: Maybe<Scalars['String']>;
};

/** GraphQL schema for user freezing state. */
export type UserFreezingSchema = {
  __typename?: 'UserFreezingSchema';
  endTime?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  isAvailable: Scalars['Boolean'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<UserFreezingStatus>;
};

/** An enumeration. */
export enum UserFreezingStatus {
  ErroredWithFrozenPeriods = 'errored_with_frozen_periods',
  ErroredWithUnfrozenPeriods = 'errored_with_unfrozen_periods',
  FreezingInProgress = 'freezing_in_progress',
  Frozen = 'frozen',
  UnfreezingInProgress = 'unfreezing_in_progress',
  Unfrozen = 'unfrozen'
}

export type UserInfo = {
  __typename?: 'UserInfo';
  accountReauthenticationNotification?: Maybe<Scalars['Boolean']>;
  analyticsId?: Maybe<Scalars['String']>;
  anonymousId?: Maybe<Scalars['String']>;
  auth0Sub?: Maybe<Scalars['String']>;
  availableCostBasisMethods?: Maybe<Array<Maybe<CostBasisMethodSchema>>>;
  baseCurrency?: Maybe<Currency>;
  closedPeriodDatetime?: Maybe<Scalars['DateTime']>;
  costBasisByWallet?: Maybe<Scalars['Boolean']>;
  costBasisComputeEndTime?: Maybe<Scalars['Date']>;
  costBasisComputeStartTime?: Maybe<Scalars['Date']>;
  costBasisLastSyncedAt?: Maybe<Scalars['DateTime']>;
  costBasisMethod?: Maybe<CostBasisMethod>;
  costBasisMethodDetails?: Maybe<CostBasisMethodSchema>;
  costBasisMethodTimeline?: Maybe<UserCostBasisMethodTimelineSchema>;
  costBasisPaused?: Maybe<Scalars['Boolean']>;
  costBasisRecomputationDate?: Maybe<Scalars['Date']>;
  costBasisStatus?: Maybe<CostBasisStatusSchema>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Int']>;
  creditsFormatted?: Maybe<Scalars['String']>;
  dailyPortfolioEmail?: Maybe<Scalars['Boolean']>;
  dailyPortfolioNotification?: Maybe<Scalars['Boolean']>;
  daysUntilTaxDeadline?: Maybe<Scalars['Int']>;
  debugPermission?: Maybe<Scalars['Boolean']>;
  displayUser?: Maybe<DisplayUser>;
  displayedBalances?: Maybe<DisplayedBalances>;
  emailChangeIsAllowed?: Maybe<UserEmailChangeIsAllowedResult>;
  emailChangeRequestStatus?: Maybe<UserEmailChangeRequestStatus>;
  enableCbe?: Maybe<Scalars['Boolean']>;
  enableEmbedded?: Maybe<Scalars['Boolean']>;
  freezing?: Maybe<UserFreezingSchema>;
  hasAnyWallet?: Maybe<Scalars['Boolean']>;
  hasPaidTaxPlanForYear?: Maybe<Scalars['Boolean']>;
  hasSpamHidden?: Maybe<Scalars['Boolean']>;
  hasTaxPlan?: Maybe<Scalars['Boolean']>;
  hasTransitioned?: Maybe<Scalars['Boolean']>;
  hasWalletsSpamHidden?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isAffiliate?: Maybe<Scalars['Boolean']>;
  isCostBasisRunning?: Maybe<Scalars['Boolean']>;
  isUndergoingAllocation?: Maybe<Scalars['Boolean']>;
  isUsingPersistedTransactions?: Maybe<Scalars['Boolean']>;
  lotAllocationMethod?: Maybe<LotAllocationMethod>;
  migrationPreviouslySoftBlocked?: Maybe<Scalars['Boolean']>;
  newTransactionsEmail?: Maybe<Scalars['Boolean']>;
  newTransactionsNotification?: Maybe<Scalars['Boolean']>;
  partnerSlug?: Maybe<Scalars['String']>;
  portfolioSubscription?: Maybe<Scalars['String']>;
  productUpdateEmail?: Maybe<Scalars['Boolean']>;
  publicId?: Maybe<Scalars['String']>;
  referralProperties?: Maybe<UserReferralProperties>;
  selectedTheme?: Maybe<UiTheme>;
  shouldHardcodeUsdcCostBasisToOne?: Maybe<Scalars['Boolean']>;
  shouldShowOnboardingFlow?: Maybe<Scalars['Boolean']>;
  showPlanDiscoverability?: Maybe<Scalars['Boolean']>;
  signedUpWithCoinbase?: Maybe<Scalars['Boolean']>;
  syncCutoffDate?: Maybe<Scalars['Date']>;
  taxEndDate?: Maybe<Scalars['Date']>;
  taxFilingDeadline?: Maybe<Scalars['Date']>;
  taxPlanUpgradeNeeded?: Maybe<Scalars['Boolean']>;
  taxPlans?: Maybe<Array<Maybe<TaxPlan>>>;
  taxStartDate?: Maybe<Scalars['Date']>;
  taxStartDay?: Maybe<Scalars['Int']>;
  taxStartMonth?: Maybe<Scalars['Int']>;
  unifiedSubscription?: Maybe<UnifiedSubscription>;
  useV2Lots?: Maybe<Scalars['Boolean']>;
  /** The user id of the user being viewed. Can only be accessed by admins */
  viewAsUserId?: Maybe<Scalars['String']>;
};


export type UserInfoHasPaidTaxPlanForYearArgs = {
  year?: InputMaybe<Scalars['Int']>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  createdWithPassword?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  isCpa?: Maybe<Scalars['Boolean']>;
  isTwoStepVerificationEnabled?: Maybe<Scalars['Boolean']>;
  publicId?: Maybe<Scalars['String']>;
};

export type UserPropertiesObj = {
  __typename?: 'UserPropertiesObj';
  coinbaseOneEnthusiastPromoTrialActivated?: Maybe<Scalars['Boolean']>;
  coinbaseOneEnthusiastPromoTrialQualified?: Maybe<Scalars['Boolean']>;
  hasStakingRewardsHidden?: Maybe<Scalars['Boolean']>;
};

export type UserReferralProperties = {
  __typename?: 'UserReferralProperties';
  boughtTaxPlanUsersEmail?: Maybe<Array<Maybe<Scalars['String']>>>;
  creditsEarned?: Maybe<Scalars['Int']>;
  expectedCredits?: Maybe<Scalars['Int']>;
  inviteCode?: Maybe<Scalars['String']>;
  referralLink?: Maybe<Scalars['String']>;
  signedUpUsersEmail?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** An enumeration. */
export enum UserSettings {
  DebugPermission = 'DEBUG_PERMISSION',
  RegisteredAsTaxPro = 'REGISTERED_AS_TAX_PRO',
  SendAccountReauthenticationNotificationsToMobile = 'SEND_ACCOUNT_REAUTHENTICATION_NOTIFICATIONS_TO_MOBILE',
  SendMarketingEmails = 'SEND_MARKETING_EMAILS',
  SendNewTransactionsByEmail = 'SEND_NEW_TRANSACTIONS_BY_EMAIL',
  SendNewTransactionsToMobile = 'SEND_NEW_TRANSACTIONS_TO_MOBILE',
  SendPortfolioUpdatesByEmail = 'SEND_PORTFOLIO_UPDATES_BY_EMAIL',
  SendPortfolioUpdatesToMobile = 'SEND_PORTFOLIO_UPDATES_TO_MOBILE',
  TaxPlanAutoRenewal = 'TAX_PLAN_AUTO_RENEWAL'
}

export type UserStakingAndLendingAsset = {
  __typename?: 'UserStakingAndLendingAsset';
  uaid: Scalars['String'];
  walletPublicId?: Maybe<Scalars['String']>;
};

export type UserStats = {
  __typename?: 'UserStats';
  numberOfCustomWallets?: Maybe<Scalars['Int']>;
  numberOfExchanges?: Maybe<Scalars['Int']>;
  numberOfLocalWallets?: Maybe<Scalars['Int']>;
};

export type UserTaxYear = {
  __typename?: 'UserTaxYear';
  dateRange?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
  taxYear?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type ValidationData = {
  __typename?: 'ValidationData';
  state: Scalars['String'];
};

export enum VerifyUserEmailChangeMutationError {
  OtpNotMatched = 'OTP_NOT_MATCHED',
  UnknownError = 'UNKNOWN_ERROR'
}

export type VerifyUserEmailChangeMutationResult = {
  __typename?: 'VerifyUserEmailChangeMutationResult';
  error?: Maybe<VerifyUserEmailChangeMutationError>;
  ok: Scalars['Boolean'];
};

export type Wallet = {
  __typename?: 'Wallet';
  address?: Maybe<Scalars['String']>;
  allowsHardResync?: Maybe<Scalars['Boolean']>;
  assetsCount?: Maybe<Scalars['Int']>;
  balance?: Maybe<Scalars['Float']>;
  calculatedBalance?: Maybe<Scalars['Float']>;
  calculatedValue?: Maybe<Scalars['Float']>;
  calculatedValueWithoutTokens?: Maybe<Scalars['Float']>;
  computedCryptoTransactionCount?: Maybe<Scalars['Int']>;
  computedTransactionCount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  hasDefiActivity?: Maybe<Scalars['Boolean']>;
  hasIgnoredTransactionsInFrozenPeriod?: Maybe<Scalars['Boolean']>;
  hasTransactionsInFrozenPeriod?: Maybe<Scalars['Boolean']>;
  headerLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  isBalanceDifferenceSignificant?: Maybe<Scalars['Boolean']>;
  isMining?: Maybe<Scalars['Boolean']>;
  isPortfolioValueDifferenceSignificant?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nfts?: Maybe<Array<Maybe<Nft>>>;
  numManualEdits?: Maybe<Scalars['Int']>;
  parentAccountId?: Maybe<Scalars['ID']>;
  parentAccountImageUrl?: Maybe<Scalars['String']>;
  parentAccountName?: Maybe<Scalars['String']>;
  syncInfo?: Maybe<SyncInfo>;
  syncProgress?: Maybe<SyncProgress>;
  tokens?: Maybe<Array<Maybe<Token>>>;
  transactionLabel?: Maybe<Scalars['String']>;
  uaid?: Maybe<Scalars['String']>;
  userAssetBalances?: Maybe<Array<Maybe<Balance>>>;
  value?: Maybe<Scalars['Float']>;
  valueWithoutTokens?: Maybe<Scalars['Float']>;
  walletNetwork?: Maybe<Scalars['String']>;
};

export type WalletAllocation = {
  __typename?: 'WalletAllocation';
  calculatedBalance?: Maybe<Scalars['Float']>;
  isBalanceDifferenceSignificant?: Maybe<Scalars['Boolean']>;
  isIntegration?: Maybe<Scalars['Boolean']>;
  reportedBalance?: Maybe<Scalars['Float']>;
  walletIconUrl?: Maybe<Scalars['String']>;
  walletName?: Maybe<Scalars['String']>;
  walletPublicId?: Maybe<Scalars['String']>;
  walletSlug?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum WalletClassification {
  CustomWallet = 'CustomWallet',
  UnknownWallet = 'UnknownWallet',
  Wallet = 'Wallet'
}

/** An enumeration. */
export enum WalletRenameErrors {
  MissingName = 'missing_name',
  WalletNotFound = 'wallet_not_found',
  WalletUnderExchange = 'wallet_under_exchange'
}

/** An enumeration. */
export enum WalletTypeEnum {
  CustomWallet = 'CUSTOM_WALLET',
  Wallet = 'WALLET'
}

export type WatchlistToggle = {
  __typename?: 'WatchlistToggle';
  isInWatchlist?: Maybe<Scalars['Boolean']>;
};

export type GetAppInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppInfoQuery = { __typename?: 'Query', appInfo?: { __typename?: 'AppInfo', maintenanceMode?: boolean | null, maintenanceMessage?: string | null, isViewAsUser?: boolean | null, webAppHomePage?: string | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, enableCbe?: boolean | null, viewAsUserId?: string | null, anonymousId?: string | null, analyticsId?: string | null, createdAt?: string | null, displayedBalances?: DisplayedBalances | null, useV2Lots?: boolean | null, shouldShowOnboardingFlow?: boolean | null, portfolioSubscription?: string | null, debugPermission?: boolean | null, isAdmin?: boolean | null, isAffiliate?: boolean | null, enableEmbedded?: boolean | null, closedPeriodDatetime?: any | null, showPlanDiscoverability?: boolean | null, daysUntilTaxDeadline?: number | null, selectedTheme?: UiTheme | null, syncCutoffDate?: any | null, costBasisByWallet?: boolean | null, lotAllocationMethod?: LotAllocationMethod | null, isUndergoingAllocation?: boolean | null, migrationPreviouslySoftBlocked?: boolean | null, hasTransitioned?: boolean | null, isUsingPersistedTransactions?: boolean | null, hasWalletsSpamHidden?: boolean | null, unifiedSubscription?: { __typename?: 'UnifiedSubscription', subscriptionPlan: SubscriptionPlan } | null, baseCurrency?: { __typename?: 'Currency', cmcId?: number | null, type?: CurrencyType | null, uaid?: string | null, symbol?: string | null, formatSymbol?: string | null, priceUsd?: number | null, name?: string | null } | null, country?: { __typename?: 'Country', code?: string | null, name?: string | null, canAccessTaxLossHarvesting?: boolean | null } | null, displayUser?: { __typename?: 'DisplayUser', publicId?: string | null, isWhitelisted?: boolean | null, hasDefi?: boolean | null, email?: string | null, registeredAsTaxPro?: boolean | null, taxYearToUse?: number | null, country?: { __typename?: 'Country', code?: string | null, name?: string | null, canAccessTaxLossHarvesting?: boolean | null } | null } | null, emailChangeIsAllowed?: { __typename?: 'UserEmailChangeIsAllowedResult', ok: boolean, error?: UserEmailChangeIsAllowedError | null } | null, emailChangeRequestStatus?: { __typename?: 'UserEmailChangeRequestStatus', inProgress: boolean, fromEmail?: string | null, toEmail?: string | null } | null } | null, userProfile?: { __typename?: 'UserProfile', email?: string | null, isCpa?: boolean | null } | null, myProfile?: { __typename?: 'UserProfile', createdWithPassword?: boolean | null, isTwoStepVerificationEnabled?: boolean | null } | null, session?: { __typename?: 'SessionObj', taxProsReturnPublicId?: string | null, anonymousId?: string | null } | null };

export type PresignMutationVariables = Exact<{
  filename: Scalars['String'];
}>;


export type PresignMutation = { __typename?: 'Mutations', presignFileUpload?: { __typename?: 'PresignFileUploadMutation', success?: boolean | null, error?: string | null, result?: { __typename?: 'UploadPresignResult', fileUrl?: string | null, postUrl?: string | null, uploadInfoFields?: Array<{ __typename?: 'UploadInfoField', key?: string | null, value?: string | null } | null> | null } | null } | null };

export type GetCostBasisStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCostBasisStatusQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, isUndergoingAllocation?: boolean | null, isCostBasisRunning?: boolean | null, costBasisLastSyncedAt?: any | null, costBasisComputeStartTime?: any | null, costBasisComputeEndTime?: any | null, costBasisRecomputationDate?: any | null, costBasisPaused?: boolean | null, costBasisStatus?: { __typename?: 'CostBasisStatusSchema', state?: CostBasisState | null, priority?: QueuePriority | null } | null } | null };

export type GetFreezingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFreezingStatusQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, freezing?: { __typename?: 'UserFreezingSchema', isAvailable: boolean, startTime?: any | null, endTime?: any | null, lastUpdatedAt?: any | null, status?: UserFreezingStatus | null, error?: string | null } | null } | null };

export type GetUserLendingStakingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLendingStakingDataQuery = { __typename?: 'Query', userLendingAndStakingAssets?: Array<{ __typename?: 'UserStakingAndLendingAsset', walletPublicId?: string | null, uaid: string } | null> | null };

export type GetYourAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYourAssetsQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', hasAccessToPerformanceByCrypto: boolean, currencies?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, reportedQuantity?: number | null, calculatedQuantity?: number | null, marketValue?: number | null, reportedMarketValue?: number | null, calculatedMarketValue?: number | null, costBasis?: number | null, averageCostBasis?: number | null, allTimeReturn?: number | null, allTimeReturnPercent?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, netTotalWithdrawals?: number | null, netTotalDeposits?: number | null, portfolioPercent?: number | null, error?: string | null, currency?: { __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null, slug?: string | null, symbol?: string | null, name?: string | null, price?: number | null, marketCap?: number | null, percentChange24h?: number | null, iconUrlFromInfo?: string | null } | null } | null> | null, fiats?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null, price?: number | null } | null } | null> | null, userAssets?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null, price?: number | null } | null } | null> | null } | null };

export type SearchCurrenciesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  showCryptos: Scalars['Boolean'];
  hideInactiveCryptos: Scalars['Boolean'];
  showFiats: Scalars['Boolean'];
  showUserAssets: Scalars['Boolean'];
}>;


export type SearchCurrenciesQuery = { __typename?: 'Query', searchCurrencies?: { __typename?: 'SearchCurrencies', cryptos?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null, fiats?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null, userAssets?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null, nfts?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null, blockchainTokens?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null, virtualTokens?: Array<{ __typename?: 'SearchCurrency', id?: string | null, icon?: string | null, name?: string | null, symbol?: string | null, uaid?: string | null } | null> | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countriesList?: Array<{ __typename?: 'Country', name?: string | null, code?: string | null } | null> | null };

export type GetPlanDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlanDiscountsQuery = { __typename?: 'Query', availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', plans: Array<{ __typename?: 'UnifiedPlanDetails', name?: string | null, price?: { __typename?: 'PriceInfo', discountReason?: string | null } | null }> } };

export type AcceptTaxProClientInviteMutationVariables = Exact<{
  senderPublicId: Scalars['String'];
  currentUserRole: TaxProClientInviteInitiator;
}>;


export type AcceptTaxProClientInviteMutation = { __typename?: 'Mutations', acceptTaxProClientInvite?: { __typename?: 'AcceptTaxProClientInviteMutationSchema', success?: boolean | null } | null };

export type GetIncomingInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIncomingInvitesQuery = { __typename?: 'Query', firmInvitesForPro?: Array<{ __typename?: 'TaxFirmInviteObj', email?: string | null, taxFirm?: { __typename?: 'TaxFirm', publicId?: string | null, name?: string | null } | null } | null> | null, taxProClientInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', taxProPublicId?: string | null, clientPublicId?: string | null, taxProEmail?: string | null, clientEmail?: string | null, senderEmail?: string | null, initiatedBy: TaxProClientInviteInitiator } | null> | null };

export type GetCurrenciesQueryVariables = Exact<{
  queries: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type GetCurrenciesQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', symbol?: string | null } | null> | null };

export type LotImporterStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type LotImporterStatusQuery = { __typename?: 'Query', lotImporterStatus?: { __typename?: 'LotImporterStatusSchema', jobStatus?: JobStatus | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, isCostBasisRunning?: boolean | null } | null };

export type SubmitLotsFileMutationVariables = Exact<{
  fileUrl: Scalars['String'];
}>;


export type SubmitLotsFileMutation = { __typename?: 'Mutations', submitLotsFile?: { __typename?: 'LotImporterMutationSchema', success?: boolean | null } | null };

export type AcceptFirmInviteMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
}>;


export type AcceptFirmInviteMutation = { __typename?: 'Mutations', acceptFirmInvite?: { __typename?: 'AcceptFirmInviteMutationSchema', success?: boolean | null } | null };

export type AddFirmAdminMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  email: Scalars['String'];
}>;


export type AddFirmAdminMutation = { __typename?: 'Mutations', addFirmAdmin?: { __typename?: 'AddFirmAdminMutationSchema', success?: boolean | null } | null };

export type AdminAddTaxProForClientMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  clientEmail: Scalars['String'];
  taxProEmail: Scalars['String'];
}>;


export type AdminAddTaxProForClientMutation = { __typename?: 'Mutations', adminAddTaxProForClient?: { __typename?: 'AdminAddTaxProForClient', success?: boolean | null } | null };

export type AdminRemoveTaxProForClientMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  clientEmail: Scalars['String'];
  taxProEmail: Scalars['String'];
}>;


export type AdminRemoveTaxProForClientMutation = { __typename?: 'Mutations', adminRemoveTaxProForClient?: { __typename?: 'AdminRemoveTaxProForClient', success?: boolean | null } | null };

export type DeleteFirmInviteMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  email: Scalars['String'];
}>;


export type DeleteFirmInviteMutation = { __typename?: 'Mutations', deleteFirmInvite?: { __typename?: 'DeleteFirmInviteMutationSchema', success?: boolean | null } | null };

export type DeleteFirmMemberMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  userPublicId: Scalars['String'];
}>;


export type DeleteFirmMemberMutation = { __typename?: 'Mutations', deleteFirmMember?: { __typename?: 'DeleteFirmMemberMutationSchema', success?: boolean | null } | null };

export type GetTaxFirmMembersQueryVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
}>;


export type GetTaxFirmMembersQuery = { __typename?: 'Query', taxFirm?: { __typename?: 'TaxFirm', name?: string | null, publicId?: string | null } | null, firmMembers?: Array<{ __typename?: 'TaxFirmMemberObj', userPublicId?: string | null, role?: TaxFirmRole | null, email?: string | null, sentInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', clientEmail?: string | null } | null> | null, receivedInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', senderEmail?: string | null } | null> | null } | null> | null, firmInvites?: Array<{ __typename?: 'TaxFirmInviteObj', email?: string | null } | null> | null };

export type GetTaxFirmMembersWithClientsQueryVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
}>;


export type GetTaxFirmMembersWithClientsQuery = { __typename?: 'Query', taxFirm?: { __typename?: 'TaxFirm', name?: string | null, publicId?: string | null } | null, firmMembers?: Array<{ __typename?: 'TaxFirmMemberObj', userPublicId?: string | null, role?: TaxFirmRole | null, email?: string | null, taxProClients?: Array<{ __typename?: 'TaxProsClientObj', email?: string | null, createdAt?: any | null } | null> | null, sentInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', clientEmail?: string | null } | null> | null, receivedInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', senderEmail?: string | null } | null> | null } | null> | null, firmInvites?: Array<{ __typename?: 'TaxFirmInviteObj', email?: string | null } | null> | null };

export type InviteProToFirmMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
  email: Scalars['String'];
}>;


export type InviteProToFirmMutation = { __typename?: 'Mutations', inviteProToFirm?: { __typename?: 'InviteProToFirmMutationSchema', success?: boolean | null } | null };

export type DeleteTaxProClientMutationVariables = Exact<{
  partnerPublicId: Scalars['String'];
  currentUserRole: TaxProClientInviteInitiator;
}>;


export type DeleteTaxProClientMutation = { __typename?: 'Mutations', deleteTaxProClient?: { __typename?: 'DeleteTaxProClientMutationSchema', success?: boolean | null } | null };

export type DeleteTaxProClientInviteMutationVariables = Exact<{
  senderPublicId: Scalars['String'];
  recipientEmail: Scalars['String'];
  initiatedBy: TaxProClientInviteInitiator;
}>;


export type DeleteTaxProClientInviteMutation = { __typename?: 'Mutations', deleteTaxProClientInvite?: { __typename?: 'DeleteTaxProClientInviteMutationSchema', success?: boolean | null } | null };

export type GetTaxProClientListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxProClientListQuery = { __typename?: 'Query', taxYear?: number | null, currentTaxFirm?: { __typename?: 'TaxFirm', name?: string | null, publicId?: string | null } | null, taxProClientInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', taxProPublicId?: string | null, clientEmail?: string | null, initiatedBy: TaxProClientInviteInitiator } | null> | null, taxProClients?: Array<{ __typename?: 'TaxProsClientObj', taxProsFirmMemberPublicId?: string | null, userPublicId?: string | null, email?: string | null, requiredTaxPlanStatus?: RequiredTaxPlanStatus | null } | null> | null };

export type InviteTaxProClientMutationVariables = Exact<{
  email: Scalars['String'];
  currentUserRole: TaxProClientInviteInitiator;
}>;


export type InviteTaxProClientMutation = { __typename?: 'Mutations', inviteTaxProClient?: { __typename?: 'InviteTaxProClientMutationSchema', success?: boolean | null } | null };

export type GetTaxProListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxProListQuery = { __typename?: 'Query', taxProClientInvites?: Array<{ __typename?: 'TaxProsClientInviteObj', clientPublicId?: string | null, taxProEmail?: string | null, initiatedBy: TaxProClientInviteInitiator } | null> | null, taxPros?: Array<{ __typename?: 'TaxProsClientObj', taxProsFirmMemberPublicId?: string | null, userPublicId?: string | null, taxProEmail?: string | null } | null> | null };

export type LeaveFirmMutationVariables = Exact<{
  taxFirmPublicId: Scalars['String'];
}>;


export type LeaveFirmMutation = { __typename?: 'Mutations', leaveFirm?: { __typename?: 'LeaveFirmMutationSchema', success?: boolean | null } | null };

export type EnqueueCostBasisMutationVariables = Exact<{
  priority: QueuePriority;
}>;


export type EnqueueCostBasisMutation = { __typename?: 'Mutations', enqueueCostBasis?: { __typename?: 'EnqueueCostBasisJobMutationSchema', success?: boolean | null, error?: EnqueueCostBasisJobErrors | null } | null };

export type GetSyncingAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSyncingAccountsQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, hasAnyWallet?: boolean | null } | null, localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, address?: string | null, name?: string | null, value?: number | null, assetsCount?: number | null, walletNetwork?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, imageUrl?: string | null, name?: string | null, value?: number | null, defaultName?: string | null, assetsCount?: number | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null> | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null, name?: string | null, assetsCount?: number | null, syncInfo?: { __typename?: 'SyncInfo', isSyncing?: boolean | null, willBeDeleted?: boolean | null, lastSynced?: any | null } | null } | null> | null };

export type GetWalletsAndAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWalletsAndAccountsQuery = { __typename?: 'Query', exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null } | null } | null> | null, localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null } | null } | null> | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null } | null } | null> | null };

export type GetTaxPlanYearQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxPlanYearQuery = { __typename?: 'Query', availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', transactionCountingYear?: number | null } };

export type GetPlansForSidebarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlansForSidebarQuery = { __typename?: 'Query', unifiedSubscription?: { __typename?: 'UnifiedSubscription', transactionLimit: number, subscriptionPlan: SubscriptionPlan, recommendedPlanForTax?: { __typename?: 'UnifiedPlanDetails', price?: { __typename?: 'PriceInfo', discount: any, discountReason?: string | null } | null } | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', netTransactionCount: number } | null } | null };

export type GetSpamInfoForSideBarQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpamInfoForSideBarQuery = { __typename?: 'Query', spamAssets?: Array<{ __typename?: 'SpamAsset', isSpam?: boolean | null, wasAutomarkedAsSpam?: boolean | null } | null> | null };

export type GetTaxInfoForSideBarQueryVariables = Exact<{
  taxYear: Scalars['Int'];
  taskStatus: TaskStatus;
}>;


export type GetTaxInfoForSideBarQuery = { __typename?: 'Query', taxSummary?: { __typename?: 'TaxSummary', errorsCount?: number | null, transactionCount?: number | null, sendsCount?: number | null, receivesCount?: number | null, calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, calloutCountMissingBalance?: number | null, capitalGain?: string | null, taxableIncomeTotal?: string | null, estimatedTaxes?: string | null, taxPlan?: { __typename?: 'TaxPlan', shouldRenew?: boolean | null } | null } | null, tasksByType?: { __typename?: 'TasksByType', status: TaskStatus, taskType: TaskType, tasks: Array<{ __typename?: 'FixApiCredentialsTask', id: any } | null>, pageInfo?: { __typename?: 'PageInfo', total: number } | null } | null, userStats?: { __typename?: 'UserStats', numberOfExchanges?: number | null, numberOfLocalWallets?: number | null, numberOfCustomWallets?: number | null } | null, unifiedSubscription?: { __typename?: 'UnifiedSubscription', recommendedPlanForTax?: { __typename?: 'UnifiedPlanDetails', price?: { __typename?: 'PriceInfo', discountReason?: string | null } | null } | null } | null };

export type GetTaxYearQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxYearQuery = { __typename?: 'Query', availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', transactionCountingYear?: number | null } };

export type CreateUserFeedbackMessageMutationVariables = Exact<{
  message?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
}>;


export type CreateUserFeedbackMessageMutation = { __typename?: 'Mutations', createUserFeedbackMessage?: { __typename?: 'CreateUserFeedbackMessage', success?: boolean | null } | null };

export type ImportNftMutationVariables = Exact<{
  address: Scalars['String'];
  tokenId: Scalars['String'];
  costBasis: Scalars['Float'];
  dateAcquired: Scalars['String'];
  walletId: Scalars['String'];
}>;


export type ImportNftMutation = { __typename?: 'Mutations', importNft?: { __typename?: 'NFTImporterMutationSchema', success?: boolean | null } | null };

export type UpdateInstructionsMutationVariables = Exact<{
  slug: Scalars['String'];
  instructions: Scalars['String'];
}>;


export type UpdateInstructionsMutation = { __typename?: 'Mutations', updateInstructions?: { __typename?: 'UpdateInstructionsMutationSchema', success?: boolean | null } | null };

export type AddCbeDepositMutationVariables = Exact<{
  input: AddCbeDepositInput;
}>;


export type AddCbeDepositMutation = { __typename?: 'Mutations', addCbeDeposit?: { __typename?: 'AddCbeDeposit', success?: boolean | null, message?: string | null } | null };

export type AddCbeDisposalMutationVariables = Exact<{
  input: AddCbeDisposalInput;
}>;


export type AddCbeDisposalMutation = { __typename?: 'Mutations', addCbeDisposal?: { __typename?: 'AddCbeDisposal', success?: boolean | null, message?: string | null } | null };

export type GetCbeUserCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCbeUserCurrenciesQuery = { __typename?: 'Query', cbeUserCurrencies?: Array<{ __typename?: 'UserCurrency', uaid: string, slug?: string | null, name: string, symbol: string, cmcId?: number | null, iconUrlFromInfo?: string | null } | null> | null };

export type ResetCbeDemoUserMutationVariables = Exact<{
  input: ResetCbeUserInput;
}>;


export type ResetCbeDemoUserMutation = { __typename?: 'Mutations', resetCbeUser?: { __typename?: 'ResetCbeUser', success?: boolean | null, message?: string | null } | null };

export type GetBrokerTaxPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokerTaxPageQuery = { __typename?: 'Query', cbeUserSettings?: { __typename?: 'CBEUserSettings', isExchangeReportingBasis: boolean } | null };

export type UpdateExchangeReportingBasisMutationVariables = Exact<{
  isExchangeReportingBasis: Scalars['Boolean'];
}>;


export type UpdateExchangeReportingBasisMutation = { __typename?: 'Mutations', updateExchangeSettings?: { __typename?: 'UpdateExchangeSettingsMutationSchema', message?: string | null, success?: boolean | null } | null };

export type GetAvailableTaxSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableTaxSettingsQuery = { __typename?: 'Query', availableSettings?: Array<{ __typename?: 'TaxIdMethod', setting: string } | null> | null };

export type GetCbeTaxMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCbeTaxMethodQuery = { __typename?: 'Query', cbeUserSettings?: { __typename?: 'CBEUserSettings', userTaxReportingStatus: boolean, isExchangeReportingBasis: boolean } | null, cbeUserTaxSettings?: Array<{ __typename?: 'TaxSettings', startDate: any, endDate: any, taxIdMethod: string } | null> | null };

export type UpdateUserTaxSettingsCbeMutationVariables = Exact<{
  input: Array<InputMaybe<TaxSettingsInput>> | InputMaybe<TaxSettingsInput>;
}>;


export type UpdateUserTaxSettingsCbeMutation = { __typename?: 'Mutations', updateUserTaxSettings?: { __typename?: 'UpdateUserTaxSettingsMutation', success?: boolean | null, message?: string | null } | null };

export type ConsumerTaxSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsumerTaxSettingsQuery = { __typename?: 'Query', cbeUserSettings?: { __typename?: 'CBEUserSettings', userTaxReportingStatus: boolean } | null };

export type UpdateUserTaxReportSettingsMutationVariables = Exact<{
  userTaxReportingStatus: Scalars['Boolean'];
}>;


export type UpdateUserTaxReportSettingsMutation = { __typename?: 'Mutations', updateUserTaxReportSettings?: { __typename?: 'UpdateUserTaxReportSettingsMutationSchema', message?: string | null, success?: boolean | null } | null };

export type GetDemoTaxPageQueryVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type GetDemoTaxPageQuery = { __typename?: 'Query', taxYears?: Array<{ __typename?: 'UserTaxYear', taxYear?: number | null, title?: string | null, dateRange?: string | null } | null> | null, taxSummary?: { __typename?: 'TaxSummary', taxYear?: number | null, hasSufficientPlan?: boolean | null, taxReports?: { __typename?: 'TaxReports', capitalGainsCsv?: boolean | null } | null, taxPlan?: { __typename?: 'TaxPlan', shouldRenew?: boolean | null } | null } | null };

export type GetExchangeLevelReportQueryVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type GetExchangeLevelReportQuery = { __typename?: 'Query', exchangeLevelReport?: Array<{ __typename?: 'ExchangeTaxData', userId: string, txId: string, field8949Code: string, field1aCodeOfDa: string, field1bNameOfDa: string, field1cNumberOfUnits: string, field1dDateAcquired: string, field1eDateSold: string, field1fProceeds: string, field1gCostBasis: string, field2BasisReported: string, field3aReportedToTheIrs: string, field4FederalIncomeTaxWithheld: string, field6aGainOrLoss: string, field6bShortTerm: boolean, field6cLongTerm: boolean, field6dOrdinary: boolean, field7CashOnly: boolean, field8ReliedOnCustomerInfo: boolean, field9Noncovered: boolean, field11aGpAggregate: string, field11bNumberOfTxs: string, field11cSnftsFirstSale: string, field12aNumberOfUnitsTransferredIn: string, field12bTransferInDate: string, field14StateName: string, field15StateId: string, field16StateTaxWithheld: string, customerSpecificField1dDateAcquired: string, customerSpecificField1gCostBasis: string, customerSpecificField6aGainOrLoss: string } | null> | null };

export type GetDepositHistoryAuditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepositHistoryAuditQuery = { __typename?: 'Query', depositOverrideHistory?: { __typename?: 'DepositOverrideHistory', history?: any | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null, priceUsd?: number | null } | null } | null };

export type GainsLossesDisposedLotsQueryVariables = Exact<{
  taxYear?: InputMaybe<Scalars['Int']>;
  flowId?: InputMaybe<Scalars['String']>;
}>;


export type GainsLossesDisposedLotsQuery = { __typename?: 'Query', disposedLots?: Array<{ __typename?: 'DisposedLotData', id: string, assetName: string, dateAcquired: any, dateSold: any, adjustedCostBasis: any, adjustedAmountRealized: any, gainLoss: any, quantity: any, price: any, coveredState: string, holdingPeriod: string, flowId: string } | null> | null };

export type GetTaxYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxYearsQuery = { __typename?: 'Query', taxYears?: Array<{ __typename?: 'UserTaxYear', taxYear?: number | null, title?: string | null, dateRange?: string | null } | null> | null };

export type GetGraphLotsQueryVariables = Exact<{
  flowId: Scalars['String'];
  disposedLotId: Scalars['String'];
}>;


export type GetGraphLotsQuery = { __typename?: 'Query', graphData?: Array<{ __typename?: 'GraphData', availableLotNodes?: Array<{ __typename?: 'AvailableLotNodeData', id: string, startDate: any, quantity: any, dateAcquired: any, price: any, adjustedCostBasis: any, assetName: string, taxEvent: string, txQueryLinkId: string, storageType: string, coveredState: string, walletName: string } | null> | null, disposedLotNodes?: Array<{ __typename?: 'DisposedLotNodeData', id: string, quantity: any, adjustedCostBasis: any, adjustedAmountRealized: any, gainLoss: any, price: any, dateAcquired: any, dateSold: any, assetName: string, taxEvent: string, txQueryLinkId: string, coveredState: string } | null> | null, edges?: Array<{ __typename?: 'EdgeData', sourceNodeId: string, targetNodeId: string, edgeEvent: string } | null> | null } | null> | null };

export type GetTableLotsQueryVariables = Exact<{
  flowId: Scalars['String'];
}>;


export type GetTableLotsQuery = { __typename?: 'Query', availableLotNodes?: Array<{ __typename?: 'AvailableLotNodeData', id: string, startDate: any, quantity: any, dateAcquired: any, price: any, adjustedCostBasis: any, assetName: string, taxEvent: string, txQueryLinkId: string, storageType: string, coveredState: string, walletName: string } | null> | null };

export type GetConnectedCtUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedCtUsersQuery = { __typename?: 'Query', connectedCtUsers?: Array<{ __typename?: 'CostBasisEngineConnectUser', id?: number | null, email?: string | null } | null> | null, depositInformationStatus?: Array<{ __typename?: 'DepositInformation', transactionId?: string | null, hasDepositInformation?: boolean | null } | null> | null };

export type SyncConnectedCtUserDepositsMutationVariables = Exact<{
  input: SyncCtDepositInput;
}>;


export type SyncConnectedCtUserDepositsMutation = { __typename?: 'Mutations', syncCtDeposits?: { __typename?: 'SyncCtDeposit', success?: boolean | null, message?: string | null } | null };

export type GetCostBasisEnginePipelineStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCostBasisEnginePipelineStatusQuery = { __typename?: 'Query', cbePipelineStages?: Array<{ __typename?: 'TransactionStageStatus', stage?: string | null, status?: string | null, count?: number | null, minDatetime?: any | null, maxDatetime?: any | null } | null> | null };

export type UploadCostBasisEngineCsvMutationVariables = Exact<{
  input: UploadCbeCsvInput;
}>;


export type UploadCostBasisEngineCsvMutation = { __typename?: 'Mutations', uploadCbeCsv?: { __typename?: 'UploadCbeCsv', success?: boolean | null, message?: string | null } | null };

export type GetUserLotsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLotsQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', currencies?: Array<{ __typename?: 'PortfolioCurrency', currency?: { __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null, slug?: string | null, symbol?: string | null, name?: string | null, price?: number | null, marketCap?: number | null, percentChange24h?: number | null, iconUrlFromInfo?: string | null } | null } | null> | null, fiats?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null, price?: number | null } | null } | null> | null, userAssets?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null, price?: number | null } | null } | null> | null } | null };

export type AddUserAssetMutationVariables = Exact<{
  symbol: Scalars['String'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  priceUsd: Scalars['Float'];
}>;


export type AddUserAssetMutation = { __typename?: 'Mutations', addAsset?: { __typename?: 'AddAssetMutation', success?: boolean | null } | null };

export type EditUserAssetMutationVariables = Exact<{
  assetId: Scalars['Int'];
  symbol: Scalars['String'];
  name: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  priceUsd: Scalars['Float'];
}>;


export type EditUserAssetMutation = { __typename?: 'Mutations', editAsset?: { __typename?: 'EditAssetMutation', success?: boolean | null } | null };

export type GetUserAssetsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserAssetsQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetConnection', totalCount: number, edges?: Array<{ __typename?: 'Asset', id?: number | null, type?: CurrencyType | null, symbol?: string | null, name?: string | null, description?: string | null, priceUsd?: number | null } | null> | null } | null };

export type GetDashboardQueryVariables = Exact<{
  performanceDuration?: InputMaybe<PerformanceDuration>;
  toDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetDashboardQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', marketValue?: number | null, reportedMarketValue?: number | null, calculatedMarketValue?: number | null, isSignificantMarketValueDiff?: boolean | null, netFiat?: number | null, costBasis?: number | null, allTimeReturn?: number | null, allTimeReturnPercent?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, timeSpanMarketReturn?: number | null, timeSpanMarketReturnPercent?: number | null, netTotalDeposits?: number | null, netTotalWithdrawals?: number | null, hasSubscription: boolean, currencies?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, reportedQuantity?: number | null, calculatedQuantity?: number | null, marketValue?: number | null, reportedMarketValue?: number | null, calculatedMarketValue?: number | null, costBasis?: number | null, allTimeReturn?: number | null, allTimeReturnPercent?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, netTotalWithdrawals?: number | null, netTotalDeposits?: number | null, portfolioPercent?: number | null, error?: string | null, currency?: { __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, symbol?: string | null, name?: string | null, price?: number | null, marketCap?: number | null, percentChange24h?: number | null, iconUrlFromInfo?: string | null } | null } | null> | null, userAssets?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null, price?: number | null } | null } | null> | null } | null, performanceHistory?: { __typename?: 'PerformanceDataPointConnection', hasAccess: boolean, noAccessMessage?: string | null, hasAccessToPortfolioFeatures?: boolean | null, edges?: Array<{ __typename?: 'PerformanceDataPoint', date?: any | null, marketValue?: number | null, costBasis?: number | null, netTotalDeposits?: number | null, netTotalWithdrawals?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, returnOnInvestment?: number | null, returnOnInvestmentPercent?: number | null } | null> | null } | null };

export type GetHasWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHasWalletsQuery = { __typename?: 'Query', localWallets?: Array<{ __typename?: 'Wallet', id?: string | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null } | null> | null };

export type GetMarketValueQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketValueQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', marketValue?: number | null, reportedMarketValue?: number | null, calculatedMarketValue?: number | null, isSignificantMarketValueDiff?: boolean | null } | null };

export type GetPerformanceCardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPerformanceCardQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', costBasis?: number | null, allTimeReturn?: number | null, allTimeReturnPercent?: number | null } | null };

export type GetTaxLossPotentialQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxLossPotentialQuery = { __typename?: 'Query', taxLossHarvest?: { __typename?: 'TaxLossHarvest', taxLossTotals?: { __typename?: 'TaxLossTotals', potentialSavings?: number | null } | null } | null };

export type GetTaxSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxSummaryQuery = { __typename?: 'Query', taxSummaries?: Array<{ __typename?: 'TaxSummary', capitalGain?: string | null, taxIncome?: string | null, taxYear?: number | null, hasSufficientPlan?: boolean | null, hasPlan?: boolean | null, taxPlan?: { __typename?: 'TaxPlan', isUnified?: boolean | null } | null } | null> | null };

export type AccountLevelTaxSummaryQueryVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type AccountLevelTaxSummaryQuery = { __typename?: 'Query', accountLevelTaxSummary?: Array<{ __typename?: 'AccountLevelTaxSummary', walletPublicId?: string | null, walletName?: string | null, walletType?: string | null, taxSummary?: { __typename?: 'TaxSummary', taxYear?: number | null, hasPlan?: boolean | null, errorsCount?: number | null, taxYearTitle?: string | null, taxYearLabel?: string | null, taxStartDate?: string | null, taxEndDate?: string | null, hasSufficientPlan?: boolean | null, capitalGain?: string | null, capitalGainWithoutSymbol?: string | null, longTermGain?: string | null, longTermCostBasis?: string | null, longTermProceeds?: string | null, shortTermGain?: string | null, shortTermCostBasis?: string | null, shortTermProceeds?: string | null, shortTermCryptoToCryptoGain?: string | null, longTermCryptoToCryptoGain?: string | null, shortTermOtherGain?: string | null, longTermOtherGain?: string | null, totalGains?: string | null, totalLosses?: string | null, numberOfDisposals?: string | null, shortTermLosses?: string | null, totalShortTermLosses?: string | null, totalShortTermGains?: string | null, incomeSalary?: string | null, incomeFork?: string | null, incomeMining?: string | null, incomeAirdrops?: string | null, incomeStaking?: string | null, incomeInterest?: string | null, incomeOther?: string | null, incomeRoyalty?: string | null, totalGifts?: string | null, totalDonations?: string | null, donationShortTerm?: string | null, donationLongTerm?: string | null, netFuturesGains?: string | null, totalMarginFees?: string | null, totalInterestExpense?: string | null, taxIncome?: string | null, transactionCount?: number | null, freeTransactionsCount?: number | null, sendsCount?: number | null, receivesCount?: number | null, calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, calloutCountMissingBalance?: number | null, taxableIncomeTotal?: string | null, otherCategoriesTotal?: string | null, taxPlan?: { __typename?: 'TaxPlan', planName?: string | null, startDate?: string | null, dynamicTransactionLimitLabel?: string | null, transactionLimit?: number | null, type?: TaxPackage | null, isSufficient?: boolean | null, insufficientReason?: InsufficientPlanReason | null, shouldRenew?: boolean | null, isUnified?: boolean | null, insufficientUnifiedPlanShortReason?: string | null, insufficientUnifiedPlanLongReason?: string | null, hasGeneratedTaxReport?: boolean | null } | null, taxSummaryByAccounts?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByWallets?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByCustomWallets?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByForeignAccounts?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxReports?: { __typename?: 'TaxReports', irsForm8949?: boolean | null, condensedIrsForm8949?: boolean | null, irsScheduleDForm1040?: boolean | null, irsSchedule1Form1040?: boolean | null, craSchedule3?: boolean | null, selfFileWithCointracker?: boolean | null, hAndRBlock?: boolean | null, turboTaxOnlineSync?: boolean | null, turbotaxOnline?: boolean | null, taxcaddy8949?: boolean | null, taxcaddySchedule1?: boolean | null, turbotaxCdDownload?: boolean | null, taxactFile?: boolean | null, woltersKluwerCchFile?: boolean | null, transactionHistoryCsv?: boolean | null, capitalGainsCsv?: boolean | null } | null, taxConstants?: { __typename?: 'TaxConstants', faqUrl?: string | null, taxFormUrl?: string | null, taxInstructionsUrl?: string | null, fileOnlineUrl?: string | null } | null, taxItems?: Array<{ __typename?: 'TaxItem', name?: string | null, amount?: string | null, value?: number | null, transactionsCount?: number | null, isTaxable?: boolean | null, isTaxableNow?: boolean | null, taxEvent?: TaxEvent | null } | null> | null } | null } | null> | null };

export type GetCustomWalletDataForUpdateQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetCustomWalletDataForUpdateQuery = { __typename?: 'Query', customWallet?: { __typename?: 'CustomWallet', id?: string | null, name?: string | null, slug?: string | null, syncMethod?: string | null, instructions?: string | null, supportedFileFormats?: Array<FileFormats | null> | null } | null };

export type ImportCustomWalletTransactionsMutationVariables = Exact<{
  customWalletInput: ImportCustomWalletTransactionsInput;
}>;


export type ImportCustomWalletTransactionsMutation = { __typename?: 'Mutations', importCustomWalletTransactions?: { __typename?: 'ImportCustomWalletTransactionsMutationSchema', success?: boolean | null, jobId?: string | null, error?: CustomWalletMutationErrors | null } | null };

export type ImportExchangeTransactionsMutationVariables = Exact<{
  importTransactionsInput: ImportExchangeTransactionsInput;
}>;


export type ImportExchangeTransactionsMutation = { __typename?: 'Mutations', importExchangeTransactions?: { __typename?: 'ImportExchangeTransactionsSchema', success?: boolean | null, jobId?: string | null, error?: ExchangeMutationErrors | null } | null };

export type ConfirmSettingsMutationVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type ConfirmSettingsMutation = { __typename?: 'Mutations', confirmOnboardingSettings?: { __typename?: 'OnboardingConfirmSettingsMutation', success?: boolean | null } | null };

export type GetOnboardingUserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingUserDetailsQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, hasAnyWallet?: boolean | null, signedUpWithCoinbase?: boolean | null } | null };

export type GetCoinDiversityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoinDiversityQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', currencies?: Array<{ __typename?: 'PortfolioCurrency', marketValue?: number | null, portfolioPercent?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, name?: string | null } | null } | null> | null } | null };

export type GetPerformanceHistoryQueryVariables = Exact<{
  performanceDuration?: InputMaybe<PerformanceDuration>;
}>;


export type GetPerformanceHistoryQuery = { __typename?: 'Query', performanceHistory?: { __typename?: 'PerformanceDataPointConnection', hasAccess: boolean, noAccessMessage?: string | null, hasAccessToPerformanceFeatures?: boolean | null, hasAccessToPortfolioFeatures?: boolean | null, edges?: Array<{ __typename?: 'PerformanceDataPoint', date?: any | null, marketValue?: number | null, costBasis?: number | null, netTotalDeposits?: number | null, netTotalWithdrawals?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, returnOnInvestment?: number | null, returnOnInvestmentPercent?: number | null } | null> | null } | null };

export type GetPerformanceSummaryQueryVariables = Exact<{
  performanceDuration?: InputMaybe<PerformanceDuration>;
}>;


export type GetPerformanceSummaryQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', hasAccessToPerformanceByCrypto: boolean, marketValue?: number | null, calculatedMarketValue?: number | null, reportedMarketValue?: number | null, allTimeReturn?: number | null, totalReturnOnInvestment?: number | null, costBasis?: number | null, netTotalDeposits?: number | null, netTotalWithdrawals?: number | null, timeSpanMarketReturn?: number | null, timeSpanMarketReturnPercent?: number | null } | null };

export type GetPortfolioInsightsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortfolioInsightsQuery = { __typename?: 'Query', taxLossHarvest?: { __typename?: 'TaxLossHarvest', taxLossTotals?: { __typename?: 'TaxLossTotals', potentialSavings?: number | null, absUnrealizedLoss?: number | null } | null } | null, exchangeFunds?: { __typename?: 'ExchangeFundsInfo', value?: number | null, percent?: number | null } | null };

export type GetUserCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrenciesQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', currencies?: Array<{ __typename?: 'PortfolioCurrency', currency?: { __typename?: 'Currency', uaid?: string | null, slug?: string | null, symbol?: string | null, type?: CurrencyType | null, name?: string | null, cmcId?: number | null, iconUrlFromInfo?: string | null } | null } | null> | null } | null };

export type GetCurrencyForPricePageQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  timeSpan?: InputMaybe<PerformanceDuration>;
}>;


export type GetCurrencyForPricePageQuery = { __typename?: 'Query', currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, slug?: string | null, type?: CurrencyType | null, nameOrSymbol?: string | null, summary?: string | null, website?: string | null, whitepaper?: string | null, forum?: string | null, twitter?: string | null, reddit?: string | null, chat?: string | null, code?: string | null, cmcId?: number | null, priceUsd?: number | null, price?: number | null, marketCapUsd?: number | null, marketCap?: number | null, percentChange24h?: number | null, percentChange7d?: number | null, volume24hUsd?: number | null, volume24h?: number | null, availableSupply?: number | null, priceHigh?: number | null, priceLow?: number | null, priceHighDate?: string | null, priceLowDate?: string | null, marketDominance?: number | null, iconUrlFromInfo?: string | null, isInWatchlist?: boolean | null, similarCurrencies?: Array<{ __typename?: 'SearchCurrency', id?: string | null, symbol?: string | null, name?: string | null, price?: number | null, icon?: string | null, slug?: string | null, iconUrlFromInfo?: string | null } | null> | null, priceHistoryUsd?: Array<{ __typename?: 'CurrencyPriceHistory', date?: any | null, price?: number | null } | null> | null } | null, portfolio?: { __typename?: 'Portfolio', currencies?: Array<{ __typename?: 'PortfolioCurrency', portfolioPercent?: number | null, quantity?: number | null, marketValue?: number | null, currency?: { __typename?: 'Currency', slug?: string | null, symbol?: string | null, iconUrlFromInfo?: string | null } | null } | null> | null } | null };

export type PerformanceGraphListQueryQueryVariables = Exact<{
  normalizedNamesList: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  walletList: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  timeSpan?: InputMaybe<PerformanceDuration>;
}>;


export type PerformanceGraphListQueryQuery = { __typename?: 'Query', performanceGraphList?: Array<{ __typename?: 'PerformanceGraphList', symbol?: string | null, dataPoints?: Array<{ __typename?: 'PerformanceDataPointV2', dateTime?: any | null, balanceDelta?: number | null, runningBalance?: number | null, runningCostBasis?: number | null, marketValue?: number | null } | null> | null, graphBalance?: Array<{ __typename?: 'PerformanceGraphBalance', balanceDelta?: number | null, dateTime?: any | null, runningBalance?: number | null } | null> | null, graphMarketValue?: Array<{ __typename?: 'PerformanceGraphMarketValue', dateTime?: any | null, marketValue?: number | null } | null> | null } | null> | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, baseCurrency?: { __typename?: 'Currency', symbol?: string | null, priceUsd?: number | null, type?: CurrencyType | null } | null } | null };

export type PricingPageQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type PricingPageQuery = { __typename?: 'Query', currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, type?: CurrencyType | null, summary?: string | null, website?: string | null, whitepaper?: string | null, forum?: string | null, twitter?: string | null, reddit?: string | null, chat?: string | null, code?: string | null, cmcId?: number | null, priceUsd?: number | null, price?: number | null, marketCapUsd?: number | null, marketCap?: number | null, percentChange24h?: number | null, percentChange7d?: number | null, volume24hUsd?: number | null, volume24h?: number | null, availableSupply?: number | null, priceHigh?: number | null, priceLow?: number | null, priceHighDate?: string | null, priceLowDate?: string | null, iconUrlFromInfo?: string | null, marketDominance?: number | null, similarCurrencies?: Array<{ __typename?: 'SearchCurrency', id?: string | null, symbol?: string | null, name?: string | null, price?: number | null, icon?: string | null, slug?: string | null, iconUrlFromInfo?: string | null } | null> | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null, formatSymbol?: string | null, priceUsd?: number | null } | null } | null, portfolio?: { __typename?: 'Portfolio', currencies?: Array<{ __typename?: 'PortfolioCurrency', portfolioPercent?: number | null, quantity?: number | null, marketValue?: number | null, currency?: { __typename?: 'Currency', slug?: string | null, symbol?: string | null } | null } | null> | null } | null };

export type WatchlistToggleMutationVariables = Exact<{
  symbol?: InputMaybe<Scalars['String']>;
}>;


export type WatchlistToggleMutation = { __typename?: 'Mutations', watchlistToggle?: { __typename?: 'WatchlistToggle', isInWatchlist?: boolean | null } | null };

export type MarketInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketInfoQuery = { __typename?: 'Query', marketInfo?: { __typename?: 'MarketInfo', bitcoinPercentageOfMarketCap?: number | null, totalMarketCapUsd?: number | null, totalVolume24hUsd?: number | null, pricesLastUpdated?: any | null, ethereumPercentageOfMarketCap?: number | null } | null };

export type PriceQueryVariables = Exact<{
  symbol?: InputMaybe<Scalars['String']>;
}>;


export type PriceQuery = { __typename?: 'Query', price?: { __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, symbol?: string | null, name?: string | null, nameOrSymbol?: string | null, priceUsd?: number | null, marketCap?: number | null, percentChange24h?: number | null, isInWatchlist?: boolean | null, volume24hUsd?: number | null, maxSupply?: number | null, availableSupply?: number | null } | null };

export type PricesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PricesQuery = { __typename?: 'Query', prices?: { __typename?: 'CurrenciesConnection', totalCount: number, edges?: Array<{ __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, slug?: string | null, symbol?: string | null, name?: string | null, nameOrSymbol?: string | null, priceUsd?: number | null, marketCap?: number | null, percentChange24h?: number | null, isInWatchlist?: boolean | null, volume24hUsd?: number | null, maxSupply?: number | null, availableSupply?: number | null } | null> | null } | null };

export type WatchlistPricesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type WatchlistPricesQuery = { __typename?: 'Query', prices?: { __typename?: 'CurrenciesConnection', totalCount: number, edges?: Array<{ __typename?: 'Currency', type?: CurrencyType | null, cmcId?: number | null, slug?: string | null, symbol?: string | null, name?: string | null, nameOrSymbol?: string | null, priceUsd?: number | null, marketCap?: number | null, percentChange24h?: number | null, isInWatchlist?: boolean | null, volume24hUsd?: number | null, maxSupply?: number | null, availableSupply?: number | null } | null> | null } | null };

export type GenerateCoinbaseOneCreditMutationVariables = Exact<{
  input: GenerateCoinbaseOneCreditInput;
}>;


export type GenerateCoinbaseOneCreditMutation = { __typename?: 'Mutations', generateCoinbaseOneCredit?: { __typename?: 'GenerateCoinbaseOneCredit', coinbaseOneCreditStatus: { __typename?: 'CoinbaseOneCreditStatusOutput', status?: CoinbaseOneCreditStatus | null, tier?: CoinbaseOneTier | null, creditValue?: string | null } } | null };

export type GetCoinbaseOneCreditStatusQueryVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type GetCoinbaseOneCreditStatusQuery = { __typename?: 'Query', coinbaseOneCreditStatus: { __typename?: 'CoinbaseOneCreditStatusOutput', status?: CoinbaseOneCreditStatus | null, tier?: CoinbaseOneTier | null, creditValue?: string | null } };

export type GetTaxProUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxProUserInfoQuery = { __typename?: 'Query', currentTaxFirm?: { __typename?: 'TaxFirm', publicId?: string | null, currentMember?: { __typename?: 'TaxFirmMemberObj', role?: TaxFirmRole | null } | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, displayUser?: { __typename?: 'DisplayUser', registeredAsTaxPro?: boolean | null } | null } | null };

export type RegisterAsTaxProMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterAsTaxProMutation = { __typename?: 'Mutations', registerAsTaxPro?: { __typename?: 'RegisterAsTaxProMutationSchema', success?: boolean | null } | null };

export type EditFirmMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  description: Scalars['String'];
  emailSuffix: Scalars['String'];
  partnerType?: InputMaybe<PartnerType>;
  isContracted?: InputMaybe<Scalars['Boolean']>;
  taxPlanDiscountPercent?: InputMaybe<Scalars['Int']>;
}>;


export type EditFirmMutation = { __typename?: 'Mutations', editFirm?: { __typename?: 'TaxProsEditFirmMutationSchema', success?: boolean | null, publicId?: string | null } | null };

export type ListTaxFirmsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListTaxFirmsQuery = { __typename?: 'Query', taxFirms?: Array<{ __typename?: 'TaxFirm', name?: string | null, description?: string | null, emailSuffix?: string | null, publicId?: string | null, partnerType?: PartnerType | null, isContracted?: boolean | null, taxPlanDiscountPercent?: number | null } | null> | null };

export type GetBalanceDifferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalanceDifferencesQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', marketValue?: number | null, reportedMarketValue?: number | null, calculatedMarketValue?: number | null, isSignificantMarketValueDiff?: boolean | null } | null };

export type GetExchangesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExchangesQuery = { __typename?: 'Query', exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, name?: string | null, imageUrl?: string | null, value?: number | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null> | null };

export type GetTasksQueryVariables = Exact<{
  taskStatus: TaskStatus;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasksByType?: { __typename?: 'TasksByType', status: TaskStatus, taskType: TaskType, tasks: Array<{ __typename?: 'FixApiCredentialsTask', id: any, status: TaskStatus, createdAt: any, updatedAt: any, exchange: { __typename?: 'Exchange', id?: string | null, name?: string | null, imageUrl?: string | null, value?: number | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } } | null>, pageInfo?: { __typename?: 'PageInfo', hasPrev: boolean, hasNext: boolean, page: number, pages: number, perPage: number, total: number } | null } | null };

export type UpdateTaskReconciliationMutationVariables = Exact<{
  taskId: Scalars['UUID'];
  status: TaskStatus;
}>;


export type UpdateTaskReconciliationMutation = { __typename?: 'Mutations', updateTask?: { __typename?: 'UpdateTaskMutation', success?: boolean | null, error?: UpdateTaskMutationError | null } | null };

export type UpdateUserUiThemeMutationVariables = Exact<{
  uiTheme?: InputMaybe<UiTheme>;
}>;


export type UpdateUserUiThemeMutation = { __typename?: 'Mutations', updateUserUiTheme?: { __typename?: 'UpdateUserUIThemeMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutations', deleteUser?: { __typename?: 'DeleteUserMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type ResetUserPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetUserPasswordMutation = { __typename?: 'Mutations', resetUserPassword?: { __typename?: 'ResetUserPasswordMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type StartUniversalToPerWalletMigrationMutationVariables = Exact<{ [key: string]: never; }>;


export type StartUniversalToPerWalletMigrationMutation = { __typename?: 'Mutations', startUniversalToPerWalletMigration?: { __typename?: 'StartUniversalToPerWalletMigrationMutationSchema', success?: boolean | null, errorMessage?: string | null, jobId?: string | null } | null };

export type SubmitUserEmailChangeRequestMutationVariables = Exact<{
  toEmail: Scalars['String'];
}>;


export type SubmitUserEmailChangeRequestMutation = { __typename?: 'Mutations', submitUserEmailChangeRequest?: { __typename?: 'SubmitUserEmailChangeMutationResult', ok: boolean, error?: SubmitUserEmailChangeMutationError | null } | null };

export type UpdateBaseCurrencyMutationVariables = Exact<{
  fiatId?: InputMaybe<Scalars['String']>;
  cryptoId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateBaseCurrencyMutation = { __typename?: 'Mutations', updateBaseCurrency?: { __typename?: 'UpdateBaseCurrencyMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateCostBasisMethodMutationVariables = Exact<{
  costBasisType?: InputMaybe<CostBasisMethod>;
}>;


export type UpdateCostBasisMethodMutation = { __typename?: 'Mutations', updateCostBasisMethod?: { __typename?: 'UpdateCostBasisMethodMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateCostBasisMethodTimelineMutationVariables = Exact<{
  costBasisType: CostBasisMethod;
  startDate: Scalars['DateTime'];
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateCostBasisMethodTimelineMutation = { __typename?: 'Mutations', updateCostBasisMethodTimeline?: { __typename?: 'UpdateCostBasisMethodTimelineMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateCostBasisPausedMutationVariables = Exact<{
  costBasisPaused: Scalars['Boolean'];
}>;


export type UpdateCostBasisPausedMutation = { __typename?: 'Mutations', updateCostBasisPaused?: { __typename?: 'UpdateCostBasisPausedMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateCostBasisTrackingMutationVariables = Exact<{
  costBasisTrackingMethod?: InputMaybe<CostBasisTracking>;
}>;


export type UpdateCostBasisTrackingMutation = { __typename?: 'Mutations', updateCostBasisTracking?: { __typename?: 'UpdateCostBasisTrackingMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateCountryCodeMutationVariables = Exact<{
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCountryCodeMutation = { __typename?: 'Mutations', updateCountryCode?: { __typename?: 'UpdateCountryCodeMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateLotAllocationMethodMutationVariables = Exact<{
  lotAllocationMethod?: InputMaybe<LotAllocationMethod>;
}>;


export type UpdateLotAllocationMethodMutation = { __typename?: 'Mutations', updateLotAllocationMethod?: { __typename?: 'UpdateTaxLotAllocationMethodMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateSyncCutoffDateMutationVariables = Exact<{
  syncCutoffDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpdateSyncCutoffDateMutation = { __typename?: 'Mutations', updateSyncCutoffDate?: { __typename?: 'UpdateUserSyncCutOffDateMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateTaxYearMutationVariables = Exact<{
  taxStartMonth?: InputMaybe<Scalars['Int']>;
  taxStartDay?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateTaxYearMutation = { __typename?: 'Mutations', updateTaxYear?: { __typename?: 'UpdateTaxYearMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type UpdateUserDisplayedBalancesMutationVariables = Exact<{
  displayedBalances: DisplayedBalances;
}>;


export type UpdateUserDisplayedBalancesMutation = { __typename?: 'Mutations', updateUserDisplayedBalances?: { __typename?: 'UpdateUserDisplayedBalancesMutationSchema', success?: boolean | null, errorMessage?: string | null } | null };

export type VerifyUserEmailChangeRequestMutationMutationVariables = Exact<{
  otpValue: Scalars['String'];
  toEmail: Scalars['String'];
}>;


export type VerifyUserEmailChangeRequestMutationMutation = { __typename?: 'Mutations', verifyUserEmailChangeRequest?: { __typename?: 'VerifyUserEmailChangeMutationResult', ok: boolean, error?: VerifyUserEmailChangeMutationError | null } | null };

export type GetNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, newTransactionsNotification?: boolean | null, newTransactionsEmail?: boolean | null, dailyPortfolioNotification?: boolean | null, dailyPortfolioEmail?: boolean | null, productUpdateEmail?: boolean | null, accountReauthenticationNotification?: boolean | null } | null };

export type UpdateUserinfoSettingMutationMutationVariables = Exact<{
  settingType: UserSettings;
  isEnabled: Scalars['Boolean'];
}>;


export type UpdateUserinfoSettingMutationMutation = { __typename?: 'Mutations', updateUserinfoSetting?: { __typename?: 'UpdateUserinfoSettingMutation', success?: boolean | null, errorMessage?: string | null } | null };

export type DeleteLendingUserSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteLendingUserSettingsMutation = { __typename?: 'Mutations', deleteLendingUserSettings?: { __typename?: 'DeleteLendingUserSettingsMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type DeleteLiquidStakingUserSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteLiquidStakingUserSettingsMutation = { __typename?: 'Mutations', deleteLiquidStakingUserSettings?: { __typename?: 'DeleteLiquidSettingUserSettingsMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type DeleteLiquidityUserSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteLiquidityUserSettingsMutation = { __typename?: 'Mutations', deleteLiquidityUserSettings?: { __typename?: 'DeleteLiquidityUserSettingsMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type DeleteStakingRewardsUserSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteStakingRewardsUserSettingsMutation = { __typename?: 'Mutations', deleteStakingRewardsUserSettings?: { __typename?: 'DeleteStakingRewardsUserSettingsMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type DeleteWrappingUserSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteWrappingUserSettingsMutation = { __typename?: 'Mutations', deleteWrappingUserSettings?: { __typename?: 'DeleteWrappingUserSettingsMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type UpdateLendingTaxabilityMutationVariables = Exact<{
  settingStartDate: Scalars['DateTime'];
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLendingTaxabilityMutation = { __typename?: 'Mutations', updateLendingTaxability?: { __typename?: 'UpdateLendingTaxabilityMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type UpdateLiquidStakingTaxabilityMutationVariables = Exact<{
  settingStartDate: Scalars['DateTime'];
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLiquidStakingTaxabilityMutation = { __typename?: 'Mutations', updateLiquidStakingTaxability?: { __typename?: 'UpdateLiquidStakingTaxabilityMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type UpdateLiquidityTaxabilityMutationVariables = Exact<{
  settingStartDate: Scalars['DateTime'];
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateLiquidityTaxabilityMutation = { __typename?: 'Mutations', updateLiquidityTaxability?: { __typename?: 'UpdateLiquidityTaxabilityMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type UpdateStakingRewardsTaxabilityMutationVariables = Exact<{
  settingStartDate: Scalars['DateTime'];
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateStakingRewardsTaxabilityMutation = { __typename?: 'Mutations', updateStakingRewardsTaxability?: { __typename?: 'UpdateStakingRewardsTaxabilityMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type UpdateWrappingTaxabilityMutationVariables = Exact<{
  settingStartDate: Scalars['DateTime'];
  settingEndDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateWrappingTaxabilityMutation = { __typename?: 'Mutations', updateWrappingTaxability?: { __typename?: 'UpdateWrappingTaxabilityMutationSchema', success?: boolean | null, error?: UpdateUserSettingConfigurationErrors | null } | null };

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, useV2Lots?: boolean | null, costBasisByWallet?: boolean | null, lotAllocationMethod?: LotAllocationMethod | null, isUndergoingAllocation?: boolean | null, hasTransitioned?: boolean | null, closedPeriodDatetime?: any | null, creditsFormatted?: string | null, displayedBalances?: DisplayedBalances | null, taxStartMonth?: number | null, taxStartDay?: number | null, taxStartDate?: any | null, taxEndDate?: any | null, taxFilingDeadline?: any | null, debugPermission?: boolean | null, hasTaxPlan?: boolean | null, costBasisPaused?: boolean | null, costBasisMethodDetails?: { __typename?: 'CostBasisMethodSchema', enumValue?: CostBasisMethod | null, shortName?: string | null, longName?: string | null } | null, costBasisMethodTimeline?: { __typename?: 'UserCostBasisMethodTimelineSchema', hasAccess?: boolean | null, userCostBasisSettings?: Array<{ __typename?: 'UserCostBasisMethodSetting', endDate?: any | null, startDate?: any | null, costBasisMethod?: { __typename?: 'CostBasisMethodSchema', shortName?: string | null, niceName?: string | null } | null } | null> | null } | null, availableCostBasisMethods?: Array<{ __typename?: 'CostBasisMethodSchema', shortName?: string | null, niceName?: string | null } | null> | null, country?: { __typename?: 'Country', code?: string | null, name?: string | null, canAccessTaxLossHarvesting?: boolean | null } | null, taxPlans?: Array<{ __typename?: 'TaxPlan', planName?: string | null, startDate?: string | null } | null> | null } | null, portfolioSubscription?: { __typename?: 'PortfolioSubscription', portfolioPlanName?: string | null, billing?: { __typename?: 'PortfolioSubscriptionBilling', interval: PortfolioSubscriptionBillingInterval, status: PortfolioSubscriptionBillingStatus, currentPeriodEnd: any, cancelAtPeriodEnd: boolean } | null } | null, taxConfiguration?: { __typename?: 'TaxConfiguration', hasLiquidStakingUserSetting?: boolean | null, liquidStakeSettingStartDate?: any | null, liquidStakeSettingEndDate?: any | null, hasWrappingUserSetting?: boolean | null, wrappingSettingStartDate?: any | null, wrappingSettingEndDate?: any | null, hasLendingUserSetting?: boolean | null, lendingSettingStartDate?: any | null, lendingSettingEndDate?: any | null, hasLiquidityUserSetting?: boolean | null, liquiditySettingStartDate?: any | null, liquiditySettingEndDate?: any | null, hasStakingRewardsUserSetting?: boolean | null, stakingRewardsSettingStartDate?: any | null, stakingRewardsSettingEndDate?: any | null } | null, taxYears?: Array<{ __typename?: 'UserTaxYear', taxYear?: number | null, title?: string | null } | null> | null };

export type IgnoreTokensTransactionsAndReportAsSpamMutationVariables = Exact<{
  contractAddressNetworkPairs: Array<InputMaybe<ContractAddressNetworkPairInput>> | InputMaybe<ContractAddressNetworkPairInput>;
  ignore?: InputMaybe<Scalars['Boolean']>;
}>;


export type IgnoreTokensTransactionsAndReportAsSpamMutation = { __typename?: 'Mutations', ignoreTokenTransactionsAndReportAsSpam?: { __typename?: 'IgnoreTokenTransactionsAndReportAsSpamMutation', success?: boolean | null } | null };

export type GetWalletsAccountSyncQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWalletsAccountSyncQuery = { __typename?: 'Query', localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, address?: string | null, name?: string | null, errors?: Array<string | null> | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, imageUrl?: string | null, name?: string | null, errors?: Array<string | null> | null, syncInfo?: { __typename?: 'SyncInfo', isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null> | null };

export type GetBalanceDifferenceWalletsForReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalanceDifferenceWalletsForReviewQuery = { __typename?: 'Query', localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, address?: string | null, name?: string | null, parentAccountName?: string | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null, tokens?: Array<{ __typename?: 'Token', cryptoSymbol?: string | null, sanitizedCryptoSymbol?: string | null, parentAccountName?: string | null, balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', name?: string | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, address?: string | null, name?: string | null, parentAccountName?: string | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null } | null> | null } | null> | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null } | null> | null, otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null } | null };

export type GetSpamAssetsForReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpamAssetsForReviewQuery = { __typename?: 'Query', spamAssets?: Array<{ __typename?: 'SpamAsset', contractAddress?: string | null, cryptoNetwork?: string | null, assetName?: string | null, sanitizedSymbol?: string | null, symbol?: string | null, assetType?: string | null, iconUrl?: string | null, isSpam?: boolean | null, wasAutomarkedAsSpam?: boolean | null } | null> | null };

export type GetHoldingsQueryVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type GetHoldingsQuery = { __typename?: 'Query', portfolio?: { __typename?: 'Portfolio', hasAccessToPerformanceByCrypto: boolean, currencies?: Array<{ __typename?: 'PortfolioCurrency', quantity?: number | null, marketValue?: number | null, costBasis?: number | null, averageCostBasis?: number | null, allTimeReturn?: number | null, allTimeReturnPercent?: number | null, totalReturnOnInvestment?: number | null, totalReturnOnInvestmentPercent?: number | null, currency?: { __typename?: 'Currency', uaid?: string | null, slug?: string | null, type?: CurrencyType | null, cmcId?: number | null, symbol?: string | null, name?: string | null, iconUrlFromInfo?: string | null } | null } | null> | null } | null, taxSummary?: { __typename?: 'TaxSummary', shortTermGain?: string | null, longTermGain?: string | null } | null };

export type GetLocalWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalWalletsQuery = { __typename?: 'Query', localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, address?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null } | null } | null> | null };

export type GetTaxImpactQueryVariables = Exact<{
  outflowQuantity: Scalars['Float'];
  outflowAssetSymbol: Scalars['String'];
  outflowChain: Scalars['String'];
  outflowAssetContractAddress?: InputMaybe<Scalars['String']>;
  outflowWalletAddress: Scalars['String'];
  inflowQuantity: Scalars['Float'];
  inflowAssetSymbol: Scalars['String'];
  inflowAssetContractAddress?: InputMaybe<Scalars['String']>;
  inflowWalletAddress: Scalars['String'];
  inflowChain: Scalars['String'];
  fees: Array<InputMaybe<SwapFeeInput>> | InputMaybe<SwapFeeInput>;
}>;


export type GetTaxImpactQuery = { __typename?: 'Query', taxImpactPreview?: { __typename?: 'TaxImpactPreview', gainLoss: string, gainLossPercentage: any, costBasis: string, tradeProceeds: string, totalShortTermGain: string, totalLongTermGain: string, totalShortTermEstimatedTaxes: string, totalLongTermEstimatedTaxes: string, estimatedTaxSavings: string } | null };

export type GetTaxLossHarvestForSwapQueryVariables = Exact<{
  forSwapPreview: Scalars['Boolean'];
}>;


export type GetTaxLossHarvestForSwapQuery = { __typename?: 'Query', taxLossHarvest?: { __typename?: 'TaxLossHarvest', hasAccess?: boolean | null, taxLossTotals?: { __typename?: 'TaxLossTotals', absUnrealizedLoss?: number | null, potentialSavings?: number | null } | null, taxLossInfoList?: Array<{ __typename?: 'TaxLossInfo', cryptoCmcId?: number | null, cryptoName?: string | null, cryptoSymbol?: string | null, cryptoSlug?: string | null, cryptoContractAddress?: string | null, holdings?: number | null, marketValue?: number | null, costBasis?: number | null, absUnrealizedLoss?: number | null, potentialSavings?: number | null, wallet?: { __typename?: 'Wallet', id?: string | null, name?: string | null, imageUrl?: string | null, parentAccountId?: string | null, parentAccountName?: string | null, parentAccountImageUrl?: string | null, walletNetwork?: string | null } | null, customWallet?: { __typename?: 'CustomWallet', id?: string | null, name?: string | null } | null } | null> | null } | null, taxSummary?: { __typename?: 'TaxSummary', calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, taxStartDate?: string | null, taxEndDate?: string | null, taxYearTitle?: string | null, taxYearLabel?: string | null, capitalGain?: string | null, capitalGainWithoutSymbol?: string | null, totalGains?: string | null, totalLosses?: string | null, shortTermGain?: string | null, longTermGain?: string | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, costBasisByWallet?: boolean | null, costBasisMethodTimeline?: { __typename?: 'UserCostBasisMethodTimelineSchema', userCostBasisSettings?: Array<{ __typename?: 'UserCostBasisMethodSetting', endDate?: any | null, startDate?: any | null, costBasisMethod?: { __typename?: 'CostBasisMethodSchema', shortName?: string | null, longName?: string | null } | null } | null> | null } | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null } | null } | null };

export type FreezeUserMutationVariables = Exact<{
  year: Scalars['Int'];
}>;


export type FreezeUserMutation = { __typename?: 'Mutations', freezeUser?: { __typename?: 'FreezeUserMutationSchema', success?: boolean | null } | null };

export type UnfreezeUserMutationVariables = Exact<{
  year: Scalars['Int'];
}>;


export type UnfreezeUserMutation = { __typename?: 'Mutations', unfreezeUser?: { __typename?: 'UnfreezeUserMutationSchema', success?: boolean | null } | null };

export type GenerateTaxReportMutationVariables = Exact<{
  reportType?: InputMaybe<TaxReportType>;
  taxYear?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
}>;


export type GenerateTaxReportMutation = { __typename?: 'Mutations', generateTaxReport?: { __typename?: 'GenerateTaxReport', success?: boolean | null, message?: GenerateTaxReportResult | null, jobId?: string | null } | null };

export type GetBuyModalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuyModalQuery = { __typename?: 'Query', availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', transactionCountingYear?: number | null, plans: Array<{ __typename?: 'UnifiedPlanDetails', name?: string | null, internalName?: string | null, description?: string | null, featureList?: Array<PlanFeature> | null, transactionLimit?: number | null, lifetimeTransactionLimit?: number | null, hasSufficientTransactionLimit?: boolean | null, plan?: SubscriptionPlan | null, isRecommended?: boolean | null, price?: { __typename?: 'PriceInfo', originalPrice: any, finalPrice: any, currencySymbol: string, discount: any, discountReason?: string | null } | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', totalTransactionCount: number, lifetimeTransactionCount: number, excludedStakingTransactionCount: number, netTransactionCount: number } | null }> }, unifiedSubscription?: { __typename?: 'UnifiedSubscription', subscriptionPlan: SubscriptionPlan, billing: { __typename?: 'UnifiedSubscriptionBilling', currentPeriodEnd?: any | null, cancelAtPeriodEnd: boolean, renewalNeeded: boolean } } | null, taxLossHarvest?: { __typename?: 'TaxLossHarvest', taxLossTotals?: { __typename?: 'TaxLossTotals', potentialSavings?: number | null } | null } | null };

export type GetTaxPageQueryVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type GetTaxPageQuery = { __typename?: 'Query', taxYears?: Array<{ __typename?: 'UserTaxYear', taxYear?: number | null, title?: string | null, dateRange?: string | null } | null> | null, taxSummary?: { __typename?: 'TaxSummary', taxYear?: number | null, hasPlan?: boolean | null, errorsCount?: number | null, taxYearTitle?: string | null, taxYearLabel?: string | null, taxStartDate?: string | null, taxEndDate?: string | null, hasSufficientPlan?: boolean | null, capitalGain?: string | null, capitalGainWithoutSymbol?: string | null, longTermGain?: string | null, longTermCostBasis?: string | null, longTermProceeds?: string | null, shortTermGain?: string | null, shortTermCostBasis?: string | null, shortTermProceeds?: string | null, shortTermCryptoToCryptoGain?: string | null, longTermCryptoToCryptoGain?: string | null, shortTermOtherGain?: string | null, longTermOtherGain?: string | null, totalGains?: string | null, totalLosses?: string | null, numberOfDisposals?: string | null, shortTermLosses?: string | null, totalCostBasis?: string | null, totalCapitalGains?: string | null, totalProceeds?: string | null, totalShortTermLosses?: string | null, totalShortTermGains?: string | null, incomeSalary?: string | null, incomeFork?: string | null, incomeMining?: string | null, incomeAirdrops?: string | null, incomeStaking?: string | null, incomeInterest?: string | null, incomeOther?: string | null, incomeRoyalty?: string | null, totalGifts?: string | null, totalDonations?: string | null, donationShortTerm?: string | null, donationLongTerm?: string | null, netFuturesGains?: string | null, totalMarginFees?: string | null, totalInterestExpense?: string | null, taxIncome?: string | null, transactionCount?: number | null, freeTransactionsCount?: number | null, sendsCount?: number | null, receivesCount?: number | null, calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, calloutCountMissingBalance?: number | null, taxableIncomeTotal?: string | null, otherCategoriesTotal?: string | null, taxPlan?: { __typename?: 'TaxPlan', planName?: string | null, startDate?: string | null, dynamicTransactionLimitLabel?: string | null, transactionLimit?: number | null, type?: TaxPackage | null, isSufficient?: boolean | null, insufficientReason?: InsufficientPlanReason | null, shouldRenew?: boolean | null, isUnified?: boolean | null, insufficientUnifiedPlanShortReason?: string | null, insufficientUnifiedPlanLongReason?: string | null, hasGeneratedTaxReport?: boolean | null } | null, taxSummaryByAccounts?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByWallets?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByCustomWallets?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxSummaryByForeignAccounts?: Array<{ __typename?: 'TaxSummaryByType', name?: string | null, gains?: string | null, transactionsCount?: string | null } | null> | null, taxReports?: { __typename?: 'TaxReports', irsForm8949?: boolean | null, condensedIrsForm8949?: boolean | null, irsScheduleDForm1040?: boolean | null, irsSchedule1Form1040?: boolean | null, craSchedule3?: boolean | null, selfFileWithCointracker?: boolean | null, hAndRBlock?: boolean | null, turboTaxOnlineSync?: boolean | null, turbotaxOnline?: boolean | null, taxcaddy8949?: boolean | null, taxcaddySchedule1?: boolean | null, turbotaxCdDownload?: boolean | null, taxactFile?: boolean | null, woltersKluwerCchFile?: boolean | null, transactionHistoryCsv?: boolean | null, capitalGainsCsv?: boolean | null, eoyTaxLotsReport?: boolean | null, wisoCsv?: boolean | null, incomeCsvReport?: boolean | null, anlageSoReport?: boolean | null } | null, taxConstants?: { __typename?: 'TaxConstants', faqUrl?: string | null, taxFormUrl?: string | null, taxInstructionsUrl?: string | null, fileOnlineUrl?: string | null } | null, taxItems?: Array<{ __typename?: 'TaxItem', name?: string | null, amount?: string | null, value?: number | null, transactionsCount?: number | null, isTaxable?: boolean | null, isTaxableNow?: boolean | null, taxEvent?: TaxEvent | null } | null> | null } | null, unifiedSubscription?: { __typename?: 'UnifiedSubscription', subscriptionPlanName: string, subscriptionPlan: SubscriptionPlan, transactionLimit: number, lifetimeTransactionLimit: number, recommendedPlanForTax?: { __typename?: 'UnifiedPlanDetails', internalName?: string | null, name?: string | null, featureList?: Array<PlanFeature> | null, transactionLimit?: number | null, lifetimeTransactionLimit?: number | null, hasSufficientTransactionLimit?: boolean | null, isRecommended?: boolean | null, plan?: SubscriptionPlan | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', totalTransactionCount: number, lifetimeTransactionCount: number, excludedStakingTransactionCount: number, netTransactionCount: number } | null, price?: { __typename?: 'PriceInfo', originalPrice: any, discount: any, discountReason?: string | null, finalPrice: any, currencySymbol: string } | null } | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', totalTransactionCount: number, lifetimeTransactionCount: number, excludedStakingTransactionCount: number, netTransactionCount: number } | null } | null, availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', transactionCountingYear?: number | null, plans: Array<{ __typename?: 'UnifiedPlanDetails', internalName?: string | null, name?: string | null, price?: { __typename?: 'PriceInfo', finalPrice: any } | null }> }, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, costBasisByWallet?: boolean | null, costBasisPaused?: boolean | null, costBasisMethodDetails?: { __typename?: 'CostBasisMethodSchema', enumValue?: CostBasisMethod | null, shortName?: string | null, niceName?: string | null, breakoutByDateAcquired?: boolean | null } | null, costBasisMethodTimeline?: { __typename?: 'UserCostBasisMethodTimelineSchema', userCostBasisSettings?: Array<{ __typename?: 'UserCostBasisMethodSetting', startDate?: any | null, endDate?: any | null, costBasisMethod?: { __typename?: 'CostBasisMethodSchema', enumValue?: CostBasisMethod | null, shortName?: string | null, niceName?: string | null } | null } | null> | null } | null, baseCurrency?: { __typename?: 'Currency', cmcId?: number | null, type?: CurrencyType | null, symbol?: string | null, formatSymbol?: string | null, priceUsd?: number | null, name?: string | null } | null, country?: { __typename?: 'Country', code?: string | null, name?: string | null, canAccessTaxLossHarvesting?: boolean | null } | null } | null, userStats?: { __typename?: 'UserStats', numberOfExchanges?: number | null, numberOfLocalWallets?: number | null, numberOfCustomWallets?: number | null } | null };

export type PollTaxReportQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type PollTaxReportQuery = { __typename?: 'Query', taxReportPollResult?: { __typename?: 'TaxReportPollResult', success?: boolean | null, ready?: boolean | null, url?: string | null } | null };

export type RequestTaxRecalculationMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestTaxRecalculationMutation = { __typename?: 'Mutations', requestTaxRecalculation?: { __typename?: 'RequestTaxRecalculation', success?: boolean | null } | null };

export type UpdateLastUsedTaxYearMutationVariables = Exact<{
  taxYear: Scalars['Int'];
}>;


export type UpdateLastUsedTaxYearMutation = { __typename?: 'Mutations', updateLastUsedTaxYear?: { __typename?: 'UpdateLastUsedTaxYear', success?: boolean | null } | null };

export type GetTaxLossHarvestQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxLossHarvestQuery = { __typename?: 'Query', taxLossHarvest?: { __typename?: 'TaxLossHarvest', hasAccess?: boolean | null, taxYear?: number | null, taxLossTotals?: { __typename?: 'TaxLossTotals', potentialSavings?: number | null, absUnrealizedLoss?: number | null } | null, taxLossInfoList?: Array<{ __typename?: 'TaxLossInfo', cryptoCmcId?: number | null, cryptoName?: string | null, cryptoSymbol?: string | null, cryptoSlug?: string | null, cryptoContractAddress?: string | null, holdings?: number | null, marketValue?: number | null, costBasis?: number | null, absUnrealizedLoss?: number | null, potentialSavings?: number | null, wallet?: { __typename?: 'Wallet', id?: string | null, name?: string | null, imageUrl?: string | null, parentAccountId?: string | null, parentAccountName?: string | null, parentAccountImageUrl?: string | null, walletNetwork?: string | null } | null, customWallet?: { __typename?: 'CustomWallet', id?: string | null, name?: string | null } | null } | null> | null } | null, taxSummary?: { __typename?: 'TaxSummary', calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, taxStartDate?: string | null, taxEndDate?: string | null, taxYearTitle?: string | null, taxYearLabel?: string | null, capitalGain?: string | null, capitalGainWithoutSymbol?: string | null, totalGains?: string | null, totalLosses?: string | null, shortTermGain?: string | null, longTermGain?: string | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, costBasisByWallet?: boolean | null, costBasisMethodDetails?: { __typename?: 'CostBasisMethodSchema', shortName?: string | null, niceName?: string | null, longName?: string | null } | null, costBasisMethodTimeline?: { __typename?: 'UserCostBasisMethodTimelineSchema', userCostBasisSettings?: Array<{ __typename?: 'UserCostBasisMethodSetting', endDate?: any | null, startDate?: any | null, costBasisMethod?: { __typename?: 'CostBasisMethodSchema', shortName?: string | null, longName?: string | null } | null } | null> | null } | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null } | null, country?: { __typename?: 'Country', code?: string | null, name?: string | null, canAccessTaxLossHarvesting?: boolean | null } | null } | null };

export type GenerateTaxLotsCsvMutationVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type GenerateTaxLotsCsvMutation = { __typename?: 'Mutations', generateTaxLotsCsv?: { __typename?: 'GenerateTaxLotsCsv', success?: boolean | null, message?: GenerateTaxLotsCsvResult | null, jobId?: string | null } | null };

export type GetCostBasisMethodDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCostBasisMethodDetailsQuery = { __typename?: 'Query', taxSummary?: { __typename?: 'TaxSummary', calloutCountInsufficientQuantity?: number | null, calloutCountMissingPriceHistory?: number | null, taxStartDate?: string | null, taxEndDate?: string | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, costBasisMethodDetails?: { __typename?: 'CostBasisMethodSchema', enumValue?: CostBasisMethod | null, shortName?: string | null, niceName?: string | null, longName?: string | null } | null, costBasisMethodTimeline?: { __typename?: 'UserCostBasisMethodTimelineSchema', userCostBasisSettings?: Array<{ __typename?: 'UserCostBasisMethodSetting', endDate?: any | null, startDate?: any | null, costBasisMethod?: { __typename?: 'CostBasisMethodSchema', longName?: string | null, shortName?: string | null } | null } | null> | null } | null } | null };

export type GetCurrencyForTaxLotsPageQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetCurrencyForTaxLotsPageQuery = { __typename?: 'Query', currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, slug?: string | null, cmcId?: number | null, isInWatchlist?: boolean | null } | null };

export type TaxLotsQueryVariables = Exact<{
  assetIdentifier: Scalars['String'];
  assetType: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  walletPublicGid?: InputMaybe<Scalars['String']>;
  walletAddress?: InputMaybe<Scalars['String']>;
  walletChain?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  desc?: InputMaybe<Scalars['Boolean']>;
  forSwapPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type TaxLotsQuery = { __typename?: 'Query', availableLotsData?: { __typename?: 'AvailableLotsData', totalCount?: number | null, hasAccess?: boolean | null, availableLots?: Array<{ __typename?: 'AvailableLot', orderToSell?: number | null, dateAcquired?: any | null, walletName?: string | null, quantity?: number | null, adjustedCostBasis?: number | null, adjustedCostBasisPerUnit?: number | null, marketValue?: number | null, marketValuePerUnit?: number | null, holdingPeriod?: string | null, gainLossAmount?: number | null, gainLossPercent?: number | null, coveredState?: string | null, acquisitionTransactionId?: string | null, asset?: { __typename?: 'Asset', id?: number | null, type?: CurrencyType | null, symbol?: string | null, name?: string | null } | null } | null> | null } | null };

export type PollTaxLotsCsvQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type PollTaxLotsCsvQuery = { __typename?: 'Query', taxLotsCsvPollResult?: { __typename?: 'TaxLotsCsvPollResult', success?: boolean | null, ready?: boolean | null, url?: string | null } | null };

export type GetWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWalletsQuery = { __typename?: 'Query', localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, address?: string | null, name?: string | null, uaid?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, name?: string | null, imageUrl?: string | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, name?: string | null, uaid?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null } | null> | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null, name?: string | null } | null> | null };

export type CreateTransactionMutationVariables = Exact<{
  transaction: TransactionNodeInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutations', createTransaction?: { __typename?: 'CreateTransactionMutationSchema', success?: boolean | null, error?: string | null } | null };

export type GetTransactionQueryVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
}>;


export type GetTransactionQuery = { __typename?: 'Query', transaction?: { __typename?: 'TransactionNode', publicId?: string | null, transactionType?: ExtendedTransactionType | null, transactionRowType?: TransactionRowType | null, dateTime?: any | null, canEditCostBasis?: boolean | null, canEditProceeds?: boolean | null, markLabels?: Array<string | null> | null, unmarkLabels?: Array<string | null> | null, isManual?: boolean | null, isIgnored?: boolean | null, hasAtleastOneDeletableEntry?: boolean | null, hasAllDeletableEntries?: boolean | null, transactionFrom?: { __typename?: 'TransactionWalletInfo', label?: string | null, walletId?: string | null, walletType?: WalletTypeEnum | null, address?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, cmcId?: number | null, type?: CurrencyType | null } | null } | null, transactionTo?: { __typename?: 'TransactionWalletInfo', label?: string | null, walletId?: string | null, walletType?: WalletTypeEnum | null, address?: string | null, currency?: { __typename?: 'Currency', symbol?: string | null, cmcId?: number | null, type?: CurrencyType | null } | null } | null, transactionBalances?: Array<{ __typename?: 'TransactionBalanceSchema', walletLabel?: string | null, assetSymbol?: string | null, balanceAfter?: number | null } | null> | null, credits?: Array<{ __typename?: 'EntryV2', publicId?: string | null, amount?: number | null, balanceAfter?: number | null, fiatValue?: number | null, perCoinValue?: number | null, relatedEntrySymbol?: string | null, symbol?: string | null, isNft?: boolean | null, type?: string | null, iconUrl?: string | null, costBasis?: number | null, comments?: Array<string | null> | null, notes?: string | null, transactionUrl?: string | null, transactionHash?: string | null, isIgnored?: boolean | null, hasCustomCostBasis?: boolean | null, hasCustomProceeds?: boolean | null, currencyId?: string | null, currencyIdType?: CurrencyIdTypeEnum | null, feeCurrencyId?: string | null, feeCurrencyIdType?: CurrencyIdTypeEnum | null, uaid?: string | null, fee?: { __typename?: 'Fee', amount?: number | null, fiatValue?: number | null, symbol?: string | null, uaid?: string | null, type?: string | null, profitOrLoss?: number | null, costBasis?: number | null, iconUrl?: string | null } | null } | null> | null, debits?: Array<{ __typename?: 'EntryV2', publicId?: string | null, amount?: number | null, balanceAfter?: number | null, fiatValue?: number | null, perCoinValue?: number | null, relatedEntrySymbol?: string | null, symbol?: string | null, isNft?: boolean | null, type?: string | null, iconUrl?: string | null, profitOrLoss?: number | null, costBasis?: number | null, comments?: Array<string | null> | null, notes?: string | null, transactionUrl?: string | null, transactionHash?: string | null, isIgnored?: boolean | null, hasCustomCostBasis?: boolean | null, hasCustomProceeds?: boolean | null, currencyId?: string | null, currencyIdType?: CurrencyIdTypeEnum | null, feeCurrencyId?: string | null, feeCurrencyIdType?: CurrencyIdTypeEnum | null, uaid?: string | null, fee?: { __typename?: 'Fee', amount?: number | null, fiatValue?: number | null, symbol?: string | null, type?: string | null, uaid?: string | null, profitOrLoss?: number | null, costBasis?: number | null, iconUrl?: string | null } | null } | null> | null } | null };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, closedPeriodDatetime?: any | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null, priceUsd?: number | null } | null } | null };

export type UpdateTransactionMutationVariables = Exact<{
  transaction: TransactionNodeInput;
}>;


export type UpdateTransactionMutation = { __typename?: 'Mutations', updateTransaction?: { __typename?: 'UpdateTransactionMutationSchema', success?: boolean | null, error?: string | null } | null };

export type GetTransactionsCsvQueryVariables = Exact<{
  userId: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetTransactionsCsvQuery = { __typename?: 'Query', transactionsCsv?: { __typename?: 'TransactionsCSVDownloadSchema', success?: boolean | null, message?: string | null } | null };

export type GetTransactionsCsvPollQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetTransactionsCsvPollQuery = { __typename?: 'Query', transactionsCsvPoll?: { __typename?: 'TransactionsCSVPollingSchema', ready?: boolean | null, success?: boolean | null, url?: string | null } | null };

export type UpdateTransactionIgnoredStatusMutationVariables = Exact<{
  entryId: Scalars['String'];
  enable: Scalars['Boolean'];
}>;


export type UpdateTransactionIgnoredStatusMutation = { __typename?: 'Mutations', updateTransactionActiveStatus?: { __typename?: 'UpdateTransactionActiveStatusMutation', success?: boolean | null, message?: string | null } | null };

export type UpdateTransactionsIgnoredStatusMutationVariables = Exact<{
  entryIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  enable: Scalars['Boolean'];
}>;


export type UpdateTransactionsIgnoredStatusMutation = { __typename?: 'Mutations', updateTransactionsActiveStatus?: { __typename?: 'UpdateTransactionsActiveStatusMutation', successes?: Array<boolean | null> | null, messages?: Array<string | null> | null } | null };

export type UpdateTransactionsTaxabilityMutationVariables = Exact<{
  publicIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  taxable: Scalars['Boolean'];
}>;


export type UpdateTransactionsTaxabilityMutation = { __typename?: 'Mutations', updateTransactionsTaxability?: { __typename?: 'UpdateTransactionsTaxabilityMutationSchema', success?: boolean | null, message?: string | null, error?: UpdateTransactionErrors | null } | null };

export type UpdateOperationsPurposeMutationVariables = Exact<{
  operationIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  purpose: FrontendOperationPurpose;
}>;


export type UpdateOperationsPurposeMutation = { __typename?: 'Mutations', updateOperationPurpose?: { __typename?: 'UpdateOperationsPurposeMutationSchema', success?: boolean | null } | null };

export type EditCostBasisMutationVariables = Exact<{
  entryId: Scalars['String'];
  costBasis?: InputMaybe<Scalars['PositiveFloat']>;
}>;


export type EditCostBasisMutation = { __typename?: 'Mutations', updateTransactionCostBasis?: { __typename?: 'UpdateCostBasisTransactionMutation', success?: boolean | null, message?: string | null } | null };

export type GetCostBasisQueryVariables = Exact<{
  publicId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCostBasisQuery = { __typename?: 'Query', entry?: { __typename?: 'EntryView', costBasis?: { __typename?: 'EntryCostBasisSchema', dateTime?: any | null, originalCostBasis?: any | null, currentCostBasis?: any | null, quantity?: any | null, symbol?: string | null, callouts?: Array<{ __typename?: 'GrapheneCallout', severity?: CalloutSeverity | null, type?: CalloutType | null } | null> | null } | null } | null };

export type EditProceedsMutationVariables = Exact<{
  entryId: Scalars['String'];
  proceeds?: InputMaybe<Scalars['PositiveFloat']>;
}>;


export type EditProceedsMutation = { __typename?: 'Mutations', updateTransactionProceeds?: { __typename?: 'UpdateProceedsTransactionMutation', success?: boolean | null, message?: string | null } | null };

export type GetProceedsQueryVariables = Exact<{
  publicId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProceedsQuery = { __typename?: 'Query', entry?: { __typename?: 'EntryView', proceeds?: { __typename?: 'EntryProceedsSchema', dateTime?: any | null, originalProceeds?: any | null, currentProceeds?: any | null, quantity?: any | null, symbol?: string | null, callouts?: Array<{ __typename?: 'GrapheneCallout', severity?: CalloutSeverity | null, type?: CalloutType | null } | null> | null } | null } | null };

export type CreateTransactionLinkMutationVariables = Exact<{
  receiveTransactionId: Scalars['String'];
  sendTransactionId: Scalars['String'];
  transactionLinkType: TransactionLinkTypeEnum;
}>;


export type CreateTransactionLinkMutation = { __typename?: 'Mutations', createTransactionLink?: { __typename?: 'CreateTransactionLink', success?: boolean | null, message?: string | null } | null };

export type AddDepositOverrideMutationMutationVariables = Exact<{
  flowId: Scalars['String'];
  costBasis: Scalars['Decimal'];
  dateAcquired: Scalars['DateTime'];
}>;


export type AddDepositOverrideMutationMutation = { __typename?: 'Mutations', addDepositOverride?: { __typename?: 'AddDepositOverrideMutationSchema', success?: boolean | null, message?: string | null } | null };

export type GetValidationStatusQueryVariables = Exact<{
  flowId: Scalars['String'];
  costBasis: Scalars['Decimal'];
  dateAcquired: Scalars['DateTime'];
}>;


export type GetValidationStatusQuery = { __typename?: 'Query', depositValidationState?: { __typename?: 'ValidationData', state: string } | null };

export type BulkUpdateTransactionAssetMutationVariables = Exact<{
  updateTokenParameters: Array<InputMaybe<UpdateTokenInput>> | InputMaybe<UpdateTokenInput>;
}>;


export type BulkUpdateTransactionAssetMutation = { __typename?: 'Mutations', bulkUpdateTransactionAsset?: { __typename?: 'BulkUpdateTransactionAsset', jobId?: string | null, results: Array<{ __typename?: 'Result', success: boolean, error: string, index: number } | null> } | null };

export type DeleteManualTransactionsMutationVariables = Exact<{
  entryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteManualTransactionsMutation = { __typename?: 'Mutations', deleteManualTransactions?: { __typename?: 'DeleteManualTransactionsMutationSchema', successes?: Array<boolean | null> | null, messages?: Array<string | null> | null } | null };

export type GetTransactionCountQueryQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetTransactionCountQueryQuery = { __typename?: 'Query', transactionPageCount?: { __typename?: 'TransactionPageCount', totalNumberOfTransactions?: number | null, endPage?: number | null } | null };

export type GetVisualTransactionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  transactionsOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVisualTransactionsQuery = { __typename?: 'Query', transactionPage?: { __typename?: 'TransactionPage', startPage?: number | null, endPage?: number | null, visualTransactions?: Array<{ __typename?: 'TransactionRow', id?: string | null, transactionRowType?: TransactionRowType | null, dateTime?: any | null, transactionHash?: string | null, transactionUrl?: string | null, hasAllDeletableFlows?: boolean | null, hasAtLeastOneDeletableFlow?: boolean | null, canEditCostBasis?: boolean | null, canEditProceeds?: boolean | null, canUnlink?: boolean | null, totalValue?: any | null, totalGainLoss?: any | null, taxableIncome?: any | null, isFrozen?: boolean | null, skipInLinkDetection?: boolean | null, totalInflowsHidden?: number | null, totalOutflowsHidden?: number | null, taxability?: { __typename?: 'TaxabilityObject', taxable?: boolean | null, countrySupportsOptionalityForTaxEvents?: boolean | null, hasTaxabilityOverride?: boolean | null, isOptionalityEnabled?: boolean | null } | null, transactionBalances?: Array<{ __typename?: 'TransactionBalanceSchema', walletLabel?: string | null, assetSymbol?: string | null, balanceAfter?: number | null, address?: string | null, asset?: { __typename?: 'UniversalAsset', iconUrl?: string | null, label?: string | null } | null } | null> | null, operations?: Array<{ __typename?: 'Operation', id?: string | null, operationType?: OperationType | null, operationPurpose?: FrontendOperationPurpose | null, markAsOperationPurposes?: Array<FrontendOperationPurpose | null> | null, isFeeOperation?: boolean | null, flowsHiddenInOperation?: number | null, flows?: Array<{ __typename?: 'Flow', id?: string | null, direction?: FlowDirection | null, amount?: any | null, uaid?: string | null, walletUri?: string | null, isManual?: boolean | null, isImported?: boolean | null, isIgnored?: boolean | null, fiatValue?: any | null, notes?: { __typename?: 'FlowNotes', title?: string | null, subtitle?: string | null, comment?: string | null } | null, callouts?: Array<{ __typename?: 'GrapheneCallout', severity?: CalloutSeverity | null, type?: CalloutType | null, quantityRequested?: any | null, reviewActionUrl?: string | null } | null> | null, lotSummary?: { __typename?: 'LotsSummary', costBasis?: any | null, profitOrLoss?: any | null, proceeds?: any | null } | null, asset?: { __typename?: 'UniversalAsset', symbol?: string | null, iconUrl?: string | null, isSpam?: boolean | null, canMarkAsSpam?: boolean | null, assetType?: AssetType | null } | null, walletInfo?: { __typename?: 'TransactionWalletInfo', walletId?: string | null, label?: string | null, address?: string | null, walletType?: WalletTypeEnum | null, networkName?: string | null } | null } | null> | null } | null> | null } | null> | null } | null, userInfo?: { __typename?: 'UserInfo', publicId?: string | null, taxPlanUpgradeNeeded?: boolean | null, taxStartDate?: any | null, taxEndDate?: any | null, costBasisByWallet?: boolean | null, hasSpamHidden?: boolean | null, closedPeriodDatetime?: any | null, baseCurrency?: { __typename?: 'Currency', type?: CurrencyType | null, symbol?: string | null, priceUsd?: number | null } | null } | null, userProperties?: { __typename?: 'UserPropertiesObj', hasStakingRewardsHidden?: boolean | null } | null };

export type GetTransactionsSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetTransactionsSearchQuery = { __typename?: 'Query', transactionsSearch?: { __typename?: 'TransactionsSearch', status?: number | null, result?: string | null } | null };

export type MakeTransferMutationVariables = Exact<{
  transactionId: Scalars['String'];
}>;


export type MakeTransferMutation = { __typename?: 'Mutations', makeTransfer?: { __typename?: 'MakeTransferMutationSchema', success?: boolean | null, message?: string | null } | null };

export type ReportSpamMutationVariables = Exact<{
  uaids: Array<Scalars['String']> | Scalars['String'];
  markAsSpam: Scalars['Boolean'];
}>;


export type ReportSpamMutation = { __typename?: 'Mutations', reportSpam?: { __typename?: 'ReportSpamMutationSchema', success?: boolean | null } | null };

export type ToggleUserSpamPreferenceMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleUserSpamPreferenceMutation = { __typename?: 'Mutations', toggleUserSpamPreference?: { __typename?: 'ToggleUserSpamPreferenceSchema', success?: boolean | null } | null };

export type ToggleUserStakingRewardsPreferenceMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleUserStakingRewardsPreferenceMutation = { __typename?: 'Mutations', toggleUserStakingRewardsPreference?: { __typename?: 'ToggleUserStakingRewardsPreferenceSchema', success?: boolean | null } | null };

export type UpdateSkipInLinkDetectionMutationMutationVariables = Exact<{
  transactionIds: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  skipInLinkDetection: Scalars['Boolean'];
}>;


export type UpdateSkipInLinkDetectionMutationMutation = { __typename?: 'Mutations', updateSkipInLinkDetection?: { __typename?: 'UpdateSkipInLinkDetectionMutation', success?: boolean | null, message?: string | null } | null };

export type UpdateTransactionDatetimeMutationVariables = Exact<{
  transactionId: Scalars['String'];
  newDatetime: Scalars['DateTime'];
}>;


export type UpdateTransactionDatetimeMutation = { __typename?: 'Mutations', updateTransactionDatetime?: { __typename?: 'UpdateDatetimeTransactionMutation', success?: boolean | null, message?: string | null } | null };

export type GetRenewSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRenewSubscriptionQuery = { __typename?: 'Query', availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', transactionCountingYear?: number | null, plans: Array<{ __typename?: 'UnifiedPlanDetails', name?: string | null, internalName?: string | null, plan?: SubscriptionPlan | null, isRecommended?: boolean | null, price?: { __typename?: 'PriceInfo', originalPrice: any, finalPrice: any, currencySymbol: string, discount: any, discountReason?: string | null } | null }> }, unifiedSubscription?: { __typename?: 'UnifiedSubscription', subscriptionPlan: SubscriptionPlan, subscriptionPlanName: string, transactionLimit: number, lifetimeTransactionLimit: number, billing: { __typename?: 'UnifiedSubscriptionBilling', currentPeriodEnd?: any | null, cancelAtPeriodEnd: boolean, renewalNeeded: boolean }, transactionCounts?: { __typename?: 'PlanTransactionCounts', netTransactionCount: number } | null, recommendedPlanForTax?: { __typename?: 'UnifiedPlanDetails', internalName?: string | null, name?: string | null, plan?: SubscriptionPlan | null, transactionLimit?: number | null, lifetimeTransactionLimit?: number | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', netTransactionCount: number } | null } | null } | null };

export type GetSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionPlansQuery = { __typename?: 'Query', availableSubscriptionPlans?: { __typename?: 'AvailableSubscriptionPlans', currencySymbol?: string | null, hasTrial?: boolean | null, isFixedTrialEndDate?: boolean | null, trialDays?: number | null, trialEndDate?: any | null, plans?: Array<{ __typename?: 'PortfolioPlanDetails', name?: string | null, description?: string | null, features?: Array<string | null> | null, price?: number | null, isRecommended?: boolean | null, trialDays?: number | null, trialDescription?: string | null, firstChargeDate?: any | null } | null> | null } | null, portfolioSubscription?: { __typename?: 'PortfolioSubscription', portfolioPlan?: PortfolioPlan | null, portfolioPlanName?: string | null, billing?: { __typename?: 'PortfolioSubscriptionBilling', interval: PortfolioSubscriptionBillingInterval, status: PortfolioSubscriptionBillingStatus, currentPeriodEnd: any, cancelAtPeriodEnd: boolean } | null } | null };

export type GetUnifiedSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnifiedSubscriptionPlansQuery = { __typename?: 'Query', showContractedTaxFirmTaxPlans?: boolean | null, availableUnifiedSubscriptionPlans: { __typename?: 'AvailableUnifiedSubscriptionPlans', currencySymbol: string, transactionCountingYear?: number | null, featureTablePlans: Array<{ __typename?: 'UnifiedFeatureTableDetails', name: string, internalName: string, displayName: string, plan: SubscriptionPlan, transactionLimit: string, lifetimeTransactionLimit: string, hasSufficientTransactionLimit: boolean, taxForms: PlanTaxForms, staking: PlanStaking, support: PlanSupport, price: number, featureList: Array<PlanFeature>, isRecommended: boolean, priceInfo: { __typename?: 'PriceInfo', discount: any, originalPrice: any, finalPrice: any, currencySymbol: string }, pricePlusInfo?: { __typename?: 'PriceInfo', discount: any, originalPrice: any, finalPrice: any, currencySymbol: string } | null }>, plans: Array<{ __typename?: 'UnifiedPlanDetails', name?: string | null, internalName?: string | null, transactionLimit?: number | null, lifetimeTransactionLimit?: number | null, hasSufficientTransactionLimit?: boolean | null, featureList?: Array<PlanFeature> | null, plan?: SubscriptionPlan | null, isRecommended?: boolean | null, price?: { __typename?: 'PriceInfo', originalPrice: any, finalPrice: any, currencySymbol: string, discount: any, discountReason?: string | null } | null, transactionCounts?: { __typename?: 'PlanTransactionCounts', totalTransactionCount: number, lifetimeTransactionCount: number, excludedStakingTransactionCount: number, netTransactionCount: number } | null }> }, unifiedSubscription?: { __typename?: 'UnifiedSubscription', subscriptionPlan: SubscriptionPlan, subscriptionPlanName: string, transactionLimit: number, lifetimeTransactionLimit: number, showCoinbasePromo: boolean, partnersPromo?: { __typename?: 'PartnerPromo', discount: number, partner: { __typename?: 'Partner', type: PartnerType, name: string } } | null, billing: { __typename?: 'UnifiedSubscriptionBilling', currentPeriodEnd?: any | null, cancelAtPeriodEnd: boolean, renewalNeeded: boolean } } | null, portfolioSubscription?: { __typename?: 'PortfolioSubscription', portfolioPlan?: PortfolioPlan | null, billing?: { __typename?: 'PortfolioSubscriptionBilling', status: PortfolioSubscriptionBillingStatus, currentPeriodEnd: any } | null } | null, userContractedFirms?: Array<{ __typename?: 'TaxFirm', name?: string | null } | null> | null, taxLossHarvest?: { __typename?: 'TaxLossHarvest', taxLossTotals?: { __typename?: 'TaxLossTotals', absUnrealizedLoss?: number | null } | null } | null };

export type CurrencyQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type CurrencyQuery = { __typename?: 'Query', currency?: { __typename?: 'Currency', name?: string | null, symbol?: string | null, slug?: string | null, cmcId?: number | null, cryptoNetwork?: string | null } | null, commonCurrencies?: Array<{ __typename?: 'Currency', name?: string | null, symbol?: string | null, cmcId?: number | null } | null> | null };

export type GetPublicWalletBalanceQueryVariables = Exact<{
  address: Scalars['String'];
  coinSymbol: Scalars['String'];
}>;


export type GetPublicWalletBalanceQuery = { __typename?: 'Query', publicWalletBalance?: { __typename?: 'PublicBalanceResponse', success?: boolean | null, shouldPoll?: boolean | null, walletAlreadyLinked?: boolean | null, balance?: string | null, usdValue?: string | null } | null };

export type DeleteExchangeMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteExchangeMutation = { __typename?: 'Mutations', deleteExchange?: { __typename?: 'DeleteExchangeMutationSchema', success?: boolean | null, message?: string | null, error?: ExchangeDeleteErrors | null } | null };

export type DeleteWalletMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteWalletMutation = { __typename?: 'Mutations', deleteWallet?: { __typename?: 'DeleteWalletMutationSchema', success?: boolean | null, message?: string | null, error?: GenericWalletErrors | null } | null };

export type DeleteCustomWalletMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteCustomWalletMutation = { __typename?: 'Mutations', deleteCustomWallet?: { __typename?: 'DeleteCustomWalletMutationSchema', success?: boolean | null, message?: string | null, error?: GenericWalletErrors | null } | null };

export type RenameExchangeMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  newName?: InputMaybe<Scalars['String']>;
}>;


export type RenameExchangeMutation = { __typename?: 'Mutations', renameExchange?: { __typename?: 'RenameExchangeMutationSchema', success?: boolean | null, message?: string | null, error?: ExchangeRenameErrors | null } | null };

export type RenameWalletMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  newName?: InputMaybe<Scalars['String']>;
}>;


export type RenameWalletMutation = { __typename?: 'Mutations', renameWallet?: { __typename?: 'RenameWalletMutationSchema', success?: boolean | null, message?: string | null, error?: WalletRenameErrors | null } | null };

export type RenameCustomWalletMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  newName?: InputMaybe<Scalars['String']>;
}>;


export type RenameCustomWalletMutation = { __typename?: 'Mutations', renameCustomWallet?: { __typename?: 'RenameCustomWalletMutationSchema', success?: boolean | null, message?: string | null, error?: WalletRenameErrors | null } | null };

export type MigrateExchangeMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
}>;


export type MigrateExchangeMutation = { __typename?: 'Mutations', migrateExchange?: { __typename?: 'MigrateExchangeMutationSchema', success?: boolean | null, message?: string | null, error?: ExchangeMigrateErrors | null } | null };

export type SyncExchangeMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  syncType?: InputMaybe<Scalars['String']>;
}>;


export type SyncExchangeMutation = { __typename?: 'Mutations', enqueueExchangeForSync?: { __typename?: 'EnqueueExchangeForSyncMutation', success?: boolean | null, message?: string | null } | null };

export type SyncWalletMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  syncType?: InputMaybe<Scalars['String']>;
}>;


export type SyncWalletMutation = { __typename?: 'Mutations', enqueueLocalWalletForSync?: { __typename?: 'EnqueueLocalWalletForSyncMutation', success?: boolean | null, message?: string | null } | null };

export type ToggleUserWalletsSpamPreferenceMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleUserWalletsSpamPreferenceMutation = { __typename?: 'Mutations', toggleUserWalletsSpamPreference?: { __typename?: 'ToggleUserWalletsSpamPreferenceSchema', success?: boolean | null } | null };

export type SetMiningStatusMutationVariables = Exact<{
  publicId?: InputMaybe<Scalars['String']>;
  isMining?: InputMaybe<Scalars['Boolean']>;
  applyToAll?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetMiningStatusMutation = { __typename?: 'Mutations', setMiningStatus?: { __typename?: 'SetMiningStatusMutationSchema', success?: boolean | null, message?: string | null, error?: GenericWalletErrors | null } | null };

export type GetCustomWalletDetailsQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetCustomWalletDetailsQuery = { __typename?: 'Query', customWallet?: { __typename?: 'CustomWallet', id?: string | null, hasTransactionsInFrozenPeriod?: boolean | null, balances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, sanitizedCryptoSymbol?: string | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null } | null } | null> | null } | null };

export type GetExchangeDetailsQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetExchangeDetailsQuery = { __typename?: 'Query', exchange?: { __typename?: 'Exchange', id?: string | null, isPortfolioValueDifferenceSignificant?: boolean | null, hasIgnoredTransactionsInFrozenPeriod?: boolean | null, allowsHardResync?: boolean | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, hasTransactionsInFrozenPeriod?: boolean | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, type?: AccountType | null, syncInfo?: { __typename?: 'SyncInfo', isFirstTimeSync?: boolean | null } | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null } | null };

export type GetExchangeSyncProgressQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetExchangeSyncProgressQuery = { __typename?: 'Query', exchangeIncrementalPersistanceSyncProgress?: { __typename?: 'SyncProgress', total?: number | null, currentStage?: string | null } | null };

export type GetLocalWalletSyncProgressQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetLocalWalletSyncProgressQuery = { __typename?: 'Query', localWalletIncrementalPersistanceSyncProgress?: { __typename?: 'SyncProgress', total?: number | null, currentStage?: string | null } | null };

export type GetOtherTransactionDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOtherTransactionDetailsQuery = { __typename?: 'Query', otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, balances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, sanitizedCryptoSymbol?: string | null, name?: string | null, entryCount?: number | null, value?: number | null, calculatedValue?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, sanitizedCryptoSymbol?: string | null, entryCount?: number | null, value?: number | null, calculatedValue?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null } | null } | null> | null } | null };

export type GetWalletDetailsQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetWalletDetailsQuery = { __typename?: 'Query', localWallet?: { __typename?: 'Wallet', id?: string | null, balance?: number | null, calculatedBalance?: number | null, computedCryptoTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, hasIgnoredTransactionsInFrozenPeriod?: boolean | null, isMining?: boolean | null, isPortfolioValueDifferenceSignificant?: boolean | null, allowsHardResync?: boolean | null, hasTransactionsInFrozenPeriod?: boolean | null, syncInfo?: { __typename?: 'SyncInfo', isFirstTimeSync?: boolean | null } | null, currency?: { __typename?: 'Currency', symbol?: string | null, price?: number | null, type?: CurrencyType | null, cmcId?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null, calculatedValue?: number | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null, iconUrlFromInfo?: string | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, uaid?: string | null, iconUrlFromInfo?: string | null } | null } | null> | null } | null };

export type AddExchangeWithApiAndSecretKeyMutationVariables = Exact<{
  addExchangeInput: AddExchangeWithApiKeyAndSecretInput;
}>;


export type AddExchangeWithApiAndSecretKeyMutation = { __typename?: 'Mutations', addExchangeWithApiKeyAndSecret?: { __typename?: 'AddExchangeWithAPIKeyAndSecretMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, createdExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type UpdateExchangeWithApiAndSecretKeyMutationVariables = Exact<{
  updateExchangeInput: UpdateExchangeWithApiKeyAndSecretInput;
}>;


export type UpdateExchangeWithApiAndSecretKeyMutation = { __typename?: 'Mutations', updateExchangeWithApiKeyAndSecret?: { __typename?: 'UpdateExchangeWithAPIKeyAndSecretMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, updatedExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type AddExchangeWithApiKeyMutationVariables = Exact<{
  addExchangeInput: AddExchangeWithApiKeyInput;
}>;


export type AddExchangeWithApiKeyMutation = { __typename?: 'Mutations', addExchangeWithApiKey?: { __typename?: 'AddExchangeWithAPIKeyMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, createdExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type UpdateExchangeWithApiKeyMutationVariables = Exact<{
  updateExchangeInput: UpdateExchangeWithApiKeyInput;
}>;


export type UpdateExchangeWithApiKeyMutation = { __typename?: 'Mutations', updateExchangeWithApiKey?: { __typename?: 'UpdateExchangeWithAPIKeyMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, updatedExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type AddExchangeWithCustomerIdMutationVariables = Exact<{
  addExchangeInput: AddExchangeWithCustomerIdInput;
}>;


export type AddExchangeWithCustomerIdMutation = { __typename?: 'Mutations', addExchangeWithCustomerId?: { __typename?: 'AddExchangeWithCustomerIdMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, createdExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type UpdateExchangeWithCustomerIdMutationVariables = Exact<{
  updateExchangeInput: UpdateExchangeWithCustomerIdInput;
}>;


export type UpdateExchangeWithCustomerIdMutation = { __typename?: 'Mutations', updateExchangeWithCustomerId?: { __typename?: 'UpdateExchangeWithCustomerIdMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, updatedExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type GetValidationErrorsForCsvQueryVariables = Exact<{
  csvFileUrl?: InputMaybe<Scalars['String']>;
  isGeneric?: InputMaybe<Scalars['Boolean']>;
  accountTypeSlug?: InputMaybe<Scalars['String']>;
}>;


export type GetValidationErrorsForCsvQuery = { __typename?: 'Query', csvValidationErrors?: Array<string | null> | null };

export type CreateCustomWalletMutationVariables = Exact<{
  customWalletInput: CreateCustomWalletInput;
}>;


export type CreateCustomWalletMutation = { __typename?: 'Mutations', createCustomWallet?: { __typename?: 'CreateCustomWalletMutationSchema', success?: boolean | null, jobId?: string | null, error?: CustomWalletMutationErrors | null } | null };

export type GetJobStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetJobStatusQuery = { __typename?: 'Query', csvImportJobStatus?: { __typename?: 'CSVImportJobStatus', status?: JobStatus | null, isStatusFinal?: boolean | null, success?: boolean | null, error?: CsvImportJobStatusError | null, errorMessage?: string | null, numberImported?: number | null, numberIgnored?: number | null, numberUserDefinedTokens?: number | null, numberTotal?: number | null, createdCustomWallet?: { __typename?: 'CustomWallet', id?: string | null, name?: string | null, value?: number | null, computedTransactionCount?: number | null, syncInfo?: { __typename?: 'SyncInfo', isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null, balances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, sanitizedCryptoSymbol?: string | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null } | null } | null };

export type AddMultiAddressMutationVariables = Exact<{
  multiAddressInput: AddMultiAddressInput;
}>;


export type AddMultiAddressMutation = { __typename?: 'Mutations', addMultiAddress?: { __typename?: 'AddMultiAddressMutationSchema', success?: boolean | null, jobId?: string | null, error?: AddWalletErrors | null } | null };

export type GetMultiAddressJobStatusQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type GetMultiAddressJobStatusQuery = { __typename?: 'Query', multiAddressImportJobStatus?: { __typename?: 'MultiAddressImportJobStatus', status?: JobStatus | null, isStatusFinal?: boolean | null, success?: boolean | null, error?: MultiAddressImportJobStatusError | null, successMessage?: string | null, errorMessage?: string | null, warningMessage?: string | null, createdWallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, hasDefiActivity?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null, calculatedValue?: number | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null> | null } | null };

export type AddExchangeWithPassphraseMutationVariables = Exact<{
  addExchangeInput: AddExchangeWithPassphraseInput;
}>;


export type AddExchangeWithPassphraseMutation = { __typename?: 'Mutations', addExchangeWithPassphrase?: { __typename?: 'AddExchangeWithPassphraseMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, createdExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type UpdateExchangeWithPassphraseMutationVariables = Exact<{
  updateExchangeInput: UpdateExchangeWithPassphraseInput;
}>;


export type UpdateExchangeWithPassphraseMutation = { __typename?: 'Mutations', updateExchangeWithPassphrase?: { __typename?: 'UpdateExchangeWithPassphraseMutationSchema', success?: boolean | null, error?: ExchangeMutationErrors | null, updatedExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type AddTwoXpubMutationVariables = Exact<{
  twoXpubInput: AddTwoXpubInput;
}>;


export type AddTwoXpubMutation = { __typename?: 'Mutations', addTwoXpub?: { __typename?: 'AddTwoXpubMutationSchema', error?: AddWalletErrors | null, success?: boolean | null, message?: string | null, createdWallet?: { __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, hasDefiActivity?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null, calculatedValue?: number | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type AddPublicAddressMutationVariables = Exact<{
  publicAddressInput: AddPublicAddressWalletInput;
}>;


export type AddPublicAddressMutation = { __typename?: 'Mutations', addPublicAddress?: { __typename?: 'AddPublicAddressMutationSchema', success?: string | null, error?: AddWalletErrors | null, warning?: AddWalletWarnings | null, multiAddError?: string | null, multiAddWarning?: string | null, createdWallet?: { __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, hasDefiActivity?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null, calculatedValue?: number | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null, createdExchange?: { __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, type?: AccountType | null, allowsTradeImports?: boolean | null, allowsTransferImports?: boolean | null, allowsTransactionImports?: boolean | null, allowsTransactionHistoryImports?: boolean | null, errors?: Array<string | null> | null, warnings?: Array<string | null> | null, showDeprecationWarning?: boolean | null, shouldBeRemoved?: boolean | null, assetsCount?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, priceUsd?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null } | null> | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type AddPublicXPubMutationVariables = Exact<{
  publicXpubInput: AddPublicXpubInput;
}>;


export type AddPublicXPubMutation = { __typename?: 'Mutations', addPublicXpub?: { __typename?: 'AddPublicXpubMutationSchema', error?: AddWalletErrors | null, success?: string | null, warning?: AddWalletWarnings | null, createdWallet?: { __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, computedCryptoTransactionCount?: number | null, address?: string | null, name?: string | null, isBalanceDifferenceSignificant?: boolean | null, isMining?: boolean | null, hasDefiActivity?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null, price?: number | null } | null, tokens?: Array<{ __typename?: 'Token', value?: number | null, calculatedValue?: number | null, sanitizedCryptoSymbol?: string | null, balance?: number | null, calculatedBalance?: number | null, computedTransactionCount?: number | null, isBalanceDifferenceSignificant?: boolean | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, userAssetBalances?: Array<{ __typename?: 'Balance', balance?: number | null, calculatedBalance?: number | null, value?: number | null, calculatedValue?: number | null, entryCount?: number | null, currency?: { __typename?: 'Currency', symbol?: string | null, type?: CurrencyType | null, cmcId?: number | null } | null } | null> | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null } | null } | null } | null };

export type GetDetectedCryptoNetworksQueryVariables = Exact<{
  address?: InputMaybe<Scalars['String']>;
}>;


export type GetDetectedCryptoNetworksQuery = { __typename?: 'Query', detectedCryptoNetworks?: Array<{ __typename?: 'CryptoNetworkResult', cryptoNetworkName?: string | null, symbol?: string | null, website?: string | null, rank?: number | null, imageUrl?: string | null } | null> | null };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'Integration', slug?: string | null, name?: string | null, imageUrl?: string | null, category?: string | null, isDisabled?: boolean | null, syncMethod?: string | null, rank?: number | null, description?: string | null, instructions?: string | null, supportsHdWallet?: boolean | null, websiteUrl?: string | null, formId?: IntegrationFormType | null, info?: { __typename?: 'Info', hideInstructions?: boolean | null, cryptoNetwork?: string | null, circleIconUrl?: string | null, symbol?: string | null, supportedCryptoNetworks?: Array<string | null> | null, isEvmChain?: boolean | null, supportedFileFormats?: Array<FileFormats | null> | null, csvIntegrationCoverageInfo?: string | null, syncIntegrationCoverageInfo?: string | null, isInstitutional?: boolean | null } | null } | null> | null };

export type ResyncAllMutationVariables = Exact<{ [key: string]: never; }>;


export type ResyncAllMutation = { __typename?: 'Mutations', resyncAllWalletsAndAccounts?: { __typename?: 'ResyncAllWalletsAndAccountsSchema', success?: boolean | null, message?: string | null } | null };

export type GetOtherTransactionsForWalletQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOtherTransactionsForWalletQueryQuery = { __typename?: 'Query', otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null, assetsCount?: number | null } | null, exchangesPage?: { __typename?: 'PaginatedExchanges', totalCount?: number | null } | null, localWalletsPage?: { __typename?: 'PaginatedWallets', totalCount?: number | null } | null, customWalletsPage?: { __typename?: 'PaginatedCustomWallets', totalCount?: number | null } | null };

export type GetPaginatedCustomWalletsForWalletListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPaginatedCustomWalletsForWalletListQuery = { __typename?: 'Query', customWalletsPage?: { __typename?: 'PaginatedCustomWallets', totalCount?: number | null, currentPage?: number | null, endPage?: number | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null, name?: string | null, value?: number | null, assetsCount?: number | null, syncInfo?: { __typename?: 'SyncInfo', isSyncing?: boolean | null, willBeDeleted?: boolean | null, lastSynced?: any | null } | null } | null> | null } | null, exchangesPage?: { __typename?: 'PaginatedExchanges', totalCount?: number | null } | null, localWalletsPage?: { __typename?: 'PaginatedWallets', totalCount?: number | null } | null, otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null, assetsCount?: number | null } | null };

export type GetPaginatedExchangesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPaginatedExchangesQuery = { __typename?: 'Query', localWalletsPage?: { __typename?: 'PaginatedWallets', totalCount?: number | null } | null, exchangesPage?: { __typename?: 'PaginatedExchanges', totalCount?: number | null, currentPage?: number | null, endPage?: number | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, isPortfolioValueDifferenceSignificant?: boolean | null, allowsHardResync?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null, isDisabled?: boolean | null } | null } | null> | null } | null, customWalletsPage?: { __typename?: 'PaginatedCustomWallets', totalCount?: number | null } | null, otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null, assetsCount?: number | null } | null };

export type GetPaginatedWalletsForWalletListQueryVariables = Exact<{
  includeEmptyWallets?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetPaginatedWalletsForWalletListQuery = { __typename?: 'Query', localWalletsPage?: { __typename?: 'PaginatedWallets', totalCount?: number | null, currentPage?: number | null, endPage?: number | null, wallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, computedTransactionCount?: number | null, address?: string | null, name?: string | null, isPortfolioValueDifferenceSignificant?: boolean | null, allowsHardResync?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, walletNetwork?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null, isDisabled?: boolean | null } | null } | null> | null } | null, exchangesPage?: { __typename?: 'PaginatedExchanges', totalCount?: number | null } | null, customWalletsPage?: { __typename?: 'PaginatedCustomWallets', totalCount?: number | null } | null, otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null, assetsCount?: number | null } | null };

export type GetUserHasAnyWalletsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserHasAnyWalletsQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, hasAnyWallet?: boolean | null } | null };

export type GetWalletsForWalletListQueryVariables = Exact<{
  includeEmptyWallets?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetWalletsForWalletListQuery = { __typename?: 'Query', userInfo?: { __typename?: 'UserInfo', publicId?: string | null, hasAnyWallet?: boolean | null } | null, localWallets?: Array<{ __typename?: 'Wallet', id?: string | null, imageUrl?: string | null, calculatedValue?: number | null, value?: number | null, computedTransactionCount?: number | null, address?: string | null, name?: string | null, isPortfolioValueDifferenceSignificant?: boolean | null, allowsHardResync?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, walletNetwork?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null, isDisabled?: boolean | null } | null } | null> | null, exchanges?: Array<{ __typename?: 'Exchange', id?: string | null, value?: number | null, calculatedValue?: number | null, imageUrl?: string | null, name?: string | null, defaultName?: string | null, isPortfolioValueDifferenceSignificant?: boolean | null, allowsHardResync?: boolean | null, errors?: Array<string | null> | null, assetsCount?: number | null, slug?: string | null, syncInfo?: { __typename?: 'SyncInfo', lastSynced?: any | null, isSyncing?: boolean | null, willBeDeleted?: boolean | null, isDisabled?: boolean | null } | null } | null> | null, customWallets?: Array<{ __typename?: 'CustomWallet', id?: string | null, name?: string | null, value?: number | null, assetsCount?: number | null, slug?: string | null, syncInfo?: { __typename?: 'SyncInfo', isSyncing?: boolean | null, willBeDeleted?: boolean | null, lastSynced?: any | null } | null } | null> | null, otherTransactions?: { __typename?: 'OtherTransactions', id?: string | null, value?: number | null, assetsCount?: number | null } | null };

export type GetReportsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsPageQuery = { __typename?: 'Query', taxYears?: Array<{ __typename?: 'UserTaxYear', taxYear?: number | null, title?: string | null, dateRange?: string | null, startDate?: any | null, endDate?: any | null } | null> | null };

export type GetExchangeDataForUpdateQueryVariables = Exact<{
  publicId: Scalars['String'];
}>;


export type GetExchangeDataForUpdateQuery = { __typename?: 'Query', exchange?: { __typename?: 'Exchange', id?: string | null, name?: string | null, slug?: string | null, instructions?: string | null, formId?: IntegrationFormType | null, syncMethod?: string | null, imageUrl?: string | null, supportedFileFormats?: Array<FileFormats | null> | null } | null };


export const GetAppInfoDocument = gql`
    query GetAppInfo {
  appInfo {
    maintenanceMode
    maintenanceMessage
    isViewAsUser
    webAppHomePage
  }
}
    `;

/**
 * __useGetAppInfoQuery__
 *
 * To run a query within a React component, call `useGetAppInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetAppInfoQuery, GetAppInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppInfoQuery, GetAppInfoQueryVariables>(GetAppInfoDocument, options);
      }
export function useGetAppInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppInfoQuery, GetAppInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppInfoQuery, GetAppInfoQueryVariables>(GetAppInfoDocument, options);
        }
export type GetAppInfoQueryHookResult = ReturnType<typeof useGetAppInfoQuery>;
export type GetAppInfoLazyQueryHookResult = ReturnType<typeof useGetAppInfoLazyQuery>;
export type GetAppInfoQueryResult = Apollo.QueryResult<GetAppInfoQuery, GetAppInfoQueryVariables>;
export const GetUserDocument = gql`
    query GetUser {
  userInfo {
    publicId
    enableCbe
    viewAsUserId
    anonymousId
    analyticsId
    createdAt
    displayedBalances
    useV2Lots
    shouldShowOnboardingFlow
    portfolioSubscription
    unifiedSubscription {
      subscriptionPlan
    }
    debugPermission
    baseCurrency {
      cmcId
      type
      uaid
      symbol
      formatSymbol
      priceUsd
      name
    }
    country {
      code
      name
      canAccessTaxLossHarvesting
    }
    isAdmin
    isAffiliate
    enableCbe
    enableEmbedded
    displayUser {
      publicId
      isWhitelisted
      hasDefi
      email
      country {
        code
        name
        canAccessTaxLossHarvesting
      }
      registeredAsTaxPro
      taxYearToUse
    }
    closedPeriodDatetime
    showPlanDiscoverability
    daysUntilTaxDeadline
    selectedTheme
    syncCutoffDate
    costBasisByWallet
    lotAllocationMethod
    isUndergoingAllocation
    migrationPreviouslySoftBlocked
    hasTransitioned
    emailChangeIsAllowed {
      ok
      error
    }
    emailChangeRequestStatus {
      inProgress
      fromEmail
      toEmail
    }
    isUsingPersistedTransactions
    hasWalletsSpamHidden
  }
  userProfile {
    email
    isCpa
  }
  myProfile {
    createdWithPassword
    isTwoStepVerificationEnabled
  }
  session {
    taxProsReturnPublicId
    anonymousId
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const PresignDocument = gql`
    mutation Presign($filename: String!) {
  presignFileUpload(filename: $filename) {
    success
    error
    result {
      uploadInfoFields {
        key
        value
      }
      fileUrl
      postUrl
    }
  }
}
    `;
export type PresignMutationFn = Apollo.MutationFunction<PresignMutation, PresignMutationVariables>;

/**
 * __usePresignMutation__
 *
 * To run a mutation, you first call `usePresignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePresignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [presignMutation, { data, loading, error }] = usePresignMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function usePresignMutation(baseOptions?: Apollo.MutationHookOptions<PresignMutation, PresignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PresignMutation, PresignMutationVariables>(PresignDocument, options);
      }
export type PresignMutationHookResult = ReturnType<typeof usePresignMutation>;
export type PresignMutationResult = Apollo.MutationResult<PresignMutation>;
export type PresignMutationOptions = Apollo.BaseMutationOptions<PresignMutation, PresignMutationVariables>;
export const GetCostBasisStatusDocument = gql`
    query GetCostBasisStatus {
  userInfo {
    publicId
    isUndergoingAllocation
    isCostBasisRunning
    costBasisLastSyncedAt
    costBasisComputeStartTime
    costBasisComputeEndTime
    costBasisStatus {
      state
      priority
    }
    costBasisRecomputationDate
    costBasisPaused
  }
}
    `;

/**
 * __useGetCostBasisStatusQuery__
 *
 * To run a query within a React component, call `useGetCostBasisStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostBasisStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostBasisStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCostBasisStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetCostBasisStatusQuery, GetCostBasisStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostBasisStatusQuery, GetCostBasisStatusQueryVariables>(GetCostBasisStatusDocument, options);
      }
export function useGetCostBasisStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostBasisStatusQuery, GetCostBasisStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostBasisStatusQuery, GetCostBasisStatusQueryVariables>(GetCostBasisStatusDocument, options);
        }
export type GetCostBasisStatusQueryHookResult = ReturnType<typeof useGetCostBasisStatusQuery>;
export type GetCostBasisStatusLazyQueryHookResult = ReturnType<typeof useGetCostBasisStatusLazyQuery>;
export type GetCostBasisStatusQueryResult = Apollo.QueryResult<GetCostBasisStatusQuery, GetCostBasisStatusQueryVariables>;
export const GetFreezingStatusDocument = gql`
    query GetFreezingStatus {
  userInfo {
    publicId
    freezing {
      isAvailable
      startTime
      endTime
      lastUpdatedAt
      status
      error
    }
  }
}
    `;

/**
 * __useGetFreezingStatusQuery__
 *
 * To run a query within a React component, call `useGetFreezingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreezingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreezingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFreezingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetFreezingStatusQuery, GetFreezingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreezingStatusQuery, GetFreezingStatusQueryVariables>(GetFreezingStatusDocument, options);
      }
export function useGetFreezingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreezingStatusQuery, GetFreezingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreezingStatusQuery, GetFreezingStatusQueryVariables>(GetFreezingStatusDocument, options);
        }
export type GetFreezingStatusQueryHookResult = ReturnType<typeof useGetFreezingStatusQuery>;
export type GetFreezingStatusLazyQueryHookResult = ReturnType<typeof useGetFreezingStatusLazyQuery>;
export type GetFreezingStatusQueryResult = Apollo.QueryResult<GetFreezingStatusQuery, GetFreezingStatusQueryVariables>;
export const GetUserLendingStakingDataDocument = gql`
    query GetUserLendingStakingData {
  userLendingAndStakingAssets {
    walletPublicId
    uaid
  }
}
    `;

/**
 * __useGetUserLendingStakingDataQuery__
 *
 * To run a query within a React component, call `useGetUserLendingStakingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLendingStakingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLendingStakingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLendingStakingDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLendingStakingDataQuery, GetUserLendingStakingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLendingStakingDataQuery, GetUserLendingStakingDataQueryVariables>(GetUserLendingStakingDataDocument, options);
      }
export function useGetUserLendingStakingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLendingStakingDataQuery, GetUserLendingStakingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLendingStakingDataQuery, GetUserLendingStakingDataQueryVariables>(GetUserLendingStakingDataDocument, options);
        }
export type GetUserLendingStakingDataQueryHookResult = ReturnType<typeof useGetUserLendingStakingDataQuery>;
export type GetUserLendingStakingDataLazyQueryHookResult = ReturnType<typeof useGetUserLendingStakingDataLazyQuery>;
export type GetUserLendingStakingDataQueryResult = Apollo.QueryResult<GetUserLendingStakingDataQuery, GetUserLendingStakingDataQueryVariables>;
export const GetYourAssetsDocument = gql`
    query GetYourAssets {
  portfolio(performanceDuration: ALL_TIME) {
    hasAccessToPerformanceByCrypto
    currencies {
      currency {
        type
        cmcId
        uaid
        slug
        symbol
        name
        price
        marketCap
        percentChange24h
        iconUrlFromInfo
      }
      quantity
      reportedQuantity
      calculatedQuantity
      marketValue
      reportedMarketValue
      calculatedMarketValue
      costBasis
      averageCostBasis
      allTimeReturn
      allTimeReturnPercent
      totalReturnOnInvestment
      totalReturnOnInvestmentPercent
      netTotalWithdrawals
      netTotalDeposits
      portfolioPercent
      error
    }
    fiats {
      currency {
        symbol
        name
        price
      }
      quantity
    }
    userAssets {
      currency {
        symbol
        name
        price
      }
      quantity
    }
  }
}
    `;

/**
 * __useGetYourAssetsQuery__
 *
 * To run a query within a React component, call `useGetYourAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYourAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYourAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYourAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetYourAssetsQuery, GetYourAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYourAssetsQuery, GetYourAssetsQueryVariables>(GetYourAssetsDocument, options);
      }
export function useGetYourAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYourAssetsQuery, GetYourAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYourAssetsQuery, GetYourAssetsQueryVariables>(GetYourAssetsDocument, options);
        }
export type GetYourAssetsQueryHookResult = ReturnType<typeof useGetYourAssetsQuery>;
export type GetYourAssetsLazyQueryHookResult = ReturnType<typeof useGetYourAssetsLazyQuery>;
export type GetYourAssetsQueryResult = Apollo.QueryResult<GetYourAssetsQuery, GetYourAssetsQueryVariables>;
export const SearchCurrenciesDocument = gql`
    query SearchCurrencies($query: String = "", $limit: Int, $showCryptos: Boolean!, $hideInactiveCryptos: Boolean!, $showFiats: Boolean!, $showUserAssets: Boolean!) {
  searchCurrencies(
    query: $query
    limit: $limit
    hideInactiveCryptos: $hideInactiveCryptos
  ) {
    cryptos @include(if: $showCryptos) {
      id
      icon
      name
      symbol
      uaid
    }
    fiats @include(if: $showFiats) {
      id
      icon
      name
      symbol
      uaid
    }
    userAssets @include(if: $showUserAssets) {
      id
      icon
      name
      symbol
      uaid
    }
    nfts {
      id
      icon
      name
      symbol
      uaid
    }
    blockchainTokens {
      id
      icon
      name
      symbol
      uaid
    }
    virtualTokens {
      id
      icon
      name
      symbol
      uaid
    }
  }
}
    `;

/**
 * __useSearchCurrenciesQuery__
 *
 * To run a query within a React component, call `useSearchCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCurrenciesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      showCryptos: // value for 'showCryptos'
 *      hideInactiveCryptos: // value for 'hideInactiveCryptos'
 *      showFiats: // value for 'showFiats'
 *      showUserAssets: // value for 'showUserAssets'
 *   },
 * });
 */
export function useSearchCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<SearchCurrenciesQuery, SearchCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCurrenciesQuery, SearchCurrenciesQueryVariables>(SearchCurrenciesDocument, options);
      }
export function useSearchCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCurrenciesQuery, SearchCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCurrenciesQuery, SearchCurrenciesQueryVariables>(SearchCurrenciesDocument, options);
        }
export type SearchCurrenciesQueryHookResult = ReturnType<typeof useSearchCurrenciesQuery>;
export type SearchCurrenciesLazyQueryHookResult = ReturnType<typeof useSearchCurrenciesLazyQuery>;
export type SearchCurrenciesQueryResult = Apollo.QueryResult<SearchCurrenciesQuery, SearchCurrenciesQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countriesList {
    name
    code
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetPlanDiscountsDocument = gql`
    query GetPlanDiscounts {
  availableUnifiedSubscriptionPlans {
    plans {
      name
      price {
        discountReason
      }
    }
  }
}
    `;

/**
 * __useGetPlanDiscountsQuery__
 *
 * To run a query within a React component, call `useGetPlanDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanDiscountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlanDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlanDiscountsQuery, GetPlanDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanDiscountsQuery, GetPlanDiscountsQueryVariables>(GetPlanDiscountsDocument, options);
      }
export function useGetPlanDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanDiscountsQuery, GetPlanDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanDiscountsQuery, GetPlanDiscountsQueryVariables>(GetPlanDiscountsDocument, options);
        }
export type GetPlanDiscountsQueryHookResult = ReturnType<typeof useGetPlanDiscountsQuery>;
export type GetPlanDiscountsLazyQueryHookResult = ReturnType<typeof useGetPlanDiscountsLazyQuery>;
export type GetPlanDiscountsQueryResult = Apollo.QueryResult<GetPlanDiscountsQuery, GetPlanDiscountsQueryVariables>;
export const AcceptTaxProClientInviteDocument = gql`
    mutation AcceptTaxProClientInvite($senderPublicId: String!, $currentUserRole: TaxProClientInviteInitiator!) {
  acceptTaxProClientInvite(
    senderPublicId: $senderPublicId
    currentUserRole: $currentUserRole
  ) {
    success
  }
}
    `;
export type AcceptTaxProClientInviteMutationFn = Apollo.MutationFunction<AcceptTaxProClientInviteMutation, AcceptTaxProClientInviteMutationVariables>;

/**
 * __useAcceptTaxProClientInviteMutation__
 *
 * To run a mutation, you first call `useAcceptTaxProClientInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTaxProClientInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTaxProClientInviteMutation, { data, loading, error }] = useAcceptTaxProClientInviteMutation({
 *   variables: {
 *      senderPublicId: // value for 'senderPublicId'
 *      currentUserRole: // value for 'currentUserRole'
 *   },
 * });
 */
export function useAcceptTaxProClientInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTaxProClientInviteMutation, AcceptTaxProClientInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTaxProClientInviteMutation, AcceptTaxProClientInviteMutationVariables>(AcceptTaxProClientInviteDocument, options);
      }
export type AcceptTaxProClientInviteMutationHookResult = ReturnType<typeof useAcceptTaxProClientInviteMutation>;
export type AcceptTaxProClientInviteMutationResult = Apollo.MutationResult<AcceptTaxProClientInviteMutation>;
export type AcceptTaxProClientInviteMutationOptions = Apollo.BaseMutationOptions<AcceptTaxProClientInviteMutation, AcceptTaxProClientInviteMutationVariables>;
export const GetIncomingInvitesDocument = gql`
    query GetIncomingInvites {
  firmInvitesForPro {
    email
    taxFirm {
      publicId
      name
    }
  }
  taxProClientInvites(inviteFilter: RECEIVED_BY_USER) {
    taxProPublicId
    clientPublicId
    taxProEmail
    clientEmail
    senderEmail
    initiatedBy
  }
}
    `;

/**
 * __useGetIncomingInvitesQuery__
 *
 * To run a query within a React component, call `useGetIncomingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncomingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncomingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIncomingInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetIncomingInvitesQuery, GetIncomingInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncomingInvitesQuery, GetIncomingInvitesQueryVariables>(GetIncomingInvitesDocument, options);
      }
export function useGetIncomingInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncomingInvitesQuery, GetIncomingInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncomingInvitesQuery, GetIncomingInvitesQueryVariables>(GetIncomingInvitesDocument, options);
        }
export type GetIncomingInvitesQueryHookResult = ReturnType<typeof useGetIncomingInvitesQuery>;
export type GetIncomingInvitesLazyQueryHookResult = ReturnType<typeof useGetIncomingInvitesLazyQuery>;
export type GetIncomingInvitesQueryResult = Apollo.QueryResult<GetIncomingInvitesQuery, GetIncomingInvitesQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies($queries: [String]!) {
  currencies(queries: $queries) {
    symbol
  }
}
    `;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *      queries: // value for 'queries'
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const LotImporterStatusDocument = gql`
    query LotImporterStatus {
  lotImporterStatus {
    jobStatus
  }
  userInfo {
    publicId
    isCostBasisRunning
  }
}
    `;

/**
 * __useLotImporterStatusQuery__
 *
 * To run a query within a React component, call `useLotImporterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotImporterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotImporterStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useLotImporterStatusQuery(baseOptions?: Apollo.QueryHookOptions<LotImporterStatusQuery, LotImporterStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LotImporterStatusQuery, LotImporterStatusQueryVariables>(LotImporterStatusDocument, options);
      }
export function useLotImporterStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LotImporterStatusQuery, LotImporterStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LotImporterStatusQuery, LotImporterStatusQueryVariables>(LotImporterStatusDocument, options);
        }
export type LotImporterStatusQueryHookResult = ReturnType<typeof useLotImporterStatusQuery>;
export type LotImporterStatusLazyQueryHookResult = ReturnType<typeof useLotImporterStatusLazyQuery>;
export type LotImporterStatusQueryResult = Apollo.QueryResult<LotImporterStatusQuery, LotImporterStatusQueryVariables>;
export const SubmitLotsFileDocument = gql`
    mutation SubmitLotsFile($fileUrl: String!) {
  submitLotsFile(fileUrl: $fileUrl) {
    success
  }
}
    `;
export type SubmitLotsFileMutationFn = Apollo.MutationFunction<SubmitLotsFileMutation, SubmitLotsFileMutationVariables>;

/**
 * __useSubmitLotsFileMutation__
 *
 * To run a mutation, you first call `useSubmitLotsFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLotsFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLotsFileMutation, { data, loading, error }] = useSubmitLotsFileMutation({
 *   variables: {
 *      fileUrl: // value for 'fileUrl'
 *   },
 * });
 */
export function useSubmitLotsFileMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLotsFileMutation, SubmitLotsFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLotsFileMutation, SubmitLotsFileMutationVariables>(SubmitLotsFileDocument, options);
      }
export type SubmitLotsFileMutationHookResult = ReturnType<typeof useSubmitLotsFileMutation>;
export type SubmitLotsFileMutationResult = Apollo.MutationResult<SubmitLotsFileMutation>;
export type SubmitLotsFileMutationOptions = Apollo.BaseMutationOptions<SubmitLotsFileMutation, SubmitLotsFileMutationVariables>;
export const AcceptFirmInviteDocument = gql`
    mutation AcceptFirmInvite($taxFirmPublicId: String!) {
  acceptFirmInvite(taxFirmPublicId: $taxFirmPublicId) {
    success
  }
}
    `;
export type AcceptFirmInviteMutationFn = Apollo.MutationFunction<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>;

/**
 * __useAcceptFirmInviteMutation__
 *
 * To run a mutation, you first call `useAcceptFirmInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFirmInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFirmInviteMutation, { data, loading, error }] = useAcceptFirmInviteMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *   },
 * });
 */
export function useAcceptFirmInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>(AcceptFirmInviteDocument, options);
      }
export type AcceptFirmInviteMutationHookResult = ReturnType<typeof useAcceptFirmInviteMutation>;
export type AcceptFirmInviteMutationResult = Apollo.MutationResult<AcceptFirmInviteMutation>;
export type AcceptFirmInviteMutationOptions = Apollo.BaseMutationOptions<AcceptFirmInviteMutation, AcceptFirmInviteMutationVariables>;
export const AddFirmAdminDocument = gql`
    mutation AddFirmAdmin($taxFirmPublicId: String!, $email: String!) {
  addFirmAdmin(taxFirmPublicId: $taxFirmPublicId, email: $email) {
    success
  }
}
    `;
export type AddFirmAdminMutationFn = Apollo.MutationFunction<AddFirmAdminMutation, AddFirmAdminMutationVariables>;

/**
 * __useAddFirmAdminMutation__
 *
 * To run a mutation, you first call `useAddFirmAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFirmAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFirmAdminMutation, { data, loading, error }] = useAddFirmAdminMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddFirmAdminMutation(baseOptions?: Apollo.MutationHookOptions<AddFirmAdminMutation, AddFirmAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFirmAdminMutation, AddFirmAdminMutationVariables>(AddFirmAdminDocument, options);
      }
export type AddFirmAdminMutationHookResult = ReturnType<typeof useAddFirmAdminMutation>;
export type AddFirmAdminMutationResult = Apollo.MutationResult<AddFirmAdminMutation>;
export type AddFirmAdminMutationOptions = Apollo.BaseMutationOptions<AddFirmAdminMutation, AddFirmAdminMutationVariables>;
export const AdminAddTaxProForClientDocument = gql`
    mutation AdminAddTaxProForClient($taxFirmPublicId: String!, $clientEmail: String!, $taxProEmail: String!) {
  adminAddTaxProForClient(
    taxFirmPublicId: $taxFirmPublicId
    clientEmail: $clientEmail
    taxProEmail: $taxProEmail
  ) {
    success
  }
}
    `;
export type AdminAddTaxProForClientMutationFn = Apollo.MutationFunction<AdminAddTaxProForClientMutation, AdminAddTaxProForClientMutationVariables>;

/**
 * __useAdminAddTaxProForClientMutation__
 *
 * To run a mutation, you first call `useAdminAddTaxProForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddTaxProForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddTaxProForClientMutation, { data, loading, error }] = useAdminAddTaxProForClientMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      clientEmail: // value for 'clientEmail'
 *      taxProEmail: // value for 'taxProEmail'
 *   },
 * });
 */
export function useAdminAddTaxProForClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminAddTaxProForClientMutation, AdminAddTaxProForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminAddTaxProForClientMutation, AdminAddTaxProForClientMutationVariables>(AdminAddTaxProForClientDocument, options);
      }
export type AdminAddTaxProForClientMutationHookResult = ReturnType<typeof useAdminAddTaxProForClientMutation>;
export type AdminAddTaxProForClientMutationResult = Apollo.MutationResult<AdminAddTaxProForClientMutation>;
export type AdminAddTaxProForClientMutationOptions = Apollo.BaseMutationOptions<AdminAddTaxProForClientMutation, AdminAddTaxProForClientMutationVariables>;
export const AdminRemoveTaxProForClientDocument = gql`
    mutation AdminRemoveTaxProForClient($taxFirmPublicId: String!, $clientEmail: String!, $taxProEmail: String!) {
  adminRemoveTaxProForClient(
    taxFirmPublicId: $taxFirmPublicId
    clientEmail: $clientEmail
    taxProEmail: $taxProEmail
  ) {
    success
  }
}
    `;
export type AdminRemoveTaxProForClientMutationFn = Apollo.MutationFunction<AdminRemoveTaxProForClientMutation, AdminRemoveTaxProForClientMutationVariables>;

/**
 * __useAdminRemoveTaxProForClientMutation__
 *
 * To run a mutation, you first call `useAdminRemoveTaxProForClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRemoveTaxProForClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRemoveTaxProForClientMutation, { data, loading, error }] = useAdminRemoveTaxProForClientMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      clientEmail: // value for 'clientEmail'
 *      taxProEmail: // value for 'taxProEmail'
 *   },
 * });
 */
export function useAdminRemoveTaxProForClientMutation(baseOptions?: Apollo.MutationHookOptions<AdminRemoveTaxProForClientMutation, AdminRemoveTaxProForClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRemoveTaxProForClientMutation, AdminRemoveTaxProForClientMutationVariables>(AdminRemoveTaxProForClientDocument, options);
      }
export type AdminRemoveTaxProForClientMutationHookResult = ReturnType<typeof useAdminRemoveTaxProForClientMutation>;
export type AdminRemoveTaxProForClientMutationResult = Apollo.MutationResult<AdminRemoveTaxProForClientMutation>;
export type AdminRemoveTaxProForClientMutationOptions = Apollo.BaseMutationOptions<AdminRemoveTaxProForClientMutation, AdminRemoveTaxProForClientMutationVariables>;
export const DeleteFirmInviteDocument = gql`
    mutation DeleteFirmInvite($taxFirmPublicId: String!, $email: String!) {
  deleteFirmInvite(taxFirmPublicId: $taxFirmPublicId, email: $email) {
    success
  }
}
    `;
export type DeleteFirmInviteMutationFn = Apollo.MutationFunction<DeleteFirmInviteMutation, DeleteFirmInviteMutationVariables>;

/**
 * __useDeleteFirmInviteMutation__
 *
 * To run a mutation, you first call `useDeleteFirmInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFirmInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFirmInviteMutation, { data, loading, error }] = useDeleteFirmInviteMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteFirmInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFirmInviteMutation, DeleteFirmInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFirmInviteMutation, DeleteFirmInviteMutationVariables>(DeleteFirmInviteDocument, options);
      }
export type DeleteFirmInviteMutationHookResult = ReturnType<typeof useDeleteFirmInviteMutation>;
export type DeleteFirmInviteMutationResult = Apollo.MutationResult<DeleteFirmInviteMutation>;
export type DeleteFirmInviteMutationOptions = Apollo.BaseMutationOptions<DeleteFirmInviteMutation, DeleteFirmInviteMutationVariables>;
export const DeleteFirmMemberDocument = gql`
    mutation DeleteFirmMember($taxFirmPublicId: String!, $userPublicId: String!) {
  deleteFirmMember(taxFirmPublicId: $taxFirmPublicId, userPublicId: $userPublicId) {
    success
  }
}
    `;
export type DeleteFirmMemberMutationFn = Apollo.MutationFunction<DeleteFirmMemberMutation, DeleteFirmMemberMutationVariables>;

/**
 * __useDeleteFirmMemberMutation__
 *
 * To run a mutation, you first call `useDeleteFirmMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFirmMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFirmMemberMutation, { data, loading, error }] = useDeleteFirmMemberMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      userPublicId: // value for 'userPublicId'
 *   },
 * });
 */
export function useDeleteFirmMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFirmMemberMutation, DeleteFirmMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFirmMemberMutation, DeleteFirmMemberMutationVariables>(DeleteFirmMemberDocument, options);
      }
export type DeleteFirmMemberMutationHookResult = ReturnType<typeof useDeleteFirmMemberMutation>;
export type DeleteFirmMemberMutationResult = Apollo.MutationResult<DeleteFirmMemberMutation>;
export type DeleteFirmMemberMutationOptions = Apollo.BaseMutationOptions<DeleteFirmMemberMutation, DeleteFirmMemberMutationVariables>;
export const GetTaxFirmMembersDocument = gql`
    query GetTaxFirmMembers($taxFirmPublicId: String!) {
  taxFirm(publicId: $taxFirmPublicId) {
    name
    publicId
  }
  firmMembers(taxFirmPublicId: $taxFirmPublicId) {
    userPublicId
    role
    email
    sentInvites: taxProClientInvites(inviteFilter: SENT_BY_USER) {
      clientEmail
    }
    receivedInvites: taxProClientInvites(inviteFilter: RECEIVED_BY_USER) {
      senderEmail
    }
  }
  firmInvites(taxFirmPublicId: $taxFirmPublicId) {
    email
  }
}
    `;

/**
 * __useGetTaxFirmMembersQuery__
 *
 * To run a query within a React component, call `useGetTaxFirmMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxFirmMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxFirmMembersQuery({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *   },
 * });
 */
export function useGetTaxFirmMembersQuery(baseOptions: Apollo.QueryHookOptions<GetTaxFirmMembersQuery, GetTaxFirmMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxFirmMembersQuery, GetTaxFirmMembersQueryVariables>(GetTaxFirmMembersDocument, options);
      }
export function useGetTaxFirmMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxFirmMembersQuery, GetTaxFirmMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxFirmMembersQuery, GetTaxFirmMembersQueryVariables>(GetTaxFirmMembersDocument, options);
        }
export type GetTaxFirmMembersQueryHookResult = ReturnType<typeof useGetTaxFirmMembersQuery>;
export type GetTaxFirmMembersLazyQueryHookResult = ReturnType<typeof useGetTaxFirmMembersLazyQuery>;
export type GetTaxFirmMembersQueryResult = Apollo.QueryResult<GetTaxFirmMembersQuery, GetTaxFirmMembersQueryVariables>;
export const GetTaxFirmMembersWithClientsDocument = gql`
    query GetTaxFirmMembersWithClients($taxFirmPublicId: String!) {
  taxFirm(publicId: $taxFirmPublicId) {
    name
    publicId
  }
  firmMembers(taxFirmPublicId: $taxFirmPublicId) {
    userPublicId
    role
    email
    taxProClients {
      email
      createdAt
    }
    sentInvites: taxProClientInvites(inviteFilter: SENT_BY_USER) {
      clientEmail
    }
    receivedInvites: taxProClientInvites(inviteFilter: RECEIVED_BY_USER) {
      senderEmail
    }
  }
  firmInvites(taxFirmPublicId: $taxFirmPublicId) {
    email
  }
}
    `;

/**
 * __useGetTaxFirmMembersWithClientsQuery__
 *
 * To run a query within a React component, call `useGetTaxFirmMembersWithClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxFirmMembersWithClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxFirmMembersWithClientsQuery({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *   },
 * });
 */
export function useGetTaxFirmMembersWithClientsQuery(baseOptions: Apollo.QueryHookOptions<GetTaxFirmMembersWithClientsQuery, GetTaxFirmMembersWithClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxFirmMembersWithClientsQuery, GetTaxFirmMembersWithClientsQueryVariables>(GetTaxFirmMembersWithClientsDocument, options);
      }
export function useGetTaxFirmMembersWithClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxFirmMembersWithClientsQuery, GetTaxFirmMembersWithClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxFirmMembersWithClientsQuery, GetTaxFirmMembersWithClientsQueryVariables>(GetTaxFirmMembersWithClientsDocument, options);
        }
export type GetTaxFirmMembersWithClientsQueryHookResult = ReturnType<typeof useGetTaxFirmMembersWithClientsQuery>;
export type GetTaxFirmMembersWithClientsLazyQueryHookResult = ReturnType<typeof useGetTaxFirmMembersWithClientsLazyQuery>;
export type GetTaxFirmMembersWithClientsQueryResult = Apollo.QueryResult<GetTaxFirmMembersWithClientsQuery, GetTaxFirmMembersWithClientsQueryVariables>;
export const InviteProToFirmDocument = gql`
    mutation InviteProToFirm($taxFirmPublicId: String!, $email: String!) {
  inviteProToFirm(taxFirmPublicId: $taxFirmPublicId, email: $email) {
    success
  }
}
    `;
export type InviteProToFirmMutationFn = Apollo.MutationFunction<InviteProToFirmMutation, InviteProToFirmMutationVariables>;

/**
 * __useInviteProToFirmMutation__
 *
 * To run a mutation, you first call `useInviteProToFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteProToFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteProToFirmMutation, { data, loading, error }] = useInviteProToFirmMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteProToFirmMutation(baseOptions?: Apollo.MutationHookOptions<InviteProToFirmMutation, InviteProToFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteProToFirmMutation, InviteProToFirmMutationVariables>(InviteProToFirmDocument, options);
      }
export type InviteProToFirmMutationHookResult = ReturnType<typeof useInviteProToFirmMutation>;
export type InviteProToFirmMutationResult = Apollo.MutationResult<InviteProToFirmMutation>;
export type InviteProToFirmMutationOptions = Apollo.BaseMutationOptions<InviteProToFirmMutation, InviteProToFirmMutationVariables>;
export const DeleteTaxProClientDocument = gql`
    mutation DeleteTaxProClient($partnerPublicId: String!, $currentUserRole: TaxProClientInviteInitiator!) {
  deleteTaxProClient(
    partnerPublicId: $partnerPublicId
    currentUserRole: $currentUserRole
  ) {
    success
  }
}
    `;
export type DeleteTaxProClientMutationFn = Apollo.MutationFunction<DeleteTaxProClientMutation, DeleteTaxProClientMutationVariables>;

/**
 * __useDeleteTaxProClientMutation__
 *
 * To run a mutation, you first call `useDeleteTaxProClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxProClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxProClientMutation, { data, loading, error }] = useDeleteTaxProClientMutation({
 *   variables: {
 *      partnerPublicId: // value for 'partnerPublicId'
 *      currentUserRole: // value for 'currentUserRole'
 *   },
 * });
 */
export function useDeleteTaxProClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaxProClientMutation, DeleteTaxProClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaxProClientMutation, DeleteTaxProClientMutationVariables>(DeleteTaxProClientDocument, options);
      }
export type DeleteTaxProClientMutationHookResult = ReturnType<typeof useDeleteTaxProClientMutation>;
export type DeleteTaxProClientMutationResult = Apollo.MutationResult<DeleteTaxProClientMutation>;
export type DeleteTaxProClientMutationOptions = Apollo.BaseMutationOptions<DeleteTaxProClientMutation, DeleteTaxProClientMutationVariables>;
export const DeleteTaxProClientInviteDocument = gql`
    mutation DeleteTaxProClientInvite($senderPublicId: String!, $recipientEmail: String!, $initiatedBy: TaxProClientInviteInitiator!) {
  deleteTaxProClientInvite(
    senderPublicId: $senderPublicId
    recipientEmail: $recipientEmail
    initiatedBy: $initiatedBy
  ) {
    success
  }
}
    `;
export type DeleteTaxProClientInviteMutationFn = Apollo.MutationFunction<DeleteTaxProClientInviteMutation, DeleteTaxProClientInviteMutationVariables>;

/**
 * __useDeleteTaxProClientInviteMutation__
 *
 * To run a mutation, you first call `useDeleteTaxProClientInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxProClientInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxProClientInviteMutation, { data, loading, error }] = useDeleteTaxProClientInviteMutation({
 *   variables: {
 *      senderPublicId: // value for 'senderPublicId'
 *      recipientEmail: // value for 'recipientEmail'
 *      initiatedBy: // value for 'initiatedBy'
 *   },
 * });
 */
export function useDeleteTaxProClientInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaxProClientInviteMutation, DeleteTaxProClientInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaxProClientInviteMutation, DeleteTaxProClientInviteMutationVariables>(DeleteTaxProClientInviteDocument, options);
      }
export type DeleteTaxProClientInviteMutationHookResult = ReturnType<typeof useDeleteTaxProClientInviteMutation>;
export type DeleteTaxProClientInviteMutationResult = Apollo.MutationResult<DeleteTaxProClientInviteMutation>;
export type DeleteTaxProClientInviteMutationOptions = Apollo.BaseMutationOptions<DeleteTaxProClientInviteMutation, DeleteTaxProClientInviteMutationVariables>;
export const GetTaxProClientListDocument = gql`
    query GetTaxProClientList {
  currentTaxFirm {
    name
    publicId
  }
  taxProClientInvites(inviteFilter: SENT_BY_USER) {
    taxProPublicId
    clientEmail
    initiatedBy
  }
  taxProClients {
    taxProsFirmMemberPublicId
    userPublicId
    email
    requiredTaxPlanStatus
  }
  taxYear
}
    `;

/**
 * __useGetTaxProClientListQuery__
 *
 * To run a query within a React component, call `useGetTaxProClientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxProClientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxProClientListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxProClientListQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxProClientListQuery, GetTaxProClientListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxProClientListQuery, GetTaxProClientListQueryVariables>(GetTaxProClientListDocument, options);
      }
export function useGetTaxProClientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxProClientListQuery, GetTaxProClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxProClientListQuery, GetTaxProClientListQueryVariables>(GetTaxProClientListDocument, options);
        }
export type GetTaxProClientListQueryHookResult = ReturnType<typeof useGetTaxProClientListQuery>;
export type GetTaxProClientListLazyQueryHookResult = ReturnType<typeof useGetTaxProClientListLazyQuery>;
export type GetTaxProClientListQueryResult = Apollo.QueryResult<GetTaxProClientListQuery, GetTaxProClientListQueryVariables>;
export const InviteTaxProClientDocument = gql`
    mutation InviteTaxProClient($email: String!, $currentUserRole: TaxProClientInviteInitiator!) {
  inviteTaxProClient(email: $email, currentUserRole: $currentUserRole) {
    success
  }
}
    `;
export type InviteTaxProClientMutationFn = Apollo.MutationFunction<InviteTaxProClientMutation, InviteTaxProClientMutationVariables>;

/**
 * __useInviteTaxProClientMutation__
 *
 * To run a mutation, you first call `useInviteTaxProClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTaxProClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTaxProClientMutation, { data, loading, error }] = useInviteTaxProClientMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentUserRole: // value for 'currentUserRole'
 *   },
 * });
 */
export function useInviteTaxProClientMutation(baseOptions?: Apollo.MutationHookOptions<InviteTaxProClientMutation, InviteTaxProClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTaxProClientMutation, InviteTaxProClientMutationVariables>(InviteTaxProClientDocument, options);
      }
export type InviteTaxProClientMutationHookResult = ReturnType<typeof useInviteTaxProClientMutation>;
export type InviteTaxProClientMutationResult = Apollo.MutationResult<InviteTaxProClientMutation>;
export type InviteTaxProClientMutationOptions = Apollo.BaseMutationOptions<InviteTaxProClientMutation, InviteTaxProClientMutationVariables>;
export const GetTaxProListDocument = gql`
    query GetTaxProList {
  taxProClientInvites(inviteFilter: SENT_BY_USER) {
    clientPublicId
    taxProEmail
    initiatedBy
  }
  taxPros {
    taxProsFirmMemberPublicId
    userPublicId
    taxProEmail
  }
}
    `;

/**
 * __useGetTaxProListQuery__
 *
 * To run a query within a React component, call `useGetTaxProListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxProListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxProListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxProListQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxProListQuery, GetTaxProListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxProListQuery, GetTaxProListQueryVariables>(GetTaxProListDocument, options);
      }
export function useGetTaxProListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxProListQuery, GetTaxProListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxProListQuery, GetTaxProListQueryVariables>(GetTaxProListDocument, options);
        }
export type GetTaxProListQueryHookResult = ReturnType<typeof useGetTaxProListQuery>;
export type GetTaxProListLazyQueryHookResult = ReturnType<typeof useGetTaxProListLazyQuery>;
export type GetTaxProListQueryResult = Apollo.QueryResult<GetTaxProListQuery, GetTaxProListQueryVariables>;
export const LeaveFirmDocument = gql`
    mutation LeaveFirm($taxFirmPublicId: String!) {
  leaveFirm(taxFirmPublicId: $taxFirmPublicId) {
    success
  }
}
    `;
export type LeaveFirmMutationFn = Apollo.MutationFunction<LeaveFirmMutation, LeaveFirmMutationVariables>;

/**
 * __useLeaveFirmMutation__
 *
 * To run a mutation, you first call `useLeaveFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveFirmMutation, { data, loading, error }] = useLeaveFirmMutation({
 *   variables: {
 *      taxFirmPublicId: // value for 'taxFirmPublicId'
 *   },
 * });
 */
export function useLeaveFirmMutation(baseOptions?: Apollo.MutationHookOptions<LeaveFirmMutation, LeaveFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveFirmMutation, LeaveFirmMutationVariables>(LeaveFirmDocument, options);
      }
export type LeaveFirmMutationHookResult = ReturnType<typeof useLeaveFirmMutation>;
export type LeaveFirmMutationResult = Apollo.MutationResult<LeaveFirmMutation>;
export type LeaveFirmMutationOptions = Apollo.BaseMutationOptions<LeaveFirmMutation, LeaveFirmMutationVariables>;
export const EnqueueCostBasisDocument = gql`
    mutation EnqueueCostBasis($priority: QueuePriority!) {
  enqueueCostBasis(priority: $priority) {
    success
    error
  }
}
    `;
export type EnqueueCostBasisMutationFn = Apollo.MutationFunction<EnqueueCostBasisMutation, EnqueueCostBasisMutationVariables>;

/**
 * __useEnqueueCostBasisMutation__
 *
 * To run a mutation, you first call `useEnqueueCostBasisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueCostBasisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueCostBasisMutation, { data, loading, error }] = useEnqueueCostBasisMutation({
 *   variables: {
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useEnqueueCostBasisMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueCostBasisMutation, EnqueueCostBasisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnqueueCostBasisMutation, EnqueueCostBasisMutationVariables>(EnqueueCostBasisDocument, options);
      }
export type EnqueueCostBasisMutationHookResult = ReturnType<typeof useEnqueueCostBasisMutation>;
export type EnqueueCostBasisMutationResult = Apollo.MutationResult<EnqueueCostBasisMutation>;
export type EnqueueCostBasisMutationOptions = Apollo.BaseMutationOptions<EnqueueCostBasisMutation, EnqueueCostBasisMutationVariables>;
export const GetSyncingAccountsDocument = gql`
    query GetSyncingAccounts {
  userInfo {
    publicId
    hasAnyWallet
  }
  localWallets {
    id
    imageUrl
    address
    name
    value
    syncInfo {
      lastSynced
      isSyncing
      willBeDeleted
    }
    currency {
      symbol
      type
      cmcId
      price
    }
    assetsCount
    walletNetwork
  }
  exchanges {
    id
    imageUrl
    name
    value
    defaultName
    syncInfo {
      lastSynced
      isSyncing
      willBeDeleted
    }
    assetsCount
  }
  customWallets {
    id
    name
    syncInfo {
      isSyncing
      willBeDeleted
      lastSynced @client
    }
    assetsCount
  }
}
    `;

/**
 * __useGetSyncingAccountsQuery__
 *
 * To run a query within a React component, call `useGetSyncingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSyncingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSyncingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSyncingAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetSyncingAccountsQuery, GetSyncingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSyncingAccountsQuery, GetSyncingAccountsQueryVariables>(GetSyncingAccountsDocument, options);
      }
export function useGetSyncingAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSyncingAccountsQuery, GetSyncingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSyncingAccountsQuery, GetSyncingAccountsQueryVariables>(GetSyncingAccountsDocument, options);
        }
export type GetSyncingAccountsQueryHookResult = ReturnType<typeof useGetSyncingAccountsQuery>;
export type GetSyncingAccountsLazyQueryHookResult = ReturnType<typeof useGetSyncingAccountsLazyQuery>;
export type GetSyncingAccountsQueryResult = Apollo.QueryResult<GetSyncingAccountsQuery, GetSyncingAccountsQueryVariables>;
export const GetWalletsAndAccountsDocument = gql`
    query GetWalletsAndAccounts {
  exchanges {
    id
    syncInfo {
      lastSynced
    }
  }
  localWallets {
    id
    syncInfo {
      lastSynced
    }
  }
  customWallets {
    id
    syncInfo {
      lastSynced
    }
  }
}
    `;

/**
 * __useGetWalletsAndAccountsQuery__
 *
 * To run a query within a React component, call `useGetWalletsAndAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletsAndAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletsAndAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletsAndAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetWalletsAndAccountsQuery, GetWalletsAndAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletsAndAccountsQuery, GetWalletsAndAccountsQueryVariables>(GetWalletsAndAccountsDocument, options);
      }
export function useGetWalletsAndAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletsAndAccountsQuery, GetWalletsAndAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletsAndAccountsQuery, GetWalletsAndAccountsQueryVariables>(GetWalletsAndAccountsDocument, options);
        }
export type GetWalletsAndAccountsQueryHookResult = ReturnType<typeof useGetWalletsAndAccountsQuery>;
export type GetWalletsAndAccountsLazyQueryHookResult = ReturnType<typeof useGetWalletsAndAccountsLazyQuery>;
export type GetWalletsAndAccountsQueryResult = Apollo.QueryResult<GetWalletsAndAccountsQuery, GetWalletsAndAccountsQueryVariables>;
export const GetTaxPlanYearDocument = gql`
    query GetTaxPlanYear {
  availableUnifiedSubscriptionPlans {
    transactionCountingYear
  }
}
    `;

/**
 * __useGetTaxPlanYearQuery__
 *
 * To run a query within a React component, call `useGetTaxPlanYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxPlanYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxPlanYearQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxPlanYearQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxPlanYearQuery, GetTaxPlanYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxPlanYearQuery, GetTaxPlanYearQueryVariables>(GetTaxPlanYearDocument, options);
      }
export function useGetTaxPlanYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxPlanYearQuery, GetTaxPlanYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxPlanYearQuery, GetTaxPlanYearQueryVariables>(GetTaxPlanYearDocument, options);
        }
export type GetTaxPlanYearQueryHookResult = ReturnType<typeof useGetTaxPlanYearQuery>;
export type GetTaxPlanYearLazyQueryHookResult = ReturnType<typeof useGetTaxPlanYearLazyQuery>;
export type GetTaxPlanYearQueryResult = Apollo.QueryResult<GetTaxPlanYearQuery, GetTaxPlanYearQueryVariables>;
export const GetPlansForSidebarDocument = gql`
    query GetPlansForSidebar {
  unifiedSubscription {
    recommendedPlanForTax {
      price {
        discount
        discountReason
      }
    }
    transactionCounts {
      netTransactionCount
    }
    transactionLimit
    subscriptionPlan
  }
}
    `;

/**
 * __useGetPlansForSidebarQuery__
 *
 * To run a query within a React component, call `useGetPlansForSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlansForSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlansForSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlansForSidebarQuery(baseOptions?: Apollo.QueryHookOptions<GetPlansForSidebarQuery, GetPlansForSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlansForSidebarQuery, GetPlansForSidebarQueryVariables>(GetPlansForSidebarDocument, options);
      }
export function useGetPlansForSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlansForSidebarQuery, GetPlansForSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlansForSidebarQuery, GetPlansForSidebarQueryVariables>(GetPlansForSidebarDocument, options);
        }
export type GetPlansForSidebarQueryHookResult = ReturnType<typeof useGetPlansForSidebarQuery>;
export type GetPlansForSidebarLazyQueryHookResult = ReturnType<typeof useGetPlansForSidebarLazyQuery>;
export type GetPlansForSidebarQueryResult = Apollo.QueryResult<GetPlansForSidebarQuery, GetPlansForSidebarQueryVariables>;
export const GetSpamInfoForSideBarDocument = gql`
    query GetSpamInfoForSideBar {
  spamAssets {
    isSpam
    wasAutomarkedAsSpam
  }
}
    `;

/**
 * __useGetSpamInfoForSideBarQuery__
 *
 * To run a query within a React component, call `useGetSpamInfoForSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpamInfoForSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpamInfoForSideBarQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpamInfoForSideBarQuery(baseOptions?: Apollo.QueryHookOptions<GetSpamInfoForSideBarQuery, GetSpamInfoForSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpamInfoForSideBarQuery, GetSpamInfoForSideBarQueryVariables>(GetSpamInfoForSideBarDocument, options);
      }
export function useGetSpamInfoForSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpamInfoForSideBarQuery, GetSpamInfoForSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpamInfoForSideBarQuery, GetSpamInfoForSideBarQueryVariables>(GetSpamInfoForSideBarDocument, options);
        }
export type GetSpamInfoForSideBarQueryHookResult = ReturnType<typeof useGetSpamInfoForSideBarQuery>;
export type GetSpamInfoForSideBarLazyQueryHookResult = ReturnType<typeof useGetSpamInfoForSideBarLazyQuery>;
export type GetSpamInfoForSideBarQueryResult = Apollo.QueryResult<GetSpamInfoForSideBarQuery, GetSpamInfoForSideBarQueryVariables>;
export const GetTaxInfoForSideBarDocument = gql`
    query GetTaxInfoForSideBar($taxYear: Int!, $taskStatus: TaskStatus!) {
  taxSummary(taxYear: $taxYear) {
    errorsCount
    transactionCount
    sendsCount
    receivesCount
    calloutCountInsufficientQuantity
    calloutCountMissingPriceHistory
    calloutCountMissingBalance
    capitalGain
    taxableIncomeTotal
    estimatedTaxes
    taxPlan {
      shouldRenew
    }
  }
  tasksByType(status: $taskStatus, taskType: FIX_API_CREDENTIALS) {
    status
    taskType
    tasks {
      id
    }
    pageInfo {
      total
    }
  }
  userStats {
    numberOfExchanges
    numberOfLocalWallets
    numberOfCustomWallets
  }
  unifiedSubscription {
    recommendedPlanForTax {
      price {
        discountReason
      }
    }
  }
}
    `;

/**
 * __useGetTaxInfoForSideBarQuery__
 *
 * To run a query within a React component, call `useGetTaxInfoForSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxInfoForSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxInfoForSideBarQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *      taskStatus: // value for 'taskStatus'
 *   },
 * });
 */
export function useGetTaxInfoForSideBarQuery(baseOptions: Apollo.QueryHookOptions<GetTaxInfoForSideBarQuery, GetTaxInfoForSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxInfoForSideBarQuery, GetTaxInfoForSideBarQueryVariables>(GetTaxInfoForSideBarDocument, options);
      }
export function useGetTaxInfoForSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxInfoForSideBarQuery, GetTaxInfoForSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxInfoForSideBarQuery, GetTaxInfoForSideBarQueryVariables>(GetTaxInfoForSideBarDocument, options);
        }
export type GetTaxInfoForSideBarQueryHookResult = ReturnType<typeof useGetTaxInfoForSideBarQuery>;
export type GetTaxInfoForSideBarLazyQueryHookResult = ReturnType<typeof useGetTaxInfoForSideBarLazyQuery>;
export type GetTaxInfoForSideBarQueryResult = Apollo.QueryResult<GetTaxInfoForSideBarQuery, GetTaxInfoForSideBarQueryVariables>;
export const GetTaxYearDocument = gql`
    query GetTaxYear {
  availableUnifiedSubscriptionPlans {
    transactionCountingYear
  }
}
    `;

/**
 * __useGetTaxYearQuery__
 *
 * To run a query within a React component, call `useGetTaxYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxYearQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxYearQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxYearQuery, GetTaxYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxYearQuery, GetTaxYearQueryVariables>(GetTaxYearDocument, options);
      }
export function useGetTaxYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxYearQuery, GetTaxYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxYearQuery, GetTaxYearQueryVariables>(GetTaxYearDocument, options);
        }
export type GetTaxYearQueryHookResult = ReturnType<typeof useGetTaxYearQuery>;
export type GetTaxYearLazyQueryHookResult = ReturnType<typeof useGetTaxYearLazyQuery>;
export type GetTaxYearQueryResult = Apollo.QueryResult<GetTaxYearQuery, GetTaxYearQueryVariables>;
export const CreateUserFeedbackMessageDocument = gql`
    mutation CreateUserFeedbackMessage($message: String, $rating: Int) {
  createUserFeedbackMessage(message: $message, rating: $rating) {
    success
  }
}
    `;
export type CreateUserFeedbackMessageMutationFn = Apollo.MutationFunction<CreateUserFeedbackMessageMutation, CreateUserFeedbackMessageMutationVariables>;

/**
 * __useCreateUserFeedbackMessageMutation__
 *
 * To run a mutation, you first call `useCreateUserFeedbackMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeedbackMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeedbackMessageMutation, { data, loading, error }] = useCreateUserFeedbackMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      rating: // value for 'rating'
 *   },
 * });
 */
export function useCreateUserFeedbackMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeedbackMessageMutation, CreateUserFeedbackMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeedbackMessageMutation, CreateUserFeedbackMessageMutationVariables>(CreateUserFeedbackMessageDocument, options);
      }
export type CreateUserFeedbackMessageMutationHookResult = ReturnType<typeof useCreateUserFeedbackMessageMutation>;
export type CreateUserFeedbackMessageMutationResult = Apollo.MutationResult<CreateUserFeedbackMessageMutation>;
export type CreateUserFeedbackMessageMutationOptions = Apollo.BaseMutationOptions<CreateUserFeedbackMessageMutation, CreateUserFeedbackMessageMutationVariables>;
export const ImportNftDocument = gql`
    mutation ImportNft($address: String!, $tokenId: String!, $costBasis: Float!, $dateAcquired: String!, $walletId: String!) {
  importNft(
    address: $address
    tokenId: $tokenId
    costBasis: $costBasis
    dateAcquired: $dateAcquired
    walletId: $walletId
  ) {
    success
  }
}
    `;
export type ImportNftMutationFn = Apollo.MutationFunction<ImportNftMutation, ImportNftMutationVariables>;

/**
 * __useImportNftMutation__
 *
 * To run a mutation, you first call `useImportNftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportNftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importNftMutation, { data, loading, error }] = useImportNftMutation({
 *   variables: {
 *      address: // value for 'address'
 *      tokenId: // value for 'tokenId'
 *      costBasis: // value for 'costBasis'
 *      dateAcquired: // value for 'dateAcquired'
 *      walletId: // value for 'walletId'
 *   },
 * });
 */
export function useImportNftMutation(baseOptions?: Apollo.MutationHookOptions<ImportNftMutation, ImportNftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportNftMutation, ImportNftMutationVariables>(ImportNftDocument, options);
      }
export type ImportNftMutationHookResult = ReturnType<typeof useImportNftMutation>;
export type ImportNftMutationResult = Apollo.MutationResult<ImportNftMutation>;
export type ImportNftMutationOptions = Apollo.BaseMutationOptions<ImportNftMutation, ImportNftMutationVariables>;
export const UpdateInstructionsDocument = gql`
    mutation UpdateInstructions($slug: String!, $instructions: String!) {
  updateInstructions(slug: $slug, instructions: $instructions) {
    success
  }
}
    `;
export type UpdateInstructionsMutationFn = Apollo.MutationFunction<UpdateInstructionsMutation, UpdateInstructionsMutationVariables>;

/**
 * __useUpdateInstructionsMutation__
 *
 * To run a mutation, you first call `useUpdateInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstructionsMutation, { data, loading, error }] = useUpdateInstructionsMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      instructions: // value for 'instructions'
 *   },
 * });
 */
export function useUpdateInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstructionsMutation, UpdateInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstructionsMutation, UpdateInstructionsMutationVariables>(UpdateInstructionsDocument, options);
      }
export type UpdateInstructionsMutationHookResult = ReturnType<typeof useUpdateInstructionsMutation>;
export type UpdateInstructionsMutationResult = Apollo.MutationResult<UpdateInstructionsMutation>;
export type UpdateInstructionsMutationOptions = Apollo.BaseMutationOptions<UpdateInstructionsMutation, UpdateInstructionsMutationVariables>;
export const AddCbeDepositDocument = gql`
    mutation AddCbeDeposit($input: AddCbeDepositInput!) {
  addCbeDeposit(input: $input) {
    success
    message
  }
}
    `;
export type AddCbeDepositMutationFn = Apollo.MutationFunction<AddCbeDepositMutation, AddCbeDepositMutationVariables>;

/**
 * __useAddCbeDepositMutation__
 *
 * To run a mutation, you first call `useAddCbeDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCbeDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCbeDepositMutation, { data, loading, error }] = useAddCbeDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCbeDepositMutation(baseOptions?: Apollo.MutationHookOptions<AddCbeDepositMutation, AddCbeDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCbeDepositMutation, AddCbeDepositMutationVariables>(AddCbeDepositDocument, options);
      }
export type AddCbeDepositMutationHookResult = ReturnType<typeof useAddCbeDepositMutation>;
export type AddCbeDepositMutationResult = Apollo.MutationResult<AddCbeDepositMutation>;
export type AddCbeDepositMutationOptions = Apollo.BaseMutationOptions<AddCbeDepositMutation, AddCbeDepositMutationVariables>;
export const AddCbeDisposalDocument = gql`
    mutation AddCbeDisposal($input: AddCbeDisposalInput!) {
  addCbeDisposal(input: $input) {
    success
    message
  }
}
    `;
export type AddCbeDisposalMutationFn = Apollo.MutationFunction<AddCbeDisposalMutation, AddCbeDisposalMutationVariables>;

/**
 * __useAddCbeDisposalMutation__
 *
 * To run a mutation, you first call `useAddCbeDisposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCbeDisposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCbeDisposalMutation, { data, loading, error }] = useAddCbeDisposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCbeDisposalMutation(baseOptions?: Apollo.MutationHookOptions<AddCbeDisposalMutation, AddCbeDisposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCbeDisposalMutation, AddCbeDisposalMutationVariables>(AddCbeDisposalDocument, options);
      }
export type AddCbeDisposalMutationHookResult = ReturnType<typeof useAddCbeDisposalMutation>;
export type AddCbeDisposalMutationResult = Apollo.MutationResult<AddCbeDisposalMutation>;
export type AddCbeDisposalMutationOptions = Apollo.BaseMutationOptions<AddCbeDisposalMutation, AddCbeDisposalMutationVariables>;
export const GetCbeUserCurrenciesDocument = gql`
    query getCbeUserCurrencies {
  cbeUserCurrencies {
    uaid
    slug
    name
    symbol
    cmcId
    iconUrlFromInfo
  }
}
    `;

/**
 * __useGetCbeUserCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCbeUserCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCbeUserCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCbeUserCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCbeUserCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetCbeUserCurrenciesQuery, GetCbeUserCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCbeUserCurrenciesQuery, GetCbeUserCurrenciesQueryVariables>(GetCbeUserCurrenciesDocument, options);
      }
export function useGetCbeUserCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCbeUserCurrenciesQuery, GetCbeUserCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCbeUserCurrenciesQuery, GetCbeUserCurrenciesQueryVariables>(GetCbeUserCurrenciesDocument, options);
        }
export type GetCbeUserCurrenciesQueryHookResult = ReturnType<typeof useGetCbeUserCurrenciesQuery>;
export type GetCbeUserCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCbeUserCurrenciesLazyQuery>;
export type GetCbeUserCurrenciesQueryResult = Apollo.QueryResult<GetCbeUserCurrenciesQuery, GetCbeUserCurrenciesQueryVariables>;
export const ResetCbeDemoUserDocument = gql`
    mutation ResetCbeDemoUser($input: ResetCbeUserInput!) {
  resetCbeUser(input: $input) {
    success
    message
  }
}
    `;
export type ResetCbeDemoUserMutationFn = Apollo.MutationFunction<ResetCbeDemoUserMutation, ResetCbeDemoUserMutationVariables>;

/**
 * __useResetCbeDemoUserMutation__
 *
 * To run a mutation, you first call `useResetCbeDemoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCbeDemoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCbeDemoUserMutation, { data, loading, error }] = useResetCbeDemoUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetCbeDemoUserMutation(baseOptions?: Apollo.MutationHookOptions<ResetCbeDemoUserMutation, ResetCbeDemoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCbeDemoUserMutation, ResetCbeDemoUserMutationVariables>(ResetCbeDemoUserDocument, options);
      }
export type ResetCbeDemoUserMutationHookResult = ReturnType<typeof useResetCbeDemoUserMutation>;
export type ResetCbeDemoUserMutationResult = Apollo.MutationResult<ResetCbeDemoUserMutation>;
export type ResetCbeDemoUserMutationOptions = Apollo.BaseMutationOptions<ResetCbeDemoUserMutation, ResetCbeDemoUserMutationVariables>;
export const GetBrokerTaxPageDocument = gql`
    query getBrokerTaxPage {
  cbeUserSettings {
    isExchangeReportingBasis
  }
}
    `;

/**
 * __useGetBrokerTaxPageQuery__
 *
 * To run a query within a React component, call `useGetBrokerTaxPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokerTaxPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokerTaxPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokerTaxPageQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokerTaxPageQuery, GetBrokerTaxPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokerTaxPageQuery, GetBrokerTaxPageQueryVariables>(GetBrokerTaxPageDocument, options);
      }
export function useGetBrokerTaxPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokerTaxPageQuery, GetBrokerTaxPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokerTaxPageQuery, GetBrokerTaxPageQueryVariables>(GetBrokerTaxPageDocument, options);
        }
export type GetBrokerTaxPageQueryHookResult = ReturnType<typeof useGetBrokerTaxPageQuery>;
export type GetBrokerTaxPageLazyQueryHookResult = ReturnType<typeof useGetBrokerTaxPageLazyQuery>;
export type GetBrokerTaxPageQueryResult = Apollo.QueryResult<GetBrokerTaxPageQuery, GetBrokerTaxPageQueryVariables>;
export const UpdateExchangeReportingBasisDocument = gql`
    mutation updateExchangeReportingBasis($isExchangeReportingBasis: Boolean!) {
  updateExchangeSettings(isExchangeReportingBasis: $isExchangeReportingBasis) {
    message
    success
  }
}
    `;
export type UpdateExchangeReportingBasisMutationFn = Apollo.MutationFunction<UpdateExchangeReportingBasisMutation, UpdateExchangeReportingBasisMutationVariables>;

/**
 * __useUpdateExchangeReportingBasisMutation__
 *
 * To run a mutation, you first call `useUpdateExchangeReportingBasisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExchangeReportingBasisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExchangeReportingBasisMutation, { data, loading, error }] = useUpdateExchangeReportingBasisMutation({
 *   variables: {
 *      isExchangeReportingBasis: // value for 'isExchangeReportingBasis'
 *   },
 * });
 */
export function useUpdateExchangeReportingBasisMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExchangeReportingBasisMutation, UpdateExchangeReportingBasisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExchangeReportingBasisMutation, UpdateExchangeReportingBasisMutationVariables>(UpdateExchangeReportingBasisDocument, options);
      }
export type UpdateExchangeReportingBasisMutationHookResult = ReturnType<typeof useUpdateExchangeReportingBasisMutation>;
export type UpdateExchangeReportingBasisMutationResult = Apollo.MutationResult<UpdateExchangeReportingBasisMutation>;
export type UpdateExchangeReportingBasisMutationOptions = Apollo.BaseMutationOptions<UpdateExchangeReportingBasisMutation, UpdateExchangeReportingBasisMutationVariables>;
export const GetAvailableTaxSettingsDocument = gql`
    query GetAvailableTaxSettings {
  availableSettings {
    setting
  }
}
    `;

/**
 * __useGetAvailableTaxSettingsQuery__
 *
 * To run a query within a React component, call `useGetAvailableTaxSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableTaxSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableTaxSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableTaxSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableTaxSettingsQuery, GetAvailableTaxSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableTaxSettingsQuery, GetAvailableTaxSettingsQueryVariables>(GetAvailableTaxSettingsDocument, options);
      }
export function useGetAvailableTaxSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableTaxSettingsQuery, GetAvailableTaxSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableTaxSettingsQuery, GetAvailableTaxSettingsQueryVariables>(GetAvailableTaxSettingsDocument, options);
        }
export type GetAvailableTaxSettingsQueryHookResult = ReturnType<typeof useGetAvailableTaxSettingsQuery>;
export type GetAvailableTaxSettingsLazyQueryHookResult = ReturnType<typeof useGetAvailableTaxSettingsLazyQuery>;
export type GetAvailableTaxSettingsQueryResult = Apollo.QueryResult<GetAvailableTaxSettingsQuery, GetAvailableTaxSettingsQueryVariables>;
export const GetCbeTaxMethodDocument = gql`
    query getCbeTaxMethod {
  cbeUserSettings {
    userTaxReportingStatus
    isExchangeReportingBasis
  }
  cbeUserTaxSettings {
    startDate
    endDate
    taxIdMethod
  }
}
    `;

/**
 * __useGetCbeTaxMethodQuery__
 *
 * To run a query within a React component, call `useGetCbeTaxMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCbeTaxMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCbeTaxMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCbeTaxMethodQuery(baseOptions?: Apollo.QueryHookOptions<GetCbeTaxMethodQuery, GetCbeTaxMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCbeTaxMethodQuery, GetCbeTaxMethodQueryVariables>(GetCbeTaxMethodDocument, options);
      }
export function useGetCbeTaxMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCbeTaxMethodQuery, GetCbeTaxMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCbeTaxMethodQuery, GetCbeTaxMethodQueryVariables>(GetCbeTaxMethodDocument, options);
        }
export type GetCbeTaxMethodQueryHookResult = ReturnType<typeof useGetCbeTaxMethodQuery>;
export type GetCbeTaxMethodLazyQueryHookResult = ReturnType<typeof useGetCbeTaxMethodLazyQuery>;
export type GetCbeTaxMethodQueryResult = Apollo.QueryResult<GetCbeTaxMethodQuery, GetCbeTaxMethodQueryVariables>;
export const UpdateUserTaxSettingsCbeDocument = gql`
    mutation UpdateUserTaxSettingsCbe($input: [TaxSettingsInput]!) {
  updateUserTaxSettings(taxSettings: $input) {
    success
    message
  }
}
    `;
export type UpdateUserTaxSettingsCbeMutationFn = Apollo.MutationFunction<UpdateUserTaxSettingsCbeMutation, UpdateUserTaxSettingsCbeMutationVariables>;

/**
 * __useUpdateUserTaxSettingsCbeMutation__
 *
 * To run a mutation, you first call `useUpdateUserTaxSettingsCbeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTaxSettingsCbeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTaxSettingsCbeMutation, { data, loading, error }] = useUpdateUserTaxSettingsCbeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserTaxSettingsCbeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTaxSettingsCbeMutation, UpdateUserTaxSettingsCbeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTaxSettingsCbeMutation, UpdateUserTaxSettingsCbeMutationVariables>(UpdateUserTaxSettingsCbeDocument, options);
      }
export type UpdateUserTaxSettingsCbeMutationHookResult = ReturnType<typeof useUpdateUserTaxSettingsCbeMutation>;
export type UpdateUserTaxSettingsCbeMutationResult = Apollo.MutationResult<UpdateUserTaxSettingsCbeMutation>;
export type UpdateUserTaxSettingsCbeMutationOptions = Apollo.BaseMutationOptions<UpdateUserTaxSettingsCbeMutation, UpdateUserTaxSettingsCbeMutationVariables>;
export const ConsumerTaxSettingsDocument = gql`
    query consumerTaxSettings {
  cbeUserSettings {
    userTaxReportingStatus
  }
}
    `;

/**
 * __useConsumerTaxSettingsQuery__
 *
 * To run a query within a React component, call `useConsumerTaxSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsumerTaxSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsumerTaxSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsumerTaxSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ConsumerTaxSettingsQuery, ConsumerTaxSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsumerTaxSettingsQuery, ConsumerTaxSettingsQueryVariables>(ConsumerTaxSettingsDocument, options);
      }
export function useConsumerTaxSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsumerTaxSettingsQuery, ConsumerTaxSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsumerTaxSettingsQuery, ConsumerTaxSettingsQueryVariables>(ConsumerTaxSettingsDocument, options);
        }
export type ConsumerTaxSettingsQueryHookResult = ReturnType<typeof useConsumerTaxSettingsQuery>;
export type ConsumerTaxSettingsLazyQueryHookResult = ReturnType<typeof useConsumerTaxSettingsLazyQuery>;
export type ConsumerTaxSettingsQueryResult = Apollo.QueryResult<ConsumerTaxSettingsQuery, ConsumerTaxSettingsQueryVariables>;
export const UpdateUserTaxReportSettingsDocument = gql`
    mutation updateUserTaxReportSettings($userTaxReportingStatus: Boolean!) {
  updateUserTaxReportSettings(userTaxReportingStatus: $userTaxReportingStatus) {
    message
    success
  }
}
    `;
export type UpdateUserTaxReportSettingsMutationFn = Apollo.MutationFunction<UpdateUserTaxReportSettingsMutation, UpdateUserTaxReportSettingsMutationVariables>;

/**
 * __useUpdateUserTaxReportSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserTaxReportSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTaxReportSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTaxReportSettingsMutation, { data, loading, error }] = useUpdateUserTaxReportSettingsMutation({
 *   variables: {
 *      userTaxReportingStatus: // value for 'userTaxReportingStatus'
 *   },
 * });
 */
export function useUpdateUserTaxReportSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTaxReportSettingsMutation, UpdateUserTaxReportSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTaxReportSettingsMutation, UpdateUserTaxReportSettingsMutationVariables>(UpdateUserTaxReportSettingsDocument, options);
      }
export type UpdateUserTaxReportSettingsMutationHookResult = ReturnType<typeof useUpdateUserTaxReportSettingsMutation>;
export type UpdateUserTaxReportSettingsMutationResult = Apollo.MutationResult<UpdateUserTaxReportSettingsMutation>;
export type UpdateUserTaxReportSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserTaxReportSettingsMutation, UpdateUserTaxReportSettingsMutationVariables>;
export const GetDemoTaxPageDocument = gql`
    query GetDemoTaxPage($taxYear: Int!) {
  taxYears {
    taxYear
    title
    dateRange
  }
  taxSummary(taxYear: $taxYear) {
    taxYear
    taxReports {
      capitalGainsCsv
    }
    hasSufficientPlan
    taxPlan {
      shouldRenew
    }
  }
}
    `;

/**
 * __useGetDemoTaxPageQuery__
 *
 * To run a query within a React component, call `useGetDemoTaxPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemoTaxPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemoTaxPageQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useGetDemoTaxPageQuery(baseOptions: Apollo.QueryHookOptions<GetDemoTaxPageQuery, GetDemoTaxPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemoTaxPageQuery, GetDemoTaxPageQueryVariables>(GetDemoTaxPageDocument, options);
      }
export function useGetDemoTaxPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemoTaxPageQuery, GetDemoTaxPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemoTaxPageQuery, GetDemoTaxPageQueryVariables>(GetDemoTaxPageDocument, options);
        }
export type GetDemoTaxPageQueryHookResult = ReturnType<typeof useGetDemoTaxPageQuery>;
export type GetDemoTaxPageLazyQueryHookResult = ReturnType<typeof useGetDemoTaxPageLazyQuery>;
export type GetDemoTaxPageQueryResult = Apollo.QueryResult<GetDemoTaxPageQuery, GetDemoTaxPageQueryVariables>;
export const GetExchangeLevelReportDocument = gql`
    query GetExchangeLevelReport($taxYear: Int!) {
  exchangeLevelReport(taxYear: $taxYear) {
    userId
    txId
    field8949Code
    field1aCodeOfDa
    field1bNameOfDa
    field1cNumberOfUnits
    field1dDateAcquired
    field1eDateSold
    field1fProceeds
    field1gCostBasis
    field2BasisReported
    field3aReportedToTheIrs
    field4FederalIncomeTaxWithheld
    field6aGainOrLoss
    field6bShortTerm
    field6cLongTerm
    field6dOrdinary
    field7CashOnly
    field8ReliedOnCustomerInfo
    field9Noncovered
    field11aGpAggregate
    field11bNumberOfTxs
    field11cSnftsFirstSale
    field12aNumberOfUnitsTransferredIn
    field12bTransferInDate
    field14StateName
    field15StateId
    field16StateTaxWithheld
    customerSpecificField1dDateAcquired
    customerSpecificField1gCostBasis
    customerSpecificField6aGainOrLoss
  }
}
    `;

/**
 * __useGetExchangeLevelReportQuery__
 *
 * To run a query within a React component, call `useGetExchangeLevelReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeLevelReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeLevelReportQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useGetExchangeLevelReportQuery(baseOptions: Apollo.QueryHookOptions<GetExchangeLevelReportQuery, GetExchangeLevelReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeLevelReportQuery, GetExchangeLevelReportQueryVariables>(GetExchangeLevelReportDocument, options);
      }
export function useGetExchangeLevelReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeLevelReportQuery, GetExchangeLevelReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeLevelReportQuery, GetExchangeLevelReportQueryVariables>(GetExchangeLevelReportDocument, options);
        }
export type GetExchangeLevelReportQueryHookResult = ReturnType<typeof useGetExchangeLevelReportQuery>;
export type GetExchangeLevelReportLazyQueryHookResult = ReturnType<typeof useGetExchangeLevelReportLazyQuery>;
export type GetExchangeLevelReportQueryResult = Apollo.QueryResult<GetExchangeLevelReportQuery, GetExchangeLevelReportQueryVariables>;
export const GetDepositHistoryAuditDocument = gql`
    query GetDepositHistoryAudit {
  depositOverrideHistory {
    history
  }
  userInfo {
    publicId
    baseCurrency {
      type
      symbol
      priceUsd
    }
  }
}
    `;

/**
 * __useGetDepositHistoryAuditQuery__
 *
 * To run a query within a React component, call `useGetDepositHistoryAuditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepositHistoryAuditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepositHistoryAuditQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepositHistoryAuditQuery(baseOptions?: Apollo.QueryHookOptions<GetDepositHistoryAuditQuery, GetDepositHistoryAuditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepositHistoryAuditQuery, GetDepositHistoryAuditQueryVariables>(GetDepositHistoryAuditDocument, options);
      }
export function useGetDepositHistoryAuditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepositHistoryAuditQuery, GetDepositHistoryAuditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepositHistoryAuditQuery, GetDepositHistoryAuditQueryVariables>(GetDepositHistoryAuditDocument, options);
        }
export type GetDepositHistoryAuditQueryHookResult = ReturnType<typeof useGetDepositHistoryAuditQuery>;
export type GetDepositHistoryAuditLazyQueryHookResult = ReturnType<typeof useGetDepositHistoryAuditLazyQuery>;
export type GetDepositHistoryAuditQueryResult = Apollo.QueryResult<GetDepositHistoryAuditQuery, GetDepositHistoryAuditQueryVariables>;
export const GainsLossesDisposedLotsDocument = gql`
    query GainsLossesDisposedLots($taxYear: Int, $flowId: String) {
  disposedLots(taxYear: $taxYear, flowId: $flowId) {
    id
    assetName
    dateAcquired
    dateSold
    adjustedCostBasis
    adjustedAmountRealized
    gainLoss
    quantity
    price
    coveredState
    holdingPeriod
    flowId
  }
}
    `;

/**
 * __useGainsLossesDisposedLotsQuery__
 *
 * To run a query within a React component, call `useGainsLossesDisposedLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGainsLossesDisposedLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGainsLossesDisposedLotsQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *      flowId: // value for 'flowId'
 *   },
 * });
 */
export function useGainsLossesDisposedLotsQuery(baseOptions?: Apollo.QueryHookOptions<GainsLossesDisposedLotsQuery, GainsLossesDisposedLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GainsLossesDisposedLotsQuery, GainsLossesDisposedLotsQueryVariables>(GainsLossesDisposedLotsDocument, options);
      }
export function useGainsLossesDisposedLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GainsLossesDisposedLotsQuery, GainsLossesDisposedLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GainsLossesDisposedLotsQuery, GainsLossesDisposedLotsQueryVariables>(GainsLossesDisposedLotsDocument, options);
        }
export type GainsLossesDisposedLotsQueryHookResult = ReturnType<typeof useGainsLossesDisposedLotsQuery>;
export type GainsLossesDisposedLotsLazyQueryHookResult = ReturnType<typeof useGainsLossesDisposedLotsLazyQuery>;
export type GainsLossesDisposedLotsQueryResult = Apollo.QueryResult<GainsLossesDisposedLotsQuery, GainsLossesDisposedLotsQueryVariables>;
export const GetTaxYearsDocument = gql`
    query GetTaxYears {
  taxYears {
    taxYear
    title
    dateRange
  }
}
    `;

/**
 * __useGetTaxYearsQuery__
 *
 * To run a query within a React component, call `useGetTaxYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxYearsQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxYearsQuery, GetTaxYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxYearsQuery, GetTaxYearsQueryVariables>(GetTaxYearsDocument, options);
      }
export function useGetTaxYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxYearsQuery, GetTaxYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxYearsQuery, GetTaxYearsQueryVariables>(GetTaxYearsDocument, options);
        }
export type GetTaxYearsQueryHookResult = ReturnType<typeof useGetTaxYearsQuery>;
export type GetTaxYearsLazyQueryHookResult = ReturnType<typeof useGetTaxYearsLazyQuery>;
export type GetTaxYearsQueryResult = Apollo.QueryResult<GetTaxYearsQuery, GetTaxYearsQueryVariables>;
export const GetGraphLotsDocument = gql`
    query GetGraphLots($flowId: String!, $disposedLotId: String!) {
  graphData(flowId: $flowId, disposedLotId: $disposedLotId) {
    availableLotNodes {
      id
      startDate
      quantity
      dateAcquired
      price
      adjustedCostBasis
      assetName
      taxEvent
      txQueryLinkId
      storageType
      coveredState
      walletName
    }
    disposedLotNodes {
      id
      quantity
      adjustedCostBasis
      adjustedAmountRealized
      gainLoss
      price
      dateAcquired
      dateSold
      assetName
      taxEvent
      txQueryLinkId
      coveredState
    }
    edges {
      sourceNodeId
      targetNodeId
      edgeEvent
    }
  }
}
    `;

/**
 * __useGetGraphLotsQuery__
 *
 * To run a query within a React component, call `useGetGraphLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphLotsQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      disposedLotId: // value for 'disposedLotId'
 *   },
 * });
 */
export function useGetGraphLotsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphLotsQuery, GetGraphLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphLotsQuery, GetGraphLotsQueryVariables>(GetGraphLotsDocument, options);
      }
export function useGetGraphLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphLotsQuery, GetGraphLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphLotsQuery, GetGraphLotsQueryVariables>(GetGraphLotsDocument, options);
        }
export type GetGraphLotsQueryHookResult = ReturnType<typeof useGetGraphLotsQuery>;
export type GetGraphLotsLazyQueryHookResult = ReturnType<typeof useGetGraphLotsLazyQuery>;
export type GetGraphLotsQueryResult = Apollo.QueryResult<GetGraphLotsQuery, GetGraphLotsQueryVariables>;
export const GetTableLotsDocument = gql`
    query GetTableLots($flowId: String!) {
  availableLotNodes(flowId: $flowId) {
    id
    startDate
    quantity
    dateAcquired
    price
    adjustedCostBasis
    assetName
    taxEvent
    txQueryLinkId
    storageType
    coveredState
    walletName
  }
}
    `;

/**
 * __useGetTableLotsQuery__
 *
 * To run a query within a React component, call `useGetTableLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableLotsQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *   },
 * });
 */
export function useGetTableLotsQuery(baseOptions: Apollo.QueryHookOptions<GetTableLotsQuery, GetTableLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTableLotsQuery, GetTableLotsQueryVariables>(GetTableLotsDocument, options);
      }
export function useGetTableLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTableLotsQuery, GetTableLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTableLotsQuery, GetTableLotsQueryVariables>(GetTableLotsDocument, options);
        }
export type GetTableLotsQueryHookResult = ReturnType<typeof useGetTableLotsQuery>;
export type GetTableLotsLazyQueryHookResult = ReturnType<typeof useGetTableLotsLazyQuery>;
export type GetTableLotsQueryResult = Apollo.QueryResult<GetTableLotsQuery, GetTableLotsQueryVariables>;
export const GetConnectedCtUsersDocument = gql`
    query GetConnectedCtUsers {
  connectedCtUsers {
    id
    email
  }
  depositInformationStatus {
    transactionId
    hasDepositInformation
  }
}
    `;

/**
 * __useGetConnectedCtUsersQuery__
 *
 * To run a query within a React component, call `useGetConnectedCtUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedCtUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedCtUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedCtUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectedCtUsersQuery, GetConnectedCtUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedCtUsersQuery, GetConnectedCtUsersQueryVariables>(GetConnectedCtUsersDocument, options);
      }
export function useGetConnectedCtUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedCtUsersQuery, GetConnectedCtUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedCtUsersQuery, GetConnectedCtUsersQueryVariables>(GetConnectedCtUsersDocument, options);
        }
export type GetConnectedCtUsersQueryHookResult = ReturnType<typeof useGetConnectedCtUsersQuery>;
export type GetConnectedCtUsersLazyQueryHookResult = ReturnType<typeof useGetConnectedCtUsersLazyQuery>;
export type GetConnectedCtUsersQueryResult = Apollo.QueryResult<GetConnectedCtUsersQuery, GetConnectedCtUsersQueryVariables>;
export const SyncConnectedCtUserDepositsDocument = gql`
    mutation SyncConnectedCtUserDeposits($input: SyncCtDepositInput!) {
  syncCtDeposits(input: $input) {
    success
    message
  }
}
    `;
export type SyncConnectedCtUserDepositsMutationFn = Apollo.MutationFunction<SyncConnectedCtUserDepositsMutation, SyncConnectedCtUserDepositsMutationVariables>;

/**
 * __useSyncConnectedCtUserDepositsMutation__
 *
 * To run a mutation, you first call `useSyncConnectedCtUserDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncConnectedCtUserDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncConnectedCtUserDepositsMutation, { data, loading, error }] = useSyncConnectedCtUserDepositsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncConnectedCtUserDepositsMutation(baseOptions?: Apollo.MutationHookOptions<SyncConnectedCtUserDepositsMutation, SyncConnectedCtUserDepositsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncConnectedCtUserDepositsMutation, SyncConnectedCtUserDepositsMutationVariables>(SyncConnectedCtUserDepositsDocument, options);
      }
export type SyncConnectedCtUserDepositsMutationHookResult = ReturnType<typeof useSyncConnectedCtUserDepositsMutation>;
export type SyncConnectedCtUserDepositsMutationResult = Apollo.MutationResult<SyncConnectedCtUserDepositsMutation>;
export type SyncConnectedCtUserDepositsMutationOptions = Apollo.BaseMutationOptions<SyncConnectedCtUserDepositsMutation, SyncConnectedCtUserDepositsMutationVariables>;
export const GetCostBasisEnginePipelineStatusDocument = gql`
    query GetCostBasisEnginePipelineStatus {
  cbePipelineStages {
    stage
    status
    count
    minDatetime
    maxDatetime
  }
}
    `;

/**
 * __useGetCostBasisEnginePipelineStatusQuery__
 *
 * To run a query within a React component, call `useGetCostBasisEnginePipelineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostBasisEnginePipelineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostBasisEnginePipelineStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCostBasisEnginePipelineStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetCostBasisEnginePipelineStatusQuery, GetCostBasisEnginePipelineStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostBasisEnginePipelineStatusQuery, GetCostBasisEnginePipelineStatusQueryVariables>(GetCostBasisEnginePipelineStatusDocument, options);
      }
export function useGetCostBasisEnginePipelineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostBasisEnginePipelineStatusQuery, GetCostBasisEnginePipelineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostBasisEnginePipelineStatusQuery, GetCostBasisEnginePipelineStatusQueryVariables>(GetCostBasisEnginePipelineStatusDocument, options);
        }
export type GetCostBasisEnginePipelineStatusQueryHookResult = ReturnType<typeof useGetCostBasisEnginePipelineStatusQuery>;
export type GetCostBasisEnginePipelineStatusLazyQueryHookResult = ReturnType<typeof useGetCostBasisEnginePipelineStatusLazyQuery>;
export type GetCostBasisEnginePipelineStatusQueryResult = Apollo.QueryResult<GetCostBasisEnginePipelineStatusQuery, GetCostBasisEnginePipelineStatusQueryVariables>;
export const UploadCostBasisEngineCsvDocument = gql`
    mutation UploadCostBasisEngineCSV($input: UploadCbeCsvInput!) {
  uploadCbeCsv(input: $input) {
    success
    message
  }
}
    `;
export type UploadCostBasisEngineCsvMutationFn = Apollo.MutationFunction<UploadCostBasisEngineCsvMutation, UploadCostBasisEngineCsvMutationVariables>;

/**
 * __useUploadCostBasisEngineCsvMutation__
 *
 * To run a mutation, you first call `useUploadCostBasisEngineCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCostBasisEngineCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCostBasisEngineCsvMutation, { data, loading, error }] = useUploadCostBasisEngineCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCostBasisEngineCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadCostBasisEngineCsvMutation, UploadCostBasisEngineCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCostBasisEngineCsvMutation, UploadCostBasisEngineCsvMutationVariables>(UploadCostBasisEngineCsvDocument, options);
      }
export type UploadCostBasisEngineCsvMutationHookResult = ReturnType<typeof useUploadCostBasisEngineCsvMutation>;
export type UploadCostBasisEngineCsvMutationResult = Apollo.MutationResult<UploadCostBasisEngineCsvMutation>;
export type UploadCostBasisEngineCsvMutationOptions = Apollo.BaseMutationOptions<UploadCostBasisEngineCsvMutation, UploadCostBasisEngineCsvMutationVariables>;
export const GetUserLotsDocument = gql`
    query GetUserLots {
  portfolio(performanceDuration: ALL_TIME) {
    currencies {
      currency {
        type
        cmcId
        uaid
        slug
        symbol
        name
        price
        marketCap
        percentChange24h
        iconUrlFromInfo
      }
    }
    fiats {
      currency {
        symbol
        name
        price
      }
      quantity
    }
    userAssets {
      currency {
        symbol
        name
        price
      }
      quantity
    }
  }
}
    `;

/**
 * __useGetUserLotsQuery__
 *
 * To run a query within a React component, call `useGetUserLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLotsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLotsQuery, GetUserLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLotsQuery, GetUserLotsQueryVariables>(GetUserLotsDocument, options);
      }
export function useGetUserLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLotsQuery, GetUserLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLotsQuery, GetUserLotsQueryVariables>(GetUserLotsDocument, options);
        }
export type GetUserLotsQueryHookResult = ReturnType<typeof useGetUserLotsQuery>;
export type GetUserLotsLazyQueryHookResult = ReturnType<typeof useGetUserLotsLazyQuery>;
export type GetUserLotsQueryResult = Apollo.QueryResult<GetUserLotsQuery, GetUserLotsQueryVariables>;
export const AddUserAssetDocument = gql`
    mutation AddUserAsset($symbol: String!, $name: String!, $description: String, $priceUsd: Float!) {
  addAsset(
    symbol: $symbol
    name: $name
    description: $description
    priceUsd: $priceUsd
  ) {
    success
  }
}
    `;
export type AddUserAssetMutationFn = Apollo.MutationFunction<AddUserAssetMutation, AddUserAssetMutationVariables>;

/**
 * __useAddUserAssetMutation__
 *
 * To run a mutation, you first call `useAddUserAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserAssetMutation, { data, loading, error }] = useAddUserAssetMutation({
 *   variables: {
 *      symbol: // value for 'symbol'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      priceUsd: // value for 'priceUsd'
 *   },
 * });
 */
export function useAddUserAssetMutation(baseOptions?: Apollo.MutationHookOptions<AddUserAssetMutation, AddUserAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserAssetMutation, AddUserAssetMutationVariables>(AddUserAssetDocument, options);
      }
export type AddUserAssetMutationHookResult = ReturnType<typeof useAddUserAssetMutation>;
export type AddUserAssetMutationResult = Apollo.MutationResult<AddUserAssetMutation>;
export type AddUserAssetMutationOptions = Apollo.BaseMutationOptions<AddUserAssetMutation, AddUserAssetMutationVariables>;
export const EditUserAssetDocument = gql`
    mutation EditUserAsset($assetId: Int!, $symbol: String!, $name: String!, $description: String, $priceUsd: Float!) {
  editAsset(
    assetId: $assetId
    symbol: $symbol
    name: $name
    description: $description
    priceUsd: $priceUsd
  ) {
    success
  }
}
    `;
export type EditUserAssetMutationFn = Apollo.MutationFunction<EditUserAssetMutation, EditUserAssetMutationVariables>;

/**
 * __useEditUserAssetMutation__
 *
 * To run a mutation, you first call `useEditUserAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserAssetMutation, { data, loading, error }] = useEditUserAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      symbol: // value for 'symbol'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      priceUsd: // value for 'priceUsd'
 *   },
 * });
 */
export function useEditUserAssetMutation(baseOptions?: Apollo.MutationHookOptions<EditUserAssetMutation, EditUserAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserAssetMutation, EditUserAssetMutationVariables>(EditUserAssetDocument, options);
      }
export type EditUserAssetMutationHookResult = ReturnType<typeof useEditUserAssetMutation>;
export type EditUserAssetMutationResult = Apollo.MutationResult<EditUserAssetMutation>;
export type EditUserAssetMutationOptions = Apollo.BaseMutationOptions<EditUserAssetMutation, EditUserAssetMutationVariables>;
export const GetUserAssetsDocument = gql`
    query GetUserAssets($search: String, $offset: Int, $limit: Int) {
  assets: myAssets(search: $search, offset: $offset, limit: $limit) {
    totalCount
    edges {
      id
      type
      symbol
      name
      description
      priceUsd
    }
  }
}
    `;

/**
 * __useGetUserAssetsQuery__
 *
 * To run a query within a React component, call `useGetUserAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAssetsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAssetsQuery, GetUserAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAssetsQuery, GetUserAssetsQueryVariables>(GetUserAssetsDocument, options);
      }
export function useGetUserAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAssetsQuery, GetUserAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAssetsQuery, GetUserAssetsQueryVariables>(GetUserAssetsDocument, options);
        }
export type GetUserAssetsQueryHookResult = ReturnType<typeof useGetUserAssetsQuery>;
export type GetUserAssetsLazyQueryHookResult = ReturnType<typeof useGetUserAssetsLazyQuery>;
export type GetUserAssetsQueryResult = Apollo.QueryResult<GetUserAssetsQuery, GetUserAssetsQueryVariables>;
export const GetDashboardDocument = gql`
    query GetDashboard($performanceDuration: PerformanceDuration, $toDate: DateTime) {
  portfolio(performanceDuration: $performanceDuration, toDate: $toDate) {
    marketValue
    reportedMarketValue
    calculatedMarketValue
    isSignificantMarketValueDiff
    netFiat
    costBasis
    allTimeReturn
    allTimeReturnPercent
    totalReturnOnInvestment
    totalReturnOnInvestmentPercent
    timeSpanMarketReturn
    timeSpanMarketReturnPercent
    netTotalDeposits
    netTotalWithdrawals
    hasSubscription
    currencies {
      currency {
        type
        cmcId
        symbol
        name
        price
        marketCap
        percentChange24h
        iconUrlFromInfo
      }
      quantity
      reportedQuantity
      calculatedQuantity
      marketValue
      reportedMarketValue
      calculatedMarketValue
      costBasis
      allTimeReturn
      allTimeReturnPercent
      totalReturnOnInvestment
      totalReturnOnInvestmentPercent
      netTotalWithdrawals
      netTotalDeposits
      portfolioPercent
      error
    }
    userAssets {
      currency {
        symbol
        name
        price
      }
      quantity
    }
  }
  performanceHistory(performanceDuration: $performanceDuration) {
    hasAccess
    noAccessMessage
    hasAccessToPortfolioFeatures
    edges {
      date
      marketValue
      costBasis
      netTotalDeposits
      netTotalWithdrawals
      totalReturnOnInvestment
      totalReturnOnInvestmentPercent
      returnOnInvestment
      returnOnInvestmentPercent
    }
  }
}
    `;

/**
 * __useGetDashboardQuery__
 *
 * To run a query within a React component, call `useGetDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardQuery({
 *   variables: {
 *      performanceDuration: // value for 'performanceDuration'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
      }
export function useGetDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardQuery, GetDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardQuery, GetDashboardQueryVariables>(GetDashboardDocument, options);
        }
export type GetDashboardQueryHookResult = ReturnType<typeof useGetDashboardQuery>;
export type GetDashboardLazyQueryHookResult = ReturnType<typeof useGetDashboardLazyQuery>;
export type GetDashboardQueryResult = Apollo.QueryResult<GetDashboardQuery, GetDashboardQueryVariables>;
export const GetHasWalletsDocument = gql`
    query GetHasWallets {
  localWallets {
    id
  }
  exchanges {
    id
  }
}
    `;

/**
 * __useGetHasWalletsQuery__
 *
 * To run a query within a React component, call `useGetHasWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasWalletsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHasWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetHasWalletsQuery, GetHasWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasWalletsQuery, GetHasWalletsQueryVariables>(GetHasWalletsDocument, options);
      }
export function useGetHasWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasWalletsQuery, GetHasWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasWalletsQuery, GetHasWalletsQueryVariables>(GetHasWalletsDocument, options);
        }
export type GetHasWalletsQueryHookResult = ReturnType<typeof useGetHasWalletsQuery>;
export type GetHasWalletsLazyQueryHookResult = ReturnType<typeof useGetHasWalletsLazyQuery>;
export type GetHasWalletsQueryResult = Apollo.QueryResult<GetHasWalletsQuery, GetHasWalletsQueryVariables>;
export const GetMarketValueDocument = gql`
    query GetMarketValue {
  portfolio(performanceDuration: ALL_TIME) {
    marketValue
    reportedMarketValue
    calculatedMarketValue
    isSignificantMarketValueDiff
  }
}
    `;

/**
 * __useGetMarketValueQuery__
 *
 * To run a query within a React component, call `useGetMarketValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketValueQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMarketValueQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketValueQuery, GetMarketValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketValueQuery, GetMarketValueQueryVariables>(GetMarketValueDocument, options);
      }
export function useGetMarketValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketValueQuery, GetMarketValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketValueQuery, GetMarketValueQueryVariables>(GetMarketValueDocument, options);
        }
export type GetMarketValueQueryHookResult = ReturnType<typeof useGetMarketValueQuery>;
export type GetMarketValueLazyQueryHookResult = ReturnType<typeof useGetMarketValueLazyQuery>;
export type GetMarketValueQueryResult = Apollo.QueryResult<GetMarketValueQuery, GetMarketValueQueryVariables>;
export const GetPerformanceCardDocument = gql`
    query GetPerformanceCard {
  portfolio(performanceDuration: ALL_TIME) {
    costBasis
    allTimeReturn
    allTimeReturnPercent
  }
}
    `;

/**
 * __useGetPerformanceCardQuery__
 *
 * To run a query within a React component, call `useGetPerformanceCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPerformanceCardQuery(baseOptions?: Apollo.QueryHookOptions<GetPerformanceCardQuery, GetPerformanceCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformanceCardQuery, GetPerformanceCardQueryVariables>(GetPerformanceCardDocument, options);
      }
export function useGetPerformanceCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformanceCardQuery, GetPerformanceCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformanceCardQuery, GetPerformanceCardQueryVariables>(GetPerformanceCardDocument, options);
        }
export type GetPerformanceCardQueryHookResult = ReturnType<typeof useGetPerformanceCardQuery>;
export type GetPerformanceCardLazyQueryHookResult = ReturnType<typeof useGetPerformanceCardLazyQuery>;
export type GetPerformanceCardQueryResult = Apollo.QueryResult<GetPerformanceCardQuery, GetPerformanceCardQueryVariables>;
export const GetTaxLossPotentialDocument = gql`
    query GetTaxLossPotential {
  taxLossHarvest {
    taxLossTotals {
      potentialSavings
    }
  }
}
    `;

/**
 * __useGetTaxLossPotentialQuery__
 *
 * To run a query within a React component, call `useGetTaxLossPotentialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxLossPotentialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxLossPotentialQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxLossPotentialQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxLossPotentialQuery, GetTaxLossPotentialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxLossPotentialQuery, GetTaxLossPotentialQueryVariables>(GetTaxLossPotentialDocument, options);
      }
export function useGetTaxLossPotentialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxLossPotentialQuery, GetTaxLossPotentialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxLossPotentialQuery, GetTaxLossPotentialQueryVariables>(GetTaxLossPotentialDocument, options);
        }
export type GetTaxLossPotentialQueryHookResult = ReturnType<typeof useGetTaxLossPotentialQuery>;
export type GetTaxLossPotentialLazyQueryHookResult = ReturnType<typeof useGetTaxLossPotentialLazyQuery>;
export type GetTaxLossPotentialQueryResult = Apollo.QueryResult<GetTaxLossPotentialQuery, GetTaxLossPotentialQueryVariables>;
export const GetTaxSummaryDocument = gql`
    query GetTaxSummary {
  taxSummaries {
    capitalGain
    taxIncome
    taxYear
    hasSufficientPlan
    hasPlan
    taxPlan {
      isUnified
    }
  }
}
    `;

/**
 * __useGetTaxSummaryQuery__
 *
 * To run a query within a React component, call `useGetTaxSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxSummaryQuery, GetTaxSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxSummaryQuery, GetTaxSummaryQueryVariables>(GetTaxSummaryDocument, options);
      }
export function useGetTaxSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxSummaryQuery, GetTaxSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxSummaryQuery, GetTaxSummaryQueryVariables>(GetTaxSummaryDocument, options);
        }
export type GetTaxSummaryQueryHookResult = ReturnType<typeof useGetTaxSummaryQuery>;
export type GetTaxSummaryLazyQueryHookResult = ReturnType<typeof useGetTaxSummaryLazyQuery>;
export type GetTaxSummaryQueryResult = Apollo.QueryResult<GetTaxSummaryQuery, GetTaxSummaryQueryVariables>;
export const AccountLevelTaxSummaryDocument = gql`
    query AccountLevelTaxSummary($taxYear: Int!) {
  accountLevelTaxSummary(taxYear: $taxYear) {
    walletPublicId
    walletName
    walletType
    taxSummary {
      taxYear
      hasPlan
      taxPlan {
        planName
        startDate
        dynamicTransactionLimitLabel
        transactionLimit
        type
        isSufficient
        insufficientReason
        shouldRenew
        isUnified
        insufficientUnifiedPlanShortReason
        insufficientUnifiedPlanLongReason
        hasGeneratedTaxReport
      }
      errorsCount
      taxYearTitle
      taxYearLabel
      taxStartDate
      taxEndDate
      hasSufficientPlan
      capitalGain
      capitalGainWithoutSymbol
      longTermGain
      longTermCostBasis
      longTermProceeds
      shortTermGain
      shortTermCostBasis
      shortTermProceeds
      shortTermCryptoToCryptoGain
      longTermCryptoToCryptoGain
      shortTermOtherGain
      longTermOtherGain
      totalGains
      totalLosses
      numberOfDisposals
      shortTermLosses
      totalShortTermLosses
      totalShortTermGains
      incomeSalary
      incomeFork
      incomeMining
      incomeAirdrops
      incomeStaking
      incomeInterest
      incomeOther
      incomeRoyalty
      totalGifts
      totalDonations
      donationShortTerm
      donationLongTerm
      netFuturesGains
      totalMarginFees
      totalInterestExpense
      taxStartDate
      taxEndDate
      taxIncome
      transactionCount
      freeTransactionsCount
      sendsCount
      receivesCount
      calloutCountInsufficientQuantity
      calloutCountMissingPriceHistory
      calloutCountMissingBalance
      taxableIncomeTotal
      otherCategoriesTotal
      taxSummaryByAccounts {
        name
        gains
        transactionsCount
      }
      taxSummaryByWallets {
        name
        gains
        transactionsCount
      }
      taxSummaryByCustomWallets {
        name
        gains
        transactionsCount
      }
      taxSummaryByForeignAccounts {
        name
        gains
        transactionsCount
      }
      taxReports {
        irsForm8949
        condensedIrsForm8949
        irsScheduleDForm1040
        irsSchedule1Form1040
        craSchedule3
        selfFileWithCointracker
        hAndRBlock
        turboTaxOnlineSync
        turbotaxOnline
        taxcaddy8949
        taxcaddySchedule1
        turbotaxCdDownload
        taxactFile
        woltersKluwerCchFile
        transactionHistoryCsv
        capitalGainsCsv
      }
      taxConstants {
        faqUrl
        taxFormUrl
        taxInstructionsUrl
        fileOnlineUrl
      }
      taxItems {
        name
        amount
        value
        transactionsCount
        isTaxable
        isTaxableNow
        taxEvent
      }
    }
  }
}
    `;

/**
 * __useAccountLevelTaxSummaryQuery__
 *
 * To run a query within a React component, call `useAccountLevelTaxSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLevelTaxSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLevelTaxSummaryQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useAccountLevelTaxSummaryQuery(baseOptions: Apollo.QueryHookOptions<AccountLevelTaxSummaryQuery, AccountLevelTaxSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLevelTaxSummaryQuery, AccountLevelTaxSummaryQueryVariables>(AccountLevelTaxSummaryDocument, options);
      }
export function useAccountLevelTaxSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLevelTaxSummaryQuery, AccountLevelTaxSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLevelTaxSummaryQuery, AccountLevelTaxSummaryQueryVariables>(AccountLevelTaxSummaryDocument, options);
        }
export type AccountLevelTaxSummaryQueryHookResult = ReturnType<typeof useAccountLevelTaxSummaryQuery>;
export type AccountLevelTaxSummaryLazyQueryHookResult = ReturnType<typeof useAccountLevelTaxSummaryLazyQuery>;
export type AccountLevelTaxSummaryQueryResult = Apollo.QueryResult<AccountLevelTaxSummaryQuery, AccountLevelTaxSummaryQueryVariables>;
export const GetCustomWalletDataForUpdateDocument = gql`
    query GetCustomWalletDataForUpdate($publicId: String!) {
  customWallet(publicId: $publicId) {
    id
    name
    slug
    syncMethod
    instructions
    supportedFileFormats
  }
}
    `;

/**
 * __useGetCustomWalletDataForUpdateQuery__
 *
 * To run a query within a React component, call `useGetCustomWalletDataForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomWalletDataForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomWalletDataForUpdateQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetCustomWalletDataForUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetCustomWalletDataForUpdateQuery, GetCustomWalletDataForUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomWalletDataForUpdateQuery, GetCustomWalletDataForUpdateQueryVariables>(GetCustomWalletDataForUpdateDocument, options);
      }
export function useGetCustomWalletDataForUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomWalletDataForUpdateQuery, GetCustomWalletDataForUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomWalletDataForUpdateQuery, GetCustomWalletDataForUpdateQueryVariables>(GetCustomWalletDataForUpdateDocument, options);
        }
export type GetCustomWalletDataForUpdateQueryHookResult = ReturnType<typeof useGetCustomWalletDataForUpdateQuery>;
export type GetCustomWalletDataForUpdateLazyQueryHookResult = ReturnType<typeof useGetCustomWalletDataForUpdateLazyQuery>;
export type GetCustomWalletDataForUpdateQueryResult = Apollo.QueryResult<GetCustomWalletDataForUpdateQuery, GetCustomWalletDataForUpdateQueryVariables>;
export const ImportCustomWalletTransactionsDocument = gql`
    mutation ImportCustomWalletTransactions($customWalletInput: ImportCustomWalletTransactionsInput!) {
  importCustomWalletTransactions(customWalletInput: $customWalletInput) {
    success
    jobId
    error
  }
}
    `;
export type ImportCustomWalletTransactionsMutationFn = Apollo.MutationFunction<ImportCustomWalletTransactionsMutation, ImportCustomWalletTransactionsMutationVariables>;

/**
 * __useImportCustomWalletTransactionsMutation__
 *
 * To run a mutation, you first call `useImportCustomWalletTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCustomWalletTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCustomWalletTransactionsMutation, { data, loading, error }] = useImportCustomWalletTransactionsMutation({
 *   variables: {
 *      customWalletInput: // value for 'customWalletInput'
 *   },
 * });
 */
export function useImportCustomWalletTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<ImportCustomWalletTransactionsMutation, ImportCustomWalletTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCustomWalletTransactionsMutation, ImportCustomWalletTransactionsMutationVariables>(ImportCustomWalletTransactionsDocument, options);
      }
export type ImportCustomWalletTransactionsMutationHookResult = ReturnType<typeof useImportCustomWalletTransactionsMutation>;
export type ImportCustomWalletTransactionsMutationResult = Apollo.MutationResult<ImportCustomWalletTransactionsMutation>;
export type ImportCustomWalletTransactionsMutationOptions = Apollo.BaseMutationOptions<ImportCustomWalletTransactionsMutation, ImportCustomWalletTransactionsMutationVariables>;
export const ImportExchangeTransactionsDocument = gql`
    mutation ImportExchangeTransactions($importTransactionsInput: ImportExchangeTransactionsInput!) {
  importExchangeTransactions(importTransactionsInput: $importTransactionsInput) {
    success
    jobId
    error
  }
}
    `;
export type ImportExchangeTransactionsMutationFn = Apollo.MutationFunction<ImportExchangeTransactionsMutation, ImportExchangeTransactionsMutationVariables>;

/**
 * __useImportExchangeTransactionsMutation__
 *
 * To run a mutation, you first call `useImportExchangeTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportExchangeTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importExchangeTransactionsMutation, { data, loading, error }] = useImportExchangeTransactionsMutation({
 *   variables: {
 *      importTransactionsInput: // value for 'importTransactionsInput'
 *   },
 * });
 */
export function useImportExchangeTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<ImportExchangeTransactionsMutation, ImportExchangeTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportExchangeTransactionsMutation, ImportExchangeTransactionsMutationVariables>(ImportExchangeTransactionsDocument, options);
      }
export type ImportExchangeTransactionsMutationHookResult = ReturnType<typeof useImportExchangeTransactionsMutation>;
export type ImportExchangeTransactionsMutationResult = Apollo.MutationResult<ImportExchangeTransactionsMutation>;
export type ImportExchangeTransactionsMutationOptions = Apollo.BaseMutationOptions<ImportExchangeTransactionsMutation, ImportExchangeTransactionsMutationVariables>;
export const ConfirmSettingsDocument = gql`
    mutation ConfirmSettings($countryCode: String!) {
  confirmOnboardingSettings(countryCode: $countryCode) {
    success
  }
}
    `;
export type ConfirmSettingsMutationFn = Apollo.MutationFunction<ConfirmSettingsMutation, ConfirmSettingsMutationVariables>;

/**
 * __useConfirmSettingsMutation__
 *
 * To run a mutation, you first call `useConfirmSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSettingsMutation, { data, loading, error }] = useConfirmSettingsMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useConfirmSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmSettingsMutation, ConfirmSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmSettingsMutation, ConfirmSettingsMutationVariables>(ConfirmSettingsDocument, options);
      }
export type ConfirmSettingsMutationHookResult = ReturnType<typeof useConfirmSettingsMutation>;
export type ConfirmSettingsMutationResult = Apollo.MutationResult<ConfirmSettingsMutation>;
export type ConfirmSettingsMutationOptions = Apollo.BaseMutationOptions<ConfirmSettingsMutation, ConfirmSettingsMutationVariables>;
export const GetOnboardingUserDetailsDocument = gql`
    query GetOnboardingUserDetails {
  userInfo {
    publicId
    hasAnyWallet
    signedUpWithCoinbase
  }
}
    `;

/**
 * __useGetOnboardingUserDetailsQuery__
 *
 * To run a query within a React component, call `useGetOnboardingUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOnboardingUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetOnboardingUserDetailsQuery, GetOnboardingUserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingUserDetailsQuery, GetOnboardingUserDetailsQueryVariables>(GetOnboardingUserDetailsDocument, options);
      }
export function useGetOnboardingUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingUserDetailsQuery, GetOnboardingUserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingUserDetailsQuery, GetOnboardingUserDetailsQueryVariables>(GetOnboardingUserDetailsDocument, options);
        }
export type GetOnboardingUserDetailsQueryHookResult = ReturnType<typeof useGetOnboardingUserDetailsQuery>;
export type GetOnboardingUserDetailsLazyQueryHookResult = ReturnType<typeof useGetOnboardingUserDetailsLazyQuery>;
export type GetOnboardingUserDetailsQueryResult = Apollo.QueryResult<GetOnboardingUserDetailsQuery, GetOnboardingUserDetailsQueryVariables>;
export const GetCoinDiversityDocument = gql`
    query GetCoinDiversity {
  portfolio(performanceDuration: ALL_TIME) {
    currencies {
      currency {
        symbol
        name
      }
      marketValue
      portfolioPercent
    }
  }
}
    `;

/**
 * __useGetCoinDiversityQuery__
 *
 * To run a query within a React component, call `useGetCoinDiversityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoinDiversityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoinDiversityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoinDiversityQuery(baseOptions?: Apollo.QueryHookOptions<GetCoinDiversityQuery, GetCoinDiversityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoinDiversityQuery, GetCoinDiversityQueryVariables>(GetCoinDiversityDocument, options);
      }
export function useGetCoinDiversityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoinDiversityQuery, GetCoinDiversityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoinDiversityQuery, GetCoinDiversityQueryVariables>(GetCoinDiversityDocument, options);
        }
export type GetCoinDiversityQueryHookResult = ReturnType<typeof useGetCoinDiversityQuery>;
export type GetCoinDiversityLazyQueryHookResult = ReturnType<typeof useGetCoinDiversityLazyQuery>;
export type GetCoinDiversityQueryResult = Apollo.QueryResult<GetCoinDiversityQuery, GetCoinDiversityQueryVariables>;
export const GetPerformanceHistoryDocument = gql`
    query GetPerformanceHistory($performanceDuration: PerformanceDuration) {
  performanceHistory(performanceDuration: $performanceDuration) {
    hasAccess
    noAccessMessage
    hasAccessToPerformanceFeatures
    hasAccessToPortfolioFeatures
    edges {
      date
      marketValue
      costBasis
      netTotalDeposits
      netTotalWithdrawals
      totalReturnOnInvestment
      totalReturnOnInvestmentPercent
      returnOnInvestment
      returnOnInvestmentPercent
    }
  }
}
    `;

/**
 * __useGetPerformanceHistoryQuery__
 *
 * To run a query within a React component, call `useGetPerformanceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceHistoryQuery({
 *   variables: {
 *      performanceDuration: // value for 'performanceDuration'
 *   },
 * });
 */
export function useGetPerformanceHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetPerformanceHistoryQuery, GetPerformanceHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformanceHistoryQuery, GetPerformanceHistoryQueryVariables>(GetPerformanceHistoryDocument, options);
      }
export function useGetPerformanceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformanceHistoryQuery, GetPerformanceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformanceHistoryQuery, GetPerformanceHistoryQueryVariables>(GetPerformanceHistoryDocument, options);
        }
export type GetPerformanceHistoryQueryHookResult = ReturnType<typeof useGetPerformanceHistoryQuery>;
export type GetPerformanceHistoryLazyQueryHookResult = ReturnType<typeof useGetPerformanceHistoryLazyQuery>;
export type GetPerformanceHistoryQueryResult = Apollo.QueryResult<GetPerformanceHistoryQuery, GetPerformanceHistoryQueryVariables>;
export const GetPerformanceSummaryDocument = gql`
    query GetPerformanceSummary($performanceDuration: PerformanceDuration) {
  portfolio(performanceDuration: $performanceDuration) {
    hasAccessToPerformanceByCrypto
    marketValue
    calculatedMarketValue
    reportedMarketValue
    allTimeReturn
    totalReturnOnInvestment
    costBasis
    netTotalDeposits
    netTotalWithdrawals
    timeSpanMarketReturn
    timeSpanMarketReturnPercent
  }
}
    `;

/**
 * __useGetPerformanceSummaryQuery__
 *
 * To run a query within a React component, call `useGetPerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceSummaryQuery({
 *   variables: {
 *      performanceDuration: // value for 'performanceDuration'
 *   },
 * });
 */
export function useGetPerformanceSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetPerformanceSummaryQuery, GetPerformanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformanceSummaryQuery, GetPerformanceSummaryQueryVariables>(GetPerformanceSummaryDocument, options);
      }
export function useGetPerformanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformanceSummaryQuery, GetPerformanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformanceSummaryQuery, GetPerformanceSummaryQueryVariables>(GetPerformanceSummaryDocument, options);
        }
export type GetPerformanceSummaryQueryHookResult = ReturnType<typeof useGetPerformanceSummaryQuery>;
export type GetPerformanceSummaryLazyQueryHookResult = ReturnType<typeof useGetPerformanceSummaryLazyQuery>;
export type GetPerformanceSummaryQueryResult = Apollo.QueryResult<GetPerformanceSummaryQuery, GetPerformanceSummaryQueryVariables>;
export const GetPortfolioInsightsDocument = gql`
    query GetPortfolioInsights {
  taxLossHarvest {
    taxLossTotals {
      potentialSavings
      absUnrealizedLoss
    }
  }
  exchangeFunds {
    value
    percent
  }
}
    `;

/**
 * __useGetPortfolioInsightsQuery__
 *
 * To run a query within a React component, call `useGetPortfolioInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioInsightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortfolioInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfolioInsightsQuery, GetPortfolioInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioInsightsQuery, GetPortfolioInsightsQueryVariables>(GetPortfolioInsightsDocument, options);
      }
export function useGetPortfolioInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioInsightsQuery, GetPortfolioInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioInsightsQuery, GetPortfolioInsightsQueryVariables>(GetPortfolioInsightsDocument, options);
        }
export type GetPortfolioInsightsQueryHookResult = ReturnType<typeof useGetPortfolioInsightsQuery>;
export type GetPortfolioInsightsLazyQueryHookResult = ReturnType<typeof useGetPortfolioInsightsLazyQuery>;
export type GetPortfolioInsightsQueryResult = Apollo.QueryResult<GetPortfolioInsightsQuery, GetPortfolioInsightsQueryVariables>;
export const GetUserCurrenciesDocument = gql`
    query GetUserCurrencies {
  portfolio(performanceDuration: ALL_TIME) {
    currencies {
      currency {
        uaid
        slug
        symbol
        type
        name
        cmcId
        iconUrlFromInfo
      }
    }
  }
}
    `;

/**
 * __useGetUserCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetUserCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCurrenciesQuery, GetUserCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCurrenciesQuery, GetUserCurrenciesQueryVariables>(GetUserCurrenciesDocument, options);
      }
export function useGetUserCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCurrenciesQuery, GetUserCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCurrenciesQuery, GetUserCurrenciesQueryVariables>(GetUserCurrenciesDocument, options);
        }
export type GetUserCurrenciesQueryHookResult = ReturnType<typeof useGetUserCurrenciesQuery>;
export type GetUserCurrenciesLazyQueryHookResult = ReturnType<typeof useGetUserCurrenciesLazyQuery>;
export type GetUserCurrenciesQueryResult = Apollo.QueryResult<GetUserCurrenciesQuery, GetUserCurrenciesQueryVariables>;
export const GetCurrencyForPricePageDocument = gql`
    query GetCurrencyForPricePage($query: String = "", $timeSpan: PerformanceDuration) {
  currency(query: $query) {
    name
    symbol
    slug
    type
    nameOrSymbol
    summary
    website
    whitepaper
    forum
    twitter
    reddit
    chat
    code
    cmcId
    priceUsd
    price
    marketCapUsd
    marketCap
    percentChange24h
    percentChange7d
    volume24hUsd
    volume24h
    availableSupply
    priceHigh
    priceLow
    priceHighDate
    priceLowDate
    marketDominance
    iconUrlFromInfo
    similarCurrencies {
      id
      symbol
      name
      price
      icon
      slug
      iconUrlFromInfo
    }
    priceHistoryUsd(timeSpan: $timeSpan) {
      date
      price
    }
    isInWatchlist
  }
  portfolio(performanceDuration: ALL_TIME) {
    currencies {
      currency {
        slug
        symbol
        iconUrlFromInfo
      }
      portfolioPercent
      quantity
      marketValue
    }
  }
}
    `;

/**
 * __useGetCurrencyForPricePageQuery__
 *
 * To run a query within a React component, call `useGetCurrencyForPricePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyForPricePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyForPricePageQuery({
 *   variables: {
 *      query: // value for 'query'
 *      timeSpan: // value for 'timeSpan'
 *   },
 * });
 */
export function useGetCurrencyForPricePageQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyForPricePageQuery, GetCurrencyForPricePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyForPricePageQuery, GetCurrencyForPricePageQueryVariables>(GetCurrencyForPricePageDocument, options);
      }
export function useGetCurrencyForPricePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyForPricePageQuery, GetCurrencyForPricePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyForPricePageQuery, GetCurrencyForPricePageQueryVariables>(GetCurrencyForPricePageDocument, options);
        }
export type GetCurrencyForPricePageQueryHookResult = ReturnType<typeof useGetCurrencyForPricePageQuery>;
export type GetCurrencyForPricePageLazyQueryHookResult = ReturnType<typeof useGetCurrencyForPricePageLazyQuery>;
export type GetCurrencyForPricePageQueryResult = Apollo.QueryResult<GetCurrencyForPricePageQuery, GetCurrencyForPricePageQueryVariables>;
export const PerformanceGraphListQueryDocument = gql`
    query PerformanceGraphListQuery($normalizedNamesList: [String]!, $walletList: [String]!, $timeSpan: PerformanceDuration) {
  performanceGraphList(
    normalizedNamesList: $normalizedNamesList
    walletList: $walletList
    timeSpan: $timeSpan
  ) {
    symbol
    dataPoints {
      dateTime
      balanceDelta
      runningBalance
      runningCostBasis
      marketValue
    }
    graphBalance {
      balanceDelta
      dateTime
      runningBalance
    }
    graphMarketValue {
      dateTime
      marketValue
    }
  }
  userInfo {
    publicId
    baseCurrency {
      symbol
      priceUsd
      type
    }
  }
}
    `;

/**
 * __usePerformanceGraphListQueryQuery__
 *
 * To run a query within a React component, call `usePerformanceGraphListQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceGraphListQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceGraphListQueryQuery({
 *   variables: {
 *      normalizedNamesList: // value for 'normalizedNamesList'
 *      walletList: // value for 'walletList'
 *      timeSpan: // value for 'timeSpan'
 *   },
 * });
 */
export function usePerformanceGraphListQueryQuery(baseOptions: Apollo.QueryHookOptions<PerformanceGraphListQueryQuery, PerformanceGraphListQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceGraphListQueryQuery, PerformanceGraphListQueryQueryVariables>(PerformanceGraphListQueryDocument, options);
      }
export function usePerformanceGraphListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceGraphListQueryQuery, PerformanceGraphListQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceGraphListQueryQuery, PerformanceGraphListQueryQueryVariables>(PerformanceGraphListQueryDocument, options);
        }
export type PerformanceGraphListQueryQueryHookResult = ReturnType<typeof usePerformanceGraphListQueryQuery>;
export type PerformanceGraphListQueryLazyQueryHookResult = ReturnType<typeof usePerformanceGraphListQueryLazyQuery>;
export type PerformanceGraphListQueryQueryResult = Apollo.QueryResult<PerformanceGraphListQueryQuery, PerformanceGraphListQueryQueryVariables>;
export const PricingPageDocument = gql`
    query PricingPage($query: String = "") {
  currency(query: $query) {
    name
    symbol
    type
    summary
    website
    whitepaper
    forum
    twitter
    reddit
    chat
    code
    cmcId
    priceUsd
    price
    marketCapUsd
    marketCap
    percentChange24h
    percentChange7d
    volume24hUsd
    volume24h
    availableSupply
    priceHigh
    priceLow
    priceHighDate
    priceLowDate
    iconUrlFromInfo
    marketDominance
    similarCurrencies {
      id
      symbol
      name
      price
      icon
      slug
      iconUrlFromInfo
    }
  }
  userInfo {
    publicId
    baseCurrency {
      type
      symbol
      formatSymbol
      priceUsd
    }
  }
  portfolio(performanceDuration: ALL_TIME) {
    currencies {
      currency {
        slug
        symbol
      }
      portfolioPercent
      quantity
      marketValue
    }
  }
}
    `;

/**
 * __usePricingPageQuery__
 *
 * To run a query within a React component, call `usePricingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingPageQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePricingPageQuery(baseOptions?: Apollo.QueryHookOptions<PricingPageQuery, PricingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingPageQuery, PricingPageQueryVariables>(PricingPageDocument, options);
      }
export function usePricingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingPageQuery, PricingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingPageQuery, PricingPageQueryVariables>(PricingPageDocument, options);
        }
export type PricingPageQueryHookResult = ReturnType<typeof usePricingPageQuery>;
export type PricingPageLazyQueryHookResult = ReturnType<typeof usePricingPageLazyQuery>;
export type PricingPageQueryResult = Apollo.QueryResult<PricingPageQuery, PricingPageQueryVariables>;
export const WatchlistToggleDocument = gql`
    mutation WatchlistToggle($symbol: String) {
  watchlistToggle(symbol: $symbol) {
    isInWatchlist
  }
}
    `;
export type WatchlistToggleMutationFn = Apollo.MutationFunction<WatchlistToggleMutation, WatchlistToggleMutationVariables>;

/**
 * __useWatchlistToggleMutation__
 *
 * To run a mutation, you first call `useWatchlistToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchlistToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchlistToggleMutation, { data, loading, error }] = useWatchlistToggleMutation({
 *   variables: {
 *      symbol: // value for 'symbol'
 *   },
 * });
 */
export function useWatchlistToggleMutation(baseOptions?: Apollo.MutationHookOptions<WatchlistToggleMutation, WatchlistToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WatchlistToggleMutation, WatchlistToggleMutationVariables>(WatchlistToggleDocument, options);
      }
export type WatchlistToggleMutationHookResult = ReturnType<typeof useWatchlistToggleMutation>;
export type WatchlistToggleMutationResult = Apollo.MutationResult<WatchlistToggleMutation>;
export type WatchlistToggleMutationOptions = Apollo.BaseMutationOptions<WatchlistToggleMutation, WatchlistToggleMutationVariables>;
export const MarketInfoDocument = gql`
    query MarketInfo {
  marketInfo {
    bitcoinPercentageOfMarketCap
    totalMarketCapUsd
    totalVolume24hUsd
    pricesLastUpdated
    ethereumPercentageOfMarketCap
  }
}
    `;

/**
 * __useMarketInfoQuery__
 *
 * To run a query within a React component, call `useMarketInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketInfoQuery(baseOptions?: Apollo.QueryHookOptions<MarketInfoQuery, MarketInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketInfoQuery, MarketInfoQueryVariables>(MarketInfoDocument, options);
      }
export function useMarketInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketInfoQuery, MarketInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketInfoQuery, MarketInfoQueryVariables>(MarketInfoDocument, options);
        }
export type MarketInfoQueryHookResult = ReturnType<typeof useMarketInfoQuery>;
export type MarketInfoLazyQueryHookResult = ReturnType<typeof useMarketInfoLazyQuery>;
export type MarketInfoQueryResult = Apollo.QueryResult<MarketInfoQuery, MarketInfoQueryVariables>;
export const PriceDocument = gql`
    query Price($symbol: String) {
  price(symbol: $symbol) {
    type
    cmcId
    symbol
    name
    nameOrSymbol
    priceUsd
    marketCap
    percentChange24h
    isInWatchlist
    volume24hUsd
    maxSupply
    availableSupply
  }
}
    `;

/**
 * __usePriceQuery__
 *
 * To run a query within a React component, call `usePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceQuery({
 *   variables: {
 *      symbol: // value for 'symbol'
 *   },
 * });
 */
export function usePriceQuery(baseOptions?: Apollo.QueryHookOptions<PriceQuery, PriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceQuery, PriceQueryVariables>(PriceDocument, options);
      }
export function usePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceQuery, PriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceQuery, PriceQueryVariables>(PriceDocument, options);
        }
export type PriceQueryHookResult = ReturnType<typeof usePriceQuery>;
export type PriceLazyQueryHookResult = ReturnType<typeof usePriceLazyQuery>;
export type PriceQueryResult = Apollo.QueryResult<PriceQuery, PriceQueryVariables>;
export const PricesDocument = gql`
    query Prices($search: String, $offset: Int, $limit: Int) {
  prices: filteredPrices(search: $search, limit: $limit, offset: $offset) {
    totalCount
    edges {
      type
      cmcId
      slug
      symbol
      name
      nameOrSymbol
      priceUsd
      marketCap
      percentChange24h
      isInWatchlist
      volume24hUsd
      maxSupply
      availableSupply
    }
  }
}
    `;

/**
 * __usePricesQuery__
 *
 * To run a query within a React component, call `usePricesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePricesQuery(baseOptions?: Apollo.QueryHookOptions<PricesQuery, PricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricesQuery, PricesQueryVariables>(PricesDocument, options);
      }
export function usePricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricesQuery, PricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricesQuery, PricesQueryVariables>(PricesDocument, options);
        }
export type PricesQueryHookResult = ReturnType<typeof usePricesQuery>;
export type PricesLazyQueryHookResult = ReturnType<typeof usePricesLazyQuery>;
export type PricesQueryResult = Apollo.QueryResult<PricesQuery, PricesQueryVariables>;
export const WatchlistPricesDocument = gql`
    query WatchlistPrices($search: String, $offset: Int, $limit: Int) {
  prices: watchlistPrices(search: $search, limit: $limit, offset: $offset) {
    totalCount
    edges {
      type
      cmcId
      slug
      symbol
      name
      nameOrSymbol
      priceUsd
      marketCap
      percentChange24h
      isInWatchlist
      volume24hUsd
      maxSupply
      availableSupply
    }
  }
}
    `;

/**
 * __useWatchlistPricesQuery__
 *
 * To run a query within a React component, call `useWatchlistPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistPricesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWatchlistPricesQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistPricesQuery, WatchlistPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistPricesQuery, WatchlistPricesQueryVariables>(WatchlistPricesDocument, options);
      }
export function useWatchlistPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistPricesQuery, WatchlistPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistPricesQuery, WatchlistPricesQueryVariables>(WatchlistPricesDocument, options);
        }
export type WatchlistPricesQueryHookResult = ReturnType<typeof useWatchlistPricesQuery>;
export type WatchlistPricesLazyQueryHookResult = ReturnType<typeof useWatchlistPricesLazyQuery>;
export type WatchlistPricesQueryResult = Apollo.QueryResult<WatchlistPricesQuery, WatchlistPricesQueryVariables>;
export const GenerateCoinbaseOneCreditDocument = gql`
    mutation GenerateCoinbaseOneCredit($input: GenerateCoinbaseOneCreditInput!) {
  generateCoinbaseOneCredit(input: $input) {
    coinbaseOneCreditStatus {
      status
      tier
      creditValue
    }
  }
}
    `;
export type GenerateCoinbaseOneCreditMutationFn = Apollo.MutationFunction<GenerateCoinbaseOneCreditMutation, GenerateCoinbaseOneCreditMutationVariables>;

/**
 * __useGenerateCoinbaseOneCreditMutation__
 *
 * To run a mutation, you first call `useGenerateCoinbaseOneCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCoinbaseOneCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCoinbaseOneCreditMutation, { data, loading, error }] = useGenerateCoinbaseOneCreditMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCoinbaseOneCreditMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCoinbaseOneCreditMutation, GenerateCoinbaseOneCreditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCoinbaseOneCreditMutation, GenerateCoinbaseOneCreditMutationVariables>(GenerateCoinbaseOneCreditDocument, options);
      }
export type GenerateCoinbaseOneCreditMutationHookResult = ReturnType<typeof useGenerateCoinbaseOneCreditMutation>;
export type GenerateCoinbaseOneCreditMutationResult = Apollo.MutationResult<GenerateCoinbaseOneCreditMutation>;
export type GenerateCoinbaseOneCreditMutationOptions = Apollo.BaseMutationOptions<GenerateCoinbaseOneCreditMutation, GenerateCoinbaseOneCreditMutationVariables>;
export const GetCoinbaseOneCreditStatusDocument = gql`
    query GetCoinbaseOneCreditStatus($code: String) {
  coinbaseOneCreditStatus(code: $code) {
    status
    tier
    creditValue
  }
}
    `;

/**
 * __useGetCoinbaseOneCreditStatusQuery__
 *
 * To run a query within a React component, call `useGetCoinbaseOneCreditStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoinbaseOneCreditStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoinbaseOneCreditStatusQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCoinbaseOneCreditStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetCoinbaseOneCreditStatusQuery, GetCoinbaseOneCreditStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoinbaseOneCreditStatusQuery, GetCoinbaseOneCreditStatusQueryVariables>(GetCoinbaseOneCreditStatusDocument, options);
      }
export function useGetCoinbaseOneCreditStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoinbaseOneCreditStatusQuery, GetCoinbaseOneCreditStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoinbaseOneCreditStatusQuery, GetCoinbaseOneCreditStatusQueryVariables>(GetCoinbaseOneCreditStatusDocument, options);
        }
export type GetCoinbaseOneCreditStatusQueryHookResult = ReturnType<typeof useGetCoinbaseOneCreditStatusQuery>;
export type GetCoinbaseOneCreditStatusLazyQueryHookResult = ReturnType<typeof useGetCoinbaseOneCreditStatusLazyQuery>;
export type GetCoinbaseOneCreditStatusQueryResult = Apollo.QueryResult<GetCoinbaseOneCreditStatusQuery, GetCoinbaseOneCreditStatusQueryVariables>;
export const GetTaxProUserInfoDocument = gql`
    query GetTaxProUserInfo {
  currentTaxFirm {
    publicId
    currentMember {
      role
    }
  }
  userInfo {
    publicId
    displayUser {
      registeredAsTaxPro
    }
  }
}
    `;

/**
 * __useGetTaxProUserInfoQuery__
 *
 * To run a query within a React component, call `useGetTaxProUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxProUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxProUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxProUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxProUserInfoQuery, GetTaxProUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxProUserInfoQuery, GetTaxProUserInfoQueryVariables>(GetTaxProUserInfoDocument, options);
      }
export function useGetTaxProUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxProUserInfoQuery, GetTaxProUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxProUserInfoQuery, GetTaxProUserInfoQueryVariables>(GetTaxProUserInfoDocument, options);
        }
export type GetTaxProUserInfoQueryHookResult = ReturnType<typeof useGetTaxProUserInfoQuery>;
export type GetTaxProUserInfoLazyQueryHookResult = ReturnType<typeof useGetTaxProUserInfoLazyQuery>;
export type GetTaxProUserInfoQueryResult = Apollo.QueryResult<GetTaxProUserInfoQuery, GetTaxProUserInfoQueryVariables>;
export const RegisterAsTaxProDocument = gql`
    mutation RegisterAsTaxPro {
  registerAsTaxPro {
    success
  }
}
    `;
export type RegisterAsTaxProMutationFn = Apollo.MutationFunction<RegisterAsTaxProMutation, RegisterAsTaxProMutationVariables>;

/**
 * __useRegisterAsTaxProMutation__
 *
 * To run a mutation, you first call `useRegisterAsTaxProMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAsTaxProMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerAsTaxProMutation, { data, loading, error }] = useRegisterAsTaxProMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegisterAsTaxProMutation(baseOptions?: Apollo.MutationHookOptions<RegisterAsTaxProMutation, RegisterAsTaxProMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterAsTaxProMutation, RegisterAsTaxProMutationVariables>(RegisterAsTaxProDocument, options);
      }
export type RegisterAsTaxProMutationHookResult = ReturnType<typeof useRegisterAsTaxProMutation>;
export type RegisterAsTaxProMutationResult = Apollo.MutationResult<RegisterAsTaxProMutation>;
export type RegisterAsTaxProMutationOptions = Apollo.BaseMutationOptions<RegisterAsTaxProMutation, RegisterAsTaxProMutationVariables>;
export const EditFirmDocument = gql`
    mutation EditFirm($publicId: String, $name: String!, $description: String!, $emailSuffix: String!, $partnerType: PartnerType, $isContracted: Boolean, $taxPlanDiscountPercent: Int) {
  editFirm(
    publicId: $publicId
    name: $name
    description: $description
    emailSuffix: $emailSuffix
    partnerType: $partnerType
    isContracted: $isContracted
    taxPlanDiscountPercent: $taxPlanDiscountPercent
  ) {
    success
    publicId
  }
}
    `;
export type EditFirmMutationFn = Apollo.MutationFunction<EditFirmMutation, EditFirmMutationVariables>;

/**
 * __useEditFirmMutation__
 *
 * To run a mutation, you first call `useEditFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFirmMutation, { data, loading, error }] = useEditFirmMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      emailSuffix: // value for 'emailSuffix'
 *      partnerType: // value for 'partnerType'
 *      isContracted: // value for 'isContracted'
 *      taxPlanDiscountPercent: // value for 'taxPlanDiscountPercent'
 *   },
 * });
 */
export function useEditFirmMutation(baseOptions?: Apollo.MutationHookOptions<EditFirmMutation, EditFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditFirmMutation, EditFirmMutationVariables>(EditFirmDocument, options);
      }
export type EditFirmMutationHookResult = ReturnType<typeof useEditFirmMutation>;
export type EditFirmMutationResult = Apollo.MutationResult<EditFirmMutation>;
export type EditFirmMutationOptions = Apollo.BaseMutationOptions<EditFirmMutation, EditFirmMutationVariables>;
export const ListTaxFirmsDocument = gql`
    query ListTaxFirms {
  taxFirms {
    name
    description
    emailSuffix
    publicId
    partnerType
    isContracted
    taxPlanDiscountPercent
  }
}
    `;

/**
 * __useListTaxFirmsQuery__
 *
 * To run a query within a React component, call `useListTaxFirmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTaxFirmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTaxFirmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListTaxFirmsQuery(baseOptions?: Apollo.QueryHookOptions<ListTaxFirmsQuery, ListTaxFirmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTaxFirmsQuery, ListTaxFirmsQueryVariables>(ListTaxFirmsDocument, options);
      }
export function useListTaxFirmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTaxFirmsQuery, ListTaxFirmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTaxFirmsQuery, ListTaxFirmsQueryVariables>(ListTaxFirmsDocument, options);
        }
export type ListTaxFirmsQueryHookResult = ReturnType<typeof useListTaxFirmsQuery>;
export type ListTaxFirmsLazyQueryHookResult = ReturnType<typeof useListTaxFirmsLazyQuery>;
export type ListTaxFirmsQueryResult = Apollo.QueryResult<ListTaxFirmsQuery, ListTaxFirmsQueryVariables>;
export const GetBalanceDifferencesDocument = gql`
    query GetBalanceDifferences {
  portfolio(performanceDuration: ALL_TIME) {
    marketValue
    reportedMarketValue
    calculatedMarketValue
    isSignificantMarketValueDiff
  }
}
    `;

/**
 * __useGetBalanceDifferencesQuery__
 *
 * To run a query within a React component, call `useGetBalanceDifferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceDifferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalanceDifferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBalanceDifferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetBalanceDifferencesQuery, GetBalanceDifferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalanceDifferencesQuery, GetBalanceDifferencesQueryVariables>(GetBalanceDifferencesDocument, options);
      }
export function useGetBalanceDifferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalanceDifferencesQuery, GetBalanceDifferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalanceDifferencesQuery, GetBalanceDifferencesQueryVariables>(GetBalanceDifferencesDocument, options);
        }
export type GetBalanceDifferencesQueryHookResult = ReturnType<typeof useGetBalanceDifferencesQuery>;
export type GetBalanceDifferencesLazyQueryHookResult = ReturnType<typeof useGetBalanceDifferencesLazyQuery>;
export type GetBalanceDifferencesQueryResult = Apollo.QueryResult<GetBalanceDifferencesQuery, GetBalanceDifferencesQueryVariables>;
export const GetExchangesDocument = gql`
    query GetExchanges {
  exchanges {
    id
    name
    imageUrl
    value
    syncInfo {
      lastSynced
      isSyncing
      willBeDeleted
    }
  }
}
    `;

/**
 * __useGetExchangesQuery__
 *
 * To run a query within a React component, call `useGetExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangesQuery(baseOptions?: Apollo.QueryHookOptions<GetExchangesQuery, GetExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangesQuery, GetExchangesQueryVariables>(GetExchangesDocument, options);
      }
export function useGetExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangesQuery, GetExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangesQuery, GetExchangesQueryVariables>(GetExchangesDocument, options);
        }
export type GetExchangesQueryHookResult = ReturnType<typeof useGetExchangesQuery>;
export type GetExchangesLazyQueryHookResult = ReturnType<typeof useGetExchangesLazyQuery>;
export type GetExchangesQueryResult = Apollo.QueryResult<GetExchangesQuery, GetExchangesQueryVariables>;
export const GetTasksDocument = gql`
    query GetTasks($taskStatus: TaskStatus!) {
  tasksByType(status: $taskStatus, taskType: FIX_API_CREDENTIALS) {
    status
    taskType
    tasks {
      id
      status
      createdAt
      updatedAt
      ... on FixApiCredentialsTask {
        exchange {
          id
          name
          imageUrl
          value
          syncInfo {
            lastSynced
            isSyncing
            willBeDeleted
          }
        }
      }
    }
    pageInfo {
      hasPrev
      hasNext
      page
      pages
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      taskStatus: // value for 'taskStatus'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const UpdateTaskReconciliationDocument = gql`
    mutation UpdateTaskReconciliation($taskId: UUID!, $status: TaskStatus!) {
  updateTask(input: {taskId: $taskId, status: $status}) {
    success
    error
  }
}
    `;
export type UpdateTaskReconciliationMutationFn = Apollo.MutationFunction<UpdateTaskReconciliationMutation, UpdateTaskReconciliationMutationVariables>;

/**
 * __useUpdateTaskReconciliationMutation__
 *
 * To run a mutation, you first call `useUpdateTaskReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskReconciliationMutation, { data, loading, error }] = useUpdateTaskReconciliationMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTaskReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskReconciliationMutation, UpdateTaskReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskReconciliationMutation, UpdateTaskReconciliationMutationVariables>(UpdateTaskReconciliationDocument, options);
      }
export type UpdateTaskReconciliationMutationHookResult = ReturnType<typeof useUpdateTaskReconciliationMutation>;
export type UpdateTaskReconciliationMutationResult = Apollo.MutationResult<UpdateTaskReconciliationMutation>;
export type UpdateTaskReconciliationMutationOptions = Apollo.BaseMutationOptions<UpdateTaskReconciliationMutation, UpdateTaskReconciliationMutationVariables>;
export const UpdateUserUiThemeDocument = gql`
    mutation UpdateUserUITheme($uiTheme: UITheme) {
  updateUserUiTheme(uiTheme: $uiTheme) {
    success
    errorMessage
  }
}
    `;
export type UpdateUserUiThemeMutationFn = Apollo.MutationFunction<UpdateUserUiThemeMutation, UpdateUserUiThemeMutationVariables>;

/**
 * __useUpdateUserUiThemeMutation__
 *
 * To run a mutation, you first call `useUpdateUserUiThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserUiThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserUiThemeMutation, { data, loading, error }] = useUpdateUserUiThemeMutation({
 *   variables: {
 *      uiTheme: // value for 'uiTheme'
 *   },
 * });
 */
export function useUpdateUserUiThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserUiThemeMutation, UpdateUserUiThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserUiThemeMutation, UpdateUserUiThemeMutationVariables>(UpdateUserUiThemeDocument, options);
      }
export type UpdateUserUiThemeMutationHookResult = ReturnType<typeof useUpdateUserUiThemeMutation>;
export type UpdateUserUiThemeMutationResult = Apollo.MutationResult<UpdateUserUiThemeMutation>;
export type UpdateUserUiThemeMutationOptions = Apollo.BaseMutationOptions<UpdateUserUiThemeMutation, UpdateUserUiThemeMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser {
    success
    errorMessage
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword {
  resetUserPassword {
    success
    errorMessage
  }
}
    `;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const StartUniversalToPerWalletMigrationDocument = gql`
    mutation StartUniversalToPerWalletMigration {
  startUniversalToPerWalletMigration {
    success
    errorMessage
    jobId
  }
}
    `;
export type StartUniversalToPerWalletMigrationMutationFn = Apollo.MutationFunction<StartUniversalToPerWalletMigrationMutation, StartUniversalToPerWalletMigrationMutationVariables>;

/**
 * __useStartUniversalToPerWalletMigrationMutation__
 *
 * To run a mutation, you first call `useStartUniversalToPerWalletMigrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartUniversalToPerWalletMigrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startUniversalToPerWalletMigrationMutation, { data, loading, error }] = useStartUniversalToPerWalletMigrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartUniversalToPerWalletMigrationMutation(baseOptions?: Apollo.MutationHookOptions<StartUniversalToPerWalletMigrationMutation, StartUniversalToPerWalletMigrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartUniversalToPerWalletMigrationMutation, StartUniversalToPerWalletMigrationMutationVariables>(StartUniversalToPerWalletMigrationDocument, options);
      }
export type StartUniversalToPerWalletMigrationMutationHookResult = ReturnType<typeof useStartUniversalToPerWalletMigrationMutation>;
export type StartUniversalToPerWalletMigrationMutationResult = Apollo.MutationResult<StartUniversalToPerWalletMigrationMutation>;
export type StartUniversalToPerWalletMigrationMutationOptions = Apollo.BaseMutationOptions<StartUniversalToPerWalletMigrationMutation, StartUniversalToPerWalletMigrationMutationVariables>;
export const SubmitUserEmailChangeRequestDocument = gql`
    mutation SubmitUserEmailChangeRequest($toEmail: String!) {
  submitUserEmailChangeRequest(toEmail: $toEmail) {
    ok
    error
  }
}
    `;
export type SubmitUserEmailChangeRequestMutationFn = Apollo.MutationFunction<SubmitUserEmailChangeRequestMutation, SubmitUserEmailChangeRequestMutationVariables>;

/**
 * __useSubmitUserEmailChangeRequestMutation__
 *
 * To run a mutation, you first call `useSubmitUserEmailChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitUserEmailChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitUserEmailChangeRequestMutation, { data, loading, error }] = useSubmitUserEmailChangeRequestMutation({
 *   variables: {
 *      toEmail: // value for 'toEmail'
 *   },
 * });
 */
export function useSubmitUserEmailChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitUserEmailChangeRequestMutation, SubmitUserEmailChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitUserEmailChangeRequestMutation, SubmitUserEmailChangeRequestMutationVariables>(SubmitUserEmailChangeRequestDocument, options);
      }
export type SubmitUserEmailChangeRequestMutationHookResult = ReturnType<typeof useSubmitUserEmailChangeRequestMutation>;
export type SubmitUserEmailChangeRequestMutationResult = Apollo.MutationResult<SubmitUserEmailChangeRequestMutation>;
export type SubmitUserEmailChangeRequestMutationOptions = Apollo.BaseMutationOptions<SubmitUserEmailChangeRequestMutation, SubmitUserEmailChangeRequestMutationVariables>;
export const UpdateBaseCurrencyDocument = gql`
    mutation UpdateBaseCurrency($fiatId: String, $cryptoId: String) {
  updateBaseCurrency(fiatId: $fiatId, cryptoId: $cryptoId) {
    success
    errorMessage
  }
}
    `;
export type UpdateBaseCurrencyMutationFn = Apollo.MutationFunction<UpdateBaseCurrencyMutation, UpdateBaseCurrencyMutationVariables>;

/**
 * __useUpdateBaseCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateBaseCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBaseCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBaseCurrencyMutation, { data, loading, error }] = useUpdateBaseCurrencyMutation({
 *   variables: {
 *      fiatId: // value for 'fiatId'
 *      cryptoId: // value for 'cryptoId'
 *   },
 * });
 */
export function useUpdateBaseCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBaseCurrencyMutation, UpdateBaseCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBaseCurrencyMutation, UpdateBaseCurrencyMutationVariables>(UpdateBaseCurrencyDocument, options);
      }
export type UpdateBaseCurrencyMutationHookResult = ReturnType<typeof useUpdateBaseCurrencyMutation>;
export type UpdateBaseCurrencyMutationResult = Apollo.MutationResult<UpdateBaseCurrencyMutation>;
export type UpdateBaseCurrencyMutationOptions = Apollo.BaseMutationOptions<UpdateBaseCurrencyMutation, UpdateBaseCurrencyMutationVariables>;
export const UpdateCostBasisMethodDocument = gql`
    mutation UpdateCostBasisMethod($costBasisType: CostBasisMethod) {
  updateCostBasisMethod(costBasisType: $costBasisType) {
    success
    errorMessage
  }
}
    `;
export type UpdateCostBasisMethodMutationFn = Apollo.MutationFunction<UpdateCostBasisMethodMutation, UpdateCostBasisMethodMutationVariables>;

/**
 * __useUpdateCostBasisMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCostBasisMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostBasisMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostBasisMethodMutation, { data, loading, error }] = useUpdateCostBasisMethodMutation({
 *   variables: {
 *      costBasisType: // value for 'costBasisType'
 *   },
 * });
 */
export function useUpdateCostBasisMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostBasisMethodMutation, UpdateCostBasisMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostBasisMethodMutation, UpdateCostBasisMethodMutationVariables>(UpdateCostBasisMethodDocument, options);
      }
export type UpdateCostBasisMethodMutationHookResult = ReturnType<typeof useUpdateCostBasisMethodMutation>;
export type UpdateCostBasisMethodMutationResult = Apollo.MutationResult<UpdateCostBasisMethodMutation>;
export type UpdateCostBasisMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCostBasisMethodMutation, UpdateCostBasisMethodMutationVariables>;
export const UpdateCostBasisMethodTimelineDocument = gql`
    mutation UpdateCostBasisMethodTimeline($costBasisType: CostBasisMethod!, $startDate: DateTime!, $endDate: DateTime) {
  updateCostBasisMethodTimeline(
    costBasisType: $costBasisType
    startDate: $startDate
    endDate: $endDate
  ) {
    success
    errorMessage
  }
}
    `;
export type UpdateCostBasisMethodTimelineMutationFn = Apollo.MutationFunction<UpdateCostBasisMethodTimelineMutation, UpdateCostBasisMethodTimelineMutationVariables>;

/**
 * __useUpdateCostBasisMethodTimelineMutation__
 *
 * To run a mutation, you first call `useUpdateCostBasisMethodTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostBasisMethodTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostBasisMethodTimelineMutation, { data, loading, error }] = useUpdateCostBasisMethodTimelineMutation({
 *   variables: {
 *      costBasisType: // value for 'costBasisType'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUpdateCostBasisMethodTimelineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostBasisMethodTimelineMutation, UpdateCostBasisMethodTimelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostBasisMethodTimelineMutation, UpdateCostBasisMethodTimelineMutationVariables>(UpdateCostBasisMethodTimelineDocument, options);
      }
export type UpdateCostBasisMethodTimelineMutationHookResult = ReturnType<typeof useUpdateCostBasisMethodTimelineMutation>;
export type UpdateCostBasisMethodTimelineMutationResult = Apollo.MutationResult<UpdateCostBasisMethodTimelineMutation>;
export type UpdateCostBasisMethodTimelineMutationOptions = Apollo.BaseMutationOptions<UpdateCostBasisMethodTimelineMutation, UpdateCostBasisMethodTimelineMutationVariables>;
export const UpdateCostBasisPausedDocument = gql`
    mutation UpdateCostBasisPaused($costBasisPaused: Boolean!) {
  updateCostBasisPaused(costBasisPaused: $costBasisPaused) {
    success
    errorMessage
  }
}
    `;
export type UpdateCostBasisPausedMutationFn = Apollo.MutationFunction<UpdateCostBasisPausedMutation, UpdateCostBasisPausedMutationVariables>;

/**
 * __useUpdateCostBasisPausedMutation__
 *
 * To run a mutation, you first call `useUpdateCostBasisPausedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostBasisPausedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostBasisPausedMutation, { data, loading, error }] = useUpdateCostBasisPausedMutation({
 *   variables: {
 *      costBasisPaused: // value for 'costBasisPaused'
 *   },
 * });
 */
export function useUpdateCostBasisPausedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostBasisPausedMutation, UpdateCostBasisPausedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostBasisPausedMutation, UpdateCostBasisPausedMutationVariables>(UpdateCostBasisPausedDocument, options);
      }
export type UpdateCostBasisPausedMutationHookResult = ReturnType<typeof useUpdateCostBasisPausedMutation>;
export type UpdateCostBasisPausedMutationResult = Apollo.MutationResult<UpdateCostBasisPausedMutation>;
export type UpdateCostBasisPausedMutationOptions = Apollo.BaseMutationOptions<UpdateCostBasisPausedMutation, UpdateCostBasisPausedMutationVariables>;
export const UpdateCostBasisTrackingDocument = gql`
    mutation UpdateCostBasisTracking($costBasisTrackingMethod: CostBasisTracking) {
  updateCostBasisTracking(costBasisTrackingMethod: $costBasisTrackingMethod) {
    success
    errorMessage
  }
}
    `;
export type UpdateCostBasisTrackingMutationFn = Apollo.MutationFunction<UpdateCostBasisTrackingMutation, UpdateCostBasisTrackingMutationVariables>;

/**
 * __useUpdateCostBasisTrackingMutation__
 *
 * To run a mutation, you first call `useUpdateCostBasisTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCostBasisTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCostBasisTrackingMutation, { data, loading, error }] = useUpdateCostBasisTrackingMutation({
 *   variables: {
 *      costBasisTrackingMethod: // value for 'costBasisTrackingMethod'
 *   },
 * });
 */
export function useUpdateCostBasisTrackingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCostBasisTrackingMutation, UpdateCostBasisTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCostBasisTrackingMutation, UpdateCostBasisTrackingMutationVariables>(UpdateCostBasisTrackingDocument, options);
      }
export type UpdateCostBasisTrackingMutationHookResult = ReturnType<typeof useUpdateCostBasisTrackingMutation>;
export type UpdateCostBasisTrackingMutationResult = Apollo.MutationResult<UpdateCostBasisTrackingMutation>;
export type UpdateCostBasisTrackingMutationOptions = Apollo.BaseMutationOptions<UpdateCostBasisTrackingMutation, UpdateCostBasisTrackingMutationVariables>;
export const UpdateCountryCodeDocument = gql`
    mutation UpdateCountryCode($countryCode: String) {
  updateCountryCode(countryCode: $countryCode) {
    success
    errorMessage
  }
}
    `;
export type UpdateCountryCodeMutationFn = Apollo.MutationFunction<UpdateCountryCodeMutation, UpdateCountryCodeMutationVariables>;

/**
 * __useUpdateCountryCodeMutation__
 *
 * To run a mutation, you first call `useUpdateCountryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryCodeMutation, { data, loading, error }] = useUpdateCountryCodeMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useUpdateCountryCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCountryCodeMutation, UpdateCountryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCountryCodeMutation, UpdateCountryCodeMutationVariables>(UpdateCountryCodeDocument, options);
      }
export type UpdateCountryCodeMutationHookResult = ReturnType<typeof useUpdateCountryCodeMutation>;
export type UpdateCountryCodeMutationResult = Apollo.MutationResult<UpdateCountryCodeMutation>;
export type UpdateCountryCodeMutationOptions = Apollo.BaseMutationOptions<UpdateCountryCodeMutation, UpdateCountryCodeMutationVariables>;
export const UpdateLotAllocationMethodDocument = gql`
    mutation UpdateLotAllocationMethod($lotAllocationMethod: LotAllocationMethod) {
  updateLotAllocationMethod(lotAllocationMethod: $lotAllocationMethod) {
    success
    errorMessage
  }
}
    `;
export type UpdateLotAllocationMethodMutationFn = Apollo.MutationFunction<UpdateLotAllocationMethodMutation, UpdateLotAllocationMethodMutationVariables>;

/**
 * __useUpdateLotAllocationMethodMutation__
 *
 * To run a mutation, you first call `useUpdateLotAllocationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLotAllocationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLotAllocationMethodMutation, { data, loading, error }] = useUpdateLotAllocationMethodMutation({
 *   variables: {
 *      lotAllocationMethod: // value for 'lotAllocationMethod'
 *   },
 * });
 */
export function useUpdateLotAllocationMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLotAllocationMethodMutation, UpdateLotAllocationMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLotAllocationMethodMutation, UpdateLotAllocationMethodMutationVariables>(UpdateLotAllocationMethodDocument, options);
      }
export type UpdateLotAllocationMethodMutationHookResult = ReturnType<typeof useUpdateLotAllocationMethodMutation>;
export type UpdateLotAllocationMethodMutationResult = Apollo.MutationResult<UpdateLotAllocationMethodMutation>;
export type UpdateLotAllocationMethodMutationOptions = Apollo.BaseMutationOptions<UpdateLotAllocationMethodMutation, UpdateLotAllocationMethodMutationVariables>;
export const UpdateSyncCutoffDateDocument = gql`
    mutation UpdateSyncCutoffDate($syncCutoffDate: Date) {
  updateSyncCutoffDate(syncCutoffDate: $syncCutoffDate) {
    success
    errorMessage
  }
}
    `;
export type UpdateSyncCutoffDateMutationFn = Apollo.MutationFunction<UpdateSyncCutoffDateMutation, UpdateSyncCutoffDateMutationVariables>;

/**
 * __useUpdateSyncCutoffDateMutation__
 *
 * To run a mutation, you first call `useUpdateSyncCutoffDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSyncCutoffDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSyncCutoffDateMutation, { data, loading, error }] = useUpdateSyncCutoffDateMutation({
 *   variables: {
 *      syncCutoffDate: // value for 'syncCutoffDate'
 *   },
 * });
 */
export function useUpdateSyncCutoffDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSyncCutoffDateMutation, UpdateSyncCutoffDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSyncCutoffDateMutation, UpdateSyncCutoffDateMutationVariables>(UpdateSyncCutoffDateDocument, options);
      }
export type UpdateSyncCutoffDateMutationHookResult = ReturnType<typeof useUpdateSyncCutoffDateMutation>;
export type UpdateSyncCutoffDateMutationResult = Apollo.MutationResult<UpdateSyncCutoffDateMutation>;
export type UpdateSyncCutoffDateMutationOptions = Apollo.BaseMutationOptions<UpdateSyncCutoffDateMutation, UpdateSyncCutoffDateMutationVariables>;
export const UpdateTaxYearDocument = gql`
    mutation UpdateTaxYear($taxStartMonth: Int, $taxStartDay: Int) {
  updateTaxYear(taxStartMonth: $taxStartMonth, taxStartDay: $taxStartDay) {
    success
    errorMessage
  }
}
    `;
export type UpdateTaxYearMutationFn = Apollo.MutationFunction<UpdateTaxYearMutation, UpdateTaxYearMutationVariables>;

/**
 * __useUpdateTaxYearMutation__
 *
 * To run a mutation, you first call `useUpdateTaxYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxYearMutation, { data, loading, error }] = useUpdateTaxYearMutation({
 *   variables: {
 *      taxStartMonth: // value for 'taxStartMonth'
 *      taxStartDay: // value for 'taxStartDay'
 *   },
 * });
 */
export function useUpdateTaxYearMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxYearMutation, UpdateTaxYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxYearMutation, UpdateTaxYearMutationVariables>(UpdateTaxYearDocument, options);
      }
export type UpdateTaxYearMutationHookResult = ReturnType<typeof useUpdateTaxYearMutation>;
export type UpdateTaxYearMutationResult = Apollo.MutationResult<UpdateTaxYearMutation>;
export type UpdateTaxYearMutationOptions = Apollo.BaseMutationOptions<UpdateTaxYearMutation, UpdateTaxYearMutationVariables>;
export const UpdateUserDisplayedBalancesDocument = gql`
    mutation UpdateUserDisplayedBalances($displayedBalances: DisplayedBalances!) {
  updateUserDisplayedBalances(displayedBalances: $displayedBalances) {
    success
    errorMessage
  }
}
    `;
export type UpdateUserDisplayedBalancesMutationFn = Apollo.MutationFunction<UpdateUserDisplayedBalancesMutation, UpdateUserDisplayedBalancesMutationVariables>;

/**
 * __useUpdateUserDisplayedBalancesMutation__
 *
 * To run a mutation, you first call `useUpdateUserDisplayedBalancesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDisplayedBalancesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDisplayedBalancesMutation, { data, loading, error }] = useUpdateUserDisplayedBalancesMutation({
 *   variables: {
 *      displayedBalances: // value for 'displayedBalances'
 *   },
 * });
 */
export function useUpdateUserDisplayedBalancesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDisplayedBalancesMutation, UpdateUserDisplayedBalancesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDisplayedBalancesMutation, UpdateUserDisplayedBalancesMutationVariables>(UpdateUserDisplayedBalancesDocument, options);
      }
export type UpdateUserDisplayedBalancesMutationHookResult = ReturnType<typeof useUpdateUserDisplayedBalancesMutation>;
export type UpdateUserDisplayedBalancesMutationResult = Apollo.MutationResult<UpdateUserDisplayedBalancesMutation>;
export type UpdateUserDisplayedBalancesMutationOptions = Apollo.BaseMutationOptions<UpdateUserDisplayedBalancesMutation, UpdateUserDisplayedBalancesMutationVariables>;
export const VerifyUserEmailChangeRequestMutationDocument = gql`
    mutation VerifyUserEmailChangeRequestMutation($otpValue: String!, $toEmail: String!) {
  verifyUserEmailChangeRequest(otpValue: $otpValue, toEmail: $toEmail) {
    ok
    error
  }
}
    `;
export type VerifyUserEmailChangeRequestMutationMutationFn = Apollo.MutationFunction<VerifyUserEmailChangeRequestMutationMutation, VerifyUserEmailChangeRequestMutationMutationVariables>;

/**
 * __useVerifyUserEmailChangeRequestMutationMutation__
 *
 * To run a mutation, you first call `useVerifyUserEmailChangeRequestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserEmailChangeRequestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserEmailChangeRequestMutationMutation, { data, loading, error }] = useVerifyUserEmailChangeRequestMutationMutation({
 *   variables: {
 *      otpValue: // value for 'otpValue'
 *      toEmail: // value for 'toEmail'
 *   },
 * });
 */
export function useVerifyUserEmailChangeRequestMutationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserEmailChangeRequestMutationMutation, VerifyUserEmailChangeRequestMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserEmailChangeRequestMutationMutation, VerifyUserEmailChangeRequestMutationMutationVariables>(VerifyUserEmailChangeRequestMutationDocument, options);
      }
export type VerifyUserEmailChangeRequestMutationMutationHookResult = ReturnType<typeof useVerifyUserEmailChangeRequestMutationMutation>;
export type VerifyUserEmailChangeRequestMutationMutationResult = Apollo.MutationResult<VerifyUserEmailChangeRequestMutationMutation>;
export type VerifyUserEmailChangeRequestMutationMutationOptions = Apollo.BaseMutationOptions<VerifyUserEmailChangeRequestMutationMutation, VerifyUserEmailChangeRequestMutationMutationVariables>;
export const GetNotificationSettingsDocument = gql`
    query GetNotificationSettings {
  userInfo {
    publicId
    newTransactionsNotification
    newTransactionsEmail
    dailyPortfolioNotification
    dailyPortfolioEmail
    productUpdateEmail
    accountReauthenticationNotification
  }
}
    `;

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
      }
export function useGetNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export type GetNotificationSettingsQueryHookResult = ReturnType<typeof useGetNotificationSettingsQuery>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationSettingsLazyQuery>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const UpdateUserinfoSettingMutationDocument = gql`
    mutation UpdateUserinfoSettingMutation($settingType: UserSettings!, $isEnabled: Boolean!) {
  updateUserinfoSetting(settingType: $settingType, isEnabled: $isEnabled) {
    success
    errorMessage
  }
}
    `;
export type UpdateUserinfoSettingMutationMutationFn = Apollo.MutationFunction<UpdateUserinfoSettingMutationMutation, UpdateUserinfoSettingMutationMutationVariables>;

/**
 * __useUpdateUserinfoSettingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateUserinfoSettingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserinfoSettingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserinfoSettingMutationMutation, { data, loading, error }] = useUpdateUserinfoSettingMutationMutation({
 *   variables: {
 *      settingType: // value for 'settingType'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdateUserinfoSettingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserinfoSettingMutationMutation, UpdateUserinfoSettingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserinfoSettingMutationMutation, UpdateUserinfoSettingMutationMutationVariables>(UpdateUserinfoSettingMutationDocument, options);
      }
export type UpdateUserinfoSettingMutationMutationHookResult = ReturnType<typeof useUpdateUserinfoSettingMutationMutation>;
export type UpdateUserinfoSettingMutationMutationResult = Apollo.MutationResult<UpdateUserinfoSettingMutationMutation>;
export type UpdateUserinfoSettingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateUserinfoSettingMutationMutation, UpdateUserinfoSettingMutationMutationVariables>;
export const DeleteLendingUserSettingsDocument = gql`
    mutation DeleteLendingUserSettings {
  deleteLendingUserSettings {
    success
    error
  }
}
    `;
export type DeleteLendingUserSettingsMutationFn = Apollo.MutationFunction<DeleteLendingUserSettingsMutation, DeleteLendingUserSettingsMutationVariables>;

/**
 * __useDeleteLendingUserSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteLendingUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLendingUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLendingUserSettingsMutation, { data, loading, error }] = useDeleteLendingUserSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteLendingUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLendingUserSettingsMutation, DeleteLendingUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLendingUserSettingsMutation, DeleteLendingUserSettingsMutationVariables>(DeleteLendingUserSettingsDocument, options);
      }
export type DeleteLendingUserSettingsMutationHookResult = ReturnType<typeof useDeleteLendingUserSettingsMutation>;
export type DeleteLendingUserSettingsMutationResult = Apollo.MutationResult<DeleteLendingUserSettingsMutation>;
export type DeleteLendingUserSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteLendingUserSettingsMutation, DeleteLendingUserSettingsMutationVariables>;
export const DeleteLiquidStakingUserSettingsDocument = gql`
    mutation DeleteLiquidStakingUserSettings {
  deleteLiquidStakingUserSettings {
    success
    error
  }
}
    `;
export type DeleteLiquidStakingUserSettingsMutationFn = Apollo.MutationFunction<DeleteLiquidStakingUserSettingsMutation, DeleteLiquidStakingUserSettingsMutationVariables>;

/**
 * __useDeleteLiquidStakingUserSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteLiquidStakingUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLiquidStakingUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLiquidStakingUserSettingsMutation, { data, loading, error }] = useDeleteLiquidStakingUserSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteLiquidStakingUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLiquidStakingUserSettingsMutation, DeleteLiquidStakingUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLiquidStakingUserSettingsMutation, DeleteLiquidStakingUserSettingsMutationVariables>(DeleteLiquidStakingUserSettingsDocument, options);
      }
export type DeleteLiquidStakingUserSettingsMutationHookResult = ReturnType<typeof useDeleteLiquidStakingUserSettingsMutation>;
export type DeleteLiquidStakingUserSettingsMutationResult = Apollo.MutationResult<DeleteLiquidStakingUserSettingsMutation>;
export type DeleteLiquidStakingUserSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteLiquidStakingUserSettingsMutation, DeleteLiquidStakingUserSettingsMutationVariables>;
export const DeleteLiquidityUserSettingsDocument = gql`
    mutation DeleteLiquidityUserSettings {
  deleteLiquidityUserSettings {
    success
    error
  }
}
    `;
export type DeleteLiquidityUserSettingsMutationFn = Apollo.MutationFunction<DeleteLiquidityUserSettingsMutation, DeleteLiquidityUserSettingsMutationVariables>;

/**
 * __useDeleteLiquidityUserSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteLiquidityUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLiquidityUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLiquidityUserSettingsMutation, { data, loading, error }] = useDeleteLiquidityUserSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteLiquidityUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLiquidityUserSettingsMutation, DeleteLiquidityUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLiquidityUserSettingsMutation, DeleteLiquidityUserSettingsMutationVariables>(DeleteLiquidityUserSettingsDocument, options);
      }
export type DeleteLiquidityUserSettingsMutationHookResult = ReturnType<typeof useDeleteLiquidityUserSettingsMutation>;
export type DeleteLiquidityUserSettingsMutationResult = Apollo.MutationResult<DeleteLiquidityUserSettingsMutation>;
export type DeleteLiquidityUserSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteLiquidityUserSettingsMutation, DeleteLiquidityUserSettingsMutationVariables>;
export const DeleteStakingRewardsUserSettingsDocument = gql`
    mutation DeleteStakingRewardsUserSettings {
  deleteStakingRewardsUserSettings {
    success
    error
  }
}
    `;
export type DeleteStakingRewardsUserSettingsMutationFn = Apollo.MutationFunction<DeleteStakingRewardsUserSettingsMutation, DeleteStakingRewardsUserSettingsMutationVariables>;

/**
 * __useDeleteStakingRewardsUserSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteStakingRewardsUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakingRewardsUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakingRewardsUserSettingsMutation, { data, loading, error }] = useDeleteStakingRewardsUserSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteStakingRewardsUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakingRewardsUserSettingsMutation, DeleteStakingRewardsUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakingRewardsUserSettingsMutation, DeleteStakingRewardsUserSettingsMutationVariables>(DeleteStakingRewardsUserSettingsDocument, options);
      }
export type DeleteStakingRewardsUserSettingsMutationHookResult = ReturnType<typeof useDeleteStakingRewardsUserSettingsMutation>;
export type DeleteStakingRewardsUserSettingsMutationResult = Apollo.MutationResult<DeleteStakingRewardsUserSettingsMutation>;
export type DeleteStakingRewardsUserSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteStakingRewardsUserSettingsMutation, DeleteStakingRewardsUserSettingsMutationVariables>;
export const DeleteWrappingUserSettingsDocument = gql`
    mutation DeleteWrappingUserSettings {
  deleteWrappingUserSettings {
    success
    error
  }
}
    `;
export type DeleteWrappingUserSettingsMutationFn = Apollo.MutationFunction<DeleteWrappingUserSettingsMutation, DeleteWrappingUserSettingsMutationVariables>;

/**
 * __useDeleteWrappingUserSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteWrappingUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWrappingUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWrappingUserSettingsMutation, { data, loading, error }] = useDeleteWrappingUserSettingsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteWrappingUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWrappingUserSettingsMutation, DeleteWrappingUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWrappingUserSettingsMutation, DeleteWrappingUserSettingsMutationVariables>(DeleteWrappingUserSettingsDocument, options);
      }
export type DeleteWrappingUserSettingsMutationHookResult = ReturnType<typeof useDeleteWrappingUserSettingsMutation>;
export type DeleteWrappingUserSettingsMutationResult = Apollo.MutationResult<DeleteWrappingUserSettingsMutation>;
export type DeleteWrappingUserSettingsMutationOptions = Apollo.BaseMutationOptions<DeleteWrappingUserSettingsMutation, DeleteWrappingUserSettingsMutationVariables>;
export const UpdateLendingTaxabilityDocument = gql`
    mutation UpdateLendingTaxability($settingStartDate: DateTime!, $settingEndDate: DateTime) {
  updateLendingTaxability(
    settingStartDate: $settingStartDate
    settingEndDate: $settingEndDate
  ) {
    success
    error
  }
}
    `;
export type UpdateLendingTaxabilityMutationFn = Apollo.MutationFunction<UpdateLendingTaxabilityMutation, UpdateLendingTaxabilityMutationVariables>;

/**
 * __useUpdateLendingTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateLendingTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLendingTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLendingTaxabilityMutation, { data, loading, error }] = useUpdateLendingTaxabilityMutation({
 *   variables: {
 *      settingStartDate: // value for 'settingStartDate'
 *      settingEndDate: // value for 'settingEndDate'
 *   },
 * });
 */
export function useUpdateLendingTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLendingTaxabilityMutation, UpdateLendingTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLendingTaxabilityMutation, UpdateLendingTaxabilityMutationVariables>(UpdateLendingTaxabilityDocument, options);
      }
export type UpdateLendingTaxabilityMutationHookResult = ReturnType<typeof useUpdateLendingTaxabilityMutation>;
export type UpdateLendingTaxabilityMutationResult = Apollo.MutationResult<UpdateLendingTaxabilityMutation>;
export type UpdateLendingTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateLendingTaxabilityMutation, UpdateLendingTaxabilityMutationVariables>;
export const UpdateLiquidStakingTaxabilityDocument = gql`
    mutation UpdateLiquidStakingTaxability($settingStartDate: DateTime!, $settingEndDate: DateTime) {
  updateLiquidStakingTaxability(
    settingStartDate: $settingStartDate
    settingEndDate: $settingEndDate
  ) {
    success
    error
  }
}
    `;
export type UpdateLiquidStakingTaxabilityMutationFn = Apollo.MutationFunction<UpdateLiquidStakingTaxabilityMutation, UpdateLiquidStakingTaxabilityMutationVariables>;

/**
 * __useUpdateLiquidStakingTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateLiquidStakingTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiquidStakingTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiquidStakingTaxabilityMutation, { data, loading, error }] = useUpdateLiquidStakingTaxabilityMutation({
 *   variables: {
 *      settingStartDate: // value for 'settingStartDate'
 *      settingEndDate: // value for 'settingEndDate'
 *   },
 * });
 */
export function useUpdateLiquidStakingTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLiquidStakingTaxabilityMutation, UpdateLiquidStakingTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLiquidStakingTaxabilityMutation, UpdateLiquidStakingTaxabilityMutationVariables>(UpdateLiquidStakingTaxabilityDocument, options);
      }
export type UpdateLiquidStakingTaxabilityMutationHookResult = ReturnType<typeof useUpdateLiquidStakingTaxabilityMutation>;
export type UpdateLiquidStakingTaxabilityMutationResult = Apollo.MutationResult<UpdateLiquidStakingTaxabilityMutation>;
export type UpdateLiquidStakingTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateLiquidStakingTaxabilityMutation, UpdateLiquidStakingTaxabilityMutationVariables>;
export const UpdateLiquidityTaxabilityDocument = gql`
    mutation UpdateLiquidityTaxability($settingStartDate: DateTime!, $settingEndDate: DateTime) {
  updateLiquidityTaxability(
    settingStartDate: $settingStartDate
    settingEndDate: $settingEndDate
  ) {
    success
    error
  }
}
    `;
export type UpdateLiquidityTaxabilityMutationFn = Apollo.MutationFunction<UpdateLiquidityTaxabilityMutation, UpdateLiquidityTaxabilityMutationVariables>;

/**
 * __useUpdateLiquidityTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateLiquidityTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiquidityTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiquidityTaxabilityMutation, { data, loading, error }] = useUpdateLiquidityTaxabilityMutation({
 *   variables: {
 *      settingStartDate: // value for 'settingStartDate'
 *      settingEndDate: // value for 'settingEndDate'
 *   },
 * });
 */
export function useUpdateLiquidityTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLiquidityTaxabilityMutation, UpdateLiquidityTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLiquidityTaxabilityMutation, UpdateLiquidityTaxabilityMutationVariables>(UpdateLiquidityTaxabilityDocument, options);
      }
export type UpdateLiquidityTaxabilityMutationHookResult = ReturnType<typeof useUpdateLiquidityTaxabilityMutation>;
export type UpdateLiquidityTaxabilityMutationResult = Apollo.MutationResult<UpdateLiquidityTaxabilityMutation>;
export type UpdateLiquidityTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateLiquidityTaxabilityMutation, UpdateLiquidityTaxabilityMutationVariables>;
export const UpdateStakingRewardsTaxabilityDocument = gql`
    mutation UpdateStakingRewardsTaxability($settingStartDate: DateTime!, $settingEndDate: DateTime) {
  updateStakingRewardsTaxability(
    settingStartDate: $settingStartDate
    settingEndDate: $settingEndDate
  ) {
    success
    error
  }
}
    `;
export type UpdateStakingRewardsTaxabilityMutationFn = Apollo.MutationFunction<UpdateStakingRewardsTaxabilityMutation, UpdateStakingRewardsTaxabilityMutationVariables>;

/**
 * __useUpdateStakingRewardsTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateStakingRewardsTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakingRewardsTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakingRewardsTaxabilityMutation, { data, loading, error }] = useUpdateStakingRewardsTaxabilityMutation({
 *   variables: {
 *      settingStartDate: // value for 'settingStartDate'
 *      settingEndDate: // value for 'settingEndDate'
 *   },
 * });
 */
export function useUpdateStakingRewardsTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakingRewardsTaxabilityMutation, UpdateStakingRewardsTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakingRewardsTaxabilityMutation, UpdateStakingRewardsTaxabilityMutationVariables>(UpdateStakingRewardsTaxabilityDocument, options);
      }
export type UpdateStakingRewardsTaxabilityMutationHookResult = ReturnType<typeof useUpdateStakingRewardsTaxabilityMutation>;
export type UpdateStakingRewardsTaxabilityMutationResult = Apollo.MutationResult<UpdateStakingRewardsTaxabilityMutation>;
export type UpdateStakingRewardsTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateStakingRewardsTaxabilityMutation, UpdateStakingRewardsTaxabilityMutationVariables>;
export const UpdateWrappingTaxabilityDocument = gql`
    mutation UpdateWrappingTaxability($settingStartDate: DateTime!, $settingEndDate: DateTime) {
  updateWrappingTaxability(
    settingStartDate: $settingStartDate
    settingEndDate: $settingEndDate
  ) {
    success
    error
  }
}
    `;
export type UpdateWrappingTaxabilityMutationFn = Apollo.MutationFunction<UpdateWrappingTaxabilityMutation, UpdateWrappingTaxabilityMutationVariables>;

/**
 * __useUpdateWrappingTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateWrappingTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWrappingTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWrappingTaxabilityMutation, { data, loading, error }] = useUpdateWrappingTaxabilityMutation({
 *   variables: {
 *      settingStartDate: // value for 'settingStartDate'
 *      settingEndDate: // value for 'settingEndDate'
 *   },
 * });
 */
export function useUpdateWrappingTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWrappingTaxabilityMutation, UpdateWrappingTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWrappingTaxabilityMutation, UpdateWrappingTaxabilityMutationVariables>(UpdateWrappingTaxabilityDocument, options);
      }
export type UpdateWrappingTaxabilityMutationHookResult = ReturnType<typeof useUpdateWrappingTaxabilityMutation>;
export type UpdateWrappingTaxabilityMutationResult = Apollo.MutationResult<UpdateWrappingTaxabilityMutation>;
export type UpdateWrappingTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateWrappingTaxabilityMutation, UpdateWrappingTaxabilityMutationVariables>;
export const GetSettingsDocument = gql`
    query GetSettings {
  userInfo {
    publicId
    costBasisMethodDetails {
      enumValue
      shortName
      longName
    }
    costBasisMethodTimeline {
      userCostBasisSettings {
        costBasisMethod {
          shortName
          niceName
        }
        endDate
        startDate
      }
      hasAccess
    }
    availableCostBasisMethods {
      shortName
      niceName
    }
    country {
      code
      name
      canAccessTaxLossHarvesting
    }
    useV2Lots
    costBasisByWallet
    lotAllocationMethod
    isUndergoingAllocation
    hasTransitioned
    closedPeriodDatetime
    creditsFormatted
    displayedBalances
    taxStartMonth
    taxStartDay
    taxStartDate
    taxEndDate
    taxFilingDeadline
    debugPermission
    hasTaxPlan
    taxPlans {
      planName
      startDate
    }
    costBasisPaused
  }
  portfolioSubscription {
    portfolioPlanName
    billing {
      interval
      status
      currentPeriodEnd
      cancelAtPeriodEnd
    }
  }
  taxConfiguration {
    hasLiquidStakingUserSetting
    liquidStakeSettingStartDate
    liquidStakeSettingEndDate
    hasWrappingUserSetting
    wrappingSettingStartDate
    wrappingSettingEndDate
    hasLendingUserSetting
    lendingSettingStartDate
    lendingSettingEndDate
    hasLiquidityUserSetting
    liquiditySettingStartDate
    liquiditySettingEndDate
    hasStakingRewardsUserSetting
    stakingRewardsSettingStartDate
    stakingRewardsSettingEndDate
  }
  taxYears {
    taxYear
    title
  }
}
    `;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
      }
export function useGetSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsQuery, GetSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(GetSettingsDocument, options);
        }
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<typeof useGetSettingsLazyQuery>;
export type GetSettingsQueryResult = Apollo.QueryResult<GetSettingsQuery, GetSettingsQueryVariables>;
export const IgnoreTokensTransactionsAndReportAsSpamDocument = gql`
    mutation IgnoreTokensTransactionsAndReportAsSpam($contractAddressNetworkPairs: [ContractAddressNetworkPairInput]!, $ignore: Boolean) {
  ignoreTokenTransactionsAndReportAsSpam(
    contractAddressNetworkPairs: $contractAddressNetworkPairs
    ignore: $ignore
  ) {
    success
  }
}
    `;
export type IgnoreTokensTransactionsAndReportAsSpamMutationFn = Apollo.MutationFunction<IgnoreTokensTransactionsAndReportAsSpamMutation, IgnoreTokensTransactionsAndReportAsSpamMutationVariables>;

/**
 * __useIgnoreTokensTransactionsAndReportAsSpamMutation__
 *
 * To run a mutation, you first call `useIgnoreTokensTransactionsAndReportAsSpamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreTokensTransactionsAndReportAsSpamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreTokensTransactionsAndReportAsSpamMutation, { data, loading, error }] = useIgnoreTokensTransactionsAndReportAsSpamMutation({
 *   variables: {
 *      contractAddressNetworkPairs: // value for 'contractAddressNetworkPairs'
 *      ignore: // value for 'ignore'
 *   },
 * });
 */
export function useIgnoreTokensTransactionsAndReportAsSpamMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreTokensTransactionsAndReportAsSpamMutation, IgnoreTokensTransactionsAndReportAsSpamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreTokensTransactionsAndReportAsSpamMutation, IgnoreTokensTransactionsAndReportAsSpamMutationVariables>(IgnoreTokensTransactionsAndReportAsSpamDocument, options);
      }
export type IgnoreTokensTransactionsAndReportAsSpamMutationHookResult = ReturnType<typeof useIgnoreTokensTransactionsAndReportAsSpamMutation>;
export type IgnoreTokensTransactionsAndReportAsSpamMutationResult = Apollo.MutationResult<IgnoreTokensTransactionsAndReportAsSpamMutation>;
export type IgnoreTokensTransactionsAndReportAsSpamMutationOptions = Apollo.BaseMutationOptions<IgnoreTokensTransactionsAndReportAsSpamMutation, IgnoreTokensTransactionsAndReportAsSpamMutationVariables>;
export const GetWalletsAccountSyncDocument = gql`
    query GetWalletsAccountSync {
  localWallets {
    id
    imageUrl
    address
    name
    errors
  }
  exchanges {
    id
    imageUrl
    name
    errors
    syncInfo {
      isSyncing
      willBeDeleted
    }
  }
}
    `;

/**
 * __useGetWalletsAccountSyncQuery__
 *
 * To run a query within a React component, call `useGetWalletsAccountSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletsAccountSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletsAccountSyncQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletsAccountSyncQuery(baseOptions?: Apollo.QueryHookOptions<GetWalletsAccountSyncQuery, GetWalletsAccountSyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletsAccountSyncQuery, GetWalletsAccountSyncQueryVariables>(GetWalletsAccountSyncDocument, options);
      }
export function useGetWalletsAccountSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletsAccountSyncQuery, GetWalletsAccountSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletsAccountSyncQuery, GetWalletsAccountSyncQueryVariables>(GetWalletsAccountSyncDocument, options);
        }
export type GetWalletsAccountSyncQueryHookResult = ReturnType<typeof useGetWalletsAccountSyncQuery>;
export type GetWalletsAccountSyncLazyQueryHookResult = ReturnType<typeof useGetWalletsAccountSyncLazyQuery>;
export type GetWalletsAccountSyncQueryResult = Apollo.QueryResult<GetWalletsAccountSyncQuery, GetWalletsAccountSyncQueryVariables>;
export const GetBalanceDifferenceWalletsForReviewDocument = gql`
    query GetBalanceDifferenceWalletsForReview {
  localWallets {
    id
    imageUrl
    calculatedValue
    value
    balance
    calculatedBalance
    currency {
      name
      symbol
      type
      cmcId
      price
    }
    address
    name
    parentAccountName
    isBalanceDifferenceSignificant
    tokens {
      cryptoSymbol
      sanitizedCryptoSymbol
      currency {
        name
        symbol
        type
        cmcId
        price
      }
      parentAccountName
      balance
      calculatedBalance
      value
      calculatedValue
    }
    userAssetBalances {
      name
      sanitizedCryptoSymbol
      balance
      calculatedBalance
      value
      calculatedValue
      entryCount
      currency {
        symbol
        type
        cmcId
      }
    }
  }
  exchanges {
    id
    value
    calculatedValue
    imageUrl
    name
    defaultName
    type
    wallets {
      id
      imageUrl
      calculatedValue
      value
      balance
      calculatedBalance
      currency {
        name
        symbol
        type
        cmcId
        price
      }
      address
      name
      parentAccountName
      isBalanceDifferenceSignificant
    }
  }
  customWallets {
    id
  }
  otherTransactions {
    id
    value
  }
}
    `;

/**
 * __useGetBalanceDifferenceWalletsForReviewQuery__
 *
 * To run a query within a React component, call `useGetBalanceDifferenceWalletsForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalanceDifferenceWalletsForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalanceDifferenceWalletsForReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBalanceDifferenceWalletsForReviewQuery(baseOptions?: Apollo.QueryHookOptions<GetBalanceDifferenceWalletsForReviewQuery, GetBalanceDifferenceWalletsForReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalanceDifferenceWalletsForReviewQuery, GetBalanceDifferenceWalletsForReviewQueryVariables>(GetBalanceDifferenceWalletsForReviewDocument, options);
      }
export function useGetBalanceDifferenceWalletsForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalanceDifferenceWalletsForReviewQuery, GetBalanceDifferenceWalletsForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalanceDifferenceWalletsForReviewQuery, GetBalanceDifferenceWalletsForReviewQueryVariables>(GetBalanceDifferenceWalletsForReviewDocument, options);
        }
export type GetBalanceDifferenceWalletsForReviewQueryHookResult = ReturnType<typeof useGetBalanceDifferenceWalletsForReviewQuery>;
export type GetBalanceDifferenceWalletsForReviewLazyQueryHookResult = ReturnType<typeof useGetBalanceDifferenceWalletsForReviewLazyQuery>;
export type GetBalanceDifferenceWalletsForReviewQueryResult = Apollo.QueryResult<GetBalanceDifferenceWalletsForReviewQuery, GetBalanceDifferenceWalletsForReviewQueryVariables>;
export const GetSpamAssetsForReviewDocument = gql`
    query GetSpamAssetsForReview {
  spamAssets {
    contractAddress
    cryptoNetwork
    assetName
    sanitizedSymbol
    symbol
    assetType
    iconUrl
    isSpam
    wasAutomarkedAsSpam
  }
}
    `;

/**
 * __useGetSpamAssetsForReviewQuery__
 *
 * To run a query within a React component, call `useGetSpamAssetsForReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpamAssetsForReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpamAssetsForReviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSpamAssetsForReviewQuery(baseOptions?: Apollo.QueryHookOptions<GetSpamAssetsForReviewQuery, GetSpamAssetsForReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpamAssetsForReviewQuery, GetSpamAssetsForReviewQueryVariables>(GetSpamAssetsForReviewDocument, options);
      }
export function useGetSpamAssetsForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpamAssetsForReviewQuery, GetSpamAssetsForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpamAssetsForReviewQuery, GetSpamAssetsForReviewQueryVariables>(GetSpamAssetsForReviewDocument, options);
        }
export type GetSpamAssetsForReviewQueryHookResult = ReturnType<typeof useGetSpamAssetsForReviewQuery>;
export type GetSpamAssetsForReviewLazyQueryHookResult = ReturnType<typeof useGetSpamAssetsForReviewLazyQuery>;
export type GetSpamAssetsForReviewQueryResult = Apollo.QueryResult<GetSpamAssetsForReviewQuery, GetSpamAssetsForReviewQueryVariables>;
export const GetHoldingsDocument = gql`
    query GetHoldings($taxYear: Int!) {
  portfolio(performanceDuration: ALL_TIME) {
    hasAccessToPerformanceByCrypto
    currencies {
      currency {
        uaid
        slug
        type
        cmcId
        symbol
        name
        iconUrlFromInfo
      }
      quantity
      marketValue
      costBasis
      averageCostBasis
      allTimeReturn
      allTimeReturnPercent
      totalReturnOnInvestment
      totalReturnOnInvestmentPercent
    }
  }
  taxSummary(taxYear: $taxYear) {
    shortTermGain
    longTermGain
  }
}
    `;

/**
 * __useGetHoldingsQuery__
 *
 * To run a query within a React component, call `useGetHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHoldingsQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useGetHoldingsQuery(baseOptions: Apollo.QueryHookOptions<GetHoldingsQuery, GetHoldingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHoldingsQuery, GetHoldingsQueryVariables>(GetHoldingsDocument, options);
      }
export function useGetHoldingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHoldingsQuery, GetHoldingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHoldingsQuery, GetHoldingsQueryVariables>(GetHoldingsDocument, options);
        }
export type GetHoldingsQueryHookResult = ReturnType<typeof useGetHoldingsQuery>;
export type GetHoldingsLazyQueryHookResult = ReturnType<typeof useGetHoldingsLazyQuery>;
export type GetHoldingsQueryResult = Apollo.QueryResult<GetHoldingsQuery, GetHoldingsQueryVariables>;
export const GetLocalWalletsDocument = gql`
    query GetLocalWallets {
  localWallets {
    id
    address
    currency {
      symbol
    }
  }
}
    `;

/**
 * __useGetLocalWalletsQuery__
 *
 * To run a query within a React component, call `useGetLocalWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalWalletsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocalWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocalWalletsQuery, GetLocalWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalWalletsQuery, GetLocalWalletsQueryVariables>(GetLocalWalletsDocument, options);
      }
export function useGetLocalWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalWalletsQuery, GetLocalWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalWalletsQuery, GetLocalWalletsQueryVariables>(GetLocalWalletsDocument, options);
        }
export type GetLocalWalletsQueryHookResult = ReturnType<typeof useGetLocalWalletsQuery>;
export type GetLocalWalletsLazyQueryHookResult = ReturnType<typeof useGetLocalWalletsLazyQuery>;
export type GetLocalWalletsQueryResult = Apollo.QueryResult<GetLocalWalletsQuery, GetLocalWalletsQueryVariables>;
export const GetTaxImpactDocument = gql`
    query GetTaxImpact($outflowQuantity: Float!, $outflowAssetSymbol: String!, $outflowChain: String!, $outflowAssetContractAddress: String, $outflowWalletAddress: String!, $inflowQuantity: Float!, $inflowAssetSymbol: String!, $inflowAssetContractAddress: String, $inflowWalletAddress: String!, $inflowChain: String!, $fees: [SwapFeeInput]!) {
  taxImpactPreview(
    outflowQuantity: $outflowQuantity
    outflowAssetSymbol: $outflowAssetSymbol
    outflowChain: $outflowChain
    outflowAssetContractAddress: $outflowAssetContractAddress
    outflowWalletAddress: $outflowWalletAddress
    inflowQuantity: $inflowQuantity
    inflowAssetSymbol: $inflowAssetSymbol
    inflowAssetContractAddress: $inflowAssetContractAddress
    inflowWalletAddress: $inflowWalletAddress
    inflowChain: $inflowChain
    fees: $fees
  ) {
    gainLoss
    gainLossPercentage
    costBasis
    tradeProceeds
    totalShortTermGain
    totalLongTermGain
    totalShortTermEstimatedTaxes
    totalLongTermEstimatedTaxes
    estimatedTaxSavings
  }
}
    `;

/**
 * __useGetTaxImpactQuery__
 *
 * To run a query within a React component, call `useGetTaxImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxImpactQuery({
 *   variables: {
 *      outflowQuantity: // value for 'outflowQuantity'
 *      outflowAssetSymbol: // value for 'outflowAssetSymbol'
 *      outflowChain: // value for 'outflowChain'
 *      outflowAssetContractAddress: // value for 'outflowAssetContractAddress'
 *      outflowWalletAddress: // value for 'outflowWalletAddress'
 *      inflowQuantity: // value for 'inflowQuantity'
 *      inflowAssetSymbol: // value for 'inflowAssetSymbol'
 *      inflowAssetContractAddress: // value for 'inflowAssetContractAddress'
 *      inflowWalletAddress: // value for 'inflowWalletAddress'
 *      inflowChain: // value for 'inflowChain'
 *      fees: // value for 'fees'
 *   },
 * });
 */
export function useGetTaxImpactQuery(baseOptions: Apollo.QueryHookOptions<GetTaxImpactQuery, GetTaxImpactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxImpactQuery, GetTaxImpactQueryVariables>(GetTaxImpactDocument, options);
      }
export function useGetTaxImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxImpactQuery, GetTaxImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxImpactQuery, GetTaxImpactQueryVariables>(GetTaxImpactDocument, options);
        }
export type GetTaxImpactQueryHookResult = ReturnType<typeof useGetTaxImpactQuery>;
export type GetTaxImpactLazyQueryHookResult = ReturnType<typeof useGetTaxImpactLazyQuery>;
export type GetTaxImpactQueryResult = Apollo.QueryResult<GetTaxImpactQuery, GetTaxImpactQueryVariables>;
export const GetTaxLossHarvestForSwapDocument = gql`
    query GetTaxLossHarvestForSwap($forSwapPreview: Boolean!) {
  taxLossHarvest(forSwapPreview: $forSwapPreview) {
    hasAccess
    taxLossTotals {
      absUnrealizedLoss
      potentialSavings
    }
    taxLossInfoList {
      cryptoCmcId
      cryptoName
      cryptoSymbol
      cryptoSlug
      cryptoContractAddress
      holdings
      marketValue
      costBasis
      absUnrealizedLoss
      potentialSavings
      wallet {
        id
        name
        imageUrl
        parentAccountId
        parentAccountName
        parentAccountImageUrl
        walletNetwork
      }
      customWallet {
        id
        name
      }
    }
  }
  taxSummary {
    calloutCountInsufficientQuantity
    calloutCountMissingPriceHistory
    taxStartDate
    taxEndDate
    taxYearTitle
    taxYearLabel
    capitalGain
    capitalGainWithoutSymbol
    totalGains
    totalLosses
    shortTermGain
    longTermGain
  }
  userInfo {
    publicId
    costBasisMethodTimeline {
      userCostBasisSettings {
        costBasisMethod {
          shortName
          longName
        }
        endDate
        startDate
      }
    }
    costBasisByWallet
    baseCurrency {
      type
      symbol
    }
  }
}
    `;

/**
 * __useGetTaxLossHarvestForSwapQuery__
 *
 * To run a query within a React component, call `useGetTaxLossHarvestForSwapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxLossHarvestForSwapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxLossHarvestForSwapQuery({
 *   variables: {
 *      forSwapPreview: // value for 'forSwapPreview'
 *   },
 * });
 */
export function useGetTaxLossHarvestForSwapQuery(baseOptions: Apollo.QueryHookOptions<GetTaxLossHarvestForSwapQuery, GetTaxLossHarvestForSwapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxLossHarvestForSwapQuery, GetTaxLossHarvestForSwapQueryVariables>(GetTaxLossHarvestForSwapDocument, options);
      }
export function useGetTaxLossHarvestForSwapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxLossHarvestForSwapQuery, GetTaxLossHarvestForSwapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxLossHarvestForSwapQuery, GetTaxLossHarvestForSwapQueryVariables>(GetTaxLossHarvestForSwapDocument, options);
        }
export type GetTaxLossHarvestForSwapQueryHookResult = ReturnType<typeof useGetTaxLossHarvestForSwapQuery>;
export type GetTaxLossHarvestForSwapLazyQueryHookResult = ReturnType<typeof useGetTaxLossHarvestForSwapLazyQuery>;
export type GetTaxLossHarvestForSwapQueryResult = Apollo.QueryResult<GetTaxLossHarvestForSwapQuery, GetTaxLossHarvestForSwapQueryVariables>;
export const FreezeUserDocument = gql`
    mutation freezeUser($year: Int!) {
  freezeUser(year: $year) {
    success
  }
}
    `;
export type FreezeUserMutationFn = Apollo.MutationFunction<FreezeUserMutation, FreezeUserMutationVariables>;

/**
 * __useFreezeUserMutation__
 *
 * To run a mutation, you first call `useFreezeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreezeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freezeUserMutation, { data, loading, error }] = useFreezeUserMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useFreezeUserMutation(baseOptions?: Apollo.MutationHookOptions<FreezeUserMutation, FreezeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreezeUserMutation, FreezeUserMutationVariables>(FreezeUserDocument, options);
      }
export type FreezeUserMutationHookResult = ReturnType<typeof useFreezeUserMutation>;
export type FreezeUserMutationResult = Apollo.MutationResult<FreezeUserMutation>;
export type FreezeUserMutationOptions = Apollo.BaseMutationOptions<FreezeUserMutation, FreezeUserMutationVariables>;
export const UnfreezeUserDocument = gql`
    mutation unfreezeUser($year: Int!) {
  unfreezeUser(year: $year) {
    success
  }
}
    `;
export type UnfreezeUserMutationFn = Apollo.MutationFunction<UnfreezeUserMutation, UnfreezeUserMutationVariables>;

/**
 * __useUnfreezeUserMutation__
 *
 * To run a mutation, you first call `useUnfreezeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfreezeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfreezeUserMutation, { data, loading, error }] = useUnfreezeUserMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUnfreezeUserMutation(baseOptions?: Apollo.MutationHookOptions<UnfreezeUserMutation, UnfreezeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfreezeUserMutation, UnfreezeUserMutationVariables>(UnfreezeUserDocument, options);
      }
export type UnfreezeUserMutationHookResult = ReturnType<typeof useUnfreezeUserMutation>;
export type UnfreezeUserMutationResult = Apollo.MutationResult<UnfreezeUserMutation>;
export type UnfreezeUserMutationOptions = Apollo.BaseMutationOptions<UnfreezeUserMutation, UnfreezeUserMutationVariables>;
export const GenerateTaxReportDocument = gql`
    mutation GenerateTaxReport($reportType: TaxReportType, $taxYear: Int, $query: String = "", $startDate: Date, $endDate: Date) {
  generateTaxReport(
    reportType: $reportType
    taxYear: $taxYear
    query: $query
    startDate: $startDate
    endDate: $endDate
  ) {
    success
    message
    jobId
  }
}
    `;
export type GenerateTaxReportMutationFn = Apollo.MutationFunction<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>;

/**
 * __useGenerateTaxReportMutation__
 *
 * To run a mutation, you first call `useGenerateTaxReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaxReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaxReportMutation, { data, loading, error }] = useGenerateTaxReportMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      taxYear: // value for 'taxYear'
 *      query: // value for 'query'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGenerateTaxReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>(GenerateTaxReportDocument, options);
      }
export type GenerateTaxReportMutationHookResult = ReturnType<typeof useGenerateTaxReportMutation>;
export type GenerateTaxReportMutationResult = Apollo.MutationResult<GenerateTaxReportMutation>;
export type GenerateTaxReportMutationOptions = Apollo.BaseMutationOptions<GenerateTaxReportMutation, GenerateTaxReportMutationVariables>;
export const GetBuyModalDocument = gql`
    query GetBuyModal {
  availableUnifiedSubscriptionPlans {
    plans {
      name
      internalName
      description
      featureList
      transactionLimit
      lifetimeTransactionLimit
      hasSufficientTransactionLimit
      price {
        originalPrice
        finalPrice
        currencySymbol
        discount
        discountReason
      }
      plan
      isRecommended
      transactionCounts {
        totalTransactionCount
        lifetimeTransactionCount
        excludedStakingTransactionCount
        netTransactionCount
      }
    }
    transactionCountingYear
  }
  unifiedSubscription {
    subscriptionPlan
    billing {
      currentPeriodEnd
      cancelAtPeriodEnd
      renewalNeeded
    }
  }
  taxLossHarvest {
    taxLossTotals {
      potentialSavings
    }
  }
}
    `;

/**
 * __useGetBuyModalQuery__
 *
 * To run a query within a React component, call `useGetBuyModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBuyModalQuery(baseOptions?: Apollo.QueryHookOptions<GetBuyModalQuery, GetBuyModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuyModalQuery, GetBuyModalQueryVariables>(GetBuyModalDocument, options);
      }
export function useGetBuyModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyModalQuery, GetBuyModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuyModalQuery, GetBuyModalQueryVariables>(GetBuyModalDocument, options);
        }
export type GetBuyModalQueryHookResult = ReturnType<typeof useGetBuyModalQuery>;
export type GetBuyModalLazyQueryHookResult = ReturnType<typeof useGetBuyModalLazyQuery>;
export type GetBuyModalQueryResult = Apollo.QueryResult<GetBuyModalQuery, GetBuyModalQueryVariables>;
export const GetTaxPageDocument = gql`
    query GetTaxPage($taxYear: Int!) {
  taxYears {
    taxYear
    title
    dateRange
  }
  taxSummary(taxYear: $taxYear) {
    taxYear
    hasPlan
    taxPlan {
      planName
      startDate
      dynamicTransactionLimitLabel
      transactionLimit
      type
      isSufficient
      insufficientReason
      shouldRenew
      isUnified
      insufficientUnifiedPlanShortReason
      insufficientUnifiedPlanLongReason
      hasGeneratedTaxReport
    }
    errorsCount
    taxYearTitle
    taxYearLabel
    taxStartDate
    taxEndDate
    hasSufficientPlan
    capitalGain
    capitalGainWithoutSymbol
    longTermGain
    longTermCostBasis
    longTermProceeds
    shortTermGain
    shortTermCostBasis
    shortTermProceeds
    shortTermCryptoToCryptoGain
    longTermCryptoToCryptoGain
    shortTermOtherGain
    longTermOtherGain
    totalGains
    totalLosses
    numberOfDisposals
    shortTermLosses
    totalCostBasis
    totalCapitalGains
    totalProceeds
    totalShortTermLosses
    totalShortTermGains
    incomeSalary
    incomeFork
    incomeMining
    incomeAirdrops
    incomeStaking
    incomeInterest
    incomeOther
    incomeRoyalty
    totalGifts
    totalDonations
    donationShortTerm
    donationLongTerm
    netFuturesGains
    totalMarginFees
    totalInterestExpense
    taxStartDate
    taxEndDate
    taxIncome
    transactionCount
    freeTransactionsCount
    sendsCount
    receivesCount
    calloutCountInsufficientQuantity
    calloutCountMissingPriceHistory
    calloutCountMissingBalance
    taxableIncomeTotal
    otherCategoriesTotal
    taxSummaryByAccounts {
      name
      gains
      transactionsCount
    }
    taxSummaryByWallets {
      name
      gains
      transactionsCount
    }
    taxSummaryByCustomWallets {
      name
      gains
      transactionsCount
    }
    taxSummaryByForeignAccounts {
      name
      gains
      transactionsCount
    }
    taxReports {
      irsForm8949
      condensedIrsForm8949
      irsScheduleDForm1040
      irsSchedule1Form1040
      craSchedule3
      selfFileWithCointracker
      hAndRBlock
      turboTaxOnlineSync
      turbotaxOnline
      taxcaddy8949
      taxcaddySchedule1
      turbotaxCdDownload
      taxactFile
      woltersKluwerCchFile
      transactionHistoryCsv
      capitalGainsCsv
      eoyTaxLotsReport
      wisoCsv
      incomeCsvReport
      anlageSoReport
    }
    taxConstants {
      faqUrl
      taxFormUrl
      taxInstructionsUrl
      fileOnlineUrl
    }
    taxItems {
      name
      amount
      value
      transactionsCount
      isTaxable
      isTaxableNow
      taxEvent
    }
  }
  unifiedSubscription {
    recommendedPlanForTax {
      internalName
      name
      featureList
      transactionLimit
      lifetimeTransactionLimit
      transactionCounts {
        totalTransactionCount
        lifetimeTransactionCount
        excludedStakingTransactionCount
        netTransactionCount
      }
      hasSufficientTransactionLimit
      isRecommended
      plan
      price {
        originalPrice
        discount
        discountReason
        finalPrice
        currencySymbol
      }
    }
    subscriptionPlanName
    subscriptionPlan
    transactionLimit
    lifetimeTransactionLimit
    transactionCounts {
      totalTransactionCount
      lifetimeTransactionCount
      excludedStakingTransactionCount
      netTransactionCount
    }
  }
  availableUnifiedSubscriptionPlans {
    plans {
      internalName
      name
      price {
        finalPrice
      }
    }
    transactionCountingYear
  }
  userInfo {
    publicId
    costBasisMethodDetails {
      enumValue
      shortName
      niceName
      breakoutByDateAcquired
    }
    costBasisByWallet
    costBasisPaused
    costBasisMethodTimeline {
      userCostBasisSettings {
        costBasisMethod {
          enumValue
          shortName
          niceName
        }
        startDate
        endDate
      }
    }
    baseCurrency {
      cmcId
      type
      symbol
      formatSymbol
      priceUsd
      name
    }
    country {
      code
      name
      canAccessTaxLossHarvesting
    }
    publicId
  }
  userStats {
    numberOfExchanges
    numberOfLocalWallets
    numberOfCustomWallets
  }
}
    `;

/**
 * __useGetTaxPageQuery__
 *
 * To run a query within a React component, call `useGetTaxPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxPageQuery({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useGetTaxPageQuery(baseOptions: Apollo.QueryHookOptions<GetTaxPageQuery, GetTaxPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxPageQuery, GetTaxPageQueryVariables>(GetTaxPageDocument, options);
      }
export function useGetTaxPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxPageQuery, GetTaxPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxPageQuery, GetTaxPageQueryVariables>(GetTaxPageDocument, options);
        }
export type GetTaxPageQueryHookResult = ReturnType<typeof useGetTaxPageQuery>;
export type GetTaxPageLazyQueryHookResult = ReturnType<typeof useGetTaxPageLazyQuery>;
export type GetTaxPageQueryResult = Apollo.QueryResult<GetTaxPageQuery, GetTaxPageQueryVariables>;
export const PollTaxReportDocument = gql`
    query pollTaxReport($jobId: String!) {
  taxReportPollResult(jobId: $jobId) {
    success
    ready
    url
  }
}
    `;

/**
 * __usePollTaxReportQuery__
 *
 * To run a query within a React component, call `usePollTaxReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollTaxReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollTaxReportQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function usePollTaxReportQuery(baseOptions: Apollo.QueryHookOptions<PollTaxReportQuery, PollTaxReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollTaxReportQuery, PollTaxReportQueryVariables>(PollTaxReportDocument, options);
      }
export function usePollTaxReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollTaxReportQuery, PollTaxReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollTaxReportQuery, PollTaxReportQueryVariables>(PollTaxReportDocument, options);
        }
export type PollTaxReportQueryHookResult = ReturnType<typeof usePollTaxReportQuery>;
export type PollTaxReportLazyQueryHookResult = ReturnType<typeof usePollTaxReportLazyQuery>;
export type PollTaxReportQueryResult = Apollo.QueryResult<PollTaxReportQuery, PollTaxReportQueryVariables>;
export const RequestTaxRecalculationDocument = gql`
    mutation RequestTaxRecalculation {
  requestTaxRecalculation {
    success
  }
}
    `;
export type RequestTaxRecalculationMutationFn = Apollo.MutationFunction<RequestTaxRecalculationMutation, RequestTaxRecalculationMutationVariables>;

/**
 * __useRequestTaxRecalculationMutation__
 *
 * To run a mutation, you first call `useRequestTaxRecalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTaxRecalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTaxRecalculationMutation, { data, loading, error }] = useRequestTaxRecalculationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestTaxRecalculationMutation(baseOptions?: Apollo.MutationHookOptions<RequestTaxRecalculationMutation, RequestTaxRecalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTaxRecalculationMutation, RequestTaxRecalculationMutationVariables>(RequestTaxRecalculationDocument, options);
      }
export type RequestTaxRecalculationMutationHookResult = ReturnType<typeof useRequestTaxRecalculationMutation>;
export type RequestTaxRecalculationMutationResult = Apollo.MutationResult<RequestTaxRecalculationMutation>;
export type RequestTaxRecalculationMutationOptions = Apollo.BaseMutationOptions<RequestTaxRecalculationMutation, RequestTaxRecalculationMutationVariables>;
export const UpdateLastUsedTaxYearDocument = gql`
    mutation UpdateLastUsedTaxYear($taxYear: Int!) {
  updateLastUsedTaxYear(taxYear: $taxYear) {
    success
  }
}
    `;
export type UpdateLastUsedTaxYearMutationFn = Apollo.MutationFunction<UpdateLastUsedTaxYearMutation, UpdateLastUsedTaxYearMutationVariables>;

/**
 * __useUpdateLastUsedTaxYearMutation__
 *
 * To run a mutation, you first call `useUpdateLastUsedTaxYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastUsedTaxYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastUsedTaxYearMutation, { data, loading, error }] = useUpdateLastUsedTaxYearMutation({
 *   variables: {
 *      taxYear: // value for 'taxYear'
 *   },
 * });
 */
export function useUpdateLastUsedTaxYearMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastUsedTaxYearMutation, UpdateLastUsedTaxYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastUsedTaxYearMutation, UpdateLastUsedTaxYearMutationVariables>(UpdateLastUsedTaxYearDocument, options);
      }
export type UpdateLastUsedTaxYearMutationHookResult = ReturnType<typeof useUpdateLastUsedTaxYearMutation>;
export type UpdateLastUsedTaxYearMutationResult = Apollo.MutationResult<UpdateLastUsedTaxYearMutation>;
export type UpdateLastUsedTaxYearMutationOptions = Apollo.BaseMutationOptions<UpdateLastUsedTaxYearMutation, UpdateLastUsedTaxYearMutationVariables>;
export const GetTaxLossHarvestDocument = gql`
    query GetTaxLossHarvest {
  taxLossHarvest {
    hasAccess
    taxLossTotals {
      potentialSavings
      absUnrealizedLoss
    }
    taxYear
    taxLossInfoList {
      cryptoCmcId
      cryptoName
      cryptoSymbol
      cryptoSlug
      cryptoContractAddress
      holdings
      marketValue
      costBasis
      absUnrealizedLoss
      potentialSavings
      wallet {
        id
        name
        imageUrl
        parentAccountId
        parentAccountName
        parentAccountImageUrl
        walletNetwork
      }
      customWallet {
        id
        name
      }
    }
  }
  taxSummary {
    calloutCountInsufficientQuantity
    calloutCountMissingPriceHistory
    taxStartDate
    taxEndDate
    taxYearTitle
    taxYearLabel
    capitalGain
    capitalGainWithoutSymbol
    totalGains
    totalLosses
    shortTermGain
    longTermGain
  }
  userInfo {
    publicId
    costBasisMethodDetails {
      shortName
      niceName
      longName
    }
    costBasisMethodTimeline {
      userCostBasisSettings {
        costBasisMethod {
          shortName
          longName
        }
        endDate
        startDate
      }
    }
    costBasisByWallet
    baseCurrency {
      type
      symbol
    }
    country {
      code
      name
      canAccessTaxLossHarvesting
    }
  }
}
    `;

/**
 * __useGetTaxLossHarvestQuery__
 *
 * To run a query within a React component, call `useGetTaxLossHarvestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxLossHarvestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxLossHarvestQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxLossHarvestQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxLossHarvestQuery, GetTaxLossHarvestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxLossHarvestQuery, GetTaxLossHarvestQueryVariables>(GetTaxLossHarvestDocument, options);
      }
export function useGetTaxLossHarvestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxLossHarvestQuery, GetTaxLossHarvestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxLossHarvestQuery, GetTaxLossHarvestQueryVariables>(GetTaxLossHarvestDocument, options);
        }
export type GetTaxLossHarvestQueryHookResult = ReturnType<typeof useGetTaxLossHarvestQuery>;
export type GetTaxLossHarvestLazyQueryHookResult = ReturnType<typeof useGetTaxLossHarvestLazyQuery>;
export type GetTaxLossHarvestQueryResult = Apollo.QueryResult<GetTaxLossHarvestQuery, GetTaxLossHarvestQueryVariables>;
export const GenerateTaxLotsCsvDocument = gql`
    mutation GenerateTaxLotsCsv($query: String = "") {
  generateTaxLotsCsv(query: $query) {
    success
    message
    jobId
  }
}
    `;
export type GenerateTaxLotsCsvMutationFn = Apollo.MutationFunction<GenerateTaxLotsCsvMutation, GenerateTaxLotsCsvMutationVariables>;

/**
 * __useGenerateTaxLotsCsvMutation__
 *
 * To run a mutation, you first call `useGenerateTaxLotsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTaxLotsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTaxLotsCsvMutation, { data, loading, error }] = useGenerateTaxLotsCsvMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGenerateTaxLotsCsvMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTaxLotsCsvMutation, GenerateTaxLotsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTaxLotsCsvMutation, GenerateTaxLotsCsvMutationVariables>(GenerateTaxLotsCsvDocument, options);
      }
export type GenerateTaxLotsCsvMutationHookResult = ReturnType<typeof useGenerateTaxLotsCsvMutation>;
export type GenerateTaxLotsCsvMutationResult = Apollo.MutationResult<GenerateTaxLotsCsvMutation>;
export type GenerateTaxLotsCsvMutationOptions = Apollo.BaseMutationOptions<GenerateTaxLotsCsvMutation, GenerateTaxLotsCsvMutationVariables>;
export const GetCostBasisMethodDetailsDocument = gql`
    query GetCostBasisMethodDetails {
  taxSummary {
    calloutCountInsufficientQuantity
    calloutCountMissingPriceHistory
    taxStartDate
    taxEndDate
  }
  userInfo {
    publicId
    costBasisMethodDetails {
      enumValue
      shortName
      niceName
      longName
    }
    costBasisMethodTimeline {
      userCostBasisSettings {
        costBasisMethod {
          longName
          shortName
        }
        endDate
        startDate
      }
    }
  }
}
    `;

/**
 * __useGetCostBasisMethodDetailsQuery__
 *
 * To run a query within a React component, call `useGetCostBasisMethodDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostBasisMethodDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostBasisMethodDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCostBasisMethodDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetCostBasisMethodDetailsQuery, GetCostBasisMethodDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostBasisMethodDetailsQuery, GetCostBasisMethodDetailsQueryVariables>(GetCostBasisMethodDetailsDocument, options);
      }
export function useGetCostBasisMethodDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostBasisMethodDetailsQuery, GetCostBasisMethodDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostBasisMethodDetailsQuery, GetCostBasisMethodDetailsQueryVariables>(GetCostBasisMethodDetailsDocument, options);
        }
export type GetCostBasisMethodDetailsQueryHookResult = ReturnType<typeof useGetCostBasisMethodDetailsQuery>;
export type GetCostBasisMethodDetailsLazyQueryHookResult = ReturnType<typeof useGetCostBasisMethodDetailsLazyQuery>;
export type GetCostBasisMethodDetailsQueryResult = Apollo.QueryResult<GetCostBasisMethodDetailsQuery, GetCostBasisMethodDetailsQueryVariables>;
export const GetCurrencyForTaxLotsPageDocument = gql`
    query GetCurrencyForTaxLotsPage($query: String = "") {
  currency(query: $query) {
    name
    symbol
    slug
    cmcId
    isInWatchlist
  }
}
    `;

/**
 * __useGetCurrencyForTaxLotsPageQuery__
 *
 * To run a query within a React component, call `useGetCurrencyForTaxLotsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyForTaxLotsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyForTaxLotsPageQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetCurrencyForTaxLotsPageQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyForTaxLotsPageQuery, GetCurrencyForTaxLotsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyForTaxLotsPageQuery, GetCurrencyForTaxLotsPageQueryVariables>(GetCurrencyForTaxLotsPageDocument, options);
      }
export function useGetCurrencyForTaxLotsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyForTaxLotsPageQuery, GetCurrencyForTaxLotsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyForTaxLotsPageQuery, GetCurrencyForTaxLotsPageQueryVariables>(GetCurrencyForTaxLotsPageDocument, options);
        }
export type GetCurrencyForTaxLotsPageQueryHookResult = ReturnType<typeof useGetCurrencyForTaxLotsPageQuery>;
export type GetCurrencyForTaxLotsPageLazyQueryHookResult = ReturnType<typeof useGetCurrencyForTaxLotsPageLazyQuery>;
export type GetCurrencyForTaxLotsPageQueryResult = Apollo.QueryResult<GetCurrencyForTaxLotsPageQuery, GetCurrencyForTaxLotsPageQueryVariables>;
export const TaxLotsDocument = gql`
    query TaxLots($assetIdentifier: String!, $assetType: String!, $offset: Int, $limit: Int, $walletPublicGid: String, $walletAddress: String, $walletChain: String, $sortBy: String, $desc: Boolean, $forSwapPreview: Boolean) {
  availableLotsData(
    assetIdentifier: $assetIdentifier
    assetType: $assetType
    limit: $limit
    offset: $offset
    sortBy: $sortBy
    desc: $desc
    walletPublicGid: $walletPublicGid
    walletAddress: $walletAddress
    walletChain: $walletChain
    forSwapPreview: $forSwapPreview
  ) {
    totalCount
    hasAccess
    availableLots {
      asset {
        id
        type
        symbol
        name
      }
      orderToSell
      dateAcquired
      walletName
      quantity
      adjustedCostBasis
      adjustedCostBasisPerUnit
      marketValue
      marketValuePerUnit
      holdingPeriod
      gainLossAmount
      gainLossPercent
      coveredState
      acquisitionTransactionId
    }
  }
}
    `;

/**
 * __useTaxLotsQuery__
 *
 * To run a query within a React component, call `useTaxLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxLotsQuery({
 *   variables: {
 *      assetIdentifier: // value for 'assetIdentifier'
 *      assetType: // value for 'assetType'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      walletPublicGid: // value for 'walletPublicGid'
 *      walletAddress: // value for 'walletAddress'
 *      walletChain: // value for 'walletChain'
 *      sortBy: // value for 'sortBy'
 *      desc: // value for 'desc'
 *      forSwapPreview: // value for 'forSwapPreview'
 *   },
 * });
 */
export function useTaxLotsQuery(baseOptions: Apollo.QueryHookOptions<TaxLotsQuery, TaxLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxLotsQuery, TaxLotsQueryVariables>(TaxLotsDocument, options);
      }
export function useTaxLotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxLotsQuery, TaxLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxLotsQuery, TaxLotsQueryVariables>(TaxLotsDocument, options);
        }
export type TaxLotsQueryHookResult = ReturnType<typeof useTaxLotsQuery>;
export type TaxLotsLazyQueryHookResult = ReturnType<typeof useTaxLotsLazyQuery>;
export type TaxLotsQueryResult = Apollo.QueryResult<TaxLotsQuery, TaxLotsQueryVariables>;
export const PollTaxLotsCsvDocument = gql`
    query pollTaxLotsCsv($jobId: String!) {
  taxLotsCsvPollResult(jobId: $jobId) {
    success
    ready
    url
  }
}
    `;

/**
 * __usePollTaxLotsCsvQuery__
 *
 * To run a query within a React component, call `usePollTaxLotsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollTaxLotsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollTaxLotsCsvQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function usePollTaxLotsCsvQuery(baseOptions: Apollo.QueryHookOptions<PollTaxLotsCsvQuery, PollTaxLotsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PollTaxLotsCsvQuery, PollTaxLotsCsvQueryVariables>(PollTaxLotsCsvDocument, options);
      }
export function usePollTaxLotsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PollTaxLotsCsvQuery, PollTaxLotsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PollTaxLotsCsvQuery, PollTaxLotsCsvQueryVariables>(PollTaxLotsCsvDocument, options);
        }
export type PollTaxLotsCsvQueryHookResult = ReturnType<typeof usePollTaxLotsCsvQuery>;
export type PollTaxLotsCsvLazyQueryHookResult = ReturnType<typeof usePollTaxLotsCsvLazyQuery>;
export type PollTaxLotsCsvQueryResult = Apollo.QueryResult<PollTaxLotsCsvQuery, PollTaxLotsCsvQueryVariables>;
export const GetWalletsDocument = gql`
    query GetWallets {
  localWallets {
    id
    currency {
      symbol
      type
      cmcId
    }
    address
    name
    uaid
  }
  exchanges {
    id
    name
    imageUrl
    wallets {
      id
      name
      currency {
        symbol
        type
        cmcId
      }
      uaid
    }
  }
  customWallets {
    id
    name
  }
}
    `;

/**
 * __useGetWalletsQuery__
 *
 * To run a query within a React component, call `useGetWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetWalletsQuery, GetWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletsQuery, GetWalletsQueryVariables>(GetWalletsDocument, options);
      }
export function useGetWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletsQuery, GetWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletsQuery, GetWalletsQueryVariables>(GetWalletsDocument, options);
        }
export type GetWalletsQueryHookResult = ReturnType<typeof useGetWalletsQuery>;
export type GetWalletsLazyQueryHookResult = ReturnType<typeof useGetWalletsLazyQuery>;
export type GetWalletsQueryResult = Apollo.QueryResult<GetWalletsQuery, GetWalletsQueryVariables>;
export const CreateTransactionDocument = gql`
    mutation createTransaction($transaction: TransactionNodeInput!) {
  createTransaction(transaction: $transaction) {
    success
    error
  }
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      transaction: // value for 'transaction'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const GetTransactionDocument = gql`
    query GetTransaction($publicId: String = "") {
  transaction(publicId: $publicId) {
    publicId
    transactionType
    transactionRowType
    transactionFrom {
      label
      walletId
      walletType
      currency {
        symbol
        cmcId
        type
      }
      address
    }
    transactionTo {
      label
      walletId
      walletType
      currency {
        symbol
        cmcId
        type
      }
      address
    }
    dateTime
    canEditCostBasis
    canEditProceeds
    transactionBalances {
      walletLabel
      assetSymbol
      balanceAfter
    }
    credits {
      publicId
      amount
      balanceAfter
      fiatValue
      perCoinValue
      relatedEntrySymbol
      symbol
      isNft
      type
      iconUrl
      costBasis
      comments
      notes
      transactionUrl
      transactionHash
      fee {
        amount
        fiatValue
        symbol
        uaid
        type
        profitOrLoss
        costBasis
        iconUrl
      }
      isIgnored
      hasCustomCostBasis
      hasCustomProceeds
      currencyId
      currencyIdType
      feeCurrencyId
      feeCurrencyIdType
      uaid
    }
    debits {
      publicId
      amount
      balanceAfter
      fiatValue
      perCoinValue
      relatedEntrySymbol
      symbol
      isNft
      type
      iconUrl
      profitOrLoss
      costBasis
      comments
      notes
      transactionUrl
      transactionHash
      fee {
        amount
        fiatValue
        symbol
        type
        uaid
        profitOrLoss
        costBasis
        iconUrl
      }
      isIgnored
      hasCustomCostBasis
      hasCustomProceeds
      currencyId
      currencyIdType
      feeCurrencyId
      feeCurrencyIdType
      uaid
    }
    markLabels
    unmarkLabels
    isManual
    isIgnored
    hasAtleastOneDeletableEntry
    hasAllDeletableEntries
  }
}
    `;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetTransactionQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  userInfo {
    publicId
    baseCurrency {
      type
      symbol
      priceUsd
    }
    closedPeriodDatetime
  }
}
    `;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoQueryResult = Apollo.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const UpdateTransactionDocument = gql`
    mutation updateTransaction($transaction: TransactionNodeInput!) {
  updateTransaction(transaction: $transaction) {
    success
    error
  }
}
    `;
export type UpdateTransactionMutationFn = Apollo.MutationFunction<UpdateTransactionMutation, UpdateTransactionMutationVariables>;

/**
 * __useUpdateTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionMutation, { data, loading, error }] = useUpdateTransactionMutation({
 *   variables: {
 *      transaction: // value for 'transaction'
 *   },
 * });
 */
export function useUpdateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionMutation, UpdateTransactionMutationVariables>(UpdateTransactionDocument, options);
      }
export type UpdateTransactionMutationHookResult = ReturnType<typeof useUpdateTransactionMutation>;
export type UpdateTransactionMutationResult = Apollo.MutationResult<UpdateTransactionMutation>;
export type UpdateTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>;
export const GetTransactionsCsvDocument = gql`
    query getTransactionsCsv($userId: String!, $query: String = "") {
  transactionsCsv(userId: $userId, query: $query) {
    success
    message
  }
}
    `;

/**
 * __useGetTransactionsCsvQuery__
 *
 * To run a query within a React component, call `useGetTransactionsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsCsvQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetTransactionsCsvQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsCsvQuery, GetTransactionsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsCsvQuery, GetTransactionsCsvQueryVariables>(GetTransactionsCsvDocument, options);
      }
export function useGetTransactionsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsCsvQuery, GetTransactionsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsCsvQuery, GetTransactionsCsvQueryVariables>(GetTransactionsCsvDocument, options);
        }
export type GetTransactionsCsvQueryHookResult = ReturnType<typeof useGetTransactionsCsvQuery>;
export type GetTransactionsCsvLazyQueryHookResult = ReturnType<typeof useGetTransactionsCsvLazyQuery>;
export type GetTransactionsCsvQueryResult = Apollo.QueryResult<GetTransactionsCsvQuery, GetTransactionsCsvQueryVariables>;
export const GetTransactionsCsvPollDocument = gql`
    query getTransactionsCsvPoll($userId: String!) {
  transactionsCsvPoll(userId: $userId) {
    ready
    success
    url
  }
}
    `;

/**
 * __useGetTransactionsCsvPollQuery__
 *
 * To run a query within a React component, call `useGetTransactionsCsvPollQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsCsvPollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsCsvPollQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTransactionsCsvPollQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsCsvPollQuery, GetTransactionsCsvPollQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsCsvPollQuery, GetTransactionsCsvPollQueryVariables>(GetTransactionsCsvPollDocument, options);
      }
export function useGetTransactionsCsvPollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsCsvPollQuery, GetTransactionsCsvPollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsCsvPollQuery, GetTransactionsCsvPollQueryVariables>(GetTransactionsCsvPollDocument, options);
        }
export type GetTransactionsCsvPollQueryHookResult = ReturnType<typeof useGetTransactionsCsvPollQuery>;
export type GetTransactionsCsvPollLazyQueryHookResult = ReturnType<typeof useGetTransactionsCsvPollLazyQuery>;
export type GetTransactionsCsvPollQueryResult = Apollo.QueryResult<GetTransactionsCsvPollQuery, GetTransactionsCsvPollQueryVariables>;
export const UpdateTransactionIgnoredStatusDocument = gql`
    mutation UpdateTransactionIgnoredStatus($entryId: String!, $enable: Boolean!) {
  updateTransactionActiveStatus(entryId: $entryId, enable: $enable) {
    success
    message
  }
}
    `;
export type UpdateTransactionIgnoredStatusMutationFn = Apollo.MutationFunction<UpdateTransactionIgnoredStatusMutation, UpdateTransactionIgnoredStatusMutationVariables>;

/**
 * __useUpdateTransactionIgnoredStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionIgnoredStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionIgnoredStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionIgnoredStatusMutation, { data, loading, error }] = useUpdateTransactionIgnoredStatusMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useUpdateTransactionIgnoredStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionIgnoredStatusMutation, UpdateTransactionIgnoredStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionIgnoredStatusMutation, UpdateTransactionIgnoredStatusMutationVariables>(UpdateTransactionIgnoredStatusDocument, options);
      }
export type UpdateTransactionIgnoredStatusMutationHookResult = ReturnType<typeof useUpdateTransactionIgnoredStatusMutation>;
export type UpdateTransactionIgnoredStatusMutationResult = Apollo.MutationResult<UpdateTransactionIgnoredStatusMutation>;
export type UpdateTransactionIgnoredStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionIgnoredStatusMutation, UpdateTransactionIgnoredStatusMutationVariables>;
export const UpdateTransactionsIgnoredStatusDocument = gql`
    mutation UpdateTransactionsIgnoredStatus($entryIds: [String]!, $enable: Boolean!) {
  updateTransactionsActiveStatus(entryIds: $entryIds, enable: $enable) {
    successes
    messages
  }
}
    `;
export type UpdateTransactionsIgnoredStatusMutationFn = Apollo.MutationFunction<UpdateTransactionsIgnoredStatusMutation, UpdateTransactionsIgnoredStatusMutationVariables>;

/**
 * __useUpdateTransactionsIgnoredStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionsIgnoredStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionsIgnoredStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionsIgnoredStatusMutation, { data, loading, error }] = useUpdateTransactionsIgnoredStatusMutation({
 *   variables: {
 *      entryIds: // value for 'entryIds'
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useUpdateTransactionsIgnoredStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionsIgnoredStatusMutation, UpdateTransactionsIgnoredStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionsIgnoredStatusMutation, UpdateTransactionsIgnoredStatusMutationVariables>(UpdateTransactionsIgnoredStatusDocument, options);
      }
export type UpdateTransactionsIgnoredStatusMutationHookResult = ReturnType<typeof useUpdateTransactionsIgnoredStatusMutation>;
export type UpdateTransactionsIgnoredStatusMutationResult = Apollo.MutationResult<UpdateTransactionsIgnoredStatusMutation>;
export type UpdateTransactionsIgnoredStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionsIgnoredStatusMutation, UpdateTransactionsIgnoredStatusMutationVariables>;
export const UpdateTransactionsTaxabilityDocument = gql`
    mutation UpdateTransactionsTaxability($publicIds: [String]!, $taxable: Boolean!) {
  updateTransactionsTaxability(publicIds: $publicIds, taxable: $taxable) {
    success
    message
    error
  }
}
    `;
export type UpdateTransactionsTaxabilityMutationFn = Apollo.MutationFunction<UpdateTransactionsTaxabilityMutation, UpdateTransactionsTaxabilityMutationVariables>;

/**
 * __useUpdateTransactionsTaxabilityMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionsTaxabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionsTaxabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionsTaxabilityMutation, { data, loading, error }] = useUpdateTransactionsTaxabilityMutation({
 *   variables: {
 *      publicIds: // value for 'publicIds'
 *      taxable: // value for 'taxable'
 *   },
 * });
 */
export function useUpdateTransactionsTaxabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionsTaxabilityMutation, UpdateTransactionsTaxabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionsTaxabilityMutation, UpdateTransactionsTaxabilityMutationVariables>(UpdateTransactionsTaxabilityDocument, options);
      }
export type UpdateTransactionsTaxabilityMutationHookResult = ReturnType<typeof useUpdateTransactionsTaxabilityMutation>;
export type UpdateTransactionsTaxabilityMutationResult = Apollo.MutationResult<UpdateTransactionsTaxabilityMutation>;
export type UpdateTransactionsTaxabilityMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionsTaxabilityMutation, UpdateTransactionsTaxabilityMutationVariables>;
export const UpdateOperationsPurposeDocument = gql`
    mutation UpdateOperationsPurpose($operationIds: [String]!, $purpose: FrontendOperationPurpose!) {
  updateOperationPurpose(
    operationIds: $operationIds
    frontendOperationPurpose: $purpose
  ) {
    success
  }
}
    `;
export type UpdateOperationsPurposeMutationFn = Apollo.MutationFunction<UpdateOperationsPurposeMutation, UpdateOperationsPurposeMutationVariables>;

/**
 * __useUpdateOperationsPurposeMutation__
 *
 * To run a mutation, you first call `useUpdateOperationsPurposeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOperationsPurposeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOperationsPurposeMutation, { data, loading, error }] = useUpdateOperationsPurposeMutation({
 *   variables: {
 *      operationIds: // value for 'operationIds'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useUpdateOperationsPurposeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOperationsPurposeMutation, UpdateOperationsPurposeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOperationsPurposeMutation, UpdateOperationsPurposeMutationVariables>(UpdateOperationsPurposeDocument, options);
      }
export type UpdateOperationsPurposeMutationHookResult = ReturnType<typeof useUpdateOperationsPurposeMutation>;
export type UpdateOperationsPurposeMutationResult = Apollo.MutationResult<UpdateOperationsPurposeMutation>;
export type UpdateOperationsPurposeMutationOptions = Apollo.BaseMutationOptions<UpdateOperationsPurposeMutation, UpdateOperationsPurposeMutationVariables>;
export const EditCostBasisDocument = gql`
    mutation EditCostBasis($entryId: String!, $costBasis: PositiveFloat) {
  updateTransactionCostBasis(entryId: $entryId, costBasis: $costBasis) {
    success
    message
  }
}
    `;
export type EditCostBasisMutationFn = Apollo.MutationFunction<EditCostBasisMutation, EditCostBasisMutationVariables>;

/**
 * __useEditCostBasisMutation__
 *
 * To run a mutation, you first call `useEditCostBasisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCostBasisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCostBasisMutation, { data, loading, error }] = useEditCostBasisMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *      costBasis: // value for 'costBasis'
 *   },
 * });
 */
export function useEditCostBasisMutation(baseOptions?: Apollo.MutationHookOptions<EditCostBasisMutation, EditCostBasisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCostBasisMutation, EditCostBasisMutationVariables>(EditCostBasisDocument, options);
      }
export type EditCostBasisMutationHookResult = ReturnType<typeof useEditCostBasisMutation>;
export type EditCostBasisMutationResult = Apollo.MutationResult<EditCostBasisMutation>;
export type EditCostBasisMutationOptions = Apollo.BaseMutationOptions<EditCostBasisMutation, EditCostBasisMutationVariables>;
export const GetCostBasisDocument = gql`
    query GetCostBasis($publicId: ID) {
  entry(publicId: $publicId) {
    costBasis {
      dateTime
      originalCostBasis
      currentCostBasis
      quantity
      symbol
      callouts {
        severity
        type
      }
    }
  }
}
    `;

/**
 * __useGetCostBasisQuery__
 *
 * To run a query within a React component, call `useGetCostBasisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCostBasisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCostBasisQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetCostBasisQuery(baseOptions?: Apollo.QueryHookOptions<GetCostBasisQuery, GetCostBasisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCostBasisQuery, GetCostBasisQueryVariables>(GetCostBasisDocument, options);
      }
export function useGetCostBasisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCostBasisQuery, GetCostBasisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCostBasisQuery, GetCostBasisQueryVariables>(GetCostBasisDocument, options);
        }
export type GetCostBasisQueryHookResult = ReturnType<typeof useGetCostBasisQuery>;
export type GetCostBasisLazyQueryHookResult = ReturnType<typeof useGetCostBasisLazyQuery>;
export type GetCostBasisQueryResult = Apollo.QueryResult<GetCostBasisQuery, GetCostBasisQueryVariables>;
export const EditProceedsDocument = gql`
    mutation EditProceeds($entryId: String!, $proceeds: PositiveFloat) {
  updateTransactionProceeds(entryId: $entryId, proceeds: $proceeds) {
    success
    message
  }
}
    `;
export type EditProceedsMutationFn = Apollo.MutationFunction<EditProceedsMutation, EditProceedsMutationVariables>;

/**
 * __useEditProceedsMutation__
 *
 * To run a mutation, you first call `useEditProceedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProceedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProceedsMutation, { data, loading, error }] = useEditProceedsMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *      proceeds: // value for 'proceeds'
 *   },
 * });
 */
export function useEditProceedsMutation(baseOptions?: Apollo.MutationHookOptions<EditProceedsMutation, EditProceedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProceedsMutation, EditProceedsMutationVariables>(EditProceedsDocument, options);
      }
export type EditProceedsMutationHookResult = ReturnType<typeof useEditProceedsMutation>;
export type EditProceedsMutationResult = Apollo.MutationResult<EditProceedsMutation>;
export type EditProceedsMutationOptions = Apollo.BaseMutationOptions<EditProceedsMutation, EditProceedsMutationVariables>;
export const GetProceedsDocument = gql`
    query GetProceeds($publicId: ID) {
  entry(publicId: $publicId) {
    proceeds {
      dateTime
      originalProceeds
      currentProceeds
      quantity
      symbol
      callouts {
        severity
        type
      }
    }
  }
}
    `;

/**
 * __useGetProceedsQuery__
 *
 * To run a query within a React component, call `useGetProceedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProceedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProceedsQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetProceedsQuery(baseOptions?: Apollo.QueryHookOptions<GetProceedsQuery, GetProceedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProceedsQuery, GetProceedsQueryVariables>(GetProceedsDocument, options);
      }
export function useGetProceedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProceedsQuery, GetProceedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProceedsQuery, GetProceedsQueryVariables>(GetProceedsDocument, options);
        }
export type GetProceedsQueryHookResult = ReturnType<typeof useGetProceedsQuery>;
export type GetProceedsLazyQueryHookResult = ReturnType<typeof useGetProceedsLazyQuery>;
export type GetProceedsQueryResult = Apollo.QueryResult<GetProceedsQuery, GetProceedsQueryVariables>;
export const CreateTransactionLinkDocument = gql`
    mutation createTransactionLink($receiveTransactionId: String!, $sendTransactionId: String!, $transactionLinkType: TransactionLinkTypeEnum!) {
  createTransactionLink(
    receiveTransactionId: $receiveTransactionId
    sendTransactionId: $sendTransactionId
    transactionLinkType: $transactionLinkType
  ) {
    success
    message
  }
}
    `;
export type CreateTransactionLinkMutationFn = Apollo.MutationFunction<CreateTransactionLinkMutation, CreateTransactionLinkMutationVariables>;

/**
 * __useCreateTransactionLinkMutation__
 *
 * To run a mutation, you first call `useCreateTransactionLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionLinkMutation, { data, loading, error }] = useCreateTransactionLinkMutation({
 *   variables: {
 *      receiveTransactionId: // value for 'receiveTransactionId'
 *      sendTransactionId: // value for 'sendTransactionId'
 *      transactionLinkType: // value for 'transactionLinkType'
 *   },
 * });
 */
export function useCreateTransactionLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionLinkMutation, CreateTransactionLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionLinkMutation, CreateTransactionLinkMutationVariables>(CreateTransactionLinkDocument, options);
      }
export type CreateTransactionLinkMutationHookResult = ReturnType<typeof useCreateTransactionLinkMutation>;
export type CreateTransactionLinkMutationResult = Apollo.MutationResult<CreateTransactionLinkMutation>;
export type CreateTransactionLinkMutationOptions = Apollo.BaseMutationOptions<CreateTransactionLinkMutation, CreateTransactionLinkMutationVariables>;
export const AddDepositOverrideMutationDocument = gql`
    mutation AddDepositOverrideMutation($flowId: String!, $costBasis: Decimal!, $dateAcquired: DateTime!) {
  addDepositOverride(
    flowId: $flowId
    costBasis: $costBasis
    dateAcquired: $dateAcquired
  ) {
    success
    message
  }
}
    `;
export type AddDepositOverrideMutationMutationFn = Apollo.MutationFunction<AddDepositOverrideMutationMutation, AddDepositOverrideMutationMutationVariables>;

/**
 * __useAddDepositOverrideMutationMutation__
 *
 * To run a mutation, you first call `useAddDepositOverrideMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDepositOverrideMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDepositOverrideMutationMutation, { data, loading, error }] = useAddDepositOverrideMutationMutation({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      costBasis: // value for 'costBasis'
 *      dateAcquired: // value for 'dateAcquired'
 *   },
 * });
 */
export function useAddDepositOverrideMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddDepositOverrideMutationMutation, AddDepositOverrideMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDepositOverrideMutationMutation, AddDepositOverrideMutationMutationVariables>(AddDepositOverrideMutationDocument, options);
      }
export type AddDepositOverrideMutationMutationHookResult = ReturnType<typeof useAddDepositOverrideMutationMutation>;
export type AddDepositOverrideMutationMutationResult = Apollo.MutationResult<AddDepositOverrideMutationMutation>;
export type AddDepositOverrideMutationMutationOptions = Apollo.BaseMutationOptions<AddDepositOverrideMutationMutation, AddDepositOverrideMutationMutationVariables>;
export const GetValidationStatusDocument = gql`
    query GetValidationStatus($flowId: String!, $costBasis: Decimal!, $dateAcquired: DateTime!) {
  depositValidationState(
    flowId: $flowId
    costBasis: $costBasis
    dateAcquired: $dateAcquired
  ) {
    state
  }
}
    `;

/**
 * __useGetValidationStatusQuery__
 *
 * To run a query within a React component, call `useGetValidationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidationStatusQuery({
 *   variables: {
 *      flowId: // value for 'flowId'
 *      costBasis: // value for 'costBasis'
 *      dateAcquired: // value for 'dateAcquired'
 *   },
 * });
 */
export function useGetValidationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetValidationStatusQuery, GetValidationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidationStatusQuery, GetValidationStatusQueryVariables>(GetValidationStatusDocument, options);
      }
export function useGetValidationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidationStatusQuery, GetValidationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidationStatusQuery, GetValidationStatusQueryVariables>(GetValidationStatusDocument, options);
        }
export type GetValidationStatusQueryHookResult = ReturnType<typeof useGetValidationStatusQuery>;
export type GetValidationStatusLazyQueryHookResult = ReturnType<typeof useGetValidationStatusLazyQuery>;
export type GetValidationStatusQueryResult = Apollo.QueryResult<GetValidationStatusQuery, GetValidationStatusQueryVariables>;
export const BulkUpdateTransactionAssetDocument = gql`
    mutation bulkUpdateTransactionAsset($updateTokenParameters: [UpdateTokenInput]!) {
  bulkUpdateTransactionAsset(updateTokenParameters: $updateTokenParameters) {
    results {
      success
      error
      index
    }
    jobId
  }
}
    `;
export type BulkUpdateTransactionAssetMutationFn = Apollo.MutationFunction<BulkUpdateTransactionAssetMutation, BulkUpdateTransactionAssetMutationVariables>;

/**
 * __useBulkUpdateTransactionAssetMutation__
 *
 * To run a mutation, you first call `useBulkUpdateTransactionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateTransactionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateTransactionAssetMutation, { data, loading, error }] = useBulkUpdateTransactionAssetMutation({
 *   variables: {
 *      updateTokenParameters: // value for 'updateTokenParameters'
 *   },
 * });
 */
export function useBulkUpdateTransactionAssetMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateTransactionAssetMutation, BulkUpdateTransactionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateTransactionAssetMutation, BulkUpdateTransactionAssetMutationVariables>(BulkUpdateTransactionAssetDocument, options);
      }
export type BulkUpdateTransactionAssetMutationHookResult = ReturnType<typeof useBulkUpdateTransactionAssetMutation>;
export type BulkUpdateTransactionAssetMutationResult = Apollo.MutationResult<BulkUpdateTransactionAssetMutation>;
export type BulkUpdateTransactionAssetMutationOptions = Apollo.BaseMutationOptions<BulkUpdateTransactionAssetMutation, BulkUpdateTransactionAssetMutationVariables>;
export const DeleteManualTransactionsDocument = gql`
    mutation DeleteManualTransactions($entryIds: [String!]) {
  deleteManualTransactions(entryIds: $entryIds) {
    successes
    messages
  }
}
    `;
export type DeleteManualTransactionsMutationFn = Apollo.MutationFunction<DeleteManualTransactionsMutation, DeleteManualTransactionsMutationVariables>;

/**
 * __useDeleteManualTransactionsMutation__
 *
 * To run a mutation, you first call `useDeleteManualTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManualTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManualTransactionsMutation, { data, loading, error }] = useDeleteManualTransactionsMutation({
 *   variables: {
 *      entryIds: // value for 'entryIds'
 *   },
 * });
 */
export function useDeleteManualTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManualTransactionsMutation, DeleteManualTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManualTransactionsMutation, DeleteManualTransactionsMutationVariables>(DeleteManualTransactionsDocument, options);
      }
export type DeleteManualTransactionsMutationHookResult = ReturnType<typeof useDeleteManualTransactionsMutation>;
export type DeleteManualTransactionsMutationResult = Apollo.MutationResult<DeleteManualTransactionsMutation>;
export type DeleteManualTransactionsMutationOptions = Apollo.BaseMutationOptions<DeleteManualTransactionsMutation, DeleteManualTransactionsMutationVariables>;
export const GetTransactionCountQueryDocument = gql`
    query GetTransactionCountQuery($query: String = "", $limit: Int = 50) {
  transactionPageCount(query: $query, limit: $limit) {
    totalNumberOfTransactions
    endPage
  }
}
    `;

/**
 * __useGetTransactionCountQueryQuery__
 *
 * To run a query within a React component, call `useGetTransactionCountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionCountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionCountQueryQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTransactionCountQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionCountQueryQuery, GetTransactionCountQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionCountQueryQuery, GetTransactionCountQueryQueryVariables>(GetTransactionCountQueryDocument, options);
      }
export function useGetTransactionCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionCountQueryQuery, GetTransactionCountQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionCountQueryQuery, GetTransactionCountQueryQueryVariables>(GetTransactionCountQueryDocument, options);
        }
export type GetTransactionCountQueryQueryHookResult = ReturnType<typeof useGetTransactionCountQueryQuery>;
export type GetTransactionCountQueryLazyQueryHookResult = ReturnType<typeof useGetTransactionCountQueryLazyQuery>;
export type GetTransactionCountQueryQueryResult = Apollo.QueryResult<GetTransactionCountQueryQuery, GetTransactionCountQueryQueryVariables>;
export const GetVisualTransactionsDocument = gql`
    query GetVisualTransactions($page: Int = 1, $query: String = "", $limit: Int = 50, $transactionsOnly: Boolean = false) {
  transactionPage(
    page: $page
    query: $query
    limit: $limit
    transactionsOnly: $transactionsOnly
  ) {
    visualTransactions {
      id
      transactionRowType
      dateTime
      transactionHash
      transactionUrl
      hasAllDeletableFlows
      hasAtLeastOneDeletableFlow
      canEditCostBasis
      canEditProceeds
      canUnlink
      totalValue
      totalGainLoss
      taxableIncome
      isFrozen
      skipInLinkDetection
      taxability {
        taxable
        countrySupportsOptionalityForTaxEvents
        hasTaxabilityOverride
        isOptionalityEnabled
      }
      transactionBalances {
        walletLabel
        assetSymbol
        balanceAfter
        address
        asset {
          iconUrl
          label
        }
      }
      totalInflowsHidden
      totalOutflowsHidden
      operations {
        id
        operationType
        operationPurpose
        markAsOperationPurposes
        isFeeOperation
        flowsHiddenInOperation
        flows {
          id
          direction
          amount
          uaid
          walletUri
          isManual
          isImported
          isIgnored
          fiatValue
          notes {
            title
            subtitle
            comment
          }
          callouts {
            severity
            type
            quantityRequested
            reviewActionUrl
          }
          lotSummary {
            costBasis
            profitOrLoss
            proceeds
          }
          asset {
            symbol
            iconUrl
            isSpam
            canMarkAsSpam
            assetType
          }
          walletInfo {
            walletId
            label
            address
            walletType
            networkName
          }
        }
      }
    }
    startPage
    endPage
  }
  userInfo {
    publicId
    baseCurrency {
      type
      symbol
      priceUsd
    }
    taxPlanUpgradeNeeded
    taxStartDate
    taxEndDate
    costBasisByWallet
    hasSpamHidden
    closedPeriodDatetime
  }
  userProperties {
    hasStakingRewardsHidden
  }
}
    `;

/**
 * __useGetVisualTransactionsQuery__
 *
 * To run a query within a React component, call `useGetVisualTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisualTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisualTransactionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      transactionsOnly: // value for 'transactionsOnly'
 *   },
 * });
 */
export function useGetVisualTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisualTransactionsQuery, GetVisualTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisualTransactionsQuery, GetVisualTransactionsQueryVariables>(GetVisualTransactionsDocument, options);
      }
export function useGetVisualTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisualTransactionsQuery, GetVisualTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisualTransactionsQuery, GetVisualTransactionsQueryVariables>(GetVisualTransactionsDocument, options);
        }
export type GetVisualTransactionsQueryHookResult = ReturnType<typeof useGetVisualTransactionsQuery>;
export type GetVisualTransactionsLazyQueryHookResult = ReturnType<typeof useGetVisualTransactionsLazyQuery>;
export type GetVisualTransactionsQueryResult = Apollo.QueryResult<GetVisualTransactionsQuery, GetVisualTransactionsQueryVariables>;
export const GetTransactionsSearchDocument = gql`
    query GetTransactionsSearch($query: String = "") {
  transactionsSearch(query: $query) {
    status
    result
  }
}
    `;

/**
 * __useGetTransactionsSearchQuery__
 *
 * To run a query within a React component, call `useGetTransactionsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetTransactionsSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsSearchQuery, GetTransactionsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsSearchQuery, GetTransactionsSearchQueryVariables>(GetTransactionsSearchDocument, options);
      }
export function useGetTransactionsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsSearchQuery, GetTransactionsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsSearchQuery, GetTransactionsSearchQueryVariables>(GetTransactionsSearchDocument, options);
        }
export type GetTransactionsSearchQueryHookResult = ReturnType<typeof useGetTransactionsSearchQuery>;
export type GetTransactionsSearchLazyQueryHookResult = ReturnType<typeof useGetTransactionsSearchLazyQuery>;
export type GetTransactionsSearchQueryResult = Apollo.QueryResult<GetTransactionsSearchQuery, GetTransactionsSearchQueryVariables>;
export const MakeTransferDocument = gql`
    mutation MakeTransfer($transactionId: String!) {
  makeTransfer(transactionId: $transactionId) {
    success
    message
  }
}
    `;
export type MakeTransferMutationFn = Apollo.MutationFunction<MakeTransferMutation, MakeTransferMutationVariables>;

/**
 * __useMakeTransferMutation__
 *
 * To run a mutation, you first call `useMakeTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeTransferMutation, { data, loading, error }] = useMakeTransferMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useMakeTransferMutation(baseOptions?: Apollo.MutationHookOptions<MakeTransferMutation, MakeTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeTransferMutation, MakeTransferMutationVariables>(MakeTransferDocument, options);
      }
export type MakeTransferMutationHookResult = ReturnType<typeof useMakeTransferMutation>;
export type MakeTransferMutationResult = Apollo.MutationResult<MakeTransferMutation>;
export type MakeTransferMutationOptions = Apollo.BaseMutationOptions<MakeTransferMutation, MakeTransferMutationVariables>;
export const ReportSpamDocument = gql`
    mutation ReportSpam($uaids: [String!]!, $markAsSpam: Boolean!) {
  reportSpam(uaids: $uaids, markAsSpam: $markAsSpam) {
    success
  }
}
    `;
export type ReportSpamMutationFn = Apollo.MutationFunction<ReportSpamMutation, ReportSpamMutationVariables>;

/**
 * __useReportSpamMutation__
 *
 * To run a mutation, you first call `useReportSpamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportSpamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportSpamMutation, { data, loading, error }] = useReportSpamMutation({
 *   variables: {
 *      uaids: // value for 'uaids'
 *      markAsSpam: // value for 'markAsSpam'
 *   },
 * });
 */
export function useReportSpamMutation(baseOptions?: Apollo.MutationHookOptions<ReportSpamMutation, ReportSpamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportSpamMutation, ReportSpamMutationVariables>(ReportSpamDocument, options);
      }
export type ReportSpamMutationHookResult = ReturnType<typeof useReportSpamMutation>;
export type ReportSpamMutationResult = Apollo.MutationResult<ReportSpamMutation>;
export type ReportSpamMutationOptions = Apollo.BaseMutationOptions<ReportSpamMutation, ReportSpamMutationVariables>;
export const ToggleUserSpamPreferenceDocument = gql`
    mutation toggleUserSpamPreference {
  toggleUserSpamPreference {
    success
  }
}
    `;
export type ToggleUserSpamPreferenceMutationFn = Apollo.MutationFunction<ToggleUserSpamPreferenceMutation, ToggleUserSpamPreferenceMutationVariables>;

/**
 * __useToggleUserSpamPreferenceMutation__
 *
 * To run a mutation, you first call `useToggleUserSpamPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserSpamPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserSpamPreferenceMutation, { data, loading, error }] = useToggleUserSpamPreferenceMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleUserSpamPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserSpamPreferenceMutation, ToggleUserSpamPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserSpamPreferenceMutation, ToggleUserSpamPreferenceMutationVariables>(ToggleUserSpamPreferenceDocument, options);
      }
export type ToggleUserSpamPreferenceMutationHookResult = ReturnType<typeof useToggleUserSpamPreferenceMutation>;
export type ToggleUserSpamPreferenceMutationResult = Apollo.MutationResult<ToggleUserSpamPreferenceMutation>;
export type ToggleUserSpamPreferenceMutationOptions = Apollo.BaseMutationOptions<ToggleUserSpamPreferenceMutation, ToggleUserSpamPreferenceMutationVariables>;
export const ToggleUserStakingRewardsPreferenceDocument = gql`
    mutation toggleUserStakingRewardsPreference {
  toggleUserStakingRewardsPreference {
    success
  }
}
    `;
export type ToggleUserStakingRewardsPreferenceMutationFn = Apollo.MutationFunction<ToggleUserStakingRewardsPreferenceMutation, ToggleUserStakingRewardsPreferenceMutationVariables>;

/**
 * __useToggleUserStakingRewardsPreferenceMutation__
 *
 * To run a mutation, you first call `useToggleUserStakingRewardsPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserStakingRewardsPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserStakingRewardsPreferenceMutation, { data, loading, error }] = useToggleUserStakingRewardsPreferenceMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleUserStakingRewardsPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserStakingRewardsPreferenceMutation, ToggleUserStakingRewardsPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserStakingRewardsPreferenceMutation, ToggleUserStakingRewardsPreferenceMutationVariables>(ToggleUserStakingRewardsPreferenceDocument, options);
      }
export type ToggleUserStakingRewardsPreferenceMutationHookResult = ReturnType<typeof useToggleUserStakingRewardsPreferenceMutation>;
export type ToggleUserStakingRewardsPreferenceMutationResult = Apollo.MutationResult<ToggleUserStakingRewardsPreferenceMutation>;
export type ToggleUserStakingRewardsPreferenceMutationOptions = Apollo.BaseMutationOptions<ToggleUserStakingRewardsPreferenceMutation, ToggleUserStakingRewardsPreferenceMutationVariables>;
export const UpdateSkipInLinkDetectionMutationDocument = gql`
    mutation UpdateSkipInLinkDetectionMutation($transactionIds: [String]!, $skipInLinkDetection: Boolean!) {
  updateSkipInLinkDetection(
    transactionIds: $transactionIds
    skipInLinkDetection: $skipInLinkDetection
  ) {
    success
    message
  }
}
    `;
export type UpdateSkipInLinkDetectionMutationMutationFn = Apollo.MutationFunction<UpdateSkipInLinkDetectionMutationMutation, UpdateSkipInLinkDetectionMutationMutationVariables>;

/**
 * __useUpdateSkipInLinkDetectionMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSkipInLinkDetectionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkipInLinkDetectionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkipInLinkDetectionMutationMutation, { data, loading, error }] = useUpdateSkipInLinkDetectionMutationMutation({
 *   variables: {
 *      transactionIds: // value for 'transactionIds'
 *      skipInLinkDetection: // value for 'skipInLinkDetection'
 *   },
 * });
 */
export function useUpdateSkipInLinkDetectionMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkipInLinkDetectionMutationMutation, UpdateSkipInLinkDetectionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkipInLinkDetectionMutationMutation, UpdateSkipInLinkDetectionMutationMutationVariables>(UpdateSkipInLinkDetectionMutationDocument, options);
      }
export type UpdateSkipInLinkDetectionMutationMutationHookResult = ReturnType<typeof useUpdateSkipInLinkDetectionMutationMutation>;
export type UpdateSkipInLinkDetectionMutationMutationResult = Apollo.MutationResult<UpdateSkipInLinkDetectionMutationMutation>;
export type UpdateSkipInLinkDetectionMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSkipInLinkDetectionMutationMutation, UpdateSkipInLinkDetectionMutationMutationVariables>;
export const UpdateTransactionDatetimeDocument = gql`
    mutation UpdateTransactionDatetime($transactionId: String!, $newDatetime: DateTime!) {
  updateTransactionDatetime(
    transactionId: $transactionId
    newDatetime: $newDatetime
  ) {
    success
    message
  }
}
    `;
export type UpdateTransactionDatetimeMutationFn = Apollo.MutationFunction<UpdateTransactionDatetimeMutation, UpdateTransactionDatetimeMutationVariables>;

/**
 * __useUpdateTransactionDatetimeMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionDatetimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionDatetimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionDatetimeMutation, { data, loading, error }] = useUpdateTransactionDatetimeMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      newDatetime: // value for 'newDatetime'
 *   },
 * });
 */
export function useUpdateTransactionDatetimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionDatetimeMutation, UpdateTransactionDatetimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionDatetimeMutation, UpdateTransactionDatetimeMutationVariables>(UpdateTransactionDatetimeDocument, options);
      }
export type UpdateTransactionDatetimeMutationHookResult = ReturnType<typeof useUpdateTransactionDatetimeMutation>;
export type UpdateTransactionDatetimeMutationResult = Apollo.MutationResult<UpdateTransactionDatetimeMutation>;
export type UpdateTransactionDatetimeMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionDatetimeMutation, UpdateTransactionDatetimeMutationVariables>;
export const GetRenewSubscriptionDocument = gql`
    query GetRenewSubscription {
  availableUnifiedSubscriptionPlans {
    plans {
      name
      internalName
      price {
        originalPrice
        finalPrice
        currencySymbol
        discount
        discountReason
      }
      plan
      isRecommended
    }
    transactionCountingYear
  }
  unifiedSubscription {
    subscriptionPlan
    subscriptionPlanName
    transactionLimit
    lifetimeTransactionLimit
    billing {
      currentPeriodEnd
      cancelAtPeriodEnd
      renewalNeeded
    }
    transactionCounts {
      netTransactionCount
    }
    recommendedPlanForTax {
      internalName
      name
      plan
      transactionLimit
      lifetimeTransactionLimit
      transactionCounts {
        netTransactionCount
      }
    }
  }
}
    `;

/**
 * __useGetRenewSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetRenewSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenewSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenewSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRenewSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetRenewSubscriptionQuery, GetRenewSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenewSubscriptionQuery, GetRenewSubscriptionQueryVariables>(GetRenewSubscriptionDocument, options);
      }
export function useGetRenewSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenewSubscriptionQuery, GetRenewSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenewSubscriptionQuery, GetRenewSubscriptionQueryVariables>(GetRenewSubscriptionDocument, options);
        }
export type GetRenewSubscriptionQueryHookResult = ReturnType<typeof useGetRenewSubscriptionQuery>;
export type GetRenewSubscriptionLazyQueryHookResult = ReturnType<typeof useGetRenewSubscriptionLazyQuery>;
export type GetRenewSubscriptionQueryResult = Apollo.QueryResult<GetRenewSubscriptionQuery, GetRenewSubscriptionQueryVariables>;
export const GetSubscriptionPlansDocument = gql`
    query GetSubscriptionPlans {
  availableSubscriptionPlans {
    plans {
      name
      description
      features
      price
      isRecommended
      trialDays
      trialDescription
      firstChargeDate
    }
    currencySymbol
    hasTrial
    isFixedTrialEndDate
    trialDays
    trialEndDate
  }
  portfolioSubscription {
    portfolioPlan
    portfolioPlanName
    billing {
      interval
      status
      currentPeriodEnd
      cancelAtPeriodEnd
    }
  }
}
    `;

/**
 * __useGetSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, options);
      }
export function useGetSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, options);
        }
export type GetSubscriptionPlansQueryHookResult = ReturnType<typeof useGetSubscriptionPlansQuery>;
export type GetSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useGetSubscriptionPlansLazyQuery>;
export type GetSubscriptionPlansQueryResult = Apollo.QueryResult<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>;
export const GetUnifiedSubscriptionPlansDocument = gql`
    query GetUnifiedSubscriptionPlans {
  availableUnifiedSubscriptionPlans {
    featureTablePlans {
      name
      internalName
      displayName
      plan
      transactionLimit
      lifetimeTransactionLimit
      hasSufficientTransactionLimit
      taxForms
      staking
      support
      price
      featureList
      priceInfo {
        discount
        originalPrice
        finalPrice
        currencySymbol
      }
      pricePlusInfo {
        discount
        originalPrice
        finalPrice
        currencySymbol
      }
      isRecommended
    }
    plans {
      name
      internalName
      transactionLimit
      lifetimeTransactionLimit
      hasSufficientTransactionLimit
      featureList
      price {
        originalPrice
        finalPrice
        currencySymbol
        discount
        discountReason
      }
      plan
      isRecommended
      transactionCounts {
        totalTransactionCount
        lifetimeTransactionCount
        excludedStakingTransactionCount
        netTransactionCount
      }
    }
    currencySymbol
    transactionCountingYear
  }
  unifiedSubscription {
    subscriptionPlan
    subscriptionPlanName
    transactionLimit
    lifetimeTransactionLimit
    showCoinbasePromo
    partnersPromo {
      partner {
        type
        name
      }
      discount
    }
    billing {
      currentPeriodEnd
      cancelAtPeriodEnd
      renewalNeeded
    }
  }
  portfolioSubscription {
    portfolioPlan
    billing {
      status
      currentPeriodEnd
    }
  }
  showContractedTaxFirmTaxPlans
  userContractedFirms {
    name
  }
  taxLossHarvest {
    taxLossTotals {
      absUnrealizedLoss
    }
  }
}
    `;

/**
 * __useGetUnifiedSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useGetUnifiedSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnifiedSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<GetUnifiedSubscriptionPlansQuery, GetUnifiedSubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnifiedSubscriptionPlansQuery, GetUnifiedSubscriptionPlansQueryVariables>(GetUnifiedSubscriptionPlansDocument, options);
      }
export function useGetUnifiedSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnifiedSubscriptionPlansQuery, GetUnifiedSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnifiedSubscriptionPlansQuery, GetUnifiedSubscriptionPlansQueryVariables>(GetUnifiedSubscriptionPlansDocument, options);
        }
export type GetUnifiedSubscriptionPlansQueryHookResult = ReturnType<typeof useGetUnifiedSubscriptionPlansQuery>;
export type GetUnifiedSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useGetUnifiedSubscriptionPlansLazyQuery>;
export type GetUnifiedSubscriptionPlansQueryResult = Apollo.QueryResult<GetUnifiedSubscriptionPlansQuery, GetUnifiedSubscriptionPlansQueryVariables>;
export const CurrencyDocument = gql`
    query Currency($query: String = "") {
  currency(query: $query) {
    name
    symbol
    slug
    cmcId
    cryptoNetwork
  }
  commonCurrencies {
    name
    symbol
    cmcId
  }
}
    `;

/**
 * __useCurrencyQuery__
 *
 * To run a query within a React component, call `useCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
      }
export function useCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
        }
export type CurrencyQueryHookResult = ReturnType<typeof useCurrencyQuery>;
export type CurrencyLazyQueryHookResult = ReturnType<typeof useCurrencyLazyQuery>;
export type CurrencyQueryResult = Apollo.QueryResult<CurrencyQuery, CurrencyQueryVariables>;
export const GetPublicWalletBalanceDocument = gql`
    query getPublicWalletBalance($address: String!, $coinSymbol: String!) {
  publicWalletBalance(address: $address, coinSymbol: $coinSymbol) {
    success
    shouldPoll
    walletAlreadyLinked
    balance
    usdValue
  }
}
    `;

/**
 * __useGetPublicWalletBalanceQuery__
 *
 * To run a query within a React component, call `useGetPublicWalletBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicWalletBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicWalletBalanceQuery({
 *   variables: {
 *      address: // value for 'address'
 *      coinSymbol: // value for 'coinSymbol'
 *   },
 * });
 */
export function useGetPublicWalletBalanceQuery(baseOptions: Apollo.QueryHookOptions<GetPublicWalletBalanceQuery, GetPublicWalletBalanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicWalletBalanceQuery, GetPublicWalletBalanceQueryVariables>(GetPublicWalletBalanceDocument, options);
      }
export function useGetPublicWalletBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicWalletBalanceQuery, GetPublicWalletBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicWalletBalanceQuery, GetPublicWalletBalanceQueryVariables>(GetPublicWalletBalanceDocument, options);
        }
export type GetPublicWalletBalanceQueryHookResult = ReturnType<typeof useGetPublicWalletBalanceQuery>;
export type GetPublicWalletBalanceLazyQueryHookResult = ReturnType<typeof useGetPublicWalletBalanceLazyQuery>;
export type GetPublicWalletBalanceQueryResult = Apollo.QueryResult<GetPublicWalletBalanceQuery, GetPublicWalletBalanceQueryVariables>;
export const DeleteExchangeDocument = gql`
    mutation deleteExchange($publicId: String) {
  deleteExchange(publicId: $publicId) {
    success
    message
    error
  }
}
    `;
export type DeleteExchangeMutationFn = Apollo.MutationFunction<DeleteExchangeMutation, DeleteExchangeMutationVariables>;

/**
 * __useDeleteExchangeMutation__
 *
 * To run a mutation, you first call `useDeleteExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExchangeMutation, { data, loading, error }] = useDeleteExchangeMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useDeleteExchangeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExchangeMutation, DeleteExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExchangeMutation, DeleteExchangeMutationVariables>(DeleteExchangeDocument, options);
      }
export type DeleteExchangeMutationHookResult = ReturnType<typeof useDeleteExchangeMutation>;
export type DeleteExchangeMutationResult = Apollo.MutationResult<DeleteExchangeMutation>;
export type DeleteExchangeMutationOptions = Apollo.BaseMutationOptions<DeleteExchangeMutation, DeleteExchangeMutationVariables>;
export const DeleteWalletDocument = gql`
    mutation deleteWallet($publicId: String) {
  deleteWallet(publicId: $publicId) {
    success
    message
    error
  }
}
    `;
export type DeleteWalletMutationFn = Apollo.MutationFunction<DeleteWalletMutation, DeleteWalletMutationVariables>;

/**
 * __useDeleteWalletMutation__
 *
 * To run a mutation, you first call `useDeleteWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWalletMutation, { data, loading, error }] = useDeleteWalletMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useDeleteWalletMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWalletMutation, DeleteWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWalletMutation, DeleteWalletMutationVariables>(DeleteWalletDocument, options);
      }
export type DeleteWalletMutationHookResult = ReturnType<typeof useDeleteWalletMutation>;
export type DeleteWalletMutationResult = Apollo.MutationResult<DeleteWalletMutation>;
export type DeleteWalletMutationOptions = Apollo.BaseMutationOptions<DeleteWalletMutation, DeleteWalletMutationVariables>;
export const DeleteCustomWalletDocument = gql`
    mutation deleteCustomWallet($publicId: String) {
  deleteCustomWallet(publicId: $publicId) {
    success
    message
    error
  }
}
    `;
export type DeleteCustomWalletMutationFn = Apollo.MutationFunction<DeleteCustomWalletMutation, DeleteCustomWalletMutationVariables>;

/**
 * __useDeleteCustomWalletMutation__
 *
 * To run a mutation, you first call `useDeleteCustomWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomWalletMutation, { data, loading, error }] = useDeleteCustomWalletMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useDeleteCustomWalletMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomWalletMutation, DeleteCustomWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomWalletMutation, DeleteCustomWalletMutationVariables>(DeleteCustomWalletDocument, options);
      }
export type DeleteCustomWalletMutationHookResult = ReturnType<typeof useDeleteCustomWalletMutation>;
export type DeleteCustomWalletMutationResult = Apollo.MutationResult<DeleteCustomWalletMutation>;
export type DeleteCustomWalletMutationOptions = Apollo.BaseMutationOptions<DeleteCustomWalletMutation, DeleteCustomWalletMutationVariables>;
export const RenameExchangeDocument = gql`
    mutation RenameExchange($publicId: String, $newName: String) {
  renameExchange(publicId: $publicId, newName: $newName) {
    success
    message
    error
  }
}
    `;
export type RenameExchangeMutationFn = Apollo.MutationFunction<RenameExchangeMutation, RenameExchangeMutationVariables>;

/**
 * __useRenameExchangeMutation__
 *
 * To run a mutation, you first call `useRenameExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameExchangeMutation, { data, loading, error }] = useRenameExchangeMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameExchangeMutation(baseOptions?: Apollo.MutationHookOptions<RenameExchangeMutation, RenameExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameExchangeMutation, RenameExchangeMutationVariables>(RenameExchangeDocument, options);
      }
export type RenameExchangeMutationHookResult = ReturnType<typeof useRenameExchangeMutation>;
export type RenameExchangeMutationResult = Apollo.MutationResult<RenameExchangeMutation>;
export type RenameExchangeMutationOptions = Apollo.BaseMutationOptions<RenameExchangeMutation, RenameExchangeMutationVariables>;
export const RenameWalletDocument = gql`
    mutation RenameWallet($publicId: String, $newName: String) {
  renameWallet(publicId: $publicId, newName: $newName) {
    success
    message
    error
  }
}
    `;
export type RenameWalletMutationFn = Apollo.MutationFunction<RenameWalletMutation, RenameWalletMutationVariables>;

/**
 * __useRenameWalletMutation__
 *
 * To run a mutation, you first call `useRenameWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameWalletMutation, { data, loading, error }] = useRenameWalletMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameWalletMutation(baseOptions?: Apollo.MutationHookOptions<RenameWalletMutation, RenameWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameWalletMutation, RenameWalletMutationVariables>(RenameWalletDocument, options);
      }
export type RenameWalletMutationHookResult = ReturnType<typeof useRenameWalletMutation>;
export type RenameWalletMutationResult = Apollo.MutationResult<RenameWalletMutation>;
export type RenameWalletMutationOptions = Apollo.BaseMutationOptions<RenameWalletMutation, RenameWalletMutationVariables>;
export const RenameCustomWalletDocument = gql`
    mutation RenameCustomWallet($publicId: String, $newName: String) {
  renameCustomWallet(publicId: $publicId, newName: $newName) {
    success
    message
    error
  }
}
    `;
export type RenameCustomWalletMutationFn = Apollo.MutationFunction<RenameCustomWalletMutation, RenameCustomWalletMutationVariables>;

/**
 * __useRenameCustomWalletMutation__
 *
 * To run a mutation, you first call `useRenameCustomWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameCustomWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameCustomWalletMutation, { data, loading, error }] = useRenameCustomWalletMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRenameCustomWalletMutation(baseOptions?: Apollo.MutationHookOptions<RenameCustomWalletMutation, RenameCustomWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameCustomWalletMutation, RenameCustomWalletMutationVariables>(RenameCustomWalletDocument, options);
      }
export type RenameCustomWalletMutationHookResult = ReturnType<typeof useRenameCustomWalletMutation>;
export type RenameCustomWalletMutationResult = Apollo.MutationResult<RenameCustomWalletMutation>;
export type RenameCustomWalletMutationOptions = Apollo.BaseMutationOptions<RenameCustomWalletMutation, RenameCustomWalletMutationVariables>;
export const MigrateExchangeDocument = gql`
    mutation migrateExchange($publicId: String) {
  migrateExchange(publicId: $publicId) {
    success
    message
    error
  }
}
    `;
export type MigrateExchangeMutationFn = Apollo.MutationFunction<MigrateExchangeMutation, MigrateExchangeMutationVariables>;

/**
 * __useMigrateExchangeMutation__
 *
 * To run a mutation, you first call `useMigrateExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateExchangeMutation, { data, loading, error }] = useMigrateExchangeMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useMigrateExchangeMutation(baseOptions?: Apollo.MutationHookOptions<MigrateExchangeMutation, MigrateExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateExchangeMutation, MigrateExchangeMutationVariables>(MigrateExchangeDocument, options);
      }
export type MigrateExchangeMutationHookResult = ReturnType<typeof useMigrateExchangeMutation>;
export type MigrateExchangeMutationResult = Apollo.MutationResult<MigrateExchangeMutation>;
export type MigrateExchangeMutationOptions = Apollo.BaseMutationOptions<MigrateExchangeMutation, MigrateExchangeMutationVariables>;
export const SyncExchangeDocument = gql`
    mutation SyncExchange($publicId: String, $syncType: String) {
  enqueueExchangeForSync(publicId: $publicId, syncType: $syncType) {
    success
    message
  }
}
    `;
export type SyncExchangeMutationFn = Apollo.MutationFunction<SyncExchangeMutation, SyncExchangeMutationVariables>;

/**
 * __useSyncExchangeMutation__
 *
 * To run a mutation, you first call `useSyncExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncExchangeMutation, { data, loading, error }] = useSyncExchangeMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      syncType: // value for 'syncType'
 *   },
 * });
 */
export function useSyncExchangeMutation(baseOptions?: Apollo.MutationHookOptions<SyncExchangeMutation, SyncExchangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncExchangeMutation, SyncExchangeMutationVariables>(SyncExchangeDocument, options);
      }
export type SyncExchangeMutationHookResult = ReturnType<typeof useSyncExchangeMutation>;
export type SyncExchangeMutationResult = Apollo.MutationResult<SyncExchangeMutation>;
export type SyncExchangeMutationOptions = Apollo.BaseMutationOptions<SyncExchangeMutation, SyncExchangeMutationVariables>;
export const SyncWalletDocument = gql`
    mutation SyncWallet($publicId: String, $syncType: String) {
  enqueueLocalWalletForSync(publicId: $publicId, syncType: $syncType) {
    success
    message
  }
}
    `;
export type SyncWalletMutationFn = Apollo.MutationFunction<SyncWalletMutation, SyncWalletMutationVariables>;

/**
 * __useSyncWalletMutation__
 *
 * To run a mutation, you first call `useSyncWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncWalletMutation, { data, loading, error }] = useSyncWalletMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      syncType: // value for 'syncType'
 *   },
 * });
 */
export function useSyncWalletMutation(baseOptions?: Apollo.MutationHookOptions<SyncWalletMutation, SyncWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncWalletMutation, SyncWalletMutationVariables>(SyncWalletDocument, options);
      }
export type SyncWalletMutationHookResult = ReturnType<typeof useSyncWalletMutation>;
export type SyncWalletMutationResult = Apollo.MutationResult<SyncWalletMutation>;
export type SyncWalletMutationOptions = Apollo.BaseMutationOptions<SyncWalletMutation, SyncWalletMutationVariables>;
export const ToggleUserWalletsSpamPreferenceDocument = gql`
    mutation toggleUserWalletsSpamPreference {
  toggleUserWalletsSpamPreference {
    success
  }
}
    `;
export type ToggleUserWalletsSpamPreferenceMutationFn = Apollo.MutationFunction<ToggleUserWalletsSpamPreferenceMutation, ToggleUserWalletsSpamPreferenceMutationVariables>;

/**
 * __useToggleUserWalletsSpamPreferenceMutation__
 *
 * To run a mutation, you first call `useToggleUserWalletsSpamPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserWalletsSpamPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserWalletsSpamPreferenceMutation, { data, loading, error }] = useToggleUserWalletsSpamPreferenceMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleUserWalletsSpamPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserWalletsSpamPreferenceMutation, ToggleUserWalletsSpamPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserWalletsSpamPreferenceMutation, ToggleUserWalletsSpamPreferenceMutationVariables>(ToggleUserWalletsSpamPreferenceDocument, options);
      }
export type ToggleUserWalletsSpamPreferenceMutationHookResult = ReturnType<typeof useToggleUserWalletsSpamPreferenceMutation>;
export type ToggleUserWalletsSpamPreferenceMutationResult = Apollo.MutationResult<ToggleUserWalletsSpamPreferenceMutation>;
export type ToggleUserWalletsSpamPreferenceMutationOptions = Apollo.BaseMutationOptions<ToggleUserWalletsSpamPreferenceMutation, ToggleUserWalletsSpamPreferenceMutationVariables>;
export const SetMiningStatusDocument = gql`
    mutation SetMiningStatus($publicId: String, $isMining: Boolean, $applyToAll: Boolean) {
  setMiningStatus(
    publicId: $publicId
    isMining: $isMining
    applyToAll: $applyToAll
  ) {
    success
    message
    error
  }
}
    `;
export type SetMiningStatusMutationFn = Apollo.MutationFunction<SetMiningStatusMutation, SetMiningStatusMutationVariables>;

/**
 * __useSetMiningStatusMutation__
 *
 * To run a mutation, you first call `useSetMiningStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMiningStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMiningStatusMutation, { data, loading, error }] = useSetMiningStatusMutation({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      isMining: // value for 'isMining'
 *      applyToAll: // value for 'applyToAll'
 *   },
 * });
 */
export function useSetMiningStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetMiningStatusMutation, SetMiningStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMiningStatusMutation, SetMiningStatusMutationVariables>(SetMiningStatusDocument, options);
      }
export type SetMiningStatusMutationHookResult = ReturnType<typeof useSetMiningStatusMutation>;
export type SetMiningStatusMutationResult = Apollo.MutationResult<SetMiningStatusMutation>;
export type SetMiningStatusMutationOptions = Apollo.BaseMutationOptions<SetMiningStatusMutation, SetMiningStatusMutationVariables>;
export const GetCustomWalletDetailsDocument = gql`
    query GetCustomWalletDetails($publicId: String!) {
  customWallet(publicId: $publicId) {
    id
    hasTransactionsInFrozenPeriod
    balances {
      balance
      calculatedBalance
      sanitizedCryptoSymbol
      value
      calculatedValue
      entryCount
      currency {
        symbol
        type
        cmcId
      }
    }
    userAssetBalances {
      balance
      calculatedBalance
      value
      calculatedValue
      entryCount
      currency {
        symbol
        type
        cmcId
        uaid
      }
    }
  }
}
    `;

/**
 * __useGetCustomWalletDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomWalletDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomWalletDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomWalletDetailsQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetCustomWalletDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomWalletDetailsQuery, GetCustomWalletDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomWalletDetailsQuery, GetCustomWalletDetailsQueryVariables>(GetCustomWalletDetailsDocument, options);
      }
export function useGetCustomWalletDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomWalletDetailsQuery, GetCustomWalletDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomWalletDetailsQuery, GetCustomWalletDetailsQueryVariables>(GetCustomWalletDetailsDocument, options);
        }
export type GetCustomWalletDetailsQueryHookResult = ReturnType<typeof useGetCustomWalletDetailsQuery>;
export type GetCustomWalletDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomWalletDetailsLazyQuery>;
export type GetCustomWalletDetailsQueryResult = Apollo.QueryResult<GetCustomWalletDetailsQuery, GetCustomWalletDetailsQueryVariables>;
export const GetExchangeDetailsDocument = gql`
    query GetExchangeDetails($publicId: String!) {
  exchange(publicId: $publicId) {
    id
    isPortfolioValueDifferenceSignificant
    hasIgnoredTransactionsInFrozenPeriod
    allowsHardResync
    allowsTradeImports
    allowsTransferImports
    allowsTransactionImports
    allowsTransactionHistoryImports
    hasTransactionsInFrozenPeriod
    syncInfo {
      isFirstTimeSync
    }
    warnings
    showDeprecationWarning
    shouldBeRemoved
    type
    wallets {
      id
      calculatedValue
      value
      balance
      calculatedBalance
      computedTransactionCount
      computedCryptoTransactionCount
      currency {
        symbol
        type
        cmcId
        priceUsd
      }
      address
      name
      isBalanceDifferenceSignificant
      tokens {
        value
      }
      isMining
    }
  }
}
    `;

/**
 * __useGetExchangeDetailsQuery__
 *
 * To run a query within a React component, call `useGetExchangeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeDetailsQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetExchangeDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetExchangeDetailsQuery, GetExchangeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeDetailsQuery, GetExchangeDetailsQueryVariables>(GetExchangeDetailsDocument, options);
      }
export function useGetExchangeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeDetailsQuery, GetExchangeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeDetailsQuery, GetExchangeDetailsQueryVariables>(GetExchangeDetailsDocument, options);
        }
export type GetExchangeDetailsQueryHookResult = ReturnType<typeof useGetExchangeDetailsQuery>;
export type GetExchangeDetailsLazyQueryHookResult = ReturnType<typeof useGetExchangeDetailsLazyQuery>;
export type GetExchangeDetailsQueryResult = Apollo.QueryResult<GetExchangeDetailsQuery, GetExchangeDetailsQueryVariables>;
export const GetExchangeSyncProgressDocument = gql`
    query GetExchangeSyncProgress($publicId: String!) {
  exchangeIncrementalPersistanceSyncProgress(publicId: $publicId) {
    total
    currentStage
  }
}
    `;

/**
 * __useGetExchangeSyncProgressQuery__
 *
 * To run a query within a React component, call `useGetExchangeSyncProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeSyncProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeSyncProgressQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetExchangeSyncProgressQuery(baseOptions: Apollo.QueryHookOptions<GetExchangeSyncProgressQuery, GetExchangeSyncProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeSyncProgressQuery, GetExchangeSyncProgressQueryVariables>(GetExchangeSyncProgressDocument, options);
      }
export function useGetExchangeSyncProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeSyncProgressQuery, GetExchangeSyncProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeSyncProgressQuery, GetExchangeSyncProgressQueryVariables>(GetExchangeSyncProgressDocument, options);
        }
export type GetExchangeSyncProgressQueryHookResult = ReturnType<typeof useGetExchangeSyncProgressQuery>;
export type GetExchangeSyncProgressLazyQueryHookResult = ReturnType<typeof useGetExchangeSyncProgressLazyQuery>;
export type GetExchangeSyncProgressQueryResult = Apollo.QueryResult<GetExchangeSyncProgressQuery, GetExchangeSyncProgressQueryVariables>;
export const GetLocalWalletSyncProgressDocument = gql`
    query GetLocalWalletSyncProgress($publicId: String!) {
  localWalletIncrementalPersistanceSyncProgress(publicId: $publicId) {
    total
    currentStage
  }
}
    `;

/**
 * __useGetLocalWalletSyncProgressQuery__
 *
 * To run a query within a React component, call `useGetLocalWalletSyncProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalWalletSyncProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalWalletSyncProgressQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetLocalWalletSyncProgressQuery(baseOptions: Apollo.QueryHookOptions<GetLocalWalletSyncProgressQuery, GetLocalWalletSyncProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalWalletSyncProgressQuery, GetLocalWalletSyncProgressQueryVariables>(GetLocalWalletSyncProgressDocument, options);
      }
export function useGetLocalWalletSyncProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalWalletSyncProgressQuery, GetLocalWalletSyncProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalWalletSyncProgressQuery, GetLocalWalletSyncProgressQueryVariables>(GetLocalWalletSyncProgressDocument, options);
        }
export type GetLocalWalletSyncProgressQueryHookResult = ReturnType<typeof useGetLocalWalletSyncProgressQuery>;
export type GetLocalWalletSyncProgressLazyQueryHookResult = ReturnType<typeof useGetLocalWalletSyncProgressLazyQuery>;
export type GetLocalWalletSyncProgressQueryResult = Apollo.QueryResult<GetLocalWalletSyncProgressQuery, GetLocalWalletSyncProgressQueryVariables>;
export const GetOtherTransactionDetailsDocument = gql`
    query GetOtherTransactionDetails {
  otherTransactions {
    id
    balances {
      balance
      calculatedBalance
      sanitizedCryptoSymbol
      name
      entryCount
      value
      calculatedValue
      currency {
        symbol
        type
        cmcId
      }
    }
    userAssetBalances {
      balance
      calculatedBalance
      sanitizedCryptoSymbol
      entryCount
      value
      calculatedValue
      currency {
        symbol
        type
        cmcId
        uaid
      }
    }
  }
}
    `;

/**
 * __useGetOtherTransactionDetailsQuery__
 *
 * To run a query within a React component, call `useGetOtherTransactionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherTransactionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherTransactionDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOtherTransactionDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetOtherTransactionDetailsQuery, GetOtherTransactionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherTransactionDetailsQuery, GetOtherTransactionDetailsQueryVariables>(GetOtherTransactionDetailsDocument, options);
      }
export function useGetOtherTransactionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherTransactionDetailsQuery, GetOtherTransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherTransactionDetailsQuery, GetOtherTransactionDetailsQueryVariables>(GetOtherTransactionDetailsDocument, options);
        }
export type GetOtherTransactionDetailsQueryHookResult = ReturnType<typeof useGetOtherTransactionDetailsQuery>;
export type GetOtherTransactionDetailsLazyQueryHookResult = ReturnType<typeof useGetOtherTransactionDetailsLazyQuery>;
export type GetOtherTransactionDetailsQueryResult = Apollo.QueryResult<GetOtherTransactionDetailsQuery, GetOtherTransactionDetailsQueryVariables>;
export const GetWalletDetailsDocument = gql`
    query GetWalletDetails($publicId: String!) {
  localWallet(publicId: $publicId) {
    id
    balance
    calculatedBalance
    computedCryptoTransactionCount
    isBalanceDifferenceSignificant
    hasIgnoredTransactionsInFrozenPeriod
    syncInfo {
      isFirstTimeSync
    }
    isMining
    isPortfolioValueDifferenceSignificant
    allowsHardResync
    currency {
      symbol
      price
      type
      cmcId
    }
    hasTransactionsInFrozenPeriod
    tokens {
      value
      calculatedValue
      sanitizedCryptoSymbol
      balance
      calculatedBalance
      computedTransactionCount
      isBalanceDifferenceSignificant
      currency {
        symbol
        type
        cmcId
        uaid
        iconUrlFromInfo
      }
    }
    userAssetBalances {
      balance
      calculatedBalance
      value
      calculatedValue
      entryCount
      currency {
        symbol
        type
        cmcId
        uaid
        iconUrlFromInfo
      }
    }
  }
}
    `;

/**
 * __useGetWalletDetailsQuery__
 *
 * To run a query within a React component, call `useGetWalletDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletDetailsQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetWalletDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>(GetWalletDetailsDocument, options);
      }
export function useGetWalletDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>(GetWalletDetailsDocument, options);
        }
export type GetWalletDetailsQueryHookResult = ReturnType<typeof useGetWalletDetailsQuery>;
export type GetWalletDetailsLazyQueryHookResult = ReturnType<typeof useGetWalletDetailsLazyQuery>;
export type GetWalletDetailsQueryResult = Apollo.QueryResult<GetWalletDetailsQuery, GetWalletDetailsQueryVariables>;
export const AddExchangeWithApiAndSecretKeyDocument = gql`
    mutation AddExchangeWithApiAndSecretKey($addExchangeInput: AddExchangeWithAPIKeyAndSecretInput!) {
  addExchangeWithApiKeyAndSecret(addExchangeInput: $addExchangeInput) {
    success
    error
    createdExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type AddExchangeWithApiAndSecretKeyMutationFn = Apollo.MutationFunction<AddExchangeWithApiAndSecretKeyMutation, AddExchangeWithApiAndSecretKeyMutationVariables>;

/**
 * __useAddExchangeWithApiAndSecretKeyMutation__
 *
 * To run a mutation, you first call `useAddExchangeWithApiAndSecretKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeWithApiAndSecretKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeWithApiAndSecretKeyMutation, { data, loading, error }] = useAddExchangeWithApiAndSecretKeyMutation({
 *   variables: {
 *      addExchangeInput: // value for 'addExchangeInput'
 *   },
 * });
 */
export function useAddExchangeWithApiAndSecretKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddExchangeWithApiAndSecretKeyMutation, AddExchangeWithApiAndSecretKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExchangeWithApiAndSecretKeyMutation, AddExchangeWithApiAndSecretKeyMutationVariables>(AddExchangeWithApiAndSecretKeyDocument, options);
      }
export type AddExchangeWithApiAndSecretKeyMutationHookResult = ReturnType<typeof useAddExchangeWithApiAndSecretKeyMutation>;
export type AddExchangeWithApiAndSecretKeyMutationResult = Apollo.MutationResult<AddExchangeWithApiAndSecretKeyMutation>;
export type AddExchangeWithApiAndSecretKeyMutationOptions = Apollo.BaseMutationOptions<AddExchangeWithApiAndSecretKeyMutation, AddExchangeWithApiAndSecretKeyMutationVariables>;
export const UpdateExchangeWithApiAndSecretKeyDocument = gql`
    mutation UpdateExchangeWithApiAndSecretKey($updateExchangeInput: UpdateExchangeWithAPIKeyAndSecretInput!) {
  updateExchangeWithApiKeyAndSecret(updateExchangeInput: $updateExchangeInput) {
    success
    error
    updatedExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type UpdateExchangeWithApiAndSecretKeyMutationFn = Apollo.MutationFunction<UpdateExchangeWithApiAndSecretKeyMutation, UpdateExchangeWithApiAndSecretKeyMutationVariables>;

/**
 * __useUpdateExchangeWithApiAndSecretKeyMutation__
 *
 * To run a mutation, you first call `useUpdateExchangeWithApiAndSecretKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExchangeWithApiAndSecretKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExchangeWithApiAndSecretKeyMutation, { data, loading, error }] = useUpdateExchangeWithApiAndSecretKeyMutation({
 *   variables: {
 *      updateExchangeInput: // value for 'updateExchangeInput'
 *   },
 * });
 */
export function useUpdateExchangeWithApiAndSecretKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExchangeWithApiAndSecretKeyMutation, UpdateExchangeWithApiAndSecretKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExchangeWithApiAndSecretKeyMutation, UpdateExchangeWithApiAndSecretKeyMutationVariables>(UpdateExchangeWithApiAndSecretKeyDocument, options);
      }
export type UpdateExchangeWithApiAndSecretKeyMutationHookResult = ReturnType<typeof useUpdateExchangeWithApiAndSecretKeyMutation>;
export type UpdateExchangeWithApiAndSecretKeyMutationResult = Apollo.MutationResult<UpdateExchangeWithApiAndSecretKeyMutation>;
export type UpdateExchangeWithApiAndSecretKeyMutationOptions = Apollo.BaseMutationOptions<UpdateExchangeWithApiAndSecretKeyMutation, UpdateExchangeWithApiAndSecretKeyMutationVariables>;
export const AddExchangeWithApiKeyDocument = gql`
    mutation AddExchangeWithApiKey($addExchangeInput: AddExchangeWithAPIKeyInput!) {
  addExchangeWithApiKey(addExchangeInput: $addExchangeInput) {
    success
    error
    createdExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type AddExchangeWithApiKeyMutationFn = Apollo.MutationFunction<AddExchangeWithApiKeyMutation, AddExchangeWithApiKeyMutationVariables>;

/**
 * __useAddExchangeWithApiKeyMutation__
 *
 * To run a mutation, you first call `useAddExchangeWithApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeWithApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeWithApiKeyMutation, { data, loading, error }] = useAddExchangeWithApiKeyMutation({
 *   variables: {
 *      addExchangeInput: // value for 'addExchangeInput'
 *   },
 * });
 */
export function useAddExchangeWithApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddExchangeWithApiKeyMutation, AddExchangeWithApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExchangeWithApiKeyMutation, AddExchangeWithApiKeyMutationVariables>(AddExchangeWithApiKeyDocument, options);
      }
export type AddExchangeWithApiKeyMutationHookResult = ReturnType<typeof useAddExchangeWithApiKeyMutation>;
export type AddExchangeWithApiKeyMutationResult = Apollo.MutationResult<AddExchangeWithApiKeyMutation>;
export type AddExchangeWithApiKeyMutationOptions = Apollo.BaseMutationOptions<AddExchangeWithApiKeyMutation, AddExchangeWithApiKeyMutationVariables>;
export const UpdateExchangeWithApiKeyDocument = gql`
    mutation UpdateExchangeWithApiKey($updateExchangeInput: UpdateExchangeWithAPIKeyInput!) {
  updateExchangeWithApiKey(updateExchangeInput: $updateExchangeInput) {
    success
    error
    updatedExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type UpdateExchangeWithApiKeyMutationFn = Apollo.MutationFunction<UpdateExchangeWithApiKeyMutation, UpdateExchangeWithApiKeyMutationVariables>;

/**
 * __useUpdateExchangeWithApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateExchangeWithApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExchangeWithApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExchangeWithApiKeyMutation, { data, loading, error }] = useUpdateExchangeWithApiKeyMutation({
 *   variables: {
 *      updateExchangeInput: // value for 'updateExchangeInput'
 *   },
 * });
 */
export function useUpdateExchangeWithApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExchangeWithApiKeyMutation, UpdateExchangeWithApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExchangeWithApiKeyMutation, UpdateExchangeWithApiKeyMutationVariables>(UpdateExchangeWithApiKeyDocument, options);
      }
export type UpdateExchangeWithApiKeyMutationHookResult = ReturnType<typeof useUpdateExchangeWithApiKeyMutation>;
export type UpdateExchangeWithApiKeyMutationResult = Apollo.MutationResult<UpdateExchangeWithApiKeyMutation>;
export type UpdateExchangeWithApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateExchangeWithApiKeyMutation, UpdateExchangeWithApiKeyMutationVariables>;
export const AddExchangeWithCustomerIdDocument = gql`
    mutation AddExchangeWithCustomerId($addExchangeInput: AddExchangeWithCustomerIdInput!) {
  addExchangeWithCustomerId(addExchangeInput: $addExchangeInput) {
    success
    error
    createdExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type AddExchangeWithCustomerIdMutationFn = Apollo.MutationFunction<AddExchangeWithCustomerIdMutation, AddExchangeWithCustomerIdMutationVariables>;

/**
 * __useAddExchangeWithCustomerIdMutation__
 *
 * To run a mutation, you first call `useAddExchangeWithCustomerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeWithCustomerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeWithCustomerIdMutation, { data, loading, error }] = useAddExchangeWithCustomerIdMutation({
 *   variables: {
 *      addExchangeInput: // value for 'addExchangeInput'
 *   },
 * });
 */
export function useAddExchangeWithCustomerIdMutation(baseOptions?: Apollo.MutationHookOptions<AddExchangeWithCustomerIdMutation, AddExchangeWithCustomerIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExchangeWithCustomerIdMutation, AddExchangeWithCustomerIdMutationVariables>(AddExchangeWithCustomerIdDocument, options);
      }
export type AddExchangeWithCustomerIdMutationHookResult = ReturnType<typeof useAddExchangeWithCustomerIdMutation>;
export type AddExchangeWithCustomerIdMutationResult = Apollo.MutationResult<AddExchangeWithCustomerIdMutation>;
export type AddExchangeWithCustomerIdMutationOptions = Apollo.BaseMutationOptions<AddExchangeWithCustomerIdMutation, AddExchangeWithCustomerIdMutationVariables>;
export const UpdateExchangeWithCustomerIdDocument = gql`
    mutation UpdateExchangeWithCustomerId($updateExchangeInput: UpdateExchangeWithCustomerIdInput!) {
  updateExchangeWithCustomerId(updateExchangeInput: $updateExchangeInput) {
    success
    error
    updatedExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type UpdateExchangeWithCustomerIdMutationFn = Apollo.MutationFunction<UpdateExchangeWithCustomerIdMutation, UpdateExchangeWithCustomerIdMutationVariables>;

/**
 * __useUpdateExchangeWithCustomerIdMutation__
 *
 * To run a mutation, you first call `useUpdateExchangeWithCustomerIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExchangeWithCustomerIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExchangeWithCustomerIdMutation, { data, loading, error }] = useUpdateExchangeWithCustomerIdMutation({
 *   variables: {
 *      updateExchangeInput: // value for 'updateExchangeInput'
 *   },
 * });
 */
export function useUpdateExchangeWithCustomerIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExchangeWithCustomerIdMutation, UpdateExchangeWithCustomerIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExchangeWithCustomerIdMutation, UpdateExchangeWithCustomerIdMutationVariables>(UpdateExchangeWithCustomerIdDocument, options);
      }
export type UpdateExchangeWithCustomerIdMutationHookResult = ReturnType<typeof useUpdateExchangeWithCustomerIdMutation>;
export type UpdateExchangeWithCustomerIdMutationResult = Apollo.MutationResult<UpdateExchangeWithCustomerIdMutation>;
export type UpdateExchangeWithCustomerIdMutationOptions = Apollo.BaseMutationOptions<UpdateExchangeWithCustomerIdMutation, UpdateExchangeWithCustomerIdMutationVariables>;
export const GetValidationErrorsForCsvDocument = gql`
    query getValidationErrorsForCSV($csvFileUrl: String, $isGeneric: Boolean, $accountTypeSlug: String) {
  csvValidationErrors(
    csvFileUrl: $csvFileUrl
    isGeneric: $isGeneric
    accountTypeSlug: $accountTypeSlug
  )
}
    `;

/**
 * __useGetValidationErrorsForCsvQuery__
 *
 * To run a query within a React component, call `useGetValidationErrorsForCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidationErrorsForCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidationErrorsForCsvQuery({
 *   variables: {
 *      csvFileUrl: // value for 'csvFileUrl'
 *      isGeneric: // value for 'isGeneric'
 *      accountTypeSlug: // value for 'accountTypeSlug'
 *   },
 * });
 */
export function useGetValidationErrorsForCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetValidationErrorsForCsvQuery, GetValidationErrorsForCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidationErrorsForCsvQuery, GetValidationErrorsForCsvQueryVariables>(GetValidationErrorsForCsvDocument, options);
      }
export function useGetValidationErrorsForCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidationErrorsForCsvQuery, GetValidationErrorsForCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidationErrorsForCsvQuery, GetValidationErrorsForCsvQueryVariables>(GetValidationErrorsForCsvDocument, options);
        }
export type GetValidationErrorsForCsvQueryHookResult = ReturnType<typeof useGetValidationErrorsForCsvQuery>;
export type GetValidationErrorsForCsvLazyQueryHookResult = ReturnType<typeof useGetValidationErrorsForCsvLazyQuery>;
export type GetValidationErrorsForCsvQueryResult = Apollo.QueryResult<GetValidationErrorsForCsvQuery, GetValidationErrorsForCsvQueryVariables>;
export const CreateCustomWalletDocument = gql`
    mutation CreateCustomWallet($customWalletInput: CreateCustomWalletInput!) {
  createCustomWallet(customWalletInput: $customWalletInput) {
    success
    jobId
    error
  }
}
    `;
export type CreateCustomWalletMutationFn = Apollo.MutationFunction<CreateCustomWalletMutation, CreateCustomWalletMutationVariables>;

/**
 * __useCreateCustomWalletMutation__
 *
 * To run a mutation, you first call `useCreateCustomWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomWalletMutation, { data, loading, error }] = useCreateCustomWalletMutation({
 *   variables: {
 *      customWalletInput: // value for 'customWalletInput'
 *   },
 * });
 */
export function useCreateCustomWalletMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomWalletMutation, CreateCustomWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomWalletMutation, CreateCustomWalletMutationVariables>(CreateCustomWalletDocument, options);
      }
export type CreateCustomWalletMutationHookResult = ReturnType<typeof useCreateCustomWalletMutation>;
export type CreateCustomWalletMutationResult = Apollo.MutationResult<CreateCustomWalletMutation>;
export type CreateCustomWalletMutationOptions = Apollo.BaseMutationOptions<CreateCustomWalletMutation, CreateCustomWalletMutationVariables>;
export const GetJobStatusDocument = gql`
    query GetJobStatus($jobId: String!) {
  csvImportJobStatus(jobId: $jobId) {
    status
    isStatusFinal
    success
    error
    errorMessage
    numberImported
    numberIgnored
    numberUserDefinedTokens
    numberTotal
    createdCustomWallet {
      id
      name
      value
      computedTransactionCount
      syncInfo {
        isSyncing
        willBeDeleted
      }
      balances {
        balance
        calculatedBalance
        sanitizedCryptoSymbol
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
      userAssetBalances {
        balance
        calculatedBalance
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
    }
  }
}
    `;

/**
 * __useGetJobStatusQuery__
 *
 * To run a query within a React component, call `useGetJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetJobStatusQuery, GetJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobStatusQuery, GetJobStatusQueryVariables>(GetJobStatusDocument, options);
      }
export function useGetJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobStatusQuery, GetJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobStatusQuery, GetJobStatusQueryVariables>(GetJobStatusDocument, options);
        }
export type GetJobStatusQueryHookResult = ReturnType<typeof useGetJobStatusQuery>;
export type GetJobStatusLazyQueryHookResult = ReturnType<typeof useGetJobStatusLazyQuery>;
export type GetJobStatusQueryResult = Apollo.QueryResult<GetJobStatusQuery, GetJobStatusQueryVariables>;
export const AddMultiAddressDocument = gql`
    mutation AddMultiAddress($multiAddressInput: AddMultiAddressInput!) {
  addMultiAddress(multiAddressInput: $multiAddressInput) {
    success
    jobId
    error
  }
}
    `;
export type AddMultiAddressMutationFn = Apollo.MutationFunction<AddMultiAddressMutation, AddMultiAddressMutationVariables>;

/**
 * __useAddMultiAddressMutation__
 *
 * To run a mutation, you first call `useAddMultiAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultiAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultiAddressMutation, { data, loading, error }] = useAddMultiAddressMutation({
 *   variables: {
 *      multiAddressInput: // value for 'multiAddressInput'
 *   },
 * });
 */
export function useAddMultiAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddMultiAddressMutation, AddMultiAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMultiAddressMutation, AddMultiAddressMutationVariables>(AddMultiAddressDocument, options);
      }
export type AddMultiAddressMutationHookResult = ReturnType<typeof useAddMultiAddressMutation>;
export type AddMultiAddressMutationResult = Apollo.MutationResult<AddMultiAddressMutation>;
export type AddMultiAddressMutationOptions = Apollo.BaseMutationOptions<AddMultiAddressMutation, AddMultiAddressMutationVariables>;
export const GetMultiAddressJobStatusDocument = gql`
    query GetMultiAddressJobStatus($jobId: String!) {
  multiAddressImportJobStatus(jobId: $jobId) {
    status
    isStatusFinal
    success
    error
    successMessage
    errorMessage
    warningMessage
    createdWallets {
      id
      imageUrl
      calculatedValue
      value
      balance
      calculatedBalance
      computedTransactionCount
      computedCryptoTransactionCount
      currency {
        symbol
        type
        cmcId
        price
      }
      address
      name
      isBalanceDifferenceSignificant
      tokens {
        value
        calculatedValue
        sanitizedCryptoSymbol
        balance
        calculatedBalance
        computedTransactionCount
        isBalanceDifferenceSignificant
        currency {
          symbol
          type
          cmcId
        }
      }
      userAssetBalances {
        balance
        calculatedBalance
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      isMining
      hasDefiActivity
      errors
      assetsCount
    }
  }
}
    `;

/**
 * __useGetMultiAddressJobStatusQuery__
 *
 * To run a query within a React component, call `useGetMultiAddressJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiAddressJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiAddressJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetMultiAddressJobStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMultiAddressJobStatusQuery, GetMultiAddressJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiAddressJobStatusQuery, GetMultiAddressJobStatusQueryVariables>(GetMultiAddressJobStatusDocument, options);
      }
export function useGetMultiAddressJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiAddressJobStatusQuery, GetMultiAddressJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiAddressJobStatusQuery, GetMultiAddressJobStatusQueryVariables>(GetMultiAddressJobStatusDocument, options);
        }
export type GetMultiAddressJobStatusQueryHookResult = ReturnType<typeof useGetMultiAddressJobStatusQuery>;
export type GetMultiAddressJobStatusLazyQueryHookResult = ReturnType<typeof useGetMultiAddressJobStatusLazyQuery>;
export type GetMultiAddressJobStatusQueryResult = Apollo.QueryResult<GetMultiAddressJobStatusQuery, GetMultiAddressJobStatusQueryVariables>;
export const AddExchangeWithPassphraseDocument = gql`
    mutation AddExchangeWithPassphrase($addExchangeInput: AddExchangeWithPassphraseInput!) {
  addExchangeWithPassphrase(addExchangeInput: $addExchangeInput) {
    success
    error
    createdExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type AddExchangeWithPassphraseMutationFn = Apollo.MutationFunction<AddExchangeWithPassphraseMutation, AddExchangeWithPassphraseMutationVariables>;

/**
 * __useAddExchangeWithPassphraseMutation__
 *
 * To run a mutation, you first call `useAddExchangeWithPassphraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExchangeWithPassphraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExchangeWithPassphraseMutation, { data, loading, error }] = useAddExchangeWithPassphraseMutation({
 *   variables: {
 *      addExchangeInput: // value for 'addExchangeInput'
 *   },
 * });
 */
export function useAddExchangeWithPassphraseMutation(baseOptions?: Apollo.MutationHookOptions<AddExchangeWithPassphraseMutation, AddExchangeWithPassphraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExchangeWithPassphraseMutation, AddExchangeWithPassphraseMutationVariables>(AddExchangeWithPassphraseDocument, options);
      }
export type AddExchangeWithPassphraseMutationHookResult = ReturnType<typeof useAddExchangeWithPassphraseMutation>;
export type AddExchangeWithPassphraseMutationResult = Apollo.MutationResult<AddExchangeWithPassphraseMutation>;
export type AddExchangeWithPassphraseMutationOptions = Apollo.BaseMutationOptions<AddExchangeWithPassphraseMutation, AddExchangeWithPassphraseMutationVariables>;
export const UpdateExchangeWithPassphraseDocument = gql`
    mutation UpdateExchangeWithPassphrase($updateExchangeInput: UpdateExchangeWithPassphraseInput!) {
  updateExchangeWithPassphrase(updateExchangeInput: $updateExchangeInput) {
    success
    error
    updatedExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type UpdateExchangeWithPassphraseMutationFn = Apollo.MutationFunction<UpdateExchangeWithPassphraseMutation, UpdateExchangeWithPassphraseMutationVariables>;

/**
 * __useUpdateExchangeWithPassphraseMutation__
 *
 * To run a mutation, you first call `useUpdateExchangeWithPassphraseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExchangeWithPassphraseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExchangeWithPassphraseMutation, { data, loading, error }] = useUpdateExchangeWithPassphraseMutation({
 *   variables: {
 *      updateExchangeInput: // value for 'updateExchangeInput'
 *   },
 * });
 */
export function useUpdateExchangeWithPassphraseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExchangeWithPassphraseMutation, UpdateExchangeWithPassphraseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExchangeWithPassphraseMutation, UpdateExchangeWithPassphraseMutationVariables>(UpdateExchangeWithPassphraseDocument, options);
      }
export type UpdateExchangeWithPassphraseMutationHookResult = ReturnType<typeof useUpdateExchangeWithPassphraseMutation>;
export type UpdateExchangeWithPassphraseMutationResult = Apollo.MutationResult<UpdateExchangeWithPassphraseMutation>;
export type UpdateExchangeWithPassphraseMutationOptions = Apollo.BaseMutationOptions<UpdateExchangeWithPassphraseMutation, UpdateExchangeWithPassphraseMutationVariables>;
export const AddTwoXpubDocument = gql`
    mutation AddTwoXpub($twoXpubInput: AddTwoXpubInput!) {
  addTwoXpub(twoXpubInput: $twoXpubInput) {
    error
    success
    message
    createdWallet {
      id
      imageUrl
      calculatedValue
      value
      balance
      calculatedBalance
      computedTransactionCount
      computedCryptoTransactionCount
      currency {
        symbol
        type
        cmcId
        price
      }
      address
      name
      isBalanceDifferenceSignificant
      tokens {
        value
        calculatedValue
        sanitizedCryptoSymbol
        balance
        calculatedBalance
        computedTransactionCount
        isBalanceDifferenceSignificant
        currency {
          symbol
          type
          cmcId
        }
      }
      userAssetBalances {
        balance
        calculatedBalance
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      isMining
      hasDefiActivity
      errors
      assetsCount
    }
  }
}
    `;
export type AddTwoXpubMutationFn = Apollo.MutationFunction<AddTwoXpubMutation, AddTwoXpubMutationVariables>;

/**
 * __useAddTwoXpubMutation__
 *
 * To run a mutation, you first call `useAddTwoXpubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTwoXpubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTwoXpubMutation, { data, loading, error }] = useAddTwoXpubMutation({
 *   variables: {
 *      twoXpubInput: // value for 'twoXpubInput'
 *   },
 * });
 */
export function useAddTwoXpubMutation(baseOptions?: Apollo.MutationHookOptions<AddTwoXpubMutation, AddTwoXpubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTwoXpubMutation, AddTwoXpubMutationVariables>(AddTwoXpubDocument, options);
      }
export type AddTwoXpubMutationHookResult = ReturnType<typeof useAddTwoXpubMutation>;
export type AddTwoXpubMutationResult = Apollo.MutationResult<AddTwoXpubMutation>;
export type AddTwoXpubMutationOptions = Apollo.BaseMutationOptions<AddTwoXpubMutation, AddTwoXpubMutationVariables>;
export const AddPublicAddressDocument = gql`
    mutation addPublicAddress($publicAddressInput: AddPublicAddressWalletInput!) {
  addPublicAddress(publicAddressInput: $publicAddressInput) {
    success
    error
    warning
    multiAddError
    multiAddWarning
    createdWallet {
      id
      imageUrl
      calculatedValue
      value
      balance
      calculatedBalance
      computedTransactionCount
      computedCryptoTransactionCount
      currency {
        symbol
        type
        cmcId
        price
      }
      address
      name
      isBalanceDifferenceSignificant
      tokens {
        value
        calculatedValue
        sanitizedCryptoSymbol
        balance
        calculatedBalance
        computedTransactionCount
        isBalanceDifferenceSignificant
        currency {
          symbol
          type
          cmcId
        }
      }
      userAssetBalances {
        balance
        calculatedBalance
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      isMining
      hasDefiActivity
      errors
      assetsCount
    }
    createdExchange {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      type
      allowsTradeImports
      allowsTransferImports
      allowsTransactionImports
      allowsTransactionHistoryImports
      wallets {
        id
        calculatedValue
        value
        balance
        calculatedBalance
        computedTransactionCount
        computedCryptoTransactionCount
        currency {
          symbol
          type
          cmcId
          priceUsd
        }
        address
        name
        isBalanceDifferenceSignificant
        tokens {
          value
        }
        isMining
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      errors
      warnings
      showDeprecationWarning
      shouldBeRemoved
      assetsCount
    }
  }
}
    `;
export type AddPublicAddressMutationFn = Apollo.MutationFunction<AddPublicAddressMutation, AddPublicAddressMutationVariables>;

/**
 * __useAddPublicAddressMutation__
 *
 * To run a mutation, you first call `useAddPublicAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPublicAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPublicAddressMutation, { data, loading, error }] = useAddPublicAddressMutation({
 *   variables: {
 *      publicAddressInput: // value for 'publicAddressInput'
 *   },
 * });
 */
export function useAddPublicAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddPublicAddressMutation, AddPublicAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPublicAddressMutation, AddPublicAddressMutationVariables>(AddPublicAddressDocument, options);
      }
export type AddPublicAddressMutationHookResult = ReturnType<typeof useAddPublicAddressMutation>;
export type AddPublicAddressMutationResult = Apollo.MutationResult<AddPublicAddressMutation>;
export type AddPublicAddressMutationOptions = Apollo.BaseMutationOptions<AddPublicAddressMutation, AddPublicAddressMutationVariables>;
export const AddPublicXPubDocument = gql`
    mutation AddPublicXPub($publicXpubInput: AddPublicXpubInput!) {
  addPublicXpub(publicXpubInput: $publicXpubInput) {
    error
    success
    warning
    createdWallet {
      id
      imageUrl
      calculatedValue
      value
      balance
      calculatedBalance
      computedTransactionCount
      computedCryptoTransactionCount
      currency {
        symbol
        type
        cmcId
        price
      }
      address
      name
      isBalanceDifferenceSignificant
      tokens {
        value
        calculatedValue
        sanitizedCryptoSymbol
        balance
        calculatedBalance
        computedTransactionCount
        isBalanceDifferenceSignificant
        currency {
          symbol
          type
          cmcId
        }
      }
      userAssetBalances {
        balance
        calculatedBalance
        value
        calculatedValue
        entryCount
        currency {
          symbol
          type
          cmcId
        }
      }
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
      }
      isMining
      hasDefiActivity
      errors
      assetsCount
    }
  }
}
    `;
export type AddPublicXPubMutationFn = Apollo.MutationFunction<AddPublicXPubMutation, AddPublicXPubMutationVariables>;

/**
 * __useAddPublicXPubMutation__
 *
 * To run a mutation, you first call `useAddPublicXPubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPublicXPubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPublicXPubMutation, { data, loading, error }] = useAddPublicXPubMutation({
 *   variables: {
 *      publicXpubInput: // value for 'publicXpubInput'
 *   },
 * });
 */
export function useAddPublicXPubMutation(baseOptions?: Apollo.MutationHookOptions<AddPublicXPubMutation, AddPublicXPubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPublicXPubMutation, AddPublicXPubMutationVariables>(AddPublicXPubDocument, options);
      }
export type AddPublicXPubMutationHookResult = ReturnType<typeof useAddPublicXPubMutation>;
export type AddPublicXPubMutationResult = Apollo.MutationResult<AddPublicXPubMutation>;
export type AddPublicXPubMutationOptions = Apollo.BaseMutationOptions<AddPublicXPubMutation, AddPublicXPubMutationVariables>;
export const GetDetectedCryptoNetworksDocument = gql`
    query GetDetectedCryptoNetworks($address: String = "") {
  detectedCryptoNetworks(address: $address) {
    cryptoNetworkName
    symbol
    website
    rank
    imageUrl
  }
}
    `;

/**
 * __useGetDetectedCryptoNetworksQuery__
 *
 * To run a query within a React component, call `useGetDetectedCryptoNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetectedCryptoNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetectedCryptoNetworksQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetDetectedCryptoNetworksQuery(baseOptions?: Apollo.QueryHookOptions<GetDetectedCryptoNetworksQuery, GetDetectedCryptoNetworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDetectedCryptoNetworksQuery, GetDetectedCryptoNetworksQueryVariables>(GetDetectedCryptoNetworksDocument, options);
      }
export function useGetDetectedCryptoNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDetectedCryptoNetworksQuery, GetDetectedCryptoNetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDetectedCryptoNetworksQuery, GetDetectedCryptoNetworksQueryVariables>(GetDetectedCryptoNetworksDocument, options);
        }
export type GetDetectedCryptoNetworksQueryHookResult = ReturnType<typeof useGetDetectedCryptoNetworksQuery>;
export type GetDetectedCryptoNetworksLazyQueryHookResult = ReturnType<typeof useGetDetectedCryptoNetworksLazyQuery>;
export type GetDetectedCryptoNetworksQueryResult = Apollo.QueryResult<GetDetectedCryptoNetworksQuery, GetDetectedCryptoNetworksQueryVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations {
  integrations {
    slug
    name
    imageUrl
    category
    isDisabled
    syncMethod
    rank
    description
    instructions
    supportsHdWallet
    websiteUrl
    info {
      hideInstructions
      cryptoNetwork
      circleIconUrl
      symbol
      supportedCryptoNetworks
      isEvmChain
      supportedFileFormats
      csvIntegrationCoverageInfo
      syncIntegrationCoverageInfo
      isInstitutional
    }
    formId
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const ResyncAllDocument = gql`
    mutation resyncAll {
  resyncAllWalletsAndAccounts {
    success
    message
  }
}
    `;
export type ResyncAllMutationFn = Apollo.MutationFunction<ResyncAllMutation, ResyncAllMutationVariables>;

/**
 * __useResyncAllMutation__
 *
 * To run a mutation, you first call `useResyncAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncAllMutation, { data, loading, error }] = useResyncAllMutation({
 *   variables: {
 *   },
 * });
 */
export function useResyncAllMutation(baseOptions?: Apollo.MutationHookOptions<ResyncAllMutation, ResyncAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncAllMutation, ResyncAllMutationVariables>(ResyncAllDocument, options);
      }
export type ResyncAllMutationHookResult = ReturnType<typeof useResyncAllMutation>;
export type ResyncAllMutationResult = Apollo.MutationResult<ResyncAllMutation>;
export type ResyncAllMutationOptions = Apollo.BaseMutationOptions<ResyncAllMutation, ResyncAllMutationVariables>;
export const GetOtherTransactionsForWalletQueryDocument = gql`
    query GetOtherTransactionsForWalletQuery {
  otherTransactions {
    id
    value
    assetsCount
  }
  exchangesPage {
    totalCount
  }
  localWalletsPage {
    totalCount
  }
  customWalletsPage {
    totalCount
  }
}
    `;

/**
 * __useGetOtherTransactionsForWalletQueryQuery__
 *
 * To run a query within a React component, call `useGetOtherTransactionsForWalletQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherTransactionsForWalletQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherTransactionsForWalletQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOtherTransactionsForWalletQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetOtherTransactionsForWalletQueryQuery, GetOtherTransactionsForWalletQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherTransactionsForWalletQueryQuery, GetOtherTransactionsForWalletQueryQueryVariables>(GetOtherTransactionsForWalletQueryDocument, options);
      }
export function useGetOtherTransactionsForWalletQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherTransactionsForWalletQueryQuery, GetOtherTransactionsForWalletQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherTransactionsForWalletQueryQuery, GetOtherTransactionsForWalletQueryQueryVariables>(GetOtherTransactionsForWalletQueryDocument, options);
        }
export type GetOtherTransactionsForWalletQueryQueryHookResult = ReturnType<typeof useGetOtherTransactionsForWalletQueryQuery>;
export type GetOtherTransactionsForWalletQueryLazyQueryHookResult = ReturnType<typeof useGetOtherTransactionsForWalletQueryLazyQuery>;
export type GetOtherTransactionsForWalletQueryQueryResult = Apollo.QueryResult<GetOtherTransactionsForWalletQueryQuery, GetOtherTransactionsForWalletQueryQueryVariables>;
export const GetPaginatedCustomWalletsForWalletListDocument = gql`
    query GetPaginatedCustomWalletsForWalletList($page: Int, $limit: Int) {
  customWalletsPage(page: $page, limit: $limit) {
    customWallets {
      id
      name
      value
      syncInfo {
        isSyncing
        willBeDeleted
        lastSynced @client
      }
      assetsCount
    }
    totalCount
    currentPage
    endPage
  }
  exchangesPage {
    totalCount
  }
  localWalletsPage {
    totalCount
  }
  otherTransactions {
    id
    value
    assetsCount
  }
}
    `;

/**
 * __useGetPaginatedCustomWalletsForWalletListQuery__
 *
 * To run a query within a React component, call `useGetPaginatedCustomWalletsForWalletListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedCustomWalletsForWalletListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedCustomWalletsForWalletListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPaginatedCustomWalletsForWalletListQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedCustomWalletsForWalletListQuery, GetPaginatedCustomWalletsForWalletListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedCustomWalletsForWalletListQuery, GetPaginatedCustomWalletsForWalletListQueryVariables>(GetPaginatedCustomWalletsForWalletListDocument, options);
      }
export function useGetPaginatedCustomWalletsForWalletListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedCustomWalletsForWalletListQuery, GetPaginatedCustomWalletsForWalletListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedCustomWalletsForWalletListQuery, GetPaginatedCustomWalletsForWalletListQueryVariables>(GetPaginatedCustomWalletsForWalletListDocument, options);
        }
export type GetPaginatedCustomWalletsForWalletListQueryHookResult = ReturnType<typeof useGetPaginatedCustomWalletsForWalletListQuery>;
export type GetPaginatedCustomWalletsForWalletListLazyQueryHookResult = ReturnType<typeof useGetPaginatedCustomWalletsForWalletListLazyQuery>;
export type GetPaginatedCustomWalletsForWalletListQueryResult = Apollo.QueryResult<GetPaginatedCustomWalletsForWalletListQuery, GetPaginatedCustomWalletsForWalletListQueryVariables>;
export const GetPaginatedExchangesDocument = gql`
    query GetPaginatedExchanges($page: Int, $limit: Int) {
  localWalletsPage(includeEmptyWallets: false) {
    totalCount
  }
  exchangesPage(page: $page, limit: $limit) {
    totalCount
    currentPage
    endPage
    exchanges {
      id
      value
      calculatedValue
      imageUrl
      name
      defaultName
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
        isDisabled
      }
      isPortfolioValueDifferenceSignificant
      allowsHardResync
      errors
      assetsCount
    }
  }
  customWalletsPage {
    totalCount
  }
  otherTransactions {
    id
    value
    assetsCount
  }
}
    `;

/**
 * __useGetPaginatedExchangesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedExchangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedExchangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedExchangesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPaginatedExchangesQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedExchangesQuery, GetPaginatedExchangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedExchangesQuery, GetPaginatedExchangesQueryVariables>(GetPaginatedExchangesDocument, options);
      }
export function useGetPaginatedExchangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedExchangesQuery, GetPaginatedExchangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedExchangesQuery, GetPaginatedExchangesQueryVariables>(GetPaginatedExchangesDocument, options);
        }
export type GetPaginatedExchangesQueryHookResult = ReturnType<typeof useGetPaginatedExchangesQuery>;
export type GetPaginatedExchangesLazyQueryHookResult = ReturnType<typeof useGetPaginatedExchangesLazyQuery>;
export type GetPaginatedExchangesQueryResult = Apollo.QueryResult<GetPaginatedExchangesQuery, GetPaginatedExchangesQueryVariables>;
export const GetPaginatedWalletsForWalletListDocument = gql`
    query GetPaginatedWalletsForWalletList($includeEmptyWallets: Boolean, $page: Int, $limit: Int) {
  localWalletsPage(
    includeEmptyWallets: $includeEmptyWallets
    page: $page
    limit: $limit
  ) {
    wallets {
      id
      imageUrl
      calculatedValue
      value
      computedTransactionCount
      address
      name
      isPortfolioValueDifferenceSignificant
      allowsHardResync
      syncInfo {
        lastSynced
        isSyncing
        willBeDeleted
        isDisabled
      }
      errors
      assetsCount
      walletNetwork
    }
    totalCount
    currentPage
    endPage
  }
  exchangesPage {
    totalCount
  }
  customWalletsPage {
    totalCount
  }
  otherTransactions {
    id
    value
    assetsCount
  }
}
    `;

/**
 * __useGetPaginatedWalletsForWalletListQuery__
 *
 * To run a query within a React component, call `useGetPaginatedWalletsForWalletListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedWalletsForWalletListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedWalletsForWalletListQuery({
 *   variables: {
 *      includeEmptyWallets: // value for 'includeEmptyWallets'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPaginatedWalletsForWalletListQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedWalletsForWalletListQuery, GetPaginatedWalletsForWalletListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedWalletsForWalletListQuery, GetPaginatedWalletsForWalletListQueryVariables>(GetPaginatedWalletsForWalletListDocument, options);
      }
export function useGetPaginatedWalletsForWalletListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedWalletsForWalletListQuery, GetPaginatedWalletsForWalletListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedWalletsForWalletListQuery, GetPaginatedWalletsForWalletListQueryVariables>(GetPaginatedWalletsForWalletListDocument, options);
        }
export type GetPaginatedWalletsForWalletListQueryHookResult = ReturnType<typeof useGetPaginatedWalletsForWalletListQuery>;
export type GetPaginatedWalletsForWalletListLazyQueryHookResult = ReturnType<typeof useGetPaginatedWalletsForWalletListLazyQuery>;
export type GetPaginatedWalletsForWalletListQueryResult = Apollo.QueryResult<GetPaginatedWalletsForWalletListQuery, GetPaginatedWalletsForWalletListQueryVariables>;
export const GetUserHasAnyWalletsDocument = gql`
    query GetUserHasAnyWallets {
  userInfo {
    publicId
    hasAnyWallet
  }
}
    `;

/**
 * __useGetUserHasAnyWalletsQuery__
 *
 * To run a query within a React component, call `useGetUserHasAnyWalletsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserHasAnyWalletsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserHasAnyWalletsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserHasAnyWalletsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserHasAnyWalletsQuery, GetUserHasAnyWalletsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserHasAnyWalletsQuery, GetUserHasAnyWalletsQueryVariables>(GetUserHasAnyWalletsDocument, options);
      }
export function useGetUserHasAnyWalletsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserHasAnyWalletsQuery, GetUserHasAnyWalletsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserHasAnyWalletsQuery, GetUserHasAnyWalletsQueryVariables>(GetUserHasAnyWalletsDocument, options);
        }
export type GetUserHasAnyWalletsQueryHookResult = ReturnType<typeof useGetUserHasAnyWalletsQuery>;
export type GetUserHasAnyWalletsLazyQueryHookResult = ReturnType<typeof useGetUserHasAnyWalletsLazyQuery>;
export type GetUserHasAnyWalletsQueryResult = Apollo.QueryResult<GetUserHasAnyWalletsQuery, GetUserHasAnyWalletsQueryVariables>;
export const GetWalletsForWalletListDocument = gql`
    query GetWalletsForWalletList($includeEmptyWallets: Boolean) {
  userInfo {
    publicId
    hasAnyWallet
  }
  localWallets(includeEmptyWallets: $includeEmptyWallets) {
    id
    imageUrl
    calculatedValue
    value
    computedTransactionCount
    address
    name
    isPortfolioValueDifferenceSignificant
    allowsHardResync
    syncInfo {
      lastSynced
      isSyncing
      willBeDeleted
      isDisabled
    }
    errors
    assetsCount
    walletNetwork
  }
  exchanges {
    id
    value
    calculatedValue
    imageUrl
    name
    defaultName
    syncInfo {
      lastSynced
      isSyncing
      willBeDeleted
      isDisabled
    }
    isPortfolioValueDifferenceSignificant
    allowsHardResync
    errors
    assetsCount
    slug
  }
  customWallets {
    id
    name
    value
    syncInfo {
      isSyncing
      willBeDeleted
      lastSynced @client
    }
    assetsCount
    slug
  }
  otherTransactions {
    id
    value
    assetsCount
  }
}
    `;

/**
 * __useGetWalletsForWalletListQuery__
 *
 * To run a query within a React component, call `useGetWalletsForWalletListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWalletsForWalletListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWalletsForWalletListQuery({
 *   variables: {
 *      includeEmptyWallets: // value for 'includeEmptyWallets'
 *   },
 * });
 */
export function useGetWalletsForWalletListQuery(baseOptions?: Apollo.QueryHookOptions<GetWalletsForWalletListQuery, GetWalletsForWalletListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWalletsForWalletListQuery, GetWalletsForWalletListQueryVariables>(GetWalletsForWalletListDocument, options);
      }
export function useGetWalletsForWalletListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWalletsForWalletListQuery, GetWalletsForWalletListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWalletsForWalletListQuery, GetWalletsForWalletListQueryVariables>(GetWalletsForWalletListDocument, options);
        }
export type GetWalletsForWalletListQueryHookResult = ReturnType<typeof useGetWalletsForWalletListQuery>;
export type GetWalletsForWalletListLazyQueryHookResult = ReturnType<typeof useGetWalletsForWalletListLazyQuery>;
export type GetWalletsForWalletListQueryResult = Apollo.QueryResult<GetWalletsForWalletListQuery, GetWalletsForWalletListQueryVariables>;
export const GetReportsPageDocument = gql`
    query GetReportsPage {
  taxYears {
    taxYear
    title
    dateRange
    startDate
    endDate
  }
}
    `;

/**
 * __useGetReportsPageQuery__
 *
 * To run a query within a React component, call `useGetReportsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsPageQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsPageQuery, GetReportsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsPageQuery, GetReportsPageQueryVariables>(GetReportsPageDocument, options);
      }
export function useGetReportsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsPageQuery, GetReportsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsPageQuery, GetReportsPageQueryVariables>(GetReportsPageDocument, options);
        }
export type GetReportsPageQueryHookResult = ReturnType<typeof useGetReportsPageQuery>;
export type GetReportsPageLazyQueryHookResult = ReturnType<typeof useGetReportsPageLazyQuery>;
export type GetReportsPageQueryResult = Apollo.QueryResult<GetReportsPageQuery, GetReportsPageQueryVariables>;
export const GetExchangeDataForUpdateDocument = gql`
    query GetExchangeDataForUpdate($publicId: String!) {
  exchange(publicId: $publicId) {
    id
    name
    slug
    instructions
    formId
    syncMethod
    imageUrl
    supportedFileFormats
  }
}
    `;

/**
 * __useGetExchangeDataForUpdateQuery__
 *
 * To run a query within a React component, call `useGetExchangeDataForUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeDataForUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeDataForUpdateQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetExchangeDataForUpdateQuery(baseOptions: Apollo.QueryHookOptions<GetExchangeDataForUpdateQuery, GetExchangeDataForUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeDataForUpdateQuery, GetExchangeDataForUpdateQueryVariables>(GetExchangeDataForUpdateDocument, options);
      }
export function useGetExchangeDataForUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeDataForUpdateQuery, GetExchangeDataForUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeDataForUpdateQuery, GetExchangeDataForUpdateQueryVariables>(GetExchangeDataForUpdateDocument, options);
        }
export type GetExchangeDataForUpdateQueryHookResult = ReturnType<typeof useGetExchangeDataForUpdateQuery>;
export type GetExchangeDataForUpdateLazyQueryHookResult = ReturnType<typeof useGetExchangeDataForUpdateLazyQuery>;
export type GetExchangeDataForUpdateQueryResult = Apollo.QueryResult<GetExchangeDataForUpdateQuery, GetExchangeDataForUpdateQueryVariables>;